'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var pure = _interopDefault(require('recompose/pure'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var validate = _interopDefault(require('validate.js/validate'));
var tslib = require('tslib');
var PropTypes = require('prop-types');
var PropTypes__default = _interopDefault(PropTypes);
var moment = _interopDefault(require('moment'));
var DatePicker$1 = require('@witbooking/react-datepicker');
var DatePicker$1__default = _interopDefault(DatePicker$1);
require('@witbooking/react-datepicker/dist/react-datepicker.css');
var Select$3 = require('react-select');
var Select$3__default = _interopDefault(Select$3);
var dateFns = require('date-fns');
var ReactDOM = _interopDefault(require('react-dom'));
var classnames = _interopDefault(require('classnames'));
var validate$1 = _interopDefault(require('validate.js'));
var Modal$1 = _interopDefault(require('react-modal'));
var moment$1 = _interopDefault(require('moment/moment'));
var objectFitImages = _interopDefault(require('object-fit-images'));
var Slider = _interopDefault(require('react-slick'));
var Url = _interopDefault(require('url-parse'));
var lodash = require('lodash');
var recompose = require('recompose');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var constants = {
  headerTypes: {
    DEFAULT: "DEFAULT",
    CLOSE_ON_TOP: "CLOSE_ON_TOP"
  },
  restrictions: {
    AMOUNT_AND_STAY_GTE: "AMOUNT_AND_STAY_GTE",
    STAY_GTE: "STAY_GTE",
    AMOUNT_GTE: "AMOUNT_GTE",
    NO_RESTRICTION: "NO_RESTRICTION"
  },
  SERVICE_TYPE: {
    ROOM: "ROOM",
    UNIT: "UNIT",
    PERSON: "PERSON",
    PERCENTAGE: "PERCENTAGE"
  },
  BOOKABLE_STATUS: {
    AVAILABLE: "AVAILABLE",
    UNAVAILABLE: "UNAVAILABLE",
    RESTRICTED: "RESTRICTED",
    IGNORED_FILTER: "IGNORED_FILTER"
  },
  FILTER: {
    REPRESENTATION: {
      DROPDOWN: "DROPDOWN"
    },
    TYPE: {
      URL: "URL",
      ESTABLISHMENT: "ESTABLISHMENT",
      INVENTORY: "INVENTORY"
    }
  },
  DEVICE_TYPE: {
    MOBILE: "MOBILE",
    DESKTOP: "DESKTOP"
  },
  RESOLUTION: {
    XXS: "320",
    XS: "360",
    SM: "768",
    MD: "1024",
    LG: "1280"
  },
  ROOM_DENOMINATION: {
    UNITS: "UNITS",
    ROOMS: "ROOMS",
    APARTMENTS: "APARTMENTS",
    BUNGALOWS: "BUNGALOWS",
    CABINS: "CABINS",
    HOUSES: "HOUSES",
    SHIP_CABIN: "SHIP_CABIN",
    VILLAS: "VILLAS",
    BEDS: "BEDS"
  },
  OCCUPANTS_TYPE: {
    SENIOR: "SENIOR",
    ADULT: "ADULT",
    TEENAGER: "TEENAGER",
    CHILDREN: "CHILD",
    BABY: "BABY"
  },
  OCCUPANTS_FILTER_TYPE: {
    AGE: "age",
    OCCUPANTS_TYPE: "occupants_type",
    NONE: "none"
  },
  PENDING_AMOUNT_TEXT_CONFIGURATION: {
    PAY_AT_ESTABLISHMENT: "PAY_AT_ESTABLISHMENT",
    PAY_ACCORDING_TO_CONDITIONS: "PAY_ACCORDING_TO_CONDITIONS",
    AMOUNT_REMAINING: "AMOUNT_REMAINING",
    NO_TEXT: "NO_TEXT"
  },
  RESERVATION_STATUS: {
    CONFIRMED: "reserva",
    PRE_RESERVATION: "prereserva",
    CANCELED: "cancelada",
    DEFERRED: "deferred"
  },
  CANCELLATION_POLICY_RESTRICTION_TYPE: {
    FIX_AMOUNT: "FIX_AMOUNT",
    PERCENTAGE: "PERCENTAGE",
    CHARGE_FIRST_NIGHT: "CHARGE_FIRST_NIGHT"
  },
  DATE_SELECTION_TYPE: {
    NONE: "NONE",
    SPECIFIC: "SPECIFIC",
    ALL: "ALL"
  },
  TYPOGRAPHY: {
    DEFAULT: "DEFAULT",
    XXLARGE: "XXLARGE",
    XLARGE: "XLARGE",
    LARGE: "LARGE",
    STANDARD: "STANDARD",
    STANDARD_BOLD: "STANDARD_BOLD",
    STANDARD_GREY: "STANDARD_GREY",
    STANDARD_GREEN: "STANDARD_GREEN",
    STANDARD_RED: "STANDARD_RED",
    STANDARD_ORANGE: "STANDARD_ORANGE",
    STANDARD_WHITE: "STANDARD_WHITE",
    STANDARD_BLUE: "STANDARD_BLUE",
    SMALL: "SMALL",
    SMALL_BOLD: "SMALL_BOLD",
    SMALL_GREY: "SMALL_GREY",
    SMALL_WHITE: "SMALL_WHITE",
    SMALL_BLUE: "SMALL_BLUE",
    XSMALL: "XSMALL",
    XSMALL_GREY: "XSMALL_GREY",
    XSMALL_WHITE: "XSMALL_WHITE"
  },
  STEP_PATHS: {
    HEALTH_CHECK: "health",
    STEP_1: "availability",
    STEP_2: "checkout",
    STEP_3: "booking-confirmation",
    STEP_4: "booking-modification",
    SHARE_BOOKING: "share-booking",
    RECOVER_RESERVATION_CONFIRMATION: "recover-reservation"
  },
  PROMOTED_DISCOUNT_TYPE: {
    PERCENTAGE: "PERCENTAGE",
    CONSTANT: "CONSTANT"
  },
  PROPERTY_FILTER: {
    REPRESENTATION: {
      DROPDOWN: "DROPDOWN",
      RADIO: "RADIO",
      TAB: "TAB"
    }
  }
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n  display: inline-block;\n  fill: currentColor;\n  flex-shrink: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Svg = styled__default.svg(_templateObject());

function SvgIcon(props) {
  var {
    children,
    titleAccess
  } = props,
      other = tslib.__rest(props, ["children", "titleAccess"]);

  return /*#__PURE__*/React__default.createElement(Svg, _extends({
    focusable: "false",
    "aria-hidden": titleAccess ? "false" : "true"
  }, other), titleAccess ? /*#__PURE__*/React__default.createElement("title", null, titleAccess) : null, children);
}

SvgIcon.defaultProps = {
  viewBox: "0 0 24 24",
  className: "",
  color: "",
  titleAccess: ""
};

function createSvgIcon(path, displayName) {
  var Icon = React__default.memo(props => /*#__PURE__*/React__default.createElement(SvgIcon, props, path));
  Icon.displayName = displayName;
  return Icon;
}

var Close = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})), "Close");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  color: #ffffff;\n  align-self: flex-end;\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: uppercase;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  height: 80px;\n  width: 100%;\n  background-color: #222222;\n  box-sizing: border-box;\n  padding: 16px 16px 16px 16px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: white;\n  background-color: #252525;\n  display: flex;\n  padding: 2px;\n  min-height: 45px;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 15px 15px 15px 20px;\n  box-sizing: border-box;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    height: 24px;\n    width: 24px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  font-size: 18px;\n  font-weight: 700;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #908f96;\n  cursor: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  font-family: \"Open Sans\";\n  width: 100%;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var DivFather = styled__default.div(_templateObject$1());
var CloseHover = styled__default(Close)(_templateObject2(), props => props.allowClose === false ? "not-allowed" : "pointer");
var HeadTitle = styled__default.div(_templateObject3());
var DivLeft = styled__default.div(_templateObject4());
var SvgContainer = styled__default.span(_templateObject5());
var DivHeader = styled__default.div(_templateObject6());
var HeaderBackground = styled__default.div(_templateObject7());
var HeaderText = styled__default.div(_templateObject8());
var Popup = React__default.memo(props => {
  var header = null;

  switch (props.headerType) {
    case constants.headerTypes.CLOSE_ON_TOP:
      header = /*#__PURE__*/React__default.createElement(HeaderBackground, null, /*#__PURE__*/React__default.createElement(HeaderText, null, props.headerText), /*#__PURE__*/React__default.createElement(CloseHover, {
        onClick: props.closeWindow,
        color: "#908f96",
        allowClose: props.allowClose
      }));
      break;

    default:
      header = /*#__PURE__*/React__default.createElement(DivHeader, {
        className: "DivHeader"
      }, /*#__PURE__*/React__default.createElement(DivLeft, {
        className: "DivLeft"
      }, /*#__PURE__*/React__default.createElement(SvgContainer, null, props.srcLogo), props.headerText && /*#__PURE__*/React__default.createElement(HeadTitle, null, props.headerText)), /*#__PURE__*/React__default.createElement(SvgContainer, null, /*#__PURE__*/React__default.createElement(CloseHover, {
        className: "Closer",
        onClick: props.closeWindow,
        allowClose: props.allowClose
      })));
      break;
  }

  return /*#__PURE__*/React__default.createElement(DivFather, {
    className: "".concat(props.className, " Popup")
  }, header, props.children, props.footer);
});

var Person = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "Person");

// Device sizes
var minWidthTabletHorizontal = "768px";
var minWidthDesktopAlternative = "900px";
var minWidthLaptop = "1024px";
var minWidthDesktop = "1280px";
var maxWidthDesktop = "1443px";
var minWidthLargeDesktop = "1444px"; // Custom Colors

var wbBlack = "#222222";
var wbGreen = "#329911";
var wbGreyLightest = "#F0F0F0";
var wbOrange = "#FF9125";
var wbRed = "#b20e0e";
var wbPink = "#f5dada";
var white = "#FFF";
var greyBasic = "#F6F6F6";
var greyLight = "#908f96";
var greyLighter = "#E1E1E1";
var wbBlue = "#1578bc";
var backgroundButtonGrey = "#f6f6f6";

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  button {\n    padding: 5px 30px;\n    background-color: ", ";\n    border-radius: 5px;\n    font-weight: 700;\n    color: ", ";\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 18px 0 20px;\n\n  input {\n    width: 100%;\n    height: 32px;\n    max-width: 260px;\n    border: 1px solid ", ";\n    border-radius: 5px;\n    padding-left: 5px;\n    outline: 0;\n    ", ";\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  color: ", ";\n  font-size: 16px;\n  font-weight: 700;\n  text-align: center;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 40px;\n  font-size: 13px;\n\n  > div {\n    width: 100%;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var msgs = reactIntl.defineMessages({
  agencyEntries: {
    id: "footer.link.agencyEntry",
    description: "Agencies",
    defaultMessage: "Agencies"
  },
  enterEmail: {
    id: "agency.modal.enterEmail",
    description: "Enter email to access the agencies section",
    defaultMessage: "Enter email to access the agencies section"
  },
  access: {
    id: "agency.modal.enterEmail.button.access",
    description: "Access",
    defaultMessage: "Access"
  }
});
var StyledContainer = styled__default.div(_templateObject$2());
var StyledMessage = styled__default.div(_templateObject2$1(), wbBlack);
var StyledEmailInput = styled__default.div(_templateObject3$1(), greyLighter, props => props.error && "border-color: ".concat(wbRed));
var StyledButton = styled__default.div(_templateObject4$1(), wbGreen, white);

class AgentsLogin extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = event => {
      this.setState({
        email: event && event.currentTarget && event.currentTarget.value
      });
    };

    this.handleClick = () => {
      var constraints = {
        from: {
          email: true
        }
      };
      var error = validate({
        from: this.state.email
      }, constraints);

      if (error) {
        this.setState({
          error
        });
      } else {
        this.props.handleSubmit(this.state.email);
      }
    };

    this.state = {
      email: undefined,
      error: false
    };
  }

  render() {
    return /*#__PURE__*/React__default.createElement(Popup, {
      headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs.agencyEntries),
      closeWindow: this.props.buttonClose,
      srcLogo: /*#__PURE__*/React__default.createElement(Person, null)
    }, /*#__PURE__*/React__default.createElement(StyledContainer, null, /*#__PURE__*/React__default.createElement(StyledMessage, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs.enterEmail)), /*#__PURE__*/React__default.createElement(StyledEmailInput, {
      error: this.state.error
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "text",
      name: "email",
      value: this.state.email,
      onChange: this.handleChange
    })), /*#__PURE__*/React__default.createElement(StyledButton, null, /*#__PURE__*/React__default.createElement("button", {
      onClick: this.handleClick
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs.access)))));
  }

}

var index = pure(AgentsLogin);

var DateRange = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), "DateRange");

var ArrowDropDown = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7 10l5 5 5-5z"
})), "ArrowDropDown");

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  z-index: 1;\n  width: 100%;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  svg {\n    transform: translateX(-12%);\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  color: #999999;\n  position: absolute;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  svg {\n    transform: translateX(5%);\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  width: 220px;\n  position: relative;\n  align-items: center;\n  height: 30px;\n  border-bottom: ", ";\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 13px;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var theme = {
  library: {
    SelectInput: {}
  }
};
var Container = styled__default.div(_templateObject$3(), props => props.hideBorder ? "" : "1px solid #999999");
var ArrowDownContainer = styled__default.div(_templateObject2$2());
var ArrowDown = styled__default(ArrowDropDown)(_templateObject3$2());
var StyledIcon = styled__default.div(_templateObject4$2());
var ChildrenContainer = styled__default.div(_templateObject5$1(), props => props.customPadding ? "0" : "0 0 0 30px"); // Used to display Property and Room information
// It's always on top of a list of selling options

function SelectInputWrapper(_ref) {
  var {
    className,
    icon,
    disabled,
    children,
    customPadding,
    onClick,
    hideBorder,
    hideFirstIcon
  } = _ref;
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Container, {
    className: className,
    disabled: disabled,
    onClick: onClick,
    hideBorder: hideBorder
  }, icon && !hideFirstIcon && /*#__PURE__*/React__default.createElement(StyledIcon, null, icon), /*#__PURE__*/React__default.createElement(ChildrenContainer, {
    customPadding: customPadding
  }, children), icon && /*#__PURE__*/React__default.createElement(ArrowDownContainer, {
    className: "arrowDownContainer"
  }, /*#__PURE__*/React__default.createElement(ArrowDown, null))));
}

SelectInputWrapper.propTypes = {
  className: PropTypes__default.string,

  /** The component can have different appearances depending on this prop  */
  icon: PropTypes__default.node,

  /** Source of the image which illustrates the entity of the component */
  children: PropTypes__default.node.isRequired,

  /** Source of the image which illustrates the entity of the component */
  disabled: PropTypes__default.bool,
  customPadding: PropTypes__default.bool,

  /** Source of the image which illustrates the entity of the component */
  onClick: PropTypes__default.func.isRequired,
  hideBorder: PropTypes__default.bool,
  hideFirstIcon: PropTypes__default.bool
};
SelectInputWrapper.defaultProps = {
  className: "",
  disabled: false,
  icon: undefined,
  customPadding: false,
  hideBorder: false,
  hideFirstIcon: false
};
var SelectInputWrapper$1 = pure(SelectInputWrapper);

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  width: 150px;\n  color: #222222;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  color: #999999;\n  width: 24px;\n  height: 24px;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var DateRange$1 = styled__default(DateRange)(_templateObject$4());
var StyledSelectInputWrapper = styled__default(SelectInputWrapper$1)(_templateObject2$3()); // Used to display Property and Room information
// It's always on top of a list of selling options

function DropDown(_ref) {
  var {
    className,
    startDate,
    endDate,
    onClick,
    hideBorder
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledSelectInputWrapper, {
    className: className,
    onClick: onClick,
    icon: /*#__PURE__*/React__default.createElement(DateRange$1, null),
    hideBorder: hideBorder
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    month: "short",
    value: startDate
  }), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    day: "2-digit",
    value: startDate
  }), /*#__PURE__*/React__default.createElement("span", null, " - "), endDate && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    month: "short",
    value: endDate
  }), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    day: "2-digit",
    value: endDate
  })) || "?");
}

DropDown.propTypes = {
  className: PropTypes__default.string,

  /** The component can have different appearances depending on this prop  */
  startDate: PropTypes__default.object.isRequired,

  /** The component can have different appearances depending on this prop  */
  endDate: PropTypes__default.object.isRequired,

  /** The component can have different appearances depending on this prop  */
  onClick: PropTypes__default.func.isRequired,
  hideBorder: PropTypes__default.bool
};
DropDown.defaultProps = {
  className: "",
  hideBorder: false
};
var DropDown$1 = pure(DropDown);

var ArrowNext = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%20%20%20%20%3Cpath%20d%3D%22M5.88%204.12L13.76%2012l-7.88%207.88L8%2022l10-10L8%202z%22%20fill%3D%22%23888%22%2F%3E%20%20%20%20%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v24H0z%22%2F%3E%3C%2Fsvg%3E";

var ArrowPrev = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20%3E%20%20%20%20%3Cpath%20d%3D%22M11.67%203.87L9.9%202.1%200%2012l9.9%209.9%201.77-1.77L3.54%2012z%22%20fill%3D%22%23888%22%2F%3E%20%20%20%20%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v24H0z%22%2F%3E%3C%2Fsvg%3E";

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  .wbk-DayRangePicker {\n    .react-datepicker__day--outside-month {\n      visibility: hidden;\n    }\n\n    .react-datepicker {\n      border: 1px solid #e0e0e0;\n      border-radius: 0;\n      padding: 10px;\n    }\n\n    .react-datepicker__header {\n      background-color: transparent;\n      border-bottom: none;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n      padding-top: 16px;\n    }\n\n    .react-datepicker__day-name {\n      color: #888\n    }\n\n    .react-datepicker__day-name, .react-datepicker__day {\n      height: 35px;\n      width: 40px;\n      padding: 0 4px;\n      line-height: 2rem;\n\n    }\n\n    .react-datepicker__day {\n      border-radius: 0;\n      color: #888;\n      font-size: 14px;\n    }\n\n    .react-datepicker__day--in-range {\n      background-color: #ddf9ff;\n      color: #03c7f1;\n    }\n\n    .react-datepicker__day--range-start, .react-datepicker__day--range-end{\n      background-color: #03c7f1;\n      color: #fff;\n    }\n\n    .react-datepicker__current-month {\n      margin-bottom: 15px;\n      color: #888;\n      font-weight: normal;\n    }\n\n    .react-datepicker__month-container {\n      margin: 0 1rem;\n    }\n\n    .react-datepicker__navigation--next, .react-datepicker__navigation--previous {\n      width: 24px;\n      height: 24px;\n      border: none;\n      color: #888;\n      background-repeat: no-repeat;\n      background-size: contain;\n      top: 25px;\n    }\n    .react-datepicker__navigation--next {\n      background-image: url(", ");\n      right: 16px;\n    }\n\n    .react-datepicker__navigation--previous {\n      background-image: url(", ");\n      left: 16px;\n    }\n\n    .react-datepicker__triangle {\n      left: 50%;\n    }\n\n    .react-datepicker {\n    display:inline-flex;\n    }\n  }\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  z-index: 100;\n  position: relative;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
// import ArrowNext from "../../../icons/arrowForwardSimple";
// import ArrowPrev from "../../../icons/arrowBackSimple";

var Container$1 = styled__default.div(_templateObject$5());
var GlobalStyle = styled.createGlobalStyle(_templateObject2$4(), ArrowNext, ArrowPrev); // Used to display Property and Room information
// It's always on top of a list of selling options

class DayRangePicker extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: props.startDate || new Date(),
      endDate: props.endDate || new Date(),
      isStartSet: false,
      isOpen: this.props.startsOpen
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
  }

  handleChange(_ref) {
    var {
      newStartDate,
      newEndDate,
      isStartSet: isStartBeingSet
    } = _ref;
    var startDate = newStartDate || this.state.startDate;
    var endDate = newEndDate || this.state.endDate;
    var isStartSet = isStartBeingSet;

    if (isStartBeingSet && startDate && moment(startDate).isAfter(endDate)) {
      endDate = undefined;
    }

    if (!isStartBeingSet && endDate && moment(endDate).isBefore(startDate)) {
      startDate = endDate;
      endDate = undefined;
      isStartSet = true;
    }

    this.setState({
      startDate,
      endDate,
      isStartSet
    }, () => {
      this.props.sendToParent(this.state.startDate, this.state.endDate, this.props.stayLength);
    });
  }

  handleChangeStart(startDate) {
    this.setState({
      isOpen: true
    });
    this.handleChange({
      newStartDate: startDate,
      isStartSet: true
    });
  }

  handleChangeEnd(endDate) {
    if (!this.props.alwaysOpened) {
      this.setState({
        isOpen: false
      });
    }

    this.handleChange({
      newEndDate: endDate,
      isStartSet: false
    });
    this.props.onSelectEndDate();
  }

  render() {
    var {
      className,
      monthsShown,
      hideBorder
    } = this.props;
    var {
      isStartSet,
      startDate,
      endDate,
      isOpen
    } = this.state;
    var popperModifiers = {
      flip: {
        behavior: ["bottom"]
      },
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    };
    var today = new Date();
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GlobalStyle, null), /*#__PURE__*/React__default.createElement(Container$1, {
      className: "wbk-DayRangePicker ".concat(className)
    }, !isStartSet && /*#__PURE__*/React__default.createElement(DatePicker$1__default, {
      ref: elem => {
        this.calendar = elem; // eslint-disable-next-line

        this.calendar && this.calendar.setOpen(isOpen);
      },
      popperPlacement: "bottom",
      customInput: /*#__PURE__*/React__default.createElement(DropDown$1, {
        startDate: startDate,
        endDate: endDate,
        hideBorder: hideBorder
      }),
      fixedHeight: true,
      selectsStart: true,
      selected: startDate,
      startDate: startDate,
      endDate: endDate,
      onChange: this.handleChangeStart,
      monthsShown: monthsShown,
      popperModifiers: popperModifiers,
      minDate: today
    }), isStartSet && /*#__PURE__*/React__default.createElement(DatePicker$1__default, {
      ref: elem => {
        this.calendar = elem; // eslint-disable-next-line

        this.calendar && this.calendar.setOpen(isOpen);
      },
      popperPlacement: "bottom",
      customInput: /*#__PURE__*/React__default.createElement(DropDown$1, {
        startDate: startDate,
        endDate: endDate,
        hideBorder: hideBorder
      }),
      fixedHeight: true,
      openToDate: this.state.startDate,
      selectsEnd: true,
      selected: endDate,
      startDate: startDate,
      endDate: endDate,
      onChange: this.handleChangeEnd,
      monthsShown: monthsShown,
      popperModifiers: popperModifiers,
      minDate: today
    })));
  }

}

DayRangePicker.propTypes = {
  className: PropTypes__default.string,

  /** The component can have different appearances depending on this prop  */
  startDate: PropTypes__default.instanceOf(Date),

  /** The component can have different appearances depending on this prop  */
  endDate: PropTypes__default.instanceOf(Date),

  /** The component can have different appearances depending on this prop  */
  sendToParent: PropTypes__default.func.isRequired,
  monthsShown: PropTypes__default.number,
  startsOpen: PropTypes__default.bool,
  hideBorder: PropTypes__default.bool,
  alwaysOpened: PropTypes__default.bool,
  onSelectEndDate: PropTypes__default.func,
  stayLength: PropTypes__default.number
};
DayRangePicker.defaultProps = {
  className: "",
  startDate: new Date(),
  endDate: new Date(),
  monthsShown: 2,
  startsOpen: false,
  hideBorder: false,
  alwaysOpened: false,
  onSelectEndDate: () => {},
  stayLength: undefined
};
var DayRangePicker$1 = pure(DayRangePicker);

var dropDown = "data:image/svg+xml,%3Csvg%20fill%3D%22%23999%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cpath%20d%3D%22M7%2010l5%205%205-5z%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E";

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 25px;\n  cursor: pointer;\n  height: 30px;\n  width: auto;\n  border-radius: 3px;\n  border: 1px solid #e1e1e1;\n  background: ", " !important;\n  color: #908f96;\n  font-size: 13px;\n  font-weight: 400;\n  background-image: ", ";\n  background-position: right !important;\n  background-repeat: no-repeat !important;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var Select = styled__default.select(_templateObject$6(), props => props.background ? props.background : "#f6f6f6", props => props.image ? "url(".concat(dropDown, ") !important;") : null);

function WitSelect(props) {
  return /*#__PURE__*/React__default.createElement(Select, props);
}

var WitSelect$1 = React__default.memo(WitSelect);

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  button {\n    padding: 5px 30px;\n    background-color: ", ";\n    border-radius: 5px;\n    font-weight: 700;\n    color: ", ";\n    text-transform: uppercase;\n    cursor: pointer;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 250px;\n  background-color: rgba(178, 14, 14, 0.1);\n  text-align: center;\n  padding: 5px 10px;\n  margin-top: 10px;\n  font-size: 13px;\n  border-radius: 3px;\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  @media (min-width: 640px) {\n    display: block;\n    border: 1px #e1e1e1 solid;\n    border-radius: 5px;\n    margin: 3px;\n    margin-top: 15px;\n    background-color: #f6f6f6;\n    padding: 5px 13px;\n  }\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  border: 1px #e1e1e1 solid;\n  border-radius: 5px;\n  margin: 3px;\n  margin-top: 15px;\n  background-color: #f6f6f6;\n  padding: 5px 13px;\n  @media (min-width: 640px) {\n    display: none;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 5px;\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 15px;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: bold;\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 20px 40px;\n  font-size: 13px;\n  align-items: center;\n  margin-top: 35px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 20px 40px;\n  font-size: 13px;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$1 = reactIntl.defineMessages({
  description: {
    id: "agency.modalReport.title",
    description: "Fill in the fields to generate the report",
    defaultMessage: "Fill in the fields to generate the report"
  },
  dateType: {
    id: "agency.modalReport.dateType",
    description: "Date type",
    defaultMessage: "Date type"
  },
  checkInCriteria: {
    id: "agency.modalReport.dateType.checkIn",
    description: "Check in",
    defaultMessage: "Check in"
  },
  checkOutCriteria: {
    id: "agency.modalReport.dateType.checkOut",
    description: "Check out",
    defaultMessage: "Check out"
  },
  bookingCriteria: {
    id: "agency.modalReport.dateType.booking",
    description: "Booking",
    defaultMessage: "Booking"
  },
  emailSend: {
    id: "agency.modalReport.emailSent",
    description: "Se ha enviado un email a su correo electrónico",
    defaultMessage: "Se ha enviado un email con el informe"
  },
  accept: {
    id: "agency.modalReport.accept",
    description: "Accept",
    defaultMessage: "Accept"
  },
  myActivity: {
    id: "agency.modalReport.myActivity",
    description: "My activity",
    defaultMessage: "My activity"
  },
  errorMessage: {
    id: "agency.modalReport.error",
    description: "message when the send report fail",
    defaultMessage: "Operation could not be completed."
  },
  loadingMessage: {
    id: "agency.modalReport.loading",
    description: "Loading",
    defaultMessage: "Loading"
  },
  generateButton: {
    id: "agency.modalReport.generate",
    description: "Generate",
    defaultMessage: "Generate"
  }
});
var Container$2 = styled__default.div(_templateObject$7());
var ContainerSent = styled__default.div(_templateObject2$5());
var FlexRow = styled__default.div(_templateObject3$3());
var Description = styled__default(FlexRow)(_templateObject4$3());
var CriteriaContainer = styled__default(FlexRow)(_templateObject5$2());
var CriteriaSelector = styled__default.div(_templateObject6$1());
var DayRangePickerMobile = styled__default.div(_templateObject7$1());
var DayRangePickerDesktop = styled__default.div(_templateObject8$1());
var ErrorMessage = styled__default.div(_templateObject9(), wbRed);
var StyledButton$1 = styled__default.div(_templateObject10(), wbGreen, white);
var InfoText = styled__default(FlexRow)(_templateObject11(), greyLight);

class AgentsReport extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleChangeCriteria", event => {
      this.setState({
        dateSearchCriteria: event && event.target && event.target.value
      });
    });

    _defineProperty(this, "handleDateChange", (startDate, endDate) => {
      this.setState({
        startDate,
        endDate
      });
    });

    _defineProperty(this, "handleSubmit", () => {
      this.setState({
        loading: true
      });
      this.props.handleSubmit({
        dateSearchCriteria: this.state.dateSearchCriteria,
        startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
        endDate: moment(this.state.endDate).format("YYYY-MM-DD")
      });
    });

    this.state = {
      dateSearchCriteria: "checkIn",
      startDate: new Date(),
      endDate: new Date(),
      reportSend: false,
      loading: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.success && nextProps.success) {
      this.setState({
        reportSend: true
      });
    }
    /** When the component is in standard display and the report isn't sent or is restarted it should stop loading either if the previous attempt didn't succeeded or didn't exist */


    if ((this.props.success === false || this.props.success === null) && (nextProps.success === false || nextProps.success === null)) {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    if (this.state.reportSend || this.props.success) {
      return /*#__PURE__*/React__default.createElement(Popup, {
        headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.myActivity),
        closeWindow: this.props.handleCloseModal
      }, /*#__PURE__*/React__default.createElement(ContainerSent, {
        className: this.props.className
      }, /*#__PURE__*/React__default.createElement(InfoText, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.emailSend))), /*#__PURE__*/React__default.createElement(FlexRow, null, /*#__PURE__*/React__default.createElement(StyledButton$1, null, /*#__PURE__*/React__default.createElement("button", {
        onClick: this.props.handleCloseModal
      }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.accept))))));
    }

    return /*#__PURE__*/React__default.createElement(Popup, {
      headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.myActivity),
      closeWindow: this.props.handleCloseModal
    }, /*#__PURE__*/React__default.createElement(Container$2, {
      className: this.props.className
    }, /*#__PURE__*/React__default.createElement(Description, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.description)), /*#__PURE__*/React__default.createElement(CriteriaContainer, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.dateType), ":"), /*#__PURE__*/React__default.createElement(CriteriaSelector, null, /*#__PURE__*/React__default.createElement(WitSelect$1, {
      onChange: this.handleChangeCriteria,
      image: true
    }, /*#__PURE__*/React__default.createElement("option", {
      value: "checkIn"
    }, this.props.intl.formatMessage(msgs$1.checkInCriteria)), /*#__PURE__*/React__default.createElement("option", {
      value: "checkOut"
    }, this.props.intl.formatMessage(msgs$1.checkOutCriteria)), /*#__PURE__*/React__default.createElement("option", {
      value: "booking"
    }, this.props.intl.formatMessage(msgs$1.bookingCriteria))))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DayRangePickerMobile, null, /*#__PURE__*/React__default.createElement(DayRangePicker$1, {
      sendToParent: this.handleDateChange,
      monthsShown: 1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startsOpen: true,
      hideBorder: true
    })), /*#__PURE__*/React__default.createElement(DayRangePickerDesktop, null, /*#__PURE__*/React__default.createElement(DayRangePicker$1, {
      sendToParent: this.handleDateChange,
      monthsShown: 2,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startsOpen: true,
      hideBorder: true
    }))), /*#__PURE__*/React__default.createElement(FlexRow, null, /*#__PURE__*/React__default.createElement(StyledButton$1, null, !this.state.loading && /*#__PURE__*/React__default.createElement("button", {
      onClick: this.handleSubmit
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.generateButton)), this.state.loading && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.loadingMessage))), this.props.success === false && this.state.loading !== true && /*#__PURE__*/React__default.createElement(ErrorMessage, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$1.errorMessage))));
  }

}

AgentsReport.defaultProps = {
  success: null,
  className: "",
  handleSubmit: () => null,
  handleCloseModal: () => null
};
AgentsReport.propTypes = {
  className: PropTypes__default.string,
  success: PropTypes__default.bool,
  handleSubmit: PropTypes__default.func,
  handleCloseModal: PropTypes__default.func
};
var index$1 = reactIntl.injectIntl(React__default.memo(AgentsReport));

var Menu = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
})), "Menu");

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    width: 24px;\n    svg {\n      margin-top: -3px;\n    }\n    &:hover {\n      svg {\n        margin-top: -3px;\n      }\n    }\n  "]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var CustomSelect = (_ref) => {
  var {
    options,
    defaultValue,
    handleChange,
    valueName,
    labelName,
    placeholder = "Select",
    className = "basic-single",
    classNamePrefix = "select",
    isDisabled = false,
    isLoading = false,
    isClearable = false,
    isSearchable = true,
    textNoOptions = "No options"
  } = _ref;
  var [data, setData] = React.useState([]);
  var [defValue, setDefValue] = React.useState();
  React.useEffect(() => {
    var newData = options.map(option => {
      return {
        label: option[labelName],
        value: option[valueName]
      };
    });
    setData(newData);
  }, []);
  React.useEffect(() => {
    if (defaultValue && data.length > 0) {
      var value = data.find(itemData => itemData.value === defaultValue[valueName]);

      if (value) {
        setDefValue(value);
      }
    }
  }, [data, defaultValue]);
  var onHandleChange = React.useCallback(value => {
    handleChange(value);
  }, [handleChange]);
  var customStyles = {
    control: provided => Object.assign(Object.assign({}, provided), {
      background: "transparent",
      height: 33,
      minHeight: 33,
      border: 0,
      boxShadow: "none",
      "&:hover": {
        border: 0,
        svg: {
          color: "rgba(0,0,0,1)"
        }
      }
    }),
    valueContainer: provided => Object.assign(Object.assign({}, provided), {
      paddingBottom: "4px"
    }),
    menu: provided => Object.assign(Object.assign({}, provided), {
      zIndex: 999
    }),
    menuList: provided => Object.assign(Object.assign({}, provided), {
      "::-webkit-scrollbar": {
        width: "4px"
      },
      "::-webkit-scrollbar-track": {
        background: "transparent"
      },
      "::-webkit-scrollbar-thumb": {
        background: "gray",
        borderRadius: "8px"
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "gray"
      }
    }),
    option: (provided, state) => Object.assign(Object.assign({}, provided), {
      padding: "4px 12px",
      color: "black !important",
      background: state.isFocused ? "#DDF9FF" : "transparent",
      "&:hover": {
        backgroundColor: "#DDF9FF"
      }
    })
  };
  var DivArrow = styled__default.div(_templateObject$8());

  var DropdownIndicator = props => {
    return /*#__PURE__*/React__default.createElement(Select$3.components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(DivArrow, null, /*#__PURE__*/React__default.createElement(ArrowDropDown, null)));
  };

  return /*#__PURE__*/React__default.createElement(Select$3__default, {
    value: defValue,
    className: className,
    classNamePrefix: classNamePrefix,
    options: data,
    isDisabled: isDisabled,
    isLoading: isLoading,
    isClearable: isClearable,
    isSearchable: isSearchable,
    onChange: value => onHandleChange(value),
    placeholder: placeholder,
    styles: customStyles,
    components: {
      IndicatorSeparator: () => null,
      DropdownIndicator
    },
    noOptionsMessage: () => textNoOptions
  });
};

var GPSNotFixed = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), "GPSNotFixed");

var promoCodes = PropTypes__default.string;
var textNoOptions = PropTypes__default.string;
var roomDenomination = PropTypes__default.oneOf([constants.ROOM_DENOMINATION.UNITS, constants.ROOM_DENOMINATION.ROOMS, constants.ROOM_DENOMINATION.APARTMENTS, constants.ROOM_DENOMINATION.BUNGALOWS, constants.ROOM_DENOMINATION.CABINS, constants.ROOM_DENOMINATION.SHIP_CABIN, constants.ROOM_DENOMINATION.HOUSES, constants.ROOM_DENOMINATION.VILLAS, constants.ROOM_DENOMINATION.BEDS]);
var deviceType = PropTypes__default.oneOf([constants.DEVICE_TYPE.MOBILE, constants.DEVICE_TYPE.DESKTOP]);
var hotelSiteURL = PropTypes__default.string;
var showMenuOption = PropTypes__default.bool;
var onPromoCodeChanged = PropTypes__default.func;
var onSearchButtonClicked = PropTypes__default.func;
var onMenuClicked = PropTypes__default.func;
var resolution = PropTypes__default.oneOf([constants.RESOLUTION.XXS, constants.RESOLUTION.XS, constants.RESOLUTION.SM, constants.RESOLUTION.MD, constants.RESOLUTION.LG]);
var onSendSearchValue = PropTypes__default.func; // Logo

var logoSrc = PropTypes__default.string; // Filter

var filterData = PropTypes__default.shape({
  filterTicker: PropTypes__default.string,
  filterName: PropTypes__default.string,
  representation: PropTypes__default.oneOf([constants.FILTER.REPRESENTATION.DROPDOWN]),
  position: PropTypes__default.number,
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    optionTicker: PropTypes__default.string,
    optionName: PropTypes__default.string,
    pattern: PropTypes__default.string,
    type: PropTypes__default.oneOf([constants.FILTER.TYPE.URL, constants.FILTER.TYPE.ESTABLISHMENT, constants.FILTER.TYPE.INVENTORY]),
    position: PropTypes__default.number,
    active: PropTypes__default.bool
  }))
}).isRequired;
var selectedFilterValue = PropTypes__default.shape({
  optionTicker: PropTypes__default.string,
  optionName: PropTypes__default.string,
  pattern: PropTypes__default.string,
  type: PropTypes__default.oneOf([constants.FILTER.TYPE.URL, constants.FILTER.TYPE.ESTABLISHMENT, constants.FILTER.TYPE.INVENTORY]),
  position: PropTypes__default.number,
  active: PropTypes__default.bool
});
var showFilter = PropTypes__default.bool;
var onFilterChanged = PropTypes__default.func;
var ageRanges = PropTypes__default.object;
var onOccupantsChanged = PropTypes__default.func;
Object.typedKeys = Object.keys;
var occupantInfo = PropTypes__default.object;
var selectorMode = PropTypes__default.oneOf([constants.OCCUPANTS_FILTER_TYPE.AGE, constants.OCCUPANTS_FILTER_TYPE.OCCUPANTS_TYPE, constants.OCCUPANTS_FILTER_TYPE.NONE]);
var onChangeOccupantInfo = PropTypes__default.func;
var occupantType = PropTypes__default.oneOf([constants.OCCUPANTS_TYPE.ADULT, constants.OCCUPANTS_TYPE.TEENAGER, constants.OCCUPANTS_TYPE.CHILDREN, constants.OCCUPANTS_TYPE.BABY]);
var onAddRoom = PropTypes__default.func;
var onDeleteRoom = PropTypes__default.func;
var showMultipleAccommodations = PropTypes__default.bool; // DatePicker

var selectedStartDate = PropTypes__default.instanceOf(Date);
var selectedEndDate = PropTypes__default.instanceOf(Date);
var onDatesChanged = PropTypes__default.func;
var minDate = PropTypes__default.instanceOf(Date);
var locale = PropTypes__default.string;
var allowGoBackStartDate = PropTypes__default.bool;
var allowGoBackEndDate = PropTypes__default.bool;
var dates = PropTypes__default.shape({
  startDate: PropTypes__default.instanceOf(Date),
  endDate: PropTypes__default.instanceOf(Date)
});
var resetRange = PropTypes__default.bool;
var onResetRange = PropTypes__default.func; // External Menu

var onOpenExternalMenu = PropTypes__default.func;

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  border-bottom: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  svg {\n    fill: ", ";\n    opacity: 0.5;\n    width: 23px;\n    margin-right: 15px;\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  left: 30px;\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0px;\n  transform: translateX(-4%);\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  color: ", " !important;\n  height: 100%;\n  padding: 0;\n  width: 100%;\n  margin-left: ", ";\n\n  .basic-single {\n    .select__control {\n      .select__value-container {\n        .select__single-value {\n          color: ", ";\n        }\n        .select__input-container {\n          margin-top: 0px;\n          color: ", ";\n          &:hover {\n            color: ", ";\n          }\n        }\n      }\n      &:hover {\n        .select__indicators > .select__indicator > div > svg {\n          fill: ", ";\n          color: ", ";\n        }\n      }\n      .select__indicators {\n        .select__indicator > div > svg {\n          fill: ", ";\n        }\n        &:hover {\n          div > svg {\n            fill: ", ";\n            color: ", ";\n          }\n        }\n      }\n    }\n    .select__menu {\n      border-radius: 0px;\n      .select__menu-list > .select__menu-notice {\n        color: black;\n      }\n    }\n  }\n\n  select {\n    background: initial !important;\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  .svg {\n    fill: ", ";\n    pointer-events: none;\n    width: 24px;\n    height: 100%;\n    position: absolute;\n  }\n  &:hover {\n    div,\n    .svg {\n      fill: ", ";\n      color: ", ";\n    }\n    select {\n      border-color: ", ";\n    }\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var InputFilterDiv = styled__default.div(_templateObject$9(), props => props.theme[props.deviceType].svg.fill, props => props.theme[props.deviceType].filter.hover.fill, props => props.theme[props.deviceType].filter.hover.color, props => props.theme[props.deviceType].filter.hover.color);
var DivSelect = styled__default.div(_templateObject2$6(), props => props.theme[props.deviceType].datePicker.color, props => props.marginLeft, props => props.theme[props.deviceType].datePicker.color, props => props.theme[props.deviceType].datePicker.color, props => props.theme[props.deviceType].datePicker.color, props => props.theme[props.deviceType].filter.hover.fill, props => props.theme[props.deviceType].filter.hover.color, props => props.theme[props.deviceType].svg.fill, props => props.theme[props.deviceType].filter.hover.fill, props => props.theme[props.deviceType].filter.hover.color, props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "35px" : "10px", props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "20px" : "0");
var IconGPSNotFixed = styled__default(GPSNotFixed)(_templateObject3$4());
var IconGPSMobile = styled__default(GPSNotFixed)(_templateObject4$4());
var DivIconMobile = styled__default.div(_templateObject5$3(), props => props.theme[props.deviceType].svg.fill);
var DivFilter = styled__default.div(_templateObject6$2(), props => props.display, props => props.theme[props.deviceType].datePicker.borderBottom, props => props.theme.hover.color);

function Filter(_ref) {
  var {
    filterData = {},
    selectedFilterValue,
    deviceType,
    textNoOptions
  } = _ref,
      props = _objectWithoutProperties(_ref, ["filterData", "selectedFilterValue", "deviceType", "textNoOptions"]);

  var {
    representation
  } = filterData;
  var customStyles = React.useMemo(() => {
    var styles = {};

    if (deviceType === constants.DEVICE_TYPE.MOBILE) {
      styles = {
        display: "flex",
        marginLeft: "0px",
        paddingSVG: "0 10px 0 0"
      };
    } else {
      styles = {
        display: "block",
        marginLeft: "30px",
        paddingSVG: "10px 0"
      };
    }

    return styles;
  }, [deviceType]);

  var onFilterChanged = selectedValue => {
    var selectedFilterValue = filterData.options.find(f => f.optionTicker === selectedValue.value);

    if (selectedFilterValue) {
      props.onFilterChanged(selectedFilterValue);
    }
  };

  switch (representation) {
    case constants.FILTER.REPRESENTATION.DROPDOWN:
      return /*#__PURE__*/React__default.createElement(DivFilter, {
        display: customStyles.display,
        deviceType: deviceType
      }, deviceType === constants.DEVICE_TYPE.MOBILE && /*#__PURE__*/React__default.createElement(DivIconMobile, {
        deviceType: deviceType
      }, /*#__PURE__*/React__default.createElement(IconGPSMobile, null)), /*#__PURE__*/React__default.createElement(InputFilterDiv, {
        deviceType: deviceType
      }, deviceType !== constants.DEVICE_TYPE.MOBILE && /*#__PURE__*/React__default.createElement(IconGPSNotFixed, {
        className: "svg"
      }), /*#__PURE__*/React__default.createElement(DivSelect, {
        marginLeft: customStyles.marginLeft,
        deviceType: deviceType
      }, /*#__PURE__*/React__default.createElement(CustomSelect, {
        textNoOptions: textNoOptions,
        handleChange: onFilterChanged,
        options: filterData.options,
        labelName: "optionName",
        valueName: "optionTicker",
        defaultValue: selectedFilterValue
      }))));

    default:
      return /*#__PURE__*/React__default.createElement(React.Fragment, null);
  }
}

Filter.propTypes = {
  filterData,
  selectedFilterValue,
  onFilterChanged,
  deviceType
};

var SvgOccupant = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm10 8s-1.18.44-2 2c-.19.37 0 2 0 2H0v-2c0-2.66 5.33-4 8-4s3.75 0 6 2zm1.5-3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm7.5 6.25V16H13v-1c.48-1.8 3.33-2.75 5-2.75s5 .84 5 2.5z"
})), "Occupant");

var ArrowDropUp = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7 14l5-5 5 5z"
})), "ArrowDropUp");

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  text-transform: uppercase;\n  font-weight: 400;\n  color: #908f96;\n  border-radius: ", ";\n  border: 1px solid #908f96;\n  cursor: pointer;\n  padding: 10px 15px;\n  outline: none;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var DivButton = styled__default.div(_templateObject$a());
var ButtonAdd = styled__default.button(_templateObject2$7(), props => props.theme.fontFamily, props => props.theme[props.deviceType].fontSize, props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "3px" : "5px");

function ButtonAddRoom(_ref) {
  var {
    resolution,
    deviceType,
    roomDenomination,
    onAddRoom
  } = _ref;
  var messages = reactIntl.defineMessages({
    add: {
      id: "bookingForm.occuppants.add",
      description: "Add message",
      defaultMessage: "Add"
    },
    UNITS: {
      id: "inventory.roomDenomination.units.singular",
      description: "Room denomination for inventory",
      defaultMessage: "unit"
    },
    ROOMS: {
      id: "inventory.roomDenomination.rooms.singular",
      description: "Room denomination for inventory",
      defaultMessage: "room"
    },
    APARTMENTS: {
      id: "inventory.roomDenomination.apartments.singular",
      description: "Room denomination for inventory",
      defaultMessage: "apartment"
    },
    BUNGALOWS: {
      id: "inventory.roomDenomination.bungalows.singular",
      description: "Room denomination for inventory",
      defaultMessage: "bungalow"
    },
    CABINS: {
      id: "inventory.roomDenomination.cabins.singular",
      description: "Room denomination for inventory",
      defaultMessage: "cabin"
    },
    HOUSES: {
      id: "inventory.roomDenomination.houses.singular",
      description: "Room denomination for inventory",
      defaultMessage: "house"
    },
    SHIP_CABIN: {
      id: "inventory.roomDenomination.ship_cabins.singular",
      description: "Room denomination for inventory",
      defaultMessage: "cabin"
    },
    VILLAS: {
      id: "inventory.roomDenomination.villas.singular",
      description: "Room denomination for inventory",
      defaultMessage: "villa"
    },
    BEDS: {
      id: "inventory.roomDenomination.beds.singular",
      description: "Room denomination for inventory",
      defaultMessage: "bed"
    }
  });
  return /*#__PURE__*/React__default.createElement(DivButton, {
    deviceType: deviceType,
    resolution: resolution
  }, /*#__PURE__*/React__default.createElement(ButtonAdd, {
    deviceType: deviceType,
    onClick: onAddRoom
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.add), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages[roomDenomination]))));
}

var SvgBaby = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
})), "BabyCarriage");

var SvgAdults = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "Adults");

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  background: none #f9f9f9 !important;\n  color: #000;\n  text-align: center;\n  text-align-last: center;\n  width: 35px;\n  min-width: 35px;\n  height: 35px;\n  padding: 0 8px;\n  border-bottom: 1px solid #e1e1e1;\n  background: none #f9f9f9;\n  border: 1px solid hsla(0, 0%, 49%, 0.3);\n  color: #000;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  span {\n    font-size: 9px;\n    color: #7e7e7e;\n  }\n  display: flex;\n  flex-direction: column;\n  margin-right: 5px;\n  text-align: center;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  color: ", ";\n  padding: 0 10px 0 0;\n  display: flex;\n  align-items: flex-end;\n  svg {\n    fill: #7e7e7e;\n    background-repeat: no-repeat;\n    width: 28px;\n  }\n  appearance: initial;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var DivSelector = styled__default.div(_templateObject$b(), props => props.theme.colorOpposite);
var DivLogoAge = styled__default.div(_templateObject2$8());
var CustomSelect$1 = styled__default.select(_templateObject3$5());

function Selector(_ref) {
  var {
    occupantType,
    index,
    min,
    max,
    value,
    showAgeRanges,
    showIcon,
    ageRanges,
    onChangedSelectedValue
  } = _ref;
  var values = React.useMemo(() => {
    var values = [];

    for (var i = min; i <= max; i++) {
      values.push(i);
    }

    return values;
  }, [min, max]);

  function getIcon() {
    switch (occupantType) {
      case constants.OCCUPANTS_TYPE.ADULT:
        return /*#__PURE__*/React__default.createElement(SvgAdults, null);

      case constants.OCCUPANTS_TYPE.TEENAGER:
        return /*#__PURE__*/React__default.createElement(SvgAdults, null);

      case constants.OCCUPANTS_TYPE.CHILDREN:
        return /*#__PURE__*/React__default.createElement(SvgAdults, null);

      case constants.OCCUPANTS_TYPE.BABY:
        return /*#__PURE__*/React__default.createElement(SvgBaby, null);

      default:
        return /*#__PURE__*/React__default.createElement(React.Fragment, null);
    }
  }

  return /*#__PURE__*/React__default.createElement(DivSelector, {
    className: "".concat(index && "container-occupant")
  }, showIcon && (showAgeRanges && ageRanges ? /*#__PURE__*/React__default.createElement(DivLogoAge, null, /*#__PURE__*/React__default.createElement("span", null, ageRanges.max === 999 ? "+".concat(ageRanges.min) : "".concat(ageRanges.min, "-").concat(ageRanges.max)), getIcon()) : getIcon()), /*#__PURE__*/React__default.createElement(CustomSelect$1, {
    onChange: event => onChangedSelectedValue(event),
    value: value
  }, values.map(v => {
    return /*#__PURE__*/React__default.createElement("option", {
      key: v
    }, v);
  })));
}

var SVGTrashCan = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "TrashCan");

function calculateOccupantsTotal(occupantInfo) {
  var occupantTotal = Object.typedKeys(occupantInfo).reduce((sum, room) => {
    var occupantsByRoom = occupantInfo[room];
    Object.typedKeys(occupantsByRoom).forEach(occupantType => {
      var occupant = occupantsByRoom[occupantType];
      sum = sum + (occupant.value || 0);
    });
    return sum;
  }, 0);
  return occupantTotal;
}
function recalculateRoomNumber(ocupants) {
  var roomNumber = 1;
  var result = Object.typedKeys(ocupants).reduce((newOccupants, keyOccupant) => {
    return Object.assign(Object.assign({}, newOccupants), {
      [roomNumber++]: Object.assign({}, ocupants[keyOccupant])
    });
  }, {});
  return result;
}
function showSelectorAges(_ref) {
  var {
    occupant
  } = _ref;

  var _a;

  var newOccupant = Object.assign({}, occupant);
  var init = newOccupant && ((_a = newOccupant.ageRanges) === null || _a === void 0 ? void 0 : _a.min) || 0;
  var guestAges = newOccupant.guestAges || [];

  if (newOccupant.ageRanges && newOccupant.guestAges) {
    if (newOccupant.guestAges.length > newOccupant.value) {
      newOccupant.guestAges = newOccupant.guestAges.slice(0, newOccupant.value);
    } else if (newOccupant.guestAges.length < newOccupant.value) {
      newOccupant.guestAges = completeAges({
        init,
        end: newOccupant.value,
        guestAges
      });
    }
  } else if (newOccupant.guestAges) {
    guestAges = [];
    newOccupant.guestAges = completeAges({
      init,
      end: newOccupant.value,
      guestAges
    });
  }

  return newOccupant;
}
function updateAgeRanges(_ref2) {
  var {
    occupants,
    selectorMode
  } = _ref2;
  var result = Object.assign({}, occupants);

  if (selectorMode === constants.OCCUPANTS_FILTER_TYPE.AGE) {
    result = Object.typedKeys(occupants).reduce((result, room) => {
      var occupantsByRoom = occupants[room];
      Object.typedKeys(occupantsByRoom).forEach(occupantType => {
        var occupant = occupantsByRoom[occupantType];

        if (occupant.ageRanges) {
          var newOccupant = showSelectorAges({
            occupant
          });
          result = Object.assign(Object.assign({}, result), {
            [room]: Object.assign(Object.assign({}, occupantsByRoom), {
              [occupantType]: Object.assign({}, newOccupant)
            })
          });
        }
      });
      return result;
    }, {});
  }

  return result;
}

function completeAges(_ref3) {
  var {
    init,
    end,
    guestAges
  } = _ref3;

  for (var age = init; age < init + end; age++) {
    guestAges.push(init);
  }

  return guestAges;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 10px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ", ";\n  color: #908f96;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 0;\n  &:first-letter {\n    text-transform: uppercase;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n"]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n  color: #3a3a3a;\n  font-weight: 700;\n  font-size: ", ";\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteral(["\n  text-align: ", ";\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral(["\n  color: #908f96;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: 400;\n  text-transform: capitalize;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  justify-content: ", ";\n  border-bottom: ", ";\n  padding: 10px 0;\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  fill: #908f96;\n  cursor: pointer;\n  transform: translateY(8%);\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  display: flex;\n  align-items: flex-end;\n  margin-left: 20px;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  width: 100%;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n  .container-occupant {\n    margin-left: ", ";\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var DivMain = styled__default.div(_templateObject$c(), props => props.theme.fontFamily, props => props.theme[props.deviceType].fontSize);
var DivRoom = styled__default.div(_templateObject2$9());
var DivOccupants = styled__default.div(_templateObject3$6(), props => props.showMultipleAccommodations ? "normal" : "center", props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "20px" : "0");
var SpanRoom = styled__default.span(_templateObject4$5(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "normal" : "space-between");
var SpanTrashIcon = styled__default.span(_templateObject5$4());
var TrashCanIcon = styled__default(SVGTrashCan)(_templateObject6$3());
var ContainerRoom = styled__default.div(_templateObject7$2(), props => props.showMultipleAccommodations ? "block" : "flex", props => props.justifyContent, props => props.showMultipleAccommodations ? "1px solid #e1e1e1" : "none");
var SpanRoomName = styled__default.span(_templateObject8$2(), props => props.theme.fontFamily, props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "14px" : "10px");
var DivTitle = styled__default.div(_templateObject9$1(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "center" : "inherit");
var SpanTitleGuests = styled__default.span(_templateObject10$1(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "16px" : "12px");
var ContainerAges = styled__default.div(_templateObject11$1(), props => props.alignItems);
var SelectorAges = styled__default.div(_templateObject12());
var DivTitleAges = styled__default.div(_templateObject13());
var SpanTitleAges = styled__default.span(_templateObject14(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "14px" : "10px");
var DivRoomName = styled__default.div(_templateObject15());
var messages = reactIntl.defineMessages({
  guests: {
    id: "booking_form.occupants_list.guestsPerRoom",
    description: "Guests per accommodation",
    defaultMessage: "Guests per accommodation"
  },
  ages: {
    id: "booking_form.ageSelector.childrenAges.description",
    description: "age of children",
    defaultMessage: "Age of children"
  },
  UNITS: {
    id: "inventory.roomDenomination.units.singular",
    description: "Room denomination for inventory",
    defaultMessage: "unit"
  },
  ROOMS: {
    id: "inventory.roomDenomination.rooms.singular",
    description: "Room denomination for inventory",
    defaultMessage: "room"
  },
  APARTMENTS: {
    id: "inventory.roomDenomination.apartments.singular",
    description: "Room denomination for inventory",
    defaultMessage: "apartment"
  },
  BUNGALOWS: {
    id: "inventory.roomDenomination.bungalows.singular",
    description: "Room denomination for inventory",
    defaultMessage: "bungalow"
  },
  CABINS: {
    id: "inventory.roomDenomination.cabins.singular",
    description: "Room denomination for inventory",
    defaultMessage: "cabin"
  },
  HOUSES: {
    id: "inventory.roomDenomination.houses.singular",
    description: "Room denomination for inventory",
    defaultMessage: "house"
  },
  SHIP_CABIN: {
    id: "inventory.roomDenomination.ship_cabins.singular",
    description: "Room denomination for inventory",
    defaultMessage: "cabin"
  },
  VILLAS: {
    id: "inventory.roomDenomination.villas.singular",
    description: "Room denomination for inventory",
    defaultMessage: "villa"
  },
  BEDS: {
    id: "inventory.roomDenomination.beds.singular",
    description: "Room denomination for inventory",
    defaultMessage: "bed"
  }
});

function OccupantSummary(_ref) {
  var {
    deviceType,
    occupantInfo,
    onDeleteRoom,
    onOccupantsChanged,
    roomDenomination,
    selectorMode,
    showMultipleAccommodations
  } = _ref;

  function handleChangeOcuppant(e, roomNumber, occupantType) {
    e.preventDefault();
    var value = parseInt(e.currentTarget.value) || 0;
    var actualOccupant = showSelectorAges({
      occupant: Object.assign(Object.assign({}, occupantInfo[roomNumber][occupantType]), {
        value
      })
    });
    var newOccupants = Object.assign(Object.assign({}, occupantInfo), {
      [roomNumber]: Object.assign(Object.assign({}, occupantInfo[roomNumber]), {
        [occupantType]: Object.assign({}, actualOccupant)
      })
    });
    onOccupantsChanged(newOccupants);
  }

  function handleChangeAgesType(e, indexAge, roomNumber, occupantType) {
    e.preventDefault();
    var actualOccupant = occupantInfo[roomNumber][occupantType];
    var age = parseInt(e.currentTarget.value) || 0;

    if (actualOccupant.guestAges) {
      actualOccupant.guestAges[indexAge] = age;
      var newOccupants = Object.assign(Object.assign({}, occupantInfo), {
        [roomNumber]: Object.assign(Object.assign({}, occupantInfo[roomNumber]), {
          [occupantType]: Object.assign(Object.assign({}, occupantInfo[roomNumber][occupantType]), {
            guestAges: actualOccupant.guestAges
          })
        })
      });
      onOccupantsChanged(newOccupants);
    }
  }

  return /*#__PURE__*/React__default.createElement(DivMain, {
    deviceType: deviceType
  }, /*#__PURE__*/React__default.createElement(DivTitle, {
    deviceType: deviceType
  }, /*#__PURE__*/React__default.createElement(SpanTitleGuests, {
    deviceType: deviceType
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.guests))), /*#__PURE__*/React__default.createElement("div", null, Object.typedKeys(occupantInfo).map((room, indexRoom) => {
    var occupantsByRoom = occupantInfo[room];
    var totalOccupantsByRoom = Object.typedKeys(occupantsByRoom).length;
    var justifyContent = showMultipleAccommodations ? "normal" : "center";

    if (showMultipleAccommodations && totalOccupantsByRoom > 1) {
      justifyContent = "flex-start";
    }

    var alignItemsAges = showMultipleAccommodations ? "flex-start" : "center";
    return /*#__PURE__*/React__default.createElement(ContainerRoom, {
      deviceType: deviceType,
      justifyContent: justifyContent,
      showMultipleAccommodations: showMultipleAccommodations,
      key: "room-".concat(room)
    }, showMultipleAccommodations && /*#__PURE__*/React__default.createElement(DivRoomName, null, /*#__PURE__*/React__default.createElement(SpanRoomName, {
      deviceType: deviceType
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages[roomDenomination]), " ", room), deviceType === constants.DEVICE_TYPE.DESKTOP && /*#__PURE__*/React__default.createElement(SpanTrashIcon, null, indexRoom > 0 && /*#__PURE__*/React__default.createElement(TrashCanIcon, {
      onClick: e => onDeleteRoom(e, room)
    }))), /*#__PURE__*/React__default.createElement(DivRoom, null, /*#__PURE__*/React__default.createElement(DivOccupants, {
      deviceType: deviceType
    }, /*#__PURE__*/React__default.createElement(SpanRoom, {
      deviceType: deviceType
    }, Object.typedKeys(occupantsByRoom).map((occupantType, indexOccupant) => {
      var occupant = occupantsByRoom[occupantType];
      return /*#__PURE__*/React__default.createElement(Selector, {
        ageRanges: occupant.ageRanges,
        index: indexOccupant,
        key: "occupant-".concat(indexOccupant),
        min: occupant.minValue,
        max: occupant.maxValue,
        showAgeRanges: true,
        value: occupant.value,
        occupantType: occupant.occupantType,
        onChangedSelectedValue: e => handleChangeOcuppant(e, room, occupantType),
        showIcon: true
      });
    })), deviceType !== constants.DEVICE_TYPE.DESKTOP && showMultipleAccommodations && /*#__PURE__*/React__default.createElement(SpanTrashIcon, null, indexRoom > 0 && /*#__PURE__*/React__default.createElement(TrashCanIcon, {
      onClick: e => onDeleteRoom(e, room)
    }))), selectorMode === constants.OCCUPANTS_FILTER_TYPE.AGE && Object.typedKeys(occupantsByRoom).map((occupantType, indexOccupant) => {
      var occupant = occupantsByRoom[occupantType];

      if (occupant.guestAges && occupant.guestAges.length) {
        return /*#__PURE__*/React__default.createElement(ContainerAges, {
          deviceType: deviceType,
          alignItems: alignItemsAges,
          key: "ageByOccupant-".concat(indexOccupant)
        }, /*#__PURE__*/React__default.createElement(DivTitleAges, {
          deviceType: deviceType
        }, /*#__PURE__*/React__default.createElement(SpanTitleAges, {
          deviceType: deviceType
        }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.ages))), /*#__PURE__*/React__default.createElement(SelectorAges, null, occupant.guestAges.map((age, indexAge) => {
          var {
            min = 0,
            max = 0
          } = occupant.ageRanges || {};
          return /*#__PURE__*/React__default.createElement(Selector, {
            key: "age-".concat(indexAge),
            ageRanges: occupant.ageRanges,
            min: min,
            max: max,
            occupantType: occupant.occupantType,
            showAgeRanges: false,
            showIcon: false,
            value: age,
            onChangedSelectedValue: e => handleChangeAgesType(e, indexAge, room, occupantType)
          });
        })));
      }

      return null;
    })));
  })));
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 0px;\n  height: 0px;\n  top: -1px;\n  border-color: transparent transparent #e1e1e1;\n  border-top-color: #ffffff;\n  border-style: solid;\n  margin-top: -8px;\n  border-width: 0px 8px 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  &:after {\n    content: \" \";\n    position: absolute;\n    top: 2px;\n    width: 0;\n    height: 0;\n    left: -9px;\n    border-left: 9px solid transparent;\n    border-right: 9px solid transparent;\n    border-bottom: 9px solid #fff;\n    z-index: 4;\n  }\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  max-height: 400px;\n  overflow-y: auto;\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  max-height: 500px;\n  height: auto;\n  z-index: 2000;\n  top: 44px;\n  transform: translateX(-50%);\n  position: absolute;\n  background-color: #fff;\n  border: 1px solid #e1e1e1;\n  margin-left: 40px;\n  min-width: ", ";\n  padding: 20px;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var FloatingMenuContainer = styled__default.div(_templateObject$d(), props => props.theme.floatingMenu.minWidth);
var DivFloatingMenu = styled__default.div(_templateObject2$a());
var FloatingMenuArrow = styled__default.div(_templateObject3$7());
var DivButtons = styled__default.div(_templateObject4$6());

function FloatingMenu(_ref) {
  var {
    children,
    menuReference,
    scrollReference,
    showMenu,
    resolution,
    buttons
  } = _ref;
  React.useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "visible";
    };
  }, [showMenu]);

  if (showMenu) {
    return /*#__PURE__*/React__default.createElement(FloatingMenuContainer, {
      ref: menuReference,
      id: "floating-menu",
      resolution: resolution
    }, /*#__PURE__*/React__default.createElement(DivFloatingMenu, {
      ref: scrollReference
    }, /*#__PURE__*/React__default.createElement(FloatingMenuArrow, null), children), /*#__PURE__*/React__default.createElement(DivButtons, null, buttons));
  }

  return /*#__PURE__*/React__default.createElement(React.Fragment, null);
}

FloatingMenu.propTypes = {
  buttons: PropTypes__default.node,
  children: PropTypes__default.node,
  childRef: PropTypes__default.any,
  closeMenu: PropTypes__default.func,
  showMenu: PropTypes__default.bool
};

function _templateObject7$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 24px;\n  svg {\n    transform: translateX(-15%);\n  }\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 3px;\n  padding: 10px 30px;\n  background-color: #329911;\n  color: #fff;\n  font-size: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  border: 0;\n  box-shadow: none;\n  margin-left: 10px;\n  cursor: pointer;\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: ", ";\n  overflow-y: hidden;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n  width: 25px;\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: -10px;\n  width: 25px;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  position: relative;\n  font-size: 14px;\n  height: 100%;\n  padding: 0 12px;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  height: 33px;\n  border-bottom: ", ";\n  border-radius: 0px;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 70px;\n  cursor: pointer;\n  svg {\n    fill: ", ";\n    pointer-events: none;\n    width: inherit;\n  }\n  font-size: ", ";\n  &:hover {\n    svg {\n      fill: ", ";\n      color: ", ";\n    }\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var InputOccupantDiv = styled__default.div(_templateObject$e(), props => props.theme[constants.DEVICE_TYPE.DESKTOP].occupant.borderBottom, props => props.theme.colorOpposite, props => props.theme[constants.DEVICE_TYPE.DESKTOP].svg.fill, props => props.theme[constants.DEVICE_TYPE.DESKTOP].fontSize, props => props.theme.hover.fill, props => props.theme.hover.color, props => props.theme.hover.color);
var TotalDiv = styled__default.div(_templateObject2$b());
var DivOccupantSVG = styled__default.div(_templateObject3$8());
var OccupantSVG = styled__default(SvgOccupant)(_templateObject4$7());
var DivButtons$1 = styled__default.div(_templateObject5$5(), props => props.showMultipleAccommodations ? "20px" : "10px");
var ButtonApply = styled__default.button(_templateObject6$4(), props => props.theme[props.deviceType].fontSize);
var DivArrow = styled__default.div(_templateObject7$3());

function OccupantForm(_ref) {
  var {
    occupantInfo,
    onAddRoom,
    onDeleteRoom,
    onOccupantsChanged,
    sendOccupants,
    resolution,
    roomDenomination,
    selectorMode,
    showMultipleAccommodations
  } = _ref;
  var [occupantTotal, setOccupantTotal] = React.useState(0);
  var [showMenuOccupants, setShowMenuOccupants] = React.useState(false);
  var menuRef = React.useRef(null);
  var scrollRef = React.useRef(null);
  React.useEffect(() => {
    var occupantTotal = calculateOccupantsTotal(occupantInfo);
    setOccupantTotal(occupantTotal);
  }, [occupantInfo]);
  var handleClick = React.useCallback(e => {
    if (menuRef.current && menuRef.current.contains(e.target) || e.target.id === "arrow") {
      return;
    }

    setShowMenuOccupants(!showMenuOccupants);
  }, [showMenuOccupants]);
  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
    }
  }, [occupantInfo]);
  React.useEffect(() => {
    if (showMenuOccupants) {
      document.addEventListener("mousedown", handleClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [showMenuOccupants, handleClick]);
  var messages = reactIntl.defineMessages({
    apply: {
      id: "booking_form.occupants_list.apply",
      description: "Apply",
      defaultMessage: "Apply"
    }
  });

  function handleMenu(e) {
    e && e.preventDefault();
    setShowMenuOccupants(!showMenuOccupants);
  }

  function sendSelectedOccupants() {
    calculateOccupantsTotal(occupantInfo);
    sendOccupants(occupantInfo);
    handleMenu();
  }

  var buttons = /*#__PURE__*/React__default.createElement(DivButtons$1, {
    showMultipleAccommodations: showMultipleAccommodations
  }, showMultipleAccommodations && /*#__PURE__*/React__default.createElement(ButtonAddRoom, {
    deviceType: constants.DEVICE_TYPE.DESKTOP,
    onAddRoom: handleAddRoom,
    resolution: resolution,
    roomDenomination: roomDenomination
  }), /*#__PURE__*/React__default.createElement(ButtonApply, {
    deviceType: constants.DEVICE_TYPE.DESKTOP,
    onClick: sendSelectedOccupants,
    type: "submit"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.apply)));

  function handleAddRoom(e) {
    onAddRoom(e);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showMenuOccupants && /*#__PURE__*/React__default.createElement(FloatingMenu, {
    scrollReference: scrollRef,
    menuReference: menuRef,
    buttons: buttons,
    resolution: resolution,
    showMenu: showMenuOccupants
  }, /*#__PURE__*/React__default.createElement(OccupantSummary, {
    deviceType: constants.DEVICE_TYPE.DESKTOP,
    occupantInfo: occupantInfo,
    onDeleteRoom: onDeleteRoom,
    onOccupantsChanged: onOccupantsChanged,
    roomDenomination: roomDenomination,
    selectorMode: selectorMode,
    showMultipleAccommodations: showMultipleAccommodations
  })), /*#__PURE__*/React__default.createElement(InputOccupantDiv, {
    constants: constants,
    onClick: e => handleMenu(e)
  }, /*#__PURE__*/React__default.createElement(DivOccupantSVG, null, /*#__PURE__*/React__default.createElement(OccupantSVG, null)), /*#__PURE__*/React__default.createElement(TotalDiv, null, occupantTotal), /*#__PURE__*/React__default.createElement(DivArrow, {
    id: "arrow"
  }, showMenuOccupants ? /*#__PURE__*/React__default.createElement(ArrowDropUp, null) : /*#__PURE__*/React__default.createElement(ArrowDropDown, null))));
}

OccupantForm.propTypes = {
  occupantInfo,
  onAddRoom,
  onDeleteRoom,
  onOccupantsChanged,
  roomDenomination,
  selectorMode,
  sendOccupants: PropTypes__default.func,
  showMultipleAccommodations
};

var Search = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "Search");

function _templateObject5$6() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  opacity: 0.8;\n  transition: opacity 0.4s;\n  &:hover {\n    opacity: 1;\n  }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  line-height: 16px;\n  font-weight: 700;\n  opacity: 0.8;\n  transition: opacity 0.4s;\n  font-size: ", ";\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: none;\n  background-color: ", ";\n  color: ", ";\n  border-radius: ", ";\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", ";\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n  svg {\n    fill: ", ";\n    pointer-events: none;\n    width: 18px;\n  }\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  @keyframes blinkingPulse {\n    from {\n      opacity: 1;\n    }\n    10% {\n      opacity: 0.9;\n    }\n    20% {\n      opacity: 0.8;\n    }\n    30% {\n      opacity: 0.7;\n    }\n    40% {\n      opacity: 0.6;\n    }\n    50% {\n      opacity: 0.5;\n    }\n    60% {\n      opacity: 0.6;\n    }\n    70% {\n      opacity: 0.7;\n    }\n    80% {\n      opacity: 0.8;\n    }\n    90% {\n      opacity: 0.9;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation-name: ", ";\n  animation-duration: ", ";\n  animation-iteration-count: ", ";\n  width: ", ";\n  height: ", ";\n  margin-left: ", ";\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var DivButton$1 = styled__default.div(_templateObject$f(), props => props.showAnimation ? "blinkingPulse" : "", props => props.showAnimation ? "1s" : "", props => props.showAnimation ? "infinite" : "", props => props.resolution === constants.RESOLUTION.MD ? "48px" : "", props => props.resolution === constants.RESOLUTION.MD ? "47px" : "", props => props.deviceType === constants.DEVICE_TYPE.MOBILE ? "10px" : "");
var ButtonSubmit = styled__default.button(_templateObject2$c(), props => props.resolution === constants.RESOLUTION.MD ? "" : "10px 15px", props => props.theme.button.backgroundColor, props => props.theme.button.color, props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "3px" : "5px", props => props.theme.fontFamily, props => props.theme[props.deviceType].fontSize, props => props.resolution === constants.RESOLUTION.MD ? "flex" : "inline-block", props => props.theme.button.color);
var MainValue = styled__default.span(_templateObject3$9(), props => props.theme[props.deviceType].fontSize);
var DivContentButton = styled__default.div(_templateObject4$8());
var SVGSearchIcon = styled__default(Search)(_templateObject5$6(), props => props.theme.colorOpposite);

function ButtonCheckAvaialability(_ref) {
  var {
    showAnimation,
    deviceType,
    onSearchButtonClicked,
    resolution
  } = _ref;
  var messages = reactIntl.defineMessages({
    checkAvailability: {
      id: "bookingModification.modal.checkAvailability",
      description: "Check Availability",
      defaultMessage: "Check Availability"
    },
    bestPriceGuarantee: {
      id: "booking_form.slogan.best_price_guarantee",
      description: "Best price guarantee",
      defaultMessage: "Best price guarantee"
    }
  });
  return /*#__PURE__*/React__default.createElement(DivButton$1, {
    deviceType: deviceType,
    showAnimation: showAnimation,
    resolution: resolution
  }, /*#__PURE__*/React__default.createElement(ButtonSubmit, {
    deviceType: deviceType,
    onClick: onSearchButtonClicked,
    resolution: resolution
  }, /*#__PURE__*/React__default.createElement(DivContentButton, null, resolution === constants.RESOLUTION.MD ? /*#__PURE__*/React__default.createElement(SVGSearchIcon, null) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MainValue, {
    deviceType: deviceType
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.checkAvailability)), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.bestPriceGuarantee)))))));
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  text-align: ", ";\n  animation-duration: 0.25s;\n  animation-name: ", ";\n  color: #3a3a3a;\n  font-size: ", ";\n  width: ", ";\n  padding: 7px;\n  background: #fff;\n  border: 1px solid #e1e1e1;\n  border-radius: ", ";\n  @keyframes appear {\n    from {\n      opacity: 0;\n      width: 0;\n    }\n    to {\n      opacity: 1;\n      width: 100px;\n    }\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  div {\n    text-transform: lowercase;\n  }\n  color: ", ";\n  cursor: pointer;\n  font-size: ", ";\n  position: relative;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var DivCode = styled__default.div(_templateObject$g(), props => props.theme[props.deviceType].code.color, props => props.theme[props.deviceType].fontSize, props => props.theme.hover.color);
var InputCode = styled__default.input(_templateObject2$d(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "center" : "left", props => props.deviceType === constants.DEVICE_TYPE.DESKTOP && !props.promoCodes ? "appear" : "none", props => props.theme[props.deviceType].fontSize, props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "120px" : "100%", props => props.theme[props.deviceType].code.borderRadius);

function PromoCode(_ref) {
  var {
    intl,
    onPromoCodeChanged,
    deviceType,
    promoCodes,
    hidePromoCode,
    openPromoCode
  } = _ref;
  var [showInput, setShowInput] = React.useState(false);
  var [code, setCode] = React.useState(promoCodes);
  var messages = reactIntl.defineMessages({
    code: {
      id: "booking_form.promo_code",
      description: "Placeholder for promotion code",
      defaultMessage: "¿Code/coupon?"
    }
  });
  React.useEffect(() => {
    if (promoCodes !== code) {
      setCode(promoCodes);
    }
  }, [code, promoCodes]);

  function handleChangeShowInput() {
    setShowInput(true);
  }

  function handleChangePromoCode(e) {
    onPromoCodeChanged(e);
  }

  if (hidePromoCode) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(DivCode, {
    deviceType: deviceType
  }, showInput || promoCodes || openPromoCode ? /*#__PURE__*/React__default.createElement(InputCode, {
    deviceType: deviceType,
    name: "code",
    onChange: handleChangePromoCode,
    placeholder: intl.formatMessage(messages.code),
    promoCodes: code,
    value: code
  }) : /*#__PURE__*/React__default.createElement("div", {
    onClick: handleChangeShowInput
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages.code)));
}

PromoCode.propTypes = {
  deviceType,
  onPromoCodeChanged: PropTypes__default.func,
  promoCodes: promoCodes,
  openPromoCode: PropTypes__default.bool,
  hidePromoCode: PropTypes__default.bool
};
var PromoCode$1 = reactIntl.injectIntl(PromoCode);

function _templateObject5$7() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 10px;\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #828282;\n  text-transform: lowercase;\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteral(["\n  width: inherit;\n  display: flex;\n  justify-content: ", ";\n"]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$e() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  width: 100%;\n  color: ", ";\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  color: #999999;\n  width: 24px;\n  height: 24px;\n  left: 30px;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var DateRange$2 = styled__default(DateRange)(_templateObject$h());
var StyledSelectInputWrapper$1 = styled__default(SelectInputWrapper$1)(_templateObject2$e(), props => props.theme.colorOpposite);
var DivDateContainer = styled__default.div(_templateObject3$a(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "space-around" : "center");
var SpanWeekDay = styled__default.span(_templateObject4$9());
var SpanDate = styled__default.span(_templateObject5$7()); // Used to display Property and Room information
// It's always on top of a list of selling options

function DropDown$2(_ref) {
  var {
    className,
    startDate,
    endDate,
    onClick,
    hideBorder,
    showIcon = false,
    showWeekDay = false,
    date,
    nameInput,
    onClickInput,
    deviceType
  } = _ref;
  var handleClick = React.useCallback(e => {
    onClick(e);
    onClickInput(nameInput);
  }, []);

  var getDate = date => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    month: "short",
    value: date
  }), /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    day: "2-digit",
    value: date
  }));

  return /*#__PURE__*/React__default.createElement(StyledSelectInputWrapper$1, {
    className: className,
    onClick: handleClick,
    icon: showIcon && /*#__PURE__*/React__default.createElement(DateRange$2, null),
    hideBorder: hideBorder,
    customPadding: showIcon ? false : true
  }, showWeekDay && date ? /*#__PURE__*/React__default.createElement(DivDateContainer, {
    deviceType: deviceType
  }, /*#__PURE__*/React__default.createElement(SpanWeekDay, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    weekday: "short",
    value: date
  }), ". "), /*#__PURE__*/React__default.createElement(SpanDate, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    day: "2-digit",
    value: date
  }), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    month: "short",
    value: date
  }), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    year: "2-digit",
    value: date
  }))) : /*#__PURE__*/React__default.createElement(DivDateContainer, {
    deviceType: deviceType
  }, deviceType !== constants.DEVICE_TYPE.MOBILE ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getDate(startDate), /*#__PURE__*/React__default.createElement("span", null, " - "), endDate ? getDate(endDate) : "?") : "?"));
}

DropDown$2.propTypes = {
  className: PropTypes__default.string,

  /** The component can have different appearances depending on this prop  */
  startDate: PropTypes__default.object.isRequired,

  /** The component can have different appearances depending on this prop  */
  endDate: PropTypes__default.object,

  /** The component can have different appearances depending on this prop  */
  onClick: PropTypes__default.func.isRequired,
  hideBorder: PropTypes__default.bool
};
DropDown$2.defaultProps = {
  className: "",
  hideBorder: false
};
var DropDown$3 = pure(DropDown$2);

function getLocale(locale) {
  // It's required to add GB in EN, this is because in date-fns doesn't exist EN translate alone.
  switch (locale) {
    case "en":
      locale = "en-GB";
      break;

    case "eu":
      locale = "es";
      break;
  } // eslint-disable-next-line no-undef


  return require("date-fns/locale/".concat(locale, "/index"));
}

function _templateObject7$4() {
  var data = _taggedTemplateLiteral(["\n  width: 20px;\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteral(["\n  min-width: 110px;\n  flex: 1 1 44%;\n"]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$8() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-family: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  height: 30px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject5$8 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 15px;\n  svg {\n    fill: #7e7e7e;\n    width: 23px;\n    opacity: 0.5;\n  }\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: none;\n  height: 33px;\n  font-size: ", ";\n  font-family: ", ";\n  color: ", ";\n  border-bottom: ", ";\n  svg {\n    width: 24px;\n    height: 100%;\n  }\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n    border-color: ", ";\n  }\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  z-index: 100;\n  width: 100%;\n  position: relative;\n  height: inherit;\n  svg {\n    fill: ", ";\n  }\n  .react-datepicker-wrapper {\n    width: 100%;\n    height: inherit;\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  .react-datepicker__input-container {\n    height: inherit;\n    width: inherit;\n    display: flex;\n    align-items: center;\n    position: relative;\n  }\n  .react-datepicker__day--outside-month {\n    visibility: hidden;\n  }\n  .react-datepicker {\n    border: 1px solid #e0e0e0;\n    border-radius: 0;\n    padding: 10px;\n    display: inline-block;\n    outline: none;\n  }\n\n  .react-datepicker__header {\n    background-color: transparent;\n    border-bottom: none;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    padding-top: 16px;\n  }\n\n  .react-datepicker__day-name {\n    color: #888;\n  }\n\n  .react-datepicker__day-name {\n    padding: 0 4px;\n    line-height: 2rem;\n  }\n\n  .react-datepicker__navigation,\n  .react-datepicker__day {\n    outline: none;\n  }\n\n  .react-datepicker__day {\n    border-radius: 0;\n    color: #888;\n    font-size: ", ";\n  }\n\n  .react-datepicker__day--in-range:hover {\n    background-color: #03c7f1;\n    color: #fff;\n  }\n\n  .react-datepicker__day--in-range {\n    background-color: #ddf9ff;\n    color: #03c7f1;\n  }\n\n  .react-datepicker__day--range-start,\n  .react-datepicker__day--range-end {\n    background-color: #03c7f1;\n    color: #fff;\n  }\n\n  .react-datepicker__current-month {\n    margin-bottom: 15px;\n    color: #888;\n    font-weight: normal;\n  }\n\n  .react-datepicker__month-container {\n    width: 100%;\n    margin: 0 0.5rem;\n    font-size: 10px;\n    font-family: ", ";\n  }\n\n  .react-datepicker__navigation--next,\n  .react-datepicker__navigation--previous {\n    width: 24px;\n    height: 24px;\n    border: none;\n    color: #888 !important;\n    background-color: inherit !important;\n    background-repeat: no-repeat;\n    background-size: contain;\n    top: 25px;\n  }\n  .react-datepicker__navigation--next {\n    background-image: url(", ");\n    right: 16px;\n  }\n\n  .react-datepicker__navigation--previous {\n    background-image: url(", ");\n    left: 16px;\n  }\n\n  .react-datepicker__triangle {\n    left: 50%;\n    transform: translateX(-50%);\n    @media only screen and (max-width: 1023px) {\n      margin-left: ", " !important;\n    }\n    &:before {\n      border-bottom: none !important;\n    }\n    &:after {\n      content: \" \";\n      position: absolute;\n      top: 2px;\n      width: 0;\n      height: 0;\n      left: -11px;\n      border-left: 11px solid transparent;\n      border-right: 11px solid transparent;\n      border-bottom: 11px solid #fff;\n      z-index: 4;\n    }\n  }\n  .react-datepicker-popper {\n    transform: ", ";\n    left: 5px !important;\n    @media only screen and (max-width: 1023px) {\n      min-width: 200px;\n      display: flex;\n      justify-content: center;\n      left: 0 !important;\n      right: 0;\n    }\n  }\n  .react-datepicker {\n    display: inline-flex;\n    width: 650px;\n    @media only screen and (max-width: 1023px) {\n      height: 300px;\n      padding: 0;\n      width: 100%;\n    }\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--selected:hover {\n    background-color: #03c7f1;\n    color: #fff !important;\n    outline: none;\n  }\n\n  .react-datepicker__day--disabled {\n    opacity: 0.35;\n  }\n  .react-datepicker__day--in-selecting-range {\n    background-color: #ddf9ff;\n    color: #03c7f1;\n  }\n  .react-datepicker__day--selecting-range-end,\n  .react-datepicker__day--selecting-range-start {\n    background-color: #03c7f1 !important;\n    color: #fff !important;\n  }\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var Container$3 = styled__default.div(_templateObject$i(), props => props.theme[props.deviceType].svg.fill, props => props.theme[props.deviceType].fontSize, props => props.theme.fontFamily, ArrowNext, ArrowPrev, props => props.mobileStyles.marginTriangleMobile, props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "translate3d(-237px, 34px, 0px) !important;" : "translate3d(0, 32px, 0) !important");
var DatePickerContainer = styled__default(DatePicker$1__default)(_templateObject2$f(), props => props.theme[props.deviceType].fontSize, props => props.theme.fontFamily, props => props.theme[props.deviceType].datePicker.color, props => props.theme[props.deviceType].datePicker.borderBottom, props => props.theme.hover.fill, props => props.theme.hover.color);
var DivMobileView = styled__default.div(_templateObject3$b());
var DivIcon = styled__default.div(_templateObject4$a());
var DatePickerContainerMobile = styled__default(DatePicker$1__default)(_templateObject5$8(), props => props.theme[props.deviceType].fontSize, props => props.theme.fontFamily, props => props.theme[props.deviceType].datePicker.color, props => props.theme[props.deviceType].datePicker.borderColor, props => props.theme[props.deviceType].datePicker.borderRadius);
var DivDatePicker = styled__default.div(_templateObject6$5());
var DivContainerDatePickers = styled__default.div(_templateObject7$4());

function DayRangePicker$2(_ref) {
  var {
    allowGoBackStartDate,
    allowGoBackEndDate,
    dates,
    minDate,
    deviceType,
    monthsShown = 1,
    intl,
    onResetRange
  } = _ref;
  var [mobileStyles, setMobileStyles] = React.useState({
    marginMobile: "0",
    marginTriangleMobile: "0",
    transform: "0"
  });
  var endDatePickerRef = React.useRef({});
  var startDatePickerRef = React.useRef({});
  var {
    locale
  } = intl;
  var formatLocale = getLocale(locale);
  DatePicker$1.registerLocale(locale, formatLocale);
  var handleClickInput = React.useCallback(dateType => {
    if (deviceType === constants.DEVICE_TYPE.MOBILE && dateType) {
      var _mobileStyles = {
        marginTriangleMobile: dateType === "startDate" ? "-30%" : "30%"
      };
      setMobileStyles(_mobileStyles);
    }
  }, [deviceType]);
  var handleChange = React.useCallback(date => {
    var {
      startDate,
      endDate
    } = dates;
    var newDates;
    var newAllowGoBackStart = allowGoBackStartDate;
    var newAllowGoBackEnd = allowGoBackEndDate;

    if (!startDate || dateFns.isSameDay(date, startDate)) {
      newDates = {
        startDate: date,
        endDate: null
      };
    } else {
      if (startDate && endDate) {
        if (dateFns.isBefore(date, startDate)) {
          if (allowGoBackStartDate) {
            newDates = {
              startDate: date,
              endDate
            };
            newAllowGoBackStart = false;
            newAllowGoBackEnd = true;
          } else {
            newDates = {
              startDate: date,
              endDate: null
            };
          }
        } else {
          if (allowGoBackEndDate) {
            newDates = {
              startDate,
              endDate: date
            };
            newAllowGoBackEnd = false;
          } else {
            newDates = {
              startDate: date,
              endDate: null
            };
          }
        }
      } else if (dateFns.isAfter(date, startDate)) {
        newDates = {
          startDate,
          endDate: date
        };
      } else {
        newDates = {
          startDate: date,
          endDate: null
        };
      }

      if (!newDates.endDate && endDatePickerRef.current) {
        endDatePickerRef.current.setOpen(true);
        handleClickInput("endDate");
      }

      if (newDates.startDate && newDates.endDate && endDatePickerRef.current && startDatePickerRef.current && deviceType === constants.DEVICE_TYPE.MOBILE && !newAllowGoBackStart && !newAllowGoBackEnd) {
        endDatePickerRef.current.setOpen(false);
        startDatePickerRef.current.setOpen(false);
      }

      onResetRange(newDates, newAllowGoBackStart, newAllowGoBackEnd);
    }
  }, [dates, allowGoBackStartDate, allowGoBackEndDate, handleClickInput, onResetRange, deviceType]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container$3, {
    deviceType: deviceType,
    mobileStyles: mobileStyles
  }, deviceType !== constants.DEVICE_TYPE.MOBILE ? /*#__PURE__*/React__default.createElement(DatePickerContainer, {
    ref: endDatePickerRef,
    locale: locale,
    endDate: dates.endDate,
    monthSelectedIn: 1,
    minDate: minDate,
    monthsShown: monthsShown,
    onChange: handleChange,
    inlineFocusSelectedMonth: false,
    popperPlacement: "bottom",
    startDate: dates.startDate,
    selected: dates.startDate,
    deviceType: deviceType,
    customInput: /*#__PURE__*/React__default.createElement(DropDown$3, {
      deviceType: deviceType,
      showIcon: true,
      startDate: dates.startDate,
      endDate: dates.endDate,
      onClickInput: handleClickInput
    }),
    selectsEnd: dates.startDate && !dates.endDate,
    shouldCloseOnSelect: false,
    disabledKeyboardNavigation: true
  }) : /*#__PURE__*/React__default.createElement(DivMobileView, null, /*#__PURE__*/React__default.createElement(DivIcon, null, /*#__PURE__*/React__default.createElement(DateRange, null)), /*#__PURE__*/React__default.createElement(DivDatePicker, null, /*#__PURE__*/React__default.createElement(DatePickerContainerMobile, {
    locale: locale,
    ref: startDatePickerRef,
    endDate: dates.endDate,
    minDate: minDate,
    monthsShown: monthsShown,
    onChange: handleChange,
    startDate: dates.startDate,
    selected: dates.startDate,
    popperPlacement: "bottom",
    deviceType: deviceType,
    customInput: /*#__PURE__*/React__default.createElement(DropDown$3, {
      deviceType: deviceType,
      nameInput: "startDate",
      startDate: dates.startDate,
      endDate: dates.endDate,
      date: dates.startDate,
      showIcon: false,
      showWeekDay: true,
      onClickInput: handleClickInput
    }),
    selectsStart: true,
    shouldCloseOnSelect: false,
    disabledKeyboardNavigation: true
  })), /*#__PURE__*/React__default.createElement(DivContainerDatePickers, null), /*#__PURE__*/React__default.createElement(DivDatePicker, null, /*#__PURE__*/React__default.createElement(DatePickerContainerMobile, {
    locale: locale,
    ref: endDatePickerRef,
    endDate: dates.endDate,
    minDate: minDate,
    monthsShown: monthsShown,
    onChange: handleChange,
    startDate: dates.startDate,
    selected: dates.startDate,
    popperPlacement: "bottom",
    deviceType: deviceType,
    customInput: /*#__PURE__*/React__default.createElement(DropDown$3, {
      deviceType: deviceType,
      nameInput: "endDate",
      startDate: dates.startDate,
      endDate: dates.endDate,
      date: dates.endDate,
      showIcon: false,
      showWeekDay: true,
      onClickInput: handleClickInput
    }),
    selectsEnd: true,
    shouldCloseOnSelect: false,
    disabledKeyboardNavigation: true
  })))));
}

DayRangePicker$2.propTypes = {
  allowGoBackStartDate,
  allowGoBackEndDate,
  dates,
  minDate,
  monthsShown: PropTypes__default.number,
  deviceType,
  resetRange,
  onResetRange
};
DayRangePicker$2.defaultProps = {
  deviceType: constants.DEVICE_TYPE.DESKTOP,
  minDate: new Date()
};
var DatePicker = reactIntl.injectIntl(DayRangePicker$2);

function _templateObject5$9() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n  color: rgb(144, 143, 150);\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  svg {\n    width: 20px;\n    fill: rgb(144, 143, 150);\n  }\n"]);

  _templateObject5$9 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteral(["\n  color: white;\n  background-color: rgb(37, 37, 37);\n  display: flex;\n  height: 45px;\n  -moz-box-align: center;\n  align-items: center;\n  -moz-box-pack: justify;\n  justify-content: space-between;\n  padding: 15px 15px 15px 20px;\n  box-sizing: border-box;\n  white-space: nowrap;\n  font-size: 14px;\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 5000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var DivModal = styled__default.div(_templateObject$j());
var DivModalContent = styled__default.div(_templateObject2$g());
var DivHeader$1 = styled__default.div(_templateObject3$c());
var DivClose = styled__default.div(_templateObject4$b());
var CloseSpan = styled__default.span(_templateObject5$9());

function Modal(_ref) {
  var {
    children,
    closeModal,
    element,
    headerText
  } = _ref;
  return ReactDOM.createPortal( /*#__PURE__*/React__default.createElement(DivModal, null, /*#__PURE__*/React__default.createElement(DivHeader$1, null, headerText && headerText, /*#__PURE__*/React__default.createElement(DivClose, null, /*#__PURE__*/React__default.createElement(CloseSpan, {
    onClick: closeModal
  }, /*#__PURE__*/React__default.createElement(Close, null)))), /*#__PURE__*/React__default.createElement(DivModalContent, null, children)), element);
}

function _templateObject4$c() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px;\n"]);

  _templateObject4$c = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteral(["\n  min-width: 235px;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  font-family: ", ";\n  font-size: ", ";\n"]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: ", ";\n  align-items: center;\n  color: ", ";\n  border: ", ";\n  min-height: 30px;\n  border-radius: 5px;\n  border-color: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  height: 100%;\n  padding: 4px 14px;\n  text-transform: uppercase;\n  font-weight: 400;\n  line-height: 15px;\n  font-size: 10px;\n  span {\n    display: flex;\n    align-items: center;\n    padding-left: 5px;\n  }\n  svg {\n    fill: ", ";\n    pointer-events: none;\n    width: 15px;\n  }\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var SummaryView = styled__default.div(_templateObject$k(), props => props.theme.fontFamily, props => props.theme[constants.DEVICE_TYPE.MOBILE].fontSize, props => props.resolution === constants.RESOLUTION.XXS ? "normal" : "center", props => props.theme.colorOpposite, props => props.theme[constants.DEVICE_TYPE.MOBILE][props.resolution].border, props => props.theme.colorOpposite, props => props.resolution !== constants.RESOLUTION.XXS && "300px", props => props.resolution === constants.RESOLUTION.SM ? "300px" : "200px", props => props.theme.colorOpposite);
var DivComponents = styled__default.div(_templateObject2$h(), props => props.theme.fontFamily, props => props.theme[constants.DEVICE_TYPE.MOBILE].fontSize);
var DivButton$2 = styled__default.div(_templateObject3$d());
var ModalContainer = styled__default.div(_templateObject4$c());

function MobileView(_ref) {
  var {
    allowGoBackStartDate,
    allowGoBackEndDate,
    dates,
    selectedFilterValue,
    filterData,
    handleResetRange,
    onAddRoom,
    onDeleteRoom,
    occupantInfo,
    selectorMode,
    resolution,
    roomDenomination,
    element,
    onOccupantsChanged,
    onSendSearchValue,
    showOccupants,
    showMultipleAccommodations,
    promoCodes,
    isBookingFormSummaryOpened,
    toggleBookingFormSummary,
    hidePromoCode
  } = _ref;
  var [showModal, setShowModal] = React.useState(isBookingFormSummaryOpened);
  var [showAnimation, setShowAnimation] = React.useState(false);
  var [occupants, setOccupants] = React.useState(occupantInfo);
  var [filter, setFilter] = React.useState(selectedFilterValue);
  var [initialSetOccupants, setInitialSetOccupants] = React.useState(true);
  var [promoCode, setPromoCode] = React.useState("");
  React.useEffect(() => {
    setFilter(selectedFilterValue);
  }, [selectedFilterValue]);
  React.useEffect(() => {
    setPromoCode(promoCodes);
  }, [promoCodes]);
  React.useEffect(() => {
    setOccupants(occupantInfo);
  }, [occupantInfo]);
  var handleModal = React.useCallback(e => {
    e && e.preventDefault();
    setShowModal(!showModal);
    toggleBookingFormSummary(!showModal);
  }, [showModal, toggleBookingFormSummary]);
  var changeFilter = React.useCallback(selectedFilterValue => {
    setShowAnimation(true);
    setFilter(selectedFilterValue);
  }, []);
  var changeOccupants = React.useCallback(occupantInfo => {
    if (!initialSetOccupants) {
      setShowAnimation(true);
    } else {
      setInitialSetOccupants(false);
    }

    onOccupantsChanged(occupantInfo);
  }, [initialSetOccupants, onOccupantsChanged]);
  var changePromoCode = React.useCallback(e => {
    var promoCode = e.target.value;
    setShowAnimation(true);
    setPromoCode(promoCode);
  }, []);
  var sendSearchValue = React.useCallback(() => {
    onSendSearchValue(occupants, dates, filter, promoCode);
    handleModal();
  }, [occupants, dates, filter, promoCode, handleModal, onSendSearchValue]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SummaryView, {
    resolution: resolution,
    onClick: handleModal,
    constants: constants
  }, resolution === constants.RESOLUTION.XXS && /*#__PURE__*/React__default.createElement(Search, null), filter && filter.optionName && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, filter && filter.optionName), /*#__PURE__*/React__default.createElement("span", null, "\xB7")), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    value: dates.startDate,
    day: "2-digit",
    month: "short"
  }), " -", " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    value: dates.endDate,
    day: "2-digit",
    month: "short"
  })), showOccupants && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "\xB7"), /*#__PURE__*/React__default.createElement("span", null, calculateOccupantsTotal(occupantInfo), /*#__PURE__*/React__default.createElement(SvgAdults, null)))), showModal && /*#__PURE__*/React__default.createElement(Modal, {
    closeModal: handleModal,
    element: element
  }, /*#__PURE__*/React__default.createElement(ModalContainer, null, filter && filter.optionName && /*#__PURE__*/React__default.createElement(DivComponents, null, /*#__PURE__*/React__default.createElement(Filter, {
    deviceType: constants.DEVICE_TYPE.MOBILE,
    filterData: filterData,
    selectedFilterValue: filter,
    onFilterChanged: changeFilter
  })), /*#__PURE__*/React__default.createElement(DivComponents, null, /*#__PURE__*/React__default.createElement(DatePicker, {
    allowGoBackStartDate: allowGoBackStartDate,
    allowGoBackEndDate: allowGoBackEndDate,
    dates: dates,
    deviceType: constants.DEVICE_TYPE.MOBILE,
    onResetRange: handleResetRange,
    resolution: resolution
  })), /*#__PURE__*/React__default.createElement(DivComponents, null, /*#__PURE__*/React__default.createElement(PromoCode$1, {
    deviceType: constants.DEVICE_TYPE.MOBILE,
    onPromoCodeChanged: changePromoCode,
    promoCodes: promoCode,
    hidePromoCode: hidePromoCode,
    openPromoCode: true
  })), showOccupants && /*#__PURE__*/React__default.createElement(DivComponents, null, /*#__PURE__*/React__default.createElement(OccupantSummary, {
    deviceType: constants.DEVICE_TYPE.MOBILE,
    occupantInfo: occupants,
    onDeleteRoom: onDeleteRoom,
    onOccupantsChanged: changeOccupants,
    roomDenomination: roomDenomination,
    selectorMode: selectorMode,
    showMultipleAccommodations: showMultipleAccommodations
  })), /*#__PURE__*/React__default.createElement(DivButton$2, null, showOccupants && showMultipleAccommodations && /*#__PURE__*/React__default.createElement(ButtonAddRoom, {
    deviceType: constants.DEVICE_TYPE.MOBILE,
    onAddRoom: onAddRoom,
    resolution: resolution,
    roomDenomination: roomDenomination
  }), /*#__PURE__*/React__default.createElement(ButtonCheckAvaialability, {
    deviceType: constants.DEVICE_TYPE.MOBILE,
    showAnimation: showAnimation,
    onSearchButtonClicked: sendSearchValue,
    resolution: resolution
  })))));
}

MobileView.propTypes = {
  allowGoBackStartDate,
  allowGoBackEndDate,
  children: PropTypes__default.node,
  filterData,
  occupantInfo,
  onAddRoom,
  onPromoCodeChanged,
  onDeleteRoom,
  onFilterChanged: PropTypes__default.func,
  onOccupantsChanged: PropTypes__default.func,
  onSendSearchValue,
  promoCodes,
  resolution: PropTypes__default.string,
  roomDenomination,
  selectedFilterValue,
  selectorMode,
  showMultipleAccommodations,
  showOccupants: PropTypes__default.bool
};

var ArrowBackIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
})), "ArrowBack");

var AccountIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z"
}), " ", /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "Adults");

function _templateObject5$a() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n"]);

  _templateObject5$a = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$d() {
  var data = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: #222222;\n  font-weight: bold;\n"]);

  _templateObject4$d = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$e() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #a3a3a8;\n  margin-bottom: 2px;\n  text-decoration: ", ";\n  cursor: ", ";\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 180px;\n  min-height: 296px;\n  border-radius: 5px;\n  border: 1px solid #e1e1e1;\n  padding: 20px;\n  align-items: baseline;\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var messages$1 = reactIntl.defineMessages({
  category: {
    id: "loyalty.associatedTier.category",
    description: "Associated tier form field: category",
    defaultMessage: "Categoría"
  },
  reservations: {
    id: "loyalty.associatedTier.reservations",
    description: "Associated tier form field: reservations",
    defaultMessage: "Reservas"
  },
  viewBenefits: {
    id: "loyalty.associatedTier.viewBenefits",
    description: "Associated tier form field: viewBenefits",
    defaultMessage: "Ver beneficios"
  },
  benefits: {
    id: "loyalty.accountBanner.benefits",
    description: "Benefits",
    defaultMessage: "Beneficios"
  }
});
var Container$4 = styled__default.div(_templateObject$l());
var ElementContainer = styled__default.div(_templateObject2$i());
var LabelStyled = styled__default.label(_templateObject3$e(), (_ref) => {
  var {
    isLink
  } = _ref;
  return isLink && "underline";
}, (_ref2) => {
  var {
    isLink
  } = _ref2;
  return isLink && "pointer";
});
var TextStyled = styled__default.span(_templateObject4$d());
var PopupContainer = styled__default.div(_templateObject5$a());
function TiersModal(_ref3) {
  var {
    loyalty,
    handleCloseModal
  } = _ref3;
  var intl = reactIntl.useIntl();
  return /*#__PURE__*/React__default.createElement(Popup, {
    headerText: intl.formatMessage(messages$1.benefits),
    closeWindow: handleCloseModal
  }, /*#__PURE__*/React__default.createElement(PopupContainer, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.description) || ""
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.benefitDescription) || ""
    }
  })));
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteral(["\n  padding: 12px 8px;\n  border-radius: 2px;\n  margin-left: 10px;\n  text-transform: uppercase;\n  background: ", ";\n  color: #ffffff;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  margin-right: 15px;\n  margin-left: 10px;\n"]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n"]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: none;\n  a {\n    text-decoration: underline;\n    color: ", ";\n  }\n"]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$b() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  cursor: pointer;\n  text-decoration: ", ";\n  a {\n    text-decoration: none;\n    color: ", ";\n  }\n"]);

  _templateObject5$b = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$e() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  font-weight: ", ";\n  cursor: pointer;\n  text-decoration: ", ";\n  a {\n    text-decoration: none;\n    color: ", ";\n  }\n"]);

  _templateObject4$e = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  font-weight: 700;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  margin-right: 15px;\n  display: ", ";\n  svg {\n    fill: #a3a3a8 !important;\n    &:hover {\n      color: #a3a3a8;\n    }\n  }\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  padding: ", ";\n  span {\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n  }\n  svg {\n    width: 24px;\n    margin-right: 5px;\n    fill: ", ";\n  }\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var messages$2 = reactIntl.defineMessages({
  greeting: {
    id: "loyalty.accountBanner.greeting",
    description: "Greeting",
    defaultMessage: "¡Hola"
  },
  myAccount: {
    id: "loyalty.accountBanner.myAccount",
    description: "Link my account",
    defaultMessage: "Mis datos"
  },
  myReservations: {
    id: "loyalty.accountBanner.myReservations",
    description: "Link my reservations",
    defaultMessage: "Mis reservas"
  },
  logout: {
    id: "loyalty.accountBanner.logout",
    description: "Link logout",
    defaultMessage: "Cerrar sesión"
  },
  login: {
    id: "loyalty.accountBanner.login",
    description: "Link login",
    defaultMessage: "Iniciar sesión"
  },
  createAccount: {
    id: "loyalty.accountBanner.createAccount",
    description: "Link create account",
    defaultMessage: "Crear cuenta"
  },
  toEnjoyBenefits: {
    id: "loyalty.accountBanner.toEnjoyBenefits",
    description: "Text with benefits",
    defaultMessage: "para disfrutar de ventajas exclusivas"
  },
  becomeMember: {
    id: "loyalty.accountBanner.becomeMember",
    description: "Button in account banner",
    defaultMessage: "Hazte miembro"
  },
  category: {
    id: "loyalty.accountBanner.category",
    description: "Button in account banner with user",
    defaultMessage: "Categoría"
  },
  benefits: {
    id: "loyalty.accountBanner.benefits",
    description: "Benefits",
    defaultMessage: "Beneficios"
  }
});
var Container$5 = styled__default.div(_templateObject$m(), (_ref) => {
  var {
    theme
  } = _ref;
  return theme.colorOpposite;
}, (_ref2) => {
  var {
    theme
  } = _ref2;
  return theme.menu.backgroundColor;
}, (_ref3) => {
  var {
    padding
  } = _ref3;
  return padding;
}, (_ref4) => {
  var {
    theme,
    fillColor
  } = _ref4;
  return fillColor || theme.colorOpposite;
});
var OnBackIconContainer = styled__default.div(_templateObject2$j(), (_ref5) => {
  var {
    showBackArrow
  } = _ref5;
  return showBackArrow ? "block" : "none";
});
var NameStyled = styled__default.span(_templateObject3$f());
var StyledLinkMyAccount = styled__default.span(_templateObject4$e(), (_ref6) => {
  var {
    myAccountClicked
  } = _ref6;
  return myAccountClicked ? "700" : "400";
}, (_ref7) => {
  var {
    myAccountClicked
  } = _ref7;
  return myAccountClicked ? "underline" : "none";
}, (_ref8) => {
  var {
    theme
  } = _ref8;
  return theme.colorOpposite;
});
var StyledLinkMyReservations = styled__default.span(_templateObject5$b(), (_ref9) => {
  var {
    myReservationsClicked
  } = _ref9;
  return myReservationsClicked ? "700" : "400";
}, (_ref10) => {
  var {
    myReservationsClicked
  } = _ref10;
  return myReservationsClicked ? "underline" : "none";
}, (_ref11) => {
  var {
    theme
  } = _ref11;
  return theme.colorOpposite;
});
var StyledLink = styled__default.span(_templateObject6$6(), (_ref12) => {
  var {
    theme
  } = _ref12;
  return theme.colorOpposite;
});
var PopupContainer$1 = styled__default.div(_templateObject7$5());
var Divider = styled__default.div(_templateObject8$3());
var ButtonStyled = styled__default.button(_templateObject9$2(), (_ref13) => {
  var {
    background
  } = _ref13;
  return background;
});
function AccountBanner(_ref14) {
  var {
    user,
    padding,
    linkToLogin,
    linkToSignUp,
    onLogOut,
    loyalty,
    isMobile,
    history,
    params,
    handleCloseModal,
    handleModalContent,
    showBackArrow,
    myAccountClicked,
    myReservationsClicked
  } = _ref14;
  var intl = reactIntl.useIntl();
  var handleModal = React.useCallback(() => {
    handleModalContent( /*#__PURE__*/React__default.createElement(TiersModal, {
      loyalty: loyalty,
      handleCloseModal: handleCloseModal
    }), {
      modalWidth: "900px",
      hideCloseButton: true
    });
  }, [handleModalContent, loyalty]);
  var handleRedirect = React.useCallback(() => {
    location.href = linkToLogin;
  }, [handleModalContent]);
  var handleClickMyAccount = React.useCallback(() => {
    history.push("/".concat(params.hotelTicker, "/loyalty/my-account"));
  }, [history, params]);
  var handleClickMyReservations = React.useCallback(() => {
    history.push("/".concat(params.hotelTicker, "/loyalty/my-reservations"));
  }, [history, params]);
  return /*#__PURE__*/React__default.createElement(Container$5, {
    marginRight: !!user,
    padding: padding,
    fillColor: user && (loyalty === null || loyalty === void 0 ? void 0 : loyalty.color)
  }, user ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OnBackIconContainer, {
    onClick: () => history.push("/".concat(params.hotelTicker)),
    showBackArrow: showBackArrow
  }, /*#__PURE__*/React__default.createElement(ArrowBackIcon, null)), /*#__PURE__*/React__default.createElement(NameStyled, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.greeting), " ", user.name, " !"), /*#__PURE__*/React__default.createElement("a", {
    onClick: handleModal
  }, /*#__PURE__*/React__default.createElement(ButtonStyled, {
    background: loyalty === null || loyalty === void 0 ? void 0 : loyalty.color
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.category), " ", loyalty === null || loyalty === void 0 ? void 0 : loyalty.name)), /*#__PURE__*/React__default.createElement(StyledLinkMyAccount, {
    onClick: handleClickMyAccount,
    myAccountClicked: myAccountClicked
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.myAccount)), /*#__PURE__*/React__default.createElement(Divider, null, " | "), /*#__PURE__*/React__default.createElement(StyledLinkMyReservations, {
    onClick: handleClickMyReservations,
    myReservationsClicked: myReservationsClicked
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.myReservations)), /*#__PURE__*/React__default.createElement(Divider, null, " | "), /*#__PURE__*/React__default.createElement(StyledLink, {
    onClick: onLogOut
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.logout))) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(AccountIcon, null), /*#__PURE__*/React__default.createElement(StyledLink, null, /*#__PURE__*/React__default.createElement("a", {
    href: linkToLogin
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.login))), " ", /*#__PURE__*/React__default.createElement(StyledLink, null, "o "), /*#__PURE__*/React__default.createElement(StyledLink, null, /*#__PURE__*/React__default.createElement("a", {
    href: linkToSignUp
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.createAccount))), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.toEnjoyBenefits), " ", /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("a", {
    onClick: handleRedirect
  }, /*#__PURE__*/React__default.createElement(ButtonStyled, {
    background: loyalty === null || loyalty === void 0 ? void 0 : loyalty.color
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$2.becomeMember))))));
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  height: inherit;\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 30px;\n  width: fit-content;\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 30px;\n  position: relative;\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 30px;\n  min-width: 160px;\n  height: 100%;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  min-width: 220px;\n  margin-left: 20px;\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  min-width: 290px;\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  width: 100%;\n  justify-content: center;\n  margin-right: 20px;\n  @media print {\n    display: none;\n  }\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  overflow-y: hidden;\n  justify-content: center;\n  flex: 0 0 280px;\n  background-color: ", ";\n  max-height: inherit;\n  height: 140px;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  @media print {\n    justify-content: center;\n  }\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  width: fit-content;\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 20px;\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  justify-content: center;\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  height: 76px;\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  background-color: ", ";\n  max-height: inherit;\n  max-width: 235px;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  min-width: 160px;\n  height: 100%;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 20px;\n  position: relative;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  min-width: 290px;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 10px;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$1() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n"]);

  _templateObject15$1 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$1() {
  var data = _taggedTemplateLiteral(["\n  height: \"85px\";\n  flex: 0 0 100px;\n  padding: 10px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  background-color: ", ";\n"]);

  _templateObject14$1 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$1() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  align-items: center;\n  justify-content: \"space-between\";\n  width: 100%;\n  max-height: inherit;\n"]);

  _templateObject13$1 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  width: 100%;\n"]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$2() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n"]);

  _templateObject11$2 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$2() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 70px;\n  padding: ", ";\n  box-sizing: border-box;\n  height: 50px;\n"]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  max-height: inherit;\n  height: 100%;\n  padding: ", ";\n  margin-bottom: ", ";\n  background-color: ", ";\n"]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  max-height: inherit;\n  height: 100%;\n"]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$6() {
  var data = _taggedTemplateLiteral(["\n  max-height: \"130px\";\n  padding: ", ";\n"]);

  _templateObject7$6 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: ", ";\n"]);

  _templateObject6$7 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$c() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject5$c = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$f() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4$f = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    fill: ", ";\n    cursor: pointer;\n    height: 21px;\n    padding-right: 10px;\n  }\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  width: 100%;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var header = styled__default.div(_templateObject$n(), props => props.theme.menu.backgroundColor, props => props.theme.fontFamily, props => props.theme[props.deviceType].fontSize);
var HeaderRow = styled__default.div(_templateObject2$k());
var MenuOption = styled__default.div(_templateObject3$g(), props => props.theme.colorOpposite); // XXS

var ResolutionXXS = styled__default(header)(_templateObject4$f());
var HeaderRowMobile = styled__default.div(_templateObject5$c()); // XS

var MenuMobileXS = styled__default.div(_templateObject6$7(), props => props.theme.menu.backgroundColor && !props.theme.menu.backgroundColor.includes("undefined") ? "10px" : "0");
var ResolutionXS = styled__default(header)(_templateObject7$6(), props => props.addPaddingToLogo ? "0 0 10px 0" : "10px 0 10px 0");
var DivPaddingXS = styled__default.div(_templateObject8$4());
var HeaderLogoXS = styled__default.div(_templateObject9$3(), props => props.showMenuOption ? "space-between" : "center", props => props.addPaddingToLogo ? "10px" : "0", props => props.addPaddingToLogo ? "10px" : "0", props => props.theme.logo.backgroundColor);
var DivLogoXS = styled__default.div(_templateObject10$2(), props => props.addPaddingToLogo ? "5px" : "0");
var LogoXS = styled__default.img(_templateObject11$2()); // SM

var ResolutionSM = styled__default(header)(_templateObject12$1(), props => props.logo ? "space-between" : "center");
var HeaderRowSM = styled__default(HeaderRow)(_templateObject13$1());
var DivImageSM = styled__default.div(_templateObject14$1(), props => props.theme.logo.backgroundColor);
var LogoSM = styled__default.img(_templateObject15$1());
var MenuMobileSM = styled__default.div(_templateObject16()); // MD

var HeaderRowMD = styled__default(HeaderRow)(_templateObject17());
var DivComponentsMD = styled__default.div(_templateObject18());
var FilterMD = styled__default.div(_templateObject19());
var OccupantMD = styled__default.div(_templateObject20());
var DatePickerMD = styled__default.div(_templateObject21());
var ResolutionMD = styled__default(header)(_templateObject22());
var DivLogoMD = styled__default.div(_templateObject23(), props => props.theme.logo.backgroundColor);
var DivPaddingImageMD = styled__default.div(_templateObject24(), props => props.addPaddingToLogo ? "5px" : "0");
var LogoMD = styled__default.img(_templateObject25());
var DivButtonPromoCode = styled__default.div(_templateObject26());
var DivButtonMD = styled__default.div(_templateObject27());
var DivPromoCodeMD = styled__default.div(_templateObject28()); // LG

var HeaderRowLG = styled__default(HeaderRow)(_templateObject29());
var ResolutionLG = styled__default(header)(_templateObject30());
var DivLogoLG = styled__default.div(_templateObject31(), props => props.theme.logo.backgroundColor);
var DivPaddingImageLG = styled__default.div(_templateObject32());
var LogoLG = styled__default.img(_templateObject33());
var DivComponentsLG = styled__default.div(_templateObject34());
var FilterLG = styled__default.div(_templateObject35());
var DivButtonLG = styled__default.div(_templateObject36());
var DatePickerLG = styled__default.div(_templateObject37());
var OccupantLG = styled__default.div(_templateObject38());
var DivPromoCodeLG = styled__default.div(_templateObject39());
var HotelSiteLinkStyled = styled__default.a(_templateObject40());

function BookingForm(_ref) {
  var {
    addPaddingToLogo,
    filterData,
    hotelSiteURL,
    resolution,
    logoSrc,
    showMenuOption,
    showFilter,
    occupantInfo,
    selectorMode,
    selectedStartDate,
    selectedEndDate,
    selectedFilterValue,
    element,
    onPromoCodeChanged,
    onDatesChanged,
    onFilterChanged,
    onOccupantsChanged,
    onSendSearchValue,
    onSearchButtonClicked,
    onOpenExternalMenu,
    roomDenomination,
    showMultipleAccommodations,
    promoCodes,
    showMobileLogo,
    showDesktopLogo,
    isBookingFormSummaryOpened,
    toggleBookingFormSummary,
    loyaltyUser,
    showLoginLoyalty,
    hidePromoCode,
    linkToLogin,
    linkToSignUp,
    onLogOut,
    openPromoCode,
    loyalty,
    history,
    params,
    handleCloseModal,
    handleModalContent,
    textNoOptions,
    showBackArrow,
    myAccountClicked,
    myReservationsClicked
  } = _ref;
  var [showAnimation, setShowAnimation] = React.useState(false);
  var [occupants, setOccupants] = React.useState({});
  var [showOccupants, setShowOccupants] = React.useState(selectorMode !== constants.OCCUPANTS_FILTER_TYPE.NONE);
  var [dates, setDates] = React.useState({
    startDate: selectedStartDate,
    endDate: selectedEndDate
  });
  var [allowGoBackStartDate, setAllowGoBackStartDate] = React.useState(true);
  var [allowGoBackEndDate, setAllowGoBackEndDate] = React.useState(false);
  React.useEffect(() => {
    if (!filterData) {
      throw new Error("Missing required field: filterData");
    }

    if (!resolution) {
      throw new Error("Missing required field: resolution");
    }

    if (!occupantInfo) {
      throw new Error("Missing required field: occupantInfo");
    }

    if (!selectorMode) {
      throw new Error("Missing required field: selectorMode");
    }
  }, [filterData, resolution, occupantInfo, selectorMode]);
  React.useEffect(() => {
    if (selectedStartDate && !(selectedStartDate instanceof Date) || selectedEndDate && !(selectedEndDate instanceof Date)) {
      throw new Error('"selectedStartDate" and "selectedEndDate" must be of type date');
    }

    if (selectedEndDate) {
      if (selectedEndDate < selectedStartDate) {
        setDates({
          startDate: selectedEndDate,
          endDate: selectedEndDate
        });
      } else {
        setDates({
          startDate: selectedStartDate,
          endDate: selectedEndDate
        });
      }
    }
  }, [selectedStartDate, selectedEndDate]);
  React.useEffect(() => {
    if (!Object.keys(occupants).length) {
      var occupantsWithAge = updateAgeRanges({
        occupants: occupantInfo,
        selectorMode
      });
      setOccupants(occupantsWithAge);
    }
  }, [occupants, occupantInfo, selectorMode]);
  React.useEffect(() => {
    var newShowOccupants = selectorMode !== constants.OCCUPANTS_FILTER_TYPE.NONE;

    if (newShowOccupants !== showOccupants) {
      setShowOccupants(newShowOccupants);
    }
  }, [selectorMode, showOccupants]);
  var handleAddRoom = React.useCallback(() => {
    var firstIndex = Object.typedKeys(occupants)[0];
    var firstOccupant = occupants[firstIndex];
    var occupantsBase = Object.typedKeys(firstOccupant).reduce((result, occupantType) => {
      var occupant = firstOccupant[occupantType];
      var value = occupant.minValue; // 2 is the initial value by default for ADULTS in all hotels and I check if exist this value in occupant

      if (occupantType === constants.OCCUPANTS_TYPE.ADULT && (occupant.minValue <= 2 || occupant.maxValue >= 2)) {
        value = 2;
      }

      result = _objectSpread2({}, result, {
        [occupantType]: _objectSpread2({}, occupant, {
          value: value,
          guestAges: occupant.guestAges ? [] : undefined
        })
      });
      return result;
    }, {});
    var newOccupants = recalculateRoomNumber(_objectSpread2({}, occupants, {
      newRoom: _objectSpread2({}, occupantsBase)
    }));
    setOccupants(_objectSpread2({}, newOccupants));
  }, [occupants]);
  var handleDeleteRoom = React.useCallback((e, room) => {
    e && e.preventDefault();

    var filteredOccupants = _objectSpread2({}, occupants);

    delete filteredOccupants[room];
    var newOccupants = recalculateRoomNumber(filteredOccupants);
    setOccupants(_objectSpread2({}, newOccupants));
  }, [occupants]);
  var handleOccupantsChanged = React.useCallback(newOccupants => {
    var occupantsWithAge = updateAgeRanges({
      occupants: newOccupants,
      selectorMode
    });
    setOccupants(occupantsWithAge);
    onOccupantsChanged(occupantsWithAge, false);
  }, [selectorMode, onOccupantsChanged]);

  function getMobileView(_ref2) {
    var {
      resolution
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(MobileView, {
      allowGoBackStartDate: allowGoBackStartDate,
      allowGoBackEndDate: allowGoBackEndDate,
      dates: dates,
      element: element,
      filterData: filterData,
      handleResetRange: handleResetRange,
      showOccupants: showOccupants,
      occupantInfo: occupants,
      onAddRoom: handleAddRoom,
      onDeleteRoom: handleDeleteRoom,
      onFilterChanged: onFilterChanged,
      onOccupantsChanged: handleOccupantsChanged,
      onSearchButtonClicked: handleSearchButtonClicked,
      onSendSearchValue: onSendSearchValue,
      promoCodes: promoCodes,
      resolution: resolution,
      roomDenomination: roomDenomination,
      selectedFilterValue: selectedFilterValue,
      selectorMode: selectorMode,
      showMultipleAccommodations: showMultipleAccommodations,
      isBookingFormSummaryOpened: isBookingFormSummaryOpened,
      toggleBookingFormSummary: toggleBookingFormSummary,
      hidePromoCode: hidePromoCode,
      openPromoCode: openPromoCode
    });
  }

  function handleSearchButtonClicked() {
    setShowAnimation(false);
    onSearchButtonClicked();
  }

  function handleOccupantsDesktop(selectedOccupants) {
    setShowAnimation(true);
    onOccupantsChanged(selectedOccupants, true);
  }

  function handleFilter(selectedFilterValue) {
    setShowAnimation(true);
    onFilterChanged(selectedFilterValue);
  }

  var handleDates = React.useCallback((selectedDates, isSubmit) => {
    setShowAnimation(true);
    onDatesChanged(selectedDates, isSubmit);

    if (isSubmit) {
      setAllowGoBackStartDate(true);
      setAllowGoBackEndDate(true);
    }
  }, [onDatesChanged]);
  var handleResetRange = React.useCallback((selectedDates, newAllowGoBackStartDate, newAllowGoBackEndDate) => {
    setDates(selectedDates);

    if (selectedDates.startDate && selectedDates.endDate) {
      var isSubmit = newAllowGoBackStartDate && !newAllowGoBackEndDate || !newAllowGoBackStartDate && !newAllowGoBackEndDate;
      handleDates(selectedDates, isSubmit);
    }

    if (newAllowGoBackStartDate !== allowGoBackStartDate) {
      setAllowGoBackStartDate(newAllowGoBackStartDate);
    }

    if (newAllowGoBackEndDate !== allowGoBackEndDate) {
      setAllowGoBackEndDate(newAllowGoBackEndDate);
    }
  }, [allowGoBackStartDate, allowGoBackEndDate, handleDates]);

  switch (resolution) {
    case constants.RESOLUTION.XXS:
      return /*#__PURE__*/React__default.createElement(ResolutionXXS, {
        deviceType: constants.DEVICE_TYPE.MOBILE
      }, /*#__PURE__*/React__default.createElement(HeaderRowMobile, null, getMobileView({
        resolution: constants.RESOLUTION.XXS
      })), showLoginLoyalty && /*#__PURE__*/React__default.createElement(AccountBanner, {
        linkToLogin: linkToLogin,
        linkToSignUp: linkToSignUp,
        user: loyaltyUser,
        onLogOut: onLogOut,
        padding: "0 10px 10px 10px",
        loyalty: loyalty,
        isMobile: true,
        history: history,
        params: params,
        handleCloseModal: handleCloseModal,
        handleModalContent: handleModalContent,
        showBackArrow: showBackArrow,
        myAccountClicked: myAccountClicked,
        myReservationsClicked: myReservationsClicked
      }));

    case constants.RESOLUTION.XS:
      return /*#__PURE__*/React__default.createElement(ResolutionXS, {
        deviceType: constants.DEVICE_TYPE.MOBILE,
        addPaddingToLogo: addPaddingToLogo
      }, /*#__PURE__*/React__default.createElement(DivPaddingXS, null, /*#__PURE__*/React__default.createElement(HeaderLogoXS, {
        showMenuOption: showMenuOption,
        addPaddingToLogo: addPaddingToLogo
      }, logoSrc && showMobileLogo && /*#__PURE__*/React__default.createElement(HotelSiteLinkStyled, {
        href: hotelSiteURL,
        rel: "noopener noreferrer",
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement(DivLogoXS, null, /*#__PURE__*/React__default.createElement(LogoXS, {
        src: logoSrc
      }))), /*#__PURE__*/React__default.createElement(MenuOption, null, showMenuOption && /*#__PURE__*/React__default.createElement(Menu, {
        onClick: onOpenExternalMenu
      })))), /*#__PURE__*/React__default.createElement(MenuMobileXS, {
        addPaddingToLogo: addPaddingToLogo
      }, getMobileView({
        resolution: constants.RESOLUTION.XS
      })), showLoginLoyalty && /*#__PURE__*/React__default.createElement(AccountBanner, {
        linkToLogin: linkToLogin,
        linkToSignUp: linkToSignUp,
        user: loyaltyUser,
        onLogOut: onLogOut,
        padding: "10px 10px 0 10px",
        loyalty: loyalty,
        isMobile: true,
        history: history,
        params: params,
        handleCloseModal: handleCloseModal,
        handleModalContent: handleModalContent,
        showBackArrow: showBackArrow,
        myAccountClicked: myAccountClicked,
        myReservationsClicked: myReservationsClicked
      }));

    case constants.RESOLUTION.SM:
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ResolutionSM, {
        deviceType: constants.DEVICE_TYPE.MOBILE,
        logo: logoSrc
      }, /*#__PURE__*/React__default.createElement(HeaderRowSM, null, logoSrc && showMobileLogo && /*#__PURE__*/React__default.createElement(HotelSiteLinkStyled, {
        href: hotelSiteURL,
        rel: "noopener noreferrer",
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement(DivImageSM, null, /*#__PURE__*/React__default.createElement(LogoSM, {
        src: logoSrc
      }))), /*#__PURE__*/React__default.createElement(MenuMobileSM, null, getMobileView({
        resolution: constants.RESOLUTION.SM
      })), showMenuOption && /*#__PURE__*/React__default.createElement(MenuOption, null, /*#__PURE__*/React__default.createElement(Menu, {
        onClick: onOpenExternalMenu
      })))), showLoginLoyalty && /*#__PURE__*/React__default.createElement(AccountBanner, {
        linkToLogin: linkToLogin,
        linkToSignUp: linkToSignUp,
        user: loyaltyUser,
        onLogOut: onLogOut,
        padding: "10px 10px 10px 10px",
        loyalty: loyalty,
        isMobile: true,
        history: history,
        params: params,
        handleCloseModal: handleCloseModal,
        handleModalContent: handleModalContent,
        showBackArrow: showBackArrow,
        myAccountClicked: myAccountClicked,
        myReservationsClicked: myReservationsClicked
      }));

    case constants.RESOLUTION.MD:
      return /*#__PURE__*/React__default.createElement(ResolutionMD, {
        deviceType: constants.DEVICE_TYPE.DESKTOP
      }, /*#__PURE__*/React__default.createElement(HeaderRowMD, null, logoSrc && showDesktopLogo && /*#__PURE__*/React__default.createElement(DivLogoMD, null, /*#__PURE__*/React__default.createElement(HotelSiteLinkStyled, {
        href: hotelSiteURL,
        rel: "noopener noreferrer",
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement(DivPaddingImageMD, {
        className: "wbkv9-App-bookingForm-desktopLogoContainer",
        addPaddingToLogo: addPaddingToLogo
      }, /*#__PURE__*/React__default.createElement(LogoMD, {
        src: logoSrc
      })))), /*#__PURE__*/React__default.createElement(DivComponentsMD, null, showFilter && /*#__PURE__*/React__default.createElement(FilterMD, null, /*#__PURE__*/React__default.createElement(Filter, {
        filterData: filterData,
        textNoOptions: textNoOptions,
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        selectedFilterValue: selectedFilterValue,
        onFilterChanged: handleFilter
      })), /*#__PURE__*/React__default.createElement(DatePickerMD, null, /*#__PURE__*/React__default.createElement(DatePicker, {
        dates: dates,
        allowGoBackStartDate: allowGoBackStartDate,
        allowGoBackEndDate: allowGoBackEndDate,
        monthsShown: 2,
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate,
        onDatesChanged: handleDates,
        onResetRange: handleResetRange,
        resolution: resolution
      })), showOccupants && /*#__PURE__*/React__default.createElement(OccupantMD, null, /*#__PURE__*/React__default.createElement(OccupantForm, {
        occupantInfo: occupants,
        onAddRoom: handleAddRoom,
        onDeleteRoom: handleDeleteRoom,
        sendOccupants: handleOccupantsDesktop,
        onOccupantsChanged: handleOccupantsChanged,
        resolution: resolution,
        roomDenomination: roomDenomination,
        selectorMode: selectorMode,
        showMultipleAccommodations: showMultipleAccommodations
      })), /*#__PURE__*/React__default.createElement(DivButtonPromoCode, null, /*#__PURE__*/React__default.createElement(DivPromoCodeMD, null, /*#__PURE__*/React__default.createElement(PromoCode$1, {
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        onPromoCodeChanged: onPromoCodeChanged,
        promoCodes: promoCodes,
        hidePromoCode: hidePromoCode,
        openPromoCode: openPromoCode
      })), /*#__PURE__*/React__default.createElement(DivButtonMD, null, /*#__PURE__*/React__default.createElement(ButtonCheckAvaialability, {
        onSearchButtonClicked: handleSearchButtonClicked,
        showAnimation: showAnimation,
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        resolution: resolution
      }))))), showLoginLoyalty && /*#__PURE__*/React__default.createElement(AccountBanner, {
        linkToLogin: linkToLogin,
        linkToSignUp: linkToSignUp,
        user: loyaltyUser,
        onLogOut: onLogOut,
        padding: "10px 10px 10px 10px",
        loyalty: loyalty,
        history: history,
        params: params,
        handleCloseModal: handleCloseModal,
        handleModalContent: handleModalContent,
        showBackArrow: showBackArrow,
        myAccountClicked: myAccountClicked,
        myReservationsClicked: myReservationsClicked
      }));

    case constants.RESOLUTION.LG:
      return /*#__PURE__*/React__default.createElement(ResolutionLG, {
        deviceType: constants.DEVICE_TYPE.DESKTOP
      }, /*#__PURE__*/React__default.createElement(HeaderRowLG, null, logoSrc && showDesktopLogo && /*#__PURE__*/React__default.createElement(DivLogoLG, null, /*#__PURE__*/React__default.createElement(HotelSiteLinkStyled, {
        href: hotelSiteURL,
        rel: "noopener noreferrer",
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement(DivPaddingImageLG, {
        className: "wbkv9-App-bookingForm-desktopLogoContainer"
      }, /*#__PURE__*/React__default.createElement(LogoLG, {
        src: logoSrc
      })))), /*#__PURE__*/React__default.createElement(DivComponentsLG, null, showFilter && /*#__PURE__*/React__default.createElement(FilterLG, null, /*#__PURE__*/React__default.createElement(Filter, {
        filterData: filterData,
        textNoOptions: textNoOptions,
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        selectedFilterValue: selectedFilterValue,
        onFilterChanged: handleFilter
      })), /*#__PURE__*/React__default.createElement(DatePickerLG, null, /*#__PURE__*/React__default.createElement(DatePicker, {
        allowGoBackStartDate: allowGoBackStartDate,
        allowGoBackEndDate: allowGoBackEndDate,
        dates: dates,
        monthsShown: 2,
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        selectedStartDate: selectedStartDate,
        selectedEndDate: selectedEndDate,
        onDatesChanged: handleDates,
        onResetRange: handleResetRange,
        resolution: resolution
      })), showOccupants && /*#__PURE__*/React__default.createElement(OccupantLG, null, /*#__PURE__*/React__default.createElement(OccupantForm, {
        occupantInfo: occupants,
        onAddRoom: handleAddRoom,
        onDeleteRoom: handleDeleteRoom,
        sendOccupants: handleOccupantsDesktop,
        onOccupantsChanged: handleOccupantsChanged,
        resolution: resolution,
        roomDenomination: roomDenomination,
        selectorMode: selectorMode,
        showMultipleAccommodations: showMultipleAccommodations
      })), /*#__PURE__*/React__default.createElement(DivButtonPromoCode, null, /*#__PURE__*/React__default.createElement(DivPromoCodeLG, null, /*#__PURE__*/React__default.createElement(PromoCode$1, {
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        onPromoCodeChanged: onPromoCodeChanged,
        promoCodes: promoCodes,
        hidePromoCode: hidePromoCode,
        openPromoCode: openPromoCode
      })), /*#__PURE__*/React__default.createElement(DivButtonLG, null, /*#__PURE__*/React__default.createElement(ButtonCheckAvaialability, {
        onSearchButtonClicked: handleSearchButtonClicked,
        showAnimation: showAnimation,
        deviceType: constants.DEVICE_TYPE.DESKTOP,
        resolution: constants.RESOLUTION.LG
      }))))), showLoginLoyalty && /*#__PURE__*/React__default.createElement(AccountBanner, {
        linkToLogin: linkToLogin,
        linkToSignUp: linkToSignUp,
        user: loyaltyUser,
        onLogOut: onLogOut,
        loyalty: loyalty,
        padding: "20px 10px 10px 20px",
        history: history,
        params: params,
        handleCloseModal: handleCloseModal,
        handleModalContent: handleModalContent,
        showBackArrow: showBackArrow,
        myAccountClicked: myAccountClicked,
        myReservationsClicked: myReservationsClicked
      }));

    default:
      return /*#__PURE__*/React__default.createElement(React.Fragment, null);
  }
}

BookingForm.propTypes = {
  element: PropTypes__default.any,
  filterData,
  hidePromoCode: PropTypes__default.bool,
  hotelSiteURL,
  linkToLogin: PropTypes__default.string,
  linkToSignUp: PropTypes__default.string,
  locale,
  logoSrc,
  occupantInfo,
  onPromoCodeChanged: PropTypes__default.func,
  onDatesChanged: PropTypes__default.func,
  onFilterChanged: PropTypes__default.func,
  onLogOut: PropTypes__default.func,
  onMenuClicked: PropTypes__default.func,
  onOccupantsChanged: PropTypes__default.func,
  onOpenExternalMenu,
  onSearchButtonClicked: PropTypes__default.func,
  onSendSearchValue,
  openPromoCode: PropTypes__default.bool,
  promoCodes,
  resolution,
  roomDenomination,
  selectedEndDate,
  selectedFilterValue,
  selectedStartDate,
  selectorMode,
  showFilter,
  showMenuOption,
  showMobileLogo: PropTypes__default.bool,
  showDesktopLogo: PropTypes__default.bool,
  showMultipleAccommodations,
  showLoginLoyalty: PropTypes__default.bool,
  textNoOptions: PropTypes__default.string
};
var index$2 = reactIntl.injectIntl(BookingForm);

function _templateObject2$l() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 0 0 41px;\n  width: 41px;\n  cursor: pointer;\n  position: relative;\n  svg {\n    width: 16px;\n    height: 16px;\n    fill: ", ";\n  }\n\n  &:not(:last-child) {\n    border-right: 1px solid ", ";\n  }\n\n  ", ";\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  height: 31px;\n  border-radius: 3px;\n  border: 1px solid ", ";\n  background-color: ", ";\n\n  @media (min-width: ", ") {\n    .wbkv9-ButtonBar-buttonHide {\n      display: none;\n    }\n  }\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var ButtonBarContainer = styled__default.div(_templateObject$o(), greyLighter, white, minWidthLaptop);
var ButtonItem = styled__default.div(_templateObject2$l(), greyLight, greyLighter, props => props.hasBadge && "\n    :before {\n    content: \"\";\n    width: 5px;\n    height: 5px;\n    background: ".concat(wbRed, ";\n    border-radius: 100%;\n    position: absolute;\n    top: 5px;\n    right: 8px;\n    }"));

function ButtonBar(_ref) {
  var {
    buttonList
  } = _ref;
  return /*#__PURE__*/React__default.createElement(ButtonBarContainer, {
    className: "wbkv9-ButtonBar-container"
  }, buttonList && buttonList.map(button => /*#__PURE__*/React__default.createElement(ButtonItem, {
    className: classnames("wbkv9-ButtonBar-buttonItem", button.hide && "wbkv9-ButtonBar-buttonHide"),
    hasBadge: button.hasBadge,
    onClick: button.handleClick,
    key: button.key
  }, button.icon)));
}

ButtonBar.defaultProps = {
  buttonList: []
};
ButtonBar.propTypes = {
  buttonList: PropTypes__default.arrayOf(PropTypes__default.shape({
    key: PropTypes__default.string,
    icon: PropTypes__default.string,
    hide: PropTypes__default.bool,
    hasBadge: PropTypes__default.bool,
    handleClick: PropTypes__default.func
  }))
};

function _templateObject5$d() {
  var data = _taggedTemplateLiteral(["\n  height: 13px;\n  fill: #908f96;\n  color: #908f96;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 13px;\n  text-decoration: underline;\n  display: flex;\n  align-items: center;\n  width: auto;\n  &:hover {\n    cursor: pointer;\n    fill: #222222;\n    color: #222222;\n  }\n"]);

  _templateObject5$d = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$g() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject4$g = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  height: auto;\n  color: #908f96;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  margin-bottom: 20px;\n  display: inline-block;\n  & p {\n    margin: 0 0 0 0;\n  }\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  height: auto;\n  color: #222222;\n  text-transform: capitalize;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 13px;\n  margin-bottom: 7px;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px 20px 20px 20px;\n\n  & li {\n    margin-left: 20px;\n  }\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
var Body = styled__default.div(_templateObject$p());
var Title = styled__default.div(_templateObject2$m());
var Text = styled__default.div(_templateObject3$h());
var TextInline = styled__default.div(_templateObject4$g());
var Expandable = styled__default.div(_templateObject5$d());

/** A generic component that receives title and text props from the default Conditions component
 * and renders them. If the HTML received is in a string, it injects it using
 * dangerouslySetInnerHTML. */

function ConditionItem(props) {
  var {
    title,
    text
  } = props;
  return /*#__PURE__*/React__default.createElement("div", {
    className: props.className
  }, title && /*#__PURE__*/React__default.createElement(Title, null, title), /*#__PURE__*/React__default.createElement(Text, null, typeof text === "string" ? /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }) : text));
}
ConditionItem.defaultProps = {
  title: "",
  text: "text",
  className: ""
};
ConditionItem.propTypes = {
  title: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string]),
  text: PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string]),
  className: PropTypes__default.string
};

var ArrowKeyboardDown = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
})), "ArrowKeyboardDown");

var ArrowKeyboardUp = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
})), "ArrowKeyboardUp");

function _templateObject3$i() {
  var data = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 22px;\n"]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = _taggedTemplateLiteral(["\n  width: 22px;\n  height: 22px;\n  transform: translateY(1px);\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    font-size: 14px;\n  }\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$2 = reactIntl.defineMessages({
  moreInfo: {
    id: "condition.info.moreInfo",
    description: "More info button text",
    defaultMessage: "More info"
  },
  hideInfo: {
    id: "condition.info.hideInfo",
    description: "Hide info button text",
    defaultMessage: "Hide info"
  }
});
/** A component that receives title and text props and passes them to the
 *  ConditionItem component. By default the ConditionItem component is not rendered
 *  and the isExpanded state is false.
 * When .readMore is clicked, it calls the handleClick function which changes the isExpanded state
 * to the opposite (i.e. true) and as a consequence ConditionItem is rendered,
 * .readMore is not rendered and .lessInfo is rendered instead,
 * which also calls handleClick on click. */

var StyledReadMore = styled__default.div(_templateObject$q(), Expandable);
var StyledArrowKeyboardDown = styled__default(ArrowKeyboardDown)(_templateObject2$n());
var StyledArrowKeyboardUp = styled__default(ArrowKeyboardUp)(_templateObject3$i());

class ReadMore extends React.Component {
  constructor() {
    super();
    this.state = {
      isExpanded: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(StyledReadMore, null, this.state.isExpanded && /*#__PURE__*/React__default.createElement(ConditionItem, {
      title: this.props.title,
      text: this.props.text
    }), !this.state.isExpanded && /*#__PURE__*/React__default.createElement(Expandable, {
      className: "readMore",
      onClick: this.handleClick
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$2.moreInfo), /*#__PURE__*/React__default.createElement(StyledArrowKeyboardDown, null)), this.state.isExpanded && /*#__PURE__*/React__default.createElement(Expandable, {
      className: "lessInfo",
      onClick: this.handleClick
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$2.hideInfo), /*#__PURE__*/React__default.createElement(StyledArrowKeyboardUp, null)));
  }

}

ReadMore.defaultProps = {
  text: "text"
};
ReadMore.propTypes = {
  title: PropTypes__default.object.isRequired,
  text: PropTypes__default.string
};
var ReadMore$1 = pure(ReadMore);

function _templateObject5$e() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"]);

  _templateObject5$e = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$h() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject4$h = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$j() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  border-spacing: 0;\n  text-align: left;\n  & td,\n  th {\n    padding: 12px;\n    border: 0.5px solid #e1e1e1;\n  }\n\n  & thead {\n    font-weight: 700;\n    background-color: #f6f6f6;\n  }\n\n  & thead tr th:first-child {\n    border-top-left-radius: 5px;\n  }\n  & thead tr th:last-child {\n    border-top-right-radius: 5px;\n  }\n\n  & tbody tr:last-child {\n    & td:first-child {\n      border-bottom-left-radius: 5px;\n    }\n    & td:last-child {\n      border-bottom-right-radius: 5px;\n    }\n  }\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 10px;\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin-bottom: 15px;\n  color: ", ";\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$3 = reactIntl.defineMessages({
  date: {
    id: "modalConditions.cancellation.dates",
    description: "Dates",
    defaultMessage: "Dates"
  },
  penalty: {
    id: "modalConditions.cancellation.penalty",
    description: "Penalty",
    defaultMessage: "Penalty"
  },
  until: {
    id: "modalConditions.cancellation.until",
    description: "Until",
    defaultMessage: "Until"
  },
  from: {
    id: "modalConditions.cancellation.from",
    description: "From",
    defaultMessage: "From"
  },
  to: {
    id: "modalConditions.cancellation.to",
    description: "to",
    defaultMessage: "to"
  },
  header: {
    id: "modalConditions.cancellation.constraintsTitle",
    description: "Cancellation constraints",
    defaultMessage: "Cancellation constraints"
  },
  firstNight: {
    id: "modalConditions.cancellation.penaltyTable.firstNight",
    description: "First night",
    defaultMessage: "First night"
  },
  untilHours: {
    id: "modalConditions.cancellation.penaltyTable.untilHours",
    description: "Until",
    defaultMessage: "Until"
  },
  localTime: {
    id: "modalConditions.cancellation.penaltyTable.localTime",
    description: "Local Time",
    defaultMessage: "Local Time"
  }
});
var StyledCancellationTable = styled__default.div(_templateObject$r(), wbBlack);
var Header = styled__default.div(_templateObject2$o());
var Table = styled__default.table(_templateObject3$j());
var StyledCell = styled__default.td(_templateObject4$h(), props => props.green ? "font-weight: 700;\n  color: #329911;" : undefined);
var LegendWrapper = styled__default.div(_templateObject5$e(), greyLight);

function getFormattedValue(val1, val2) {
  return /*#__PURE__*/React__default.createElement("span", null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: val1,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }), " ", val2 !== undefined ? /*#__PURE__*/React__default.createElement("span", null, "(", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: val2,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }), "%)") : /*#__PURE__*/React__default.createElement("span", null, "(", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.firstNight), ")"));
}

function typeSwitch(restriction, amount, firstNightCost) {
  switch (restriction.type) {
    case constants.CANCELLATION_POLICY_RESTRICTION_TYPE.FIX_AMOUNT:
      return getFormattedValue(restriction.penalty, restriction.penalty / amount * 100);

    case constants.CANCELLATION_POLICY_RESTRICTION_TYPE.PERCENTAGE:
      return getFormattedValue(restriction.penalty / 100 * amount, restriction.penalty);

    case constants.CANCELLATION_POLICY_RESTRICTION_TYPE.CHARGE_FIRST_NIGHT:
      return getFormattedValue(firstNightCost);

    default:
      return /*#__PURE__*/React__default.createElement("span", null, " An error has occurred ");
  }
}

function DateRenderer(_ref) {
  var {
    restriction,
    cutOffDate,
    sortedRestrictions,
    checkIn,
    index
  } = _ref;

  if (!restriction.maxRelease && !restriction.minRelease) {
    return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.from), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
      value: moment(cutOffDate).toDate()
    }));
  } else if (sortedRestrictions.length > 1 && index === 0) {
    return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.until), " ");
  } else {
    var _restriction$maxRelea;

    return /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.from), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
      value: new Date(restriction.maxRelease)
    }), " ", (restriction === null || restriction === void 0 ? void 0 : restriction.maxReleaseTimeLimit) && /*#__PURE__*/React__default.createElement("span", null, " ", (restriction === null || restriction === void 0 ? void 0 : (_restriction$maxRelea = restriction.maxReleaseTimeLimit) === null || _restriction$maxRelea === void 0 ? void 0 : _restriction$maxRelea.timeLimit) || (restriction === null || restriction === void 0 ? void 0 : restriction.maxReleaseTimeLimit), " h*"));
  }
}

function CancellationTable(_ref2) {
  var {
    amount,
    restrictions,
    currency,
    cutOffDate,
    firstNightCost,
    checkIn
  } = _ref2;
  var formattedCutOffDate = moment(cutOffDate).format("YYYY-MM-DD HH:MM");
  var showHoursCutOffDate = moment(checkIn).subtract(3, "days");
  var sortedRestrictions = restrictions && restrictions.length > 0 && JSON.parse(JSON.stringify(restrictions));
  sortedRestrictions = sortedRestrictions.filter(restriction => {
    var _restriction$minRelea;

    return !moment("".concat(restriction.minRelease, " ").concat(typeof restriction.minReleaseTimeLimit === "string" ? restriction.minReleaseTimeLimit : (_restriction$minRelea = restriction.minReleaseTimeLimit) === null || _restriction$minRelea === void 0 ? void 0 : _restriction$minRelea.timeLimit)).isBefore(formattedCutOffDate);
  });
  sortedRestrictions = sortedRestrictions.map(restriction => {
    if (restriction.minRelease && moment(restriction.minRelease).isBefore(showHoursCutOffDate)) {
      delete restriction.minReleaseTimeLimit;
    }

    if (restriction.maxRelease && moment(restriction.maxRelease).isBefore(showHoursCutOffDate)) {
      delete restriction.maxReleaseTimeLimit;
    }

    return restriction;
  });

  if (sortedRestrictions && sortedRestrictions.length > 0) {
    sortedRestrictions.sort((first, second) => {
      if (!first.maxRelease) {
        return -1;
      }

      return first.maxRelease && second.maxRelease && moment(first.maxRelease).isBefore(second.maxRelease) ? -1 : first.maxRelease && second.maxRelease && moment(first.maxRelease).isAfter(second.maxRelease) ? 1 : 0;
    });
  }

  if (sortedRestrictions.length > 0 && moment(sortedRestrictions[0].maxRelease).isBefore(formattedCutOffDate)) {
    sortedRestrictions[0].maxRelease = formattedCutOffDate;
  } // FIXME: remove when migration is done


  return /*#__PURE__*/React__default.createElement("div", null, window.showCancelMsg && sortedRestrictions && sortedRestrictions.length > 0 && (amount || firstNightCost) && /*#__PURE__*/React__default.createElement(StyledCancellationTable, null, /*#__PURE__*/React__default.createElement(Header, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.header)), /*#__PURE__*/React__default.createElement(Table, null, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.date)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.penalty)))), /*#__PURE__*/React__default.createElement("tbody", null, sortedRestrictions.map((restriction, index) => {
    var _restriction$minRelea2;

    var green = !restriction.penalty && restriction.type !== constants.CANCELLATION_POLICY_RESTRICTION_TYPE.CHARGE_FIRST_NIGHT;
    return (
      /*#__PURE__*/
      // Index as key would not be a problem since the list won't be rearranged
      // eslint-disable-next-line
      React__default.createElement("tr", {
        key: index
      }, /*#__PURE__*/React__default.createElement(StyledCell, {
        green: green
      }, /*#__PURE__*/React__default.createElement(DateRenderer, {
        restriction: restriction,
        cutOffDate: cutOffDate,
        sortedRestrictions: sortedRestrictions,
        checkIn: checkIn,
        index: index
      }), restriction.minRelease && /*#__PURE__*/React__default.createElement("span", null, "\xA0", restriction.maxRelease && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.to), " "), /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
        value: sortedRestrictions.length === index + 1 ? moment(restriction.minRelease).toDate() : moment(restriction.minRelease).toDate()
      })), (restriction === null || restriction === void 0 ? void 0 : restriction.minReleaseTimeLimit) && index + 1 !== sortedRestrictions.length && /*#__PURE__*/React__default.createElement("span", null, " ", (restriction === null || restriction === void 0 ? void 0 : (_restriction$minRelea2 = restriction.minReleaseTimeLimit) === null || _restriction$minRelea2 === void 0 ? void 0 : _restriction$minRelea2.timeLimit) || (restriction === null || restriction === void 0 ? void 0 : restriction.minReleaseTimeLimit), " ", "h*")), /*#__PURE__*/React__default.createElement(StyledCell, {
        green: green
      }, /*#__PURE__*/React__default.createElement("span", null, currency), " ", typeSwitch(restriction, amount, firstNightCost)))
    );
  })))), /*#__PURE__*/React__default.createElement(LegendWrapper, null, "* ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$3.localTime)));
} //TODO: Correct proptypes
// CancellationTable.propTypes = {
//   currency: PropTypes.string.isRequired,
//   firstNightCost: PropTypes.number.isRequired,
//   checkIn: PropTypes.instanceOf(Date).isRequired,
//   amount: PropTypes.number.isRequired,
//   restrictions: PropTypes.array.isRequired,
//   cutOffDate: Date.now()
// };


CancellationTable.defaultProps = {
  currency: "EUR",
  checkIn: moment(new Date()).add(20, "days").toDate(),
  amount: 1000,
  cutOffDate: PropTypes__default.instanceOf(Date)
};
var CancellationTable$1 = pure(CancellationTable);

function _templateObject4$i() {
  var data = _taggedTemplateLiteral(["\n  min-height: 400px;\n"]);

  _templateObject4$i = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$k() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", " 1px solid;\n  display: ", ";\n"]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$p() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  border: solid;\n  border-width: 0 2px 2px 0;\n  display: inline-block;\n  padding: 3px;\n  transform: ", ";\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border-bottom: ", " 1px solid;\n  padding: 20px;\n  & > *:first-child {\n    font-weight: bold;\n  }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$4 = reactIntl.defineMessages({
  checkIn: {
    id: "condition.info.checkIn",
    description: "Condition info to check In",
    defaultMessage: "Check-in"
  },
  checkOut: {
    id: "condition.info.checkOut",
    description: "Condition info to check Out",
    defaultMessage: "Check-out"
  },
  childrenAndExtraBed: {
    id: "condition.info.childrenAndExtraBed",
    description: "Condition info if children and extra beds necessary",
    defaultMessage: "Children and Extra Beds"
  },
  pets: {
    id: "condition.info.pets",
    description: "Condition info that ask for pets",
    defaultMessage: "Pets"
  },
  groups: {
    id: "condition.info.groups",
    description: "Condition info that ask for groups",
    defaultMessage: "Groups"
  },
  additionalInfo: {
    id: "condition.info.additionalInfo",
    description: "Condition that ask for additional information",
    defaultMessage: "Additional Info"
  },
  timetable: {
    id: "condition.info.timetable",
    description: "Condition info of the timetable",
    defaultMessage: "Timetable"
  }
});
/** Default component that receives a JSON that contain various properties as a conditions prop.
 *  Cancellation, entry, exit, children, pets, groups and additionalInfo are passed down as props
 *  to sub-components. If a property has an empty value the sub-component is not rendered. */

var ConditionHeader = styled__default.div(_templateObject$s(), greyLighter);
var Chevron = styled__default.span(_templateObject2$p(), props => props.up ? "rotate(-135deg)" : "rotate(45deg)");
var ConditionBody = styled__default.div(_templateObject3$k(), greyLighter, props => props.expanded ? "block" : "none");
var ConditionsListWrapper = styled__default.div(_templateObject4$i());

function Conditions(props) {
  var {
    conditions,
    checkIn,
    amount,
    restrictions,
    currency,
    firstNightCost,
    showCancellationTable,
    cutOffDate,
    className,
    cancellationPoliciesInfo,
    conditionsList
  } = props;
  var [expandedConditionIndex, setExpandedConditionIndex] = React.useState(Array.isArray(conditionsList) && conditionsList.length === 1 ? 0 : undefined);
  var handleHeaderClick = React.useCallback(idx => {
    if (idx === expandedConditionIndex) {
      setExpandedConditionIndex(undefined);
    } else {
      setExpandedConditionIndex(idx);
    }
  }, [expandedConditionIndex, setExpandedConditionIndex]);

  var conditionBody = (_ref) => {
    var {
      conditions,
      checkIn,
      amount,
      restrictions,
      currency,
      firstNightCost,
      showCancellationTable,
      cutOffDate,
      className,
      cancellationPoliciesInfo
    } = _ref;
    return /*#__PURE__*/React__default.createElement(Body, {
      className: className
    }, conditions.cancellation && /*#__PURE__*/React__default.createElement(ConditionItem, {
      className: "cancellation",
      text: conditions.cancellation
    }), window.showCancelMsg && showCancellationTable && restrictions && restrictions.length > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(CancellationTable$1, {
      checkIn: checkIn,
      amount: amount,
      restrictions: restrictions,
      currency: currency,
      firstNightCost: firstNightCost,
      cutOffDate: cutOffDate
    }), cancellationPoliciesInfo && /*#__PURE__*/React__default.createElement(ConditionItem, {
      className: "cancellationPoliciesInfo",
      text: cancellationPoliciesInfo
    })), conditions.entry && conditions.exit && /*#__PURE__*/React__default.createElement(ConditionItem, {
      className: "entryAndExit",
      title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.timetable),
      text: /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.checkIn), ": ", /*#__PURE__*/React__default.createElement(TextInline, null, /*#__PURE__*/React__default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: conditions.entry
        }
      }))), /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.checkOut), ": ", /*#__PURE__*/React__default.createElement(TextInline, null, /*#__PURE__*/React__default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: conditions.exit
        }
      }))))
    }), conditions.pets && /*#__PURE__*/React__default.createElement(ConditionItem, {
      className: "pets",
      title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.pets),
      text: conditions.pets
    }), conditions.children && /*#__PURE__*/React__default.createElement(ConditionItem, {
      className: "children",
      title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.childrenAndExtraBed),
      text: conditions.children
    }), conditions.groups && /*#__PURE__*/React__default.createElement(ConditionItem, {
      className: "groups",
      title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.groups),
      text: conditions.groups
    }), conditions.additionalInfo && /*#__PURE__*/React__default.createElement(ReadMore$1, {
      className: "additionalInfo",
      title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$4.additionalInfo),
      text: conditions.additionalInfo,
      readMore: "Read more",
      lessInfo: "Less info"
    }));
  };

  if (Array.isArray(conditionsList) && conditionsList.length > 0) {
    return /*#__PURE__*/React__default.createElement(ConditionsListWrapper, null, conditionsList.map((condition, idx) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ConditionHeader, {
      onClick: () => handleHeaderClick(idx)
    }, /*#__PURE__*/React__default.createElement("span", null, condition.name), " \xA0", " ", /*#__PURE__*/React__default.createElement("span", null, "(", condition.checkIn, " - ", condition.checkOut, ")"), /*#__PURE__*/React__default.createElement(Chevron, {
      up: expandedConditionIndex === idx
    })), /*#__PURE__*/React__default.createElement(ConditionBody, {
      expanded: expandedConditionIndex === idx
    }, conditionBody(_objectSpread2({}, condition))))));
  } else {
    return conditionBody({
      conditions,
      checkIn,
      amount,
      restrictions,
      currency,
      firstNightCost,
      showCancellationTable,
      cutOffDate,
      className,
      cancellationPoliciesInfo
    });
  }
}

Conditions.defaultProps = {
  conditions: {},
  showCancellationTable: false,
  className: "",
  cutOffDate: Date.now(),
  cancellationPoliciesInfo: ""
};
Conditions.propTypes = {
  className: PropTypes__default.string,
  cancellationPoliciesInfo: PropTypes__default.string,
  showCancellationTable: PropTypes__default.bool,
  currency: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.oneOfType([PropTypes__default.instanceOf(Date), PropTypes__default.string]),
  amount: PropTypes__default.number,
  restrictions: PropTypes__default.array,
  firstNightCost: PropTypes__default.number,
  cutOffDate: PropTypes__default.oneOfType([PropTypes__default.instanceOf(Date), PropTypes__default.number]),

  /** JSON Object */
  conditions: PropTypes__default.shape({
    active: PropTypes__default.bool,

    /** Additional Info Text */
    additionalInfo: PropTypes__default.string,
    availability: PropTypes__default.any,
    availableSince: PropTypes__default.any,
    availableUntil: PropTypes__default.any,

    /** Cancellation Text */
    cancellation: PropTypes__default.string,

    /** Children Text */
    children: PropTypes__default.string,
    color: PropTypes__default.string,

    /** Description Text */
    description: PropTypes__default.string,
    discountTickers: PropTypes__default.any,
    discounts: PropTypes__default.any,
    earlyCharge: PropTypes__default.number,

    /** Entry Text */
    entry: PropTypes__default.string,

    /** Exit Text */
    exit: PropTypes__default.string,

    /** Groups Text */
    groups: PropTypes__default.string,
    lock: PropTypes__default.any,
    maxNotice: PropTypes__default.any,
    maxStay: PropTypes__default.any,
    media: PropTypes__default.any,
    minNotice: PropTypes__default.any,
    minStay: PropTypes__default.any,
    minimumCharge: PropTypes__default.number,
    name: PropTypes__default.string,
    order: PropTypes__default.number,
    payFirstNight: PropTypes__default.bool,
    paymentTypes: PropTypes__default.arrayOf(PropTypes__default.shape({
      active: PropTypes__default.bool,
      advancePayment: PropTypes__default.bool,
      configurationParams: PropTypes__default.any,
      dateCreation: PropTypes__default.any,
      dateModification: PropTypes__default.any,
      description: PropTypes__default.any,
      name: PropTypes__default.string,
      order: PropTypes__default.number,
      paymentPercentage: PropTypes__default.number,
      ticker: PropTypes__default.string,
      type: PropTypes__default.string
    })),

    /** Pets Text */
    pets: PropTypes__default.string,
    promoCodes: PropTypes__default.any,
    promotionalRate: PropTypes__default.any,
    rackRate: PropTypes__default.any,
    rate: PropTypes__default.any,
    ticker: PropTypes__default.string,
    validSince: PropTypes__default.any,
    validUntil: PropTypes__default.any
  })
};
var Conditions$1 = pure(Conditions);

function _templateObject2$q() {
  var data = _taggedTemplateLiteral(["\n        @media (max-width: ", "px) {\n          ", ";\n        }\n      "]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", "px) {\n          ", ";\n        }\n      "]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var sizes = {
  xs: 0,
  sm: 375,
  sml: 480,
  md: 768,
  mdm: 940,
  mdl: 1024,
  lg: 1280,
  xl: 1366,
  xxl: 1920
}; // Iterate through the sizes and create a media template

var media = {
  up: Object.keys(sizes).reduce((acc, label) => {
    acc[label] = function () {
      return styled.css(_templateObject$t(), sizes[label], styled.css( //@ts-ignore
      ...arguments));
    };

    return acc;
  }, {}),
  down: Object.keys(sizes).reduce((acc, label) => {
    acc[label] = function () {
      return styled.css(_templateObject2$q(), sizes[label], styled.css( //@ts-ignore
      ...arguments));
    };

    return acc;
  }, {})
};

function _templateObject4$j() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  "]);

  _templateObject4$j = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$l() {
  var data = _taggedTemplateLiteral(["\n  height: 35px;\n  width: 100%;\n  font-size: ", ";\n  border-radius: 3px;\n  border: 1px solid ", ";\n  padding-left: 8px;\n  ", ";\n"]);

  _templateObject3$l = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  ", ";\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var Label = styled__default.label(_templateObject$u(), props => props.inCustomerForm ? "11px" : "12px", props => props.inCustomerForm ? "#bbbbbb" : "black", media.up.md(_templateObject2$r(), props => props.inCustomerForm ? "13px" : "14px"));
var StyledInput = styled__default.input(_templateObject3$l(), props => props.inCustomerForm ? "11px" : "12px", props => props.hasError ? "#fd2734" : "#e1e1e1", media.up.md(_templateObject4$j()));

function Input(_ref) {
  var {
    disabled,
    field,
    hasError,
    onChangeField,
    value,
    obligatory,
    onBlur,
    inCustomerForm
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, field.label && /*#__PURE__*/React__default.createElement(Label, {
    htmlFor: field.ticker,
    inCustomerForm: inCustomerForm
  }, " ", obligatory && "*", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, {
    id: field.label,
    defaultMessage: field.label
  })), /*#__PURE__*/React__default.createElement(StyledInput, {
    placeholder: field.placeholder && "".concat(obligatory ? "*" : "", " ").concat(field.placeholder),
    disabled: disabled,
    name: field.ticker,
    onChange: onChangeField,
    value: value,
    hasError: hasError,
    onBlur: onBlur,
    inCustomerForm: inCustomerForm
  }));
}

Input.propTypes = {
  field: PropTypes__default.object.isRequired,
  disabled: PropTypes__default.bool,
  onChangeField: PropTypes__default.func.isRequired,
  hasError: PropTypes__default.bool.isRequired,
  value: PropTypes__default.any,
  obligatory: PropTypes__default.bool,
  onBlur: PropTypes__default.func.isRequired,
  inCustomerForm: PropTypes__default.bool
};
Input.defaultProps = {
  disabled: false,
  value: undefined,
  obligatory: false,
  inCustomerForm: false
};

function _templateObject5$f() {
  var data = _taggedTemplateLiteral(["\n  color: black;\n"]);

  _templateObject5$f = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$k() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  "]);

  _templateObject4$k = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$m() {
  var data = _taggedTemplateLiteral(["\n  height: 35px;\n  width: 100%;\n  font-size: ", ";\n  border-radius: 3px;\n  border: 1px solid ", ";\n  padding-left: 8px;\n  ", ";\n  color: ", ";\n"]);

  _templateObject3$m = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$s() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  ", ";\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var Label$1 = styled__default.label(_templateObject$v(), props => props.inCustomerForm ? "11px" : "12px", props => props.inCustomerForm ? "#bbbbbb" : "black", media.up.md(_templateObject2$s(), props => props.inCustomerForm ? "13px" : "14px"));
var StyledSelect = styled__default.select(_templateObject3$m(), props => props.inCustomerForm ? "11px" : "12px", props => props.hasError ? "#fd2734" : "#e1e1e1", media.up.md(_templateObject4$k()), props => !props.value ? "#bbbbbb" : "black");
var StyledOption = styled__default.option(_templateObject5$f());

function Select$1(_ref) {
  var {
    disabled,
    field,
    hasError,
    onChangeField,
    value,
    obligatory,
    onBlur,
    inCustomerForm
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, field.label && /*#__PURE__*/React__default.createElement(Label$1, {
    htmlFor: field.ticker,
    inCustomerForm: inCustomerForm
  }, " ", obligatory && "*", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, {
    id: field.label,
    defaultMessage: field.label
  })), /*#__PURE__*/React__default.createElement(StyledSelect, {
    disabled: disabled,
    name: field.ticker,
    onChange: onChangeField,
    value: value,
    hasError: hasError,
    onBlur: onBlur,
    inCustomerForm: inCustomerForm
  }, field.placeholder && /*#__PURE__*/React__default.createElement(StyledOption, {
    value: "",
    disabled: true,
    selected: true,
    hidden: true
  }, " ", "".concat(obligatory ? "*" : "", "\n        ").concat(field.placeholder)), /*#__PURE__*/React__default.createElement(StyledOption, {
    value: ""
  }), field.items.map(item => /*#__PURE__*/React__default.createElement(StyledOption, {
    key: item.value,
    value: item.value
  }, item.label))));
}

Select$1.propTypes = {
  field: PropTypes__default.object.isRequired,
  disabled: PropTypes__default.bool,
  onChangeField: PropTypes__default.func.isRequired,
  hasError: PropTypes__default.bool.isRequired,
  value: PropTypes__default.any,
  obligatory: PropTypes__default.bool,
  onBlur: PropTypes__default.func.isRequired,
  inCustomerForm: PropTypes__default.bool
};
Select$1.defaultProps = {
  disabled: false,
  value: undefined,
  obligatory: false,
  inCustomerForm: false
};

function _templateObject4$l() {
  var data = _taggedTemplateLiteral(["\n\nfont-size: 14px;\n"]);

  _templateObject4$l = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$n() {
  var data = _taggedTemplateLiteral(["\n  height: 35px;\n  width: 100%;\n  font-size: 12px;\n  border-radius: 3px;\n  border: 1px solid ", ";\n  ", ";\n"]);

  _templateObject3$n = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteral(["\nfont-size: 14px;\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  ", ";\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var Label$2 = styled__default.label(_templateObject$w(), media.up.md(_templateObject2$t()));
var StyledDateSelect = styled__default.select(_templateObject3$n(), props => props.hasError ? "#fd2734" : "#e1e1e1", media.up.md(_templateObject4$l()));

function DateSelect(_ref) {
  var {
    disabled,
    field,
    hasError,
    onChangeField,
    value,
    startDate,
    endDate,
    datesList,
    obligatory,
    onBlur
  } = _ref;
  var dateItems = datesList ? datesList.map(date => date) : [];

  if (!datesList) {
    for (var currDate = moment(startDate); currDate.isBefore(endDate) || currDate.isSame(endDate); currDate.add(1, "days")) {
      dateItems.push({
        value: currDate.format("YYYY-MM-DD"),
        label: currDate.format("YYYY-MM-DD")
      });
    }
  }

  return /*#__PURE__*/React__default.createElement("div", null, field.label && /*#__PURE__*/React__default.createElement(Label$2, {
    htmlFor: field.ticker
  }, " ", obligatory && "*", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, {
    id: field.label,
    defaultMessage: field.label
  })), /*#__PURE__*/React__default.createElement(StyledDateSelect, {
    disabled: disabled,
    name: field.ticker,
    onChange: onChangeField,
    value: value,
    hasError: hasError,
    onBlur: onBlur
  }, /*#__PURE__*/React__default.createElement("option", {
    value: ""
  }, field.placeholder), dateItems.map(item => /*#__PURE__*/React__default.createElement("option", {
    key: item.value,
    value: item.value
  }, item.label))));
}

DateSelect.propTypes = {
  field: PropTypes__default.object.isRequired,
  disabled: PropTypes__default.bool,
  onChangeField: PropTypes__default.func.isRequired,
  hasError: PropTypes__default.bool.isRequired,
  value: PropTypes__default.any,
  startDate: PropTypes__default.instanceOf(Date).isRequired,
  endDate: PropTypes__default.instanceOf(Date).isRequired,
  datesList: PropTypes__default.array,
  obligatory: PropTypes__default.bool,
  onBlur: PropTypes__default.func.isRequired
};
DateSelect.defaultProps = {
  disabled: false,
  value: undefined,
  datesList: undefined,
  obligatory: false
};

function _templateObject7$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject7$7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$8() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  "]);

  _templateObject6$8 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$g() {
  var data = _taggedTemplateLiteral(["\n  height: 35px;\n  width: 100% !important;\n  font-size: ", ";\n  border-radius: 3px;\n  border: 1px solid ", ";\n  padding-left: 8px;\n  margin-left: 10px;\n  ", ";\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0;\n  }\n"]);

  _templateObject5$g = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$m() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  "]);

  _templateObject4$m = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$o() {
  var data = _taggedTemplateLiteral(["\n  height: 35px;\n  width: 40%;\n  font-size: 12px;\n  border-radius: 3px;\n  border: 1px solid ", ";\n  ", ";\n"]);

  _templateObject3$o = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n  "]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  ", ";\n  display: block;\n  margin-top: -5px;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var Label$3 = styled__default.label(_templateObject$x(), props => props.inCustomerForm ? "11px" : "12px", props => props.inCustomerForm ? "#bbbbbb" : "black", media.up.md(_templateObject2$u(), props => props.inCustomerForm ? "13px" : "14px"));
var StyledPrefixSelect = styled__default.select(_templateObject3$o(), props => props.hasError ? "#fd2734" : "#e1e1e1", media.up.md(_templateObject4$m()));
var StyledInput$1 = styled__default.input(_templateObject5$g(), props => props.inCustomerForm ? "11px" : "12px", props => props.hasError ? "#fd2734" : "#e1e1e1", media.up.md(_templateObject6$8()));
var DivPhone = styled__default.div(_templateObject7$7());

class Phone extends React__default.PureComponent {
  constructor(props) {
    var _this;

    super(props);
    _this = this;

    _defineProperty(this, "setPhoneObject", () => ({
      prefix: this.state.prefix,
      number: this.state.number
    }));

    _defineProperty(this, "handleChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (event) {
        var e = {
          target: {}
        };
        e.target.value = _this.setPhoneObject();
        e.target.name = _this.props.field.ticker;

        _this.setState({
          [event.target.name]: event.target.value
        });

        _this.props.onChangeField(e);
      });

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    this.state = {
      number: props.value && props.value.number ? props.value.number : "",
      prefix: props.value && props.value.prefix ? props.value.prefix : "+34"
    };
  }

  render() {
    var {
      disabled,
      field,
      hasError,
      obligatory,
      onBlur,
      inCustomerForm,
      phonePrefixes = this.context.phonePrefixes
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", null, field.label && /*#__PURE__*/React__default.createElement(Label$3, {
      htmlFor: field.ticker,
      inCustomerForm: inCustomerForm
    }, " ", obligatory && "*", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, {
      id: field.label,
      defaultMessage: field.label
    })), /*#__PURE__*/React__default.createElement(DivPhone, null, /*#__PURE__*/React__default.createElement(StyledPrefixSelect, {
      disabled: disabled,
      name: "prefix",
      onChange: this.handleChange,
      value: this.state.prefix,
      hasError: hasError,
      onBlur: onBlur
    }, phonePrefixes.map((item, idx) => /*#__PURE__*/React__default.createElement("option", {
      key: idx,
      value: item.dial_code
    }, item.dial_code))), /*#__PURE__*/React__default.createElement(StyledInput$1, {
      type: "number",
      placeholder: field.placeholder && "".concat(obligatory ? "*" : "", " ").concat(field.placeholder),
      disabled: disabled,
      name: "number",
      onChange: this.handleChange,
      value: this.state.number,
      hasError: hasError,
      onBlur: onBlur,
      inCustomerForm: inCustomerForm
    })));
  }

}

Phone.propTypes = {
  value: PropTypes__default.any,
  field: PropTypes__default.object.isRequired,
  disabled: PropTypes__default.bool,
  onChangeField: PropTypes__default.func.isRequired,
  hasError: PropTypes__default.bool.isRequired,
  prefix: PropTypes__default.any,
  number: PropTypes__default.any,
  obligatory: PropTypes__default.bool,
  onBlur: PropTypes__default.func.isRequired,
  inCustomerForm: PropTypes__default.bool,
  phonePrefixes: PropTypes__default.array
};
Phone.defaultProps = {
  disabled: false,
  prefix: undefined,
  number: undefined,
  obligatory: false,
  inCustomerForm: false,
  value: undefined
};
Phone.contextTypes = {
  phonePrefixes: PropTypes__default.array
};

var WIDGET = {
  INPUT: "INPUT",
  SELECT: "SELECT",
  STAY_DATE: "STAY_DATE",
  PHONE: "PHONE"
};

class FieldRenderer extends React__default.PureComponent {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _defineProperty(this, "handleOnChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (event) {
        var value = Object.prototype.hasOwnProperty.call(event.target, "checked") ? event.target.checked : event.target.value;
        var field = event.target.name;
        return _this.props.onChangeField({
          field,
          value
        });
      });

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }

  render() {
    var {
      field,
      value,
      hasError,
      values,
      startDate,
      endDate,
      datesList,
      obligatory,
      onBlur,
      inCustomerForm
    } = this.props;

    if (field.visible) {
      var isVisible = field.visible({
        field,
        value,
        values
      });

      if (!isVisible) {
        return null;
      }
    }

    switch (field.widget) {
      case WIDGET.INPUT:
        return /*#__PURE__*/React__default.createElement(Input, {
          disabled: field.disabled,
          field: field,
          hasError: hasError,
          onChangeField: this.handleOnChange,
          value: value,
          obligatory: obligatory,
          onBlur: onBlur,
          inCustomerForm: inCustomerForm
        });

      case WIDGET.SELECT:
        return /*#__PURE__*/React__default.createElement(Select$1, {
          field: field,
          disabled: field.disabled,
          value: value,
          onChangeField: this.handleOnChange,
          hasError: hasError,
          obligatory: obligatory,
          onBlur: onBlur,
          inCustomerForm: inCustomerForm
        });

      case WIDGET.STAY_DATE:
        return /*#__PURE__*/React__default.createElement(DateSelect, {
          field: field,
          disabled: field.disabled,
          value: value,
          onChangeField: this.handleOnChange,
          hasError: hasError,
          startDate: startDate,
          endDate: endDate,
          datesList: datesList,
          obligatory: obligatory,
          onBlur: onBlur
        });

      case WIDGET.PHONE:
        return /*#__PURE__*/React__default.createElement(Phone, {
          disabled: field.disabled,
          field: field,
          hasError: hasError,
          onChangeField: this.handleOnChange,
          value: value,
          obligatory: obligatory,
          onBlur: onBlur,
          inCustomerForm: inCustomerForm
        });

      case WIDGET.HIDDEN:
        return null;

      default:
        return /*#__PURE__*/React__default.createElement("div", null, field.fieldName);
    }
  }

}

FieldRenderer.propTypes = {
  field: PropTypes__default.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes__default.any,
  values: PropTypes__default.objectOf(PropTypes__default.any).isRequired,
  hasError: PropTypes__default.bool.isRequired,
  onChangeField: PropTypes__default.func.isRequired,
  startDate: PropTypes__default.instanceOf(Date),
  endDate: PropTypes__default.instanceOf(Date),
  datesList: PropTypes__default.array,
  obligatory: PropTypes__default.bool,
  onBlur: PropTypes__default.func.isRequired,
  inCustomerForm: PropTypes__default.bool
};
FieldRenderer.defaultProps = {
  value: undefined,
  datesList: undefined,
  obligatory: false,
  inCustomerForm: false
};

function _templateObject$y() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  & > * {\n    margin-top: 10px;\n  }\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}

validate$1.validators.phone = function (value, options) {
  if (!options.required && (!value || !value.prefix || !value.number)) {
    return undefined;
  }

  if (value.prefix && value.number) {
    return undefined;
  }

  return "Invalid";
};

var FormContainer = styled__default.div(_templateObject$y());

class FormGenerator extends React__default.PureComponent {
  constructor(props) {
    super(props); // Saves the constraints that come from the props in this binding;

    _defineProperty(this, "onBlur", event => {
      var touched = _objectSpread2({}, this.state.touched, {
        [event.target.name]: true
      });

      this.setState({
        touched
      });
    });

    _defineProperty(this, "handleFieldChange", (_ref) => {
      var {
        field,
        value
      } = _ref;

      if (value !== this.state.values[field]) {
        var error;
        var fieldConstraints = this.constraints[field];
        var fieldObject = this.props.formShape.fields.find(elem => elem.ticker === field);

        if (fieldObject.widget === "PHONE") {
          var required = Boolean(fieldConstraints && fieldConstraints.presence && fieldConstraints.presence.allowEmpty === false);
          fieldConstraints = _objectSpread2({}, fieldConstraints, {
            phone: {
              required
            }
          });
        }

        if (fieldConstraints) {
          var constraints = {
            field: fieldConstraints
          };
          error = validate$1({
            field: value
          }, constraints);
        }

        var values = Object.assign({}, this.state.values);
        values[field] = value;
        var errors = Object.assign({}, this.state.errors);
        errors[field] = error;
        var ticker = this.props.extraItemTicker || this.props.formShape.ticker;
        var label = this.label[field];
        this.setState({
          values,
          errors
        }, () => {
          if (this.props.isFormValid) {
            this.props.isFormValid(ticker, this.isValid());
          }

          this.props.updateFormValues({
            ticker,
            field,
            value,
            label,
            fieldObject
          });
        });
      }
    });

    _defineProperty(this, "isValid", () => {
      if (Object.values(this.state.errors).map(val => !!val).includes(true)) {
        return false;
      }

      return true;
    });

    _defineProperty(this, "touchAllOnSubmit", () => {
      var touched = _objectSpread2({}, this.state.touched);

      Object.keys(touched).forEach(key => {
        touched[key] = true;
      });
      this.setState({
        touched
      });
    });

    this.filteredFields = props.formShape.fields.filter(field => field.active);
    this.constraints = this.filteredFields.reduce((accum, it) => _objectSpread2({}, accum, {
      [it.ticker]: it.constraints ? it.constraints : undefined
    }), {});
    this.label = this.filteredFields.reduce((accum, it) => _objectSpread2({}, accum, {
      [it.ticker]: it.label ? it.label : undefined
    }), {});
    this.state = {
      // Initialize value tickers in state and give them defaultValues if they exist
      values: this.filteredFields.reduce((accum, it) => _objectSpread2({}, accum, {
        [it.ticker]: it.defaultValue ? it.defaultValue : undefined
      }), {}),
      // Initialize error tickers in state
      errors: this.filteredFields.reduce((accum, it) => _objectSpread2({}, accum, {
        [it.ticker]: undefined
      }), {}),
      touched: this.filteredFields.reduce((accum, it) => _objectSpread2({}, accum, {
        [it.ticker]: this.props.touch
      }), {})
    }; // Existent values come from a different prop than defaultValues atm

    this.fillValuesFromProps = () => {
      if (this.props.existentFormValues) {
        this.state.values = Object.assign(this.state.values, this.props.existentFormValues);
      }
    };

    this.initialValidateAll = () => {
      Object.keys(this.state.values).forEach(val => {
        if (this.constraints[val]) {
          var constraints = {
            [val]: this.constraints[val]
          };
          this.state.errors[val] = validate$1({
            [val]: this.state.values[val]
          }, constraints);
          return;
        }

        this.state.errors[val] = undefined;
      });
    };

    this.sendInitialValidate = () => {
      this.initialValidateAll();
      this.props.isFormValid(this.props.extraItemTicker || this.props.formShape.ticker, this.isValid());
    };

    this.fillValuesFromProps();
    this.sendInitialValidate();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.touch !== this.props.touch) {
      this.touchAllOnSubmit();
    }
  }

  render() {
    var {
      formShape: {
        fields
      },
      className,
      startDate,
      endDate,
      datesList,
      inCustomerForm
    } = this.props;
    return /*#__PURE__*/React__default.createElement(FormContainer, {
      className: className
    }, fields.filter(field => field.active).sort((curr, next) => curr.position < next.position ? -1 : undefined).map(field => /*#__PURE__*/React__default.createElement(FieldRenderer, {
      key: field.ticker,
      field: field,
      onChangeField: this.handleFieldChange,
      value: this.state.values[field.ticker],
      values: this.state.values,
      hasError: !!this.state.errors[field.ticker] && this.state.touched[field.ticker] === true,
      startDate: startDate,
      endDate: endDate,
      datesList: datesList,
      obligatory: !!(field.constraints && field.constraints.presence && field.constraints.presence.allowEmpty === false),
      onBlur: this.onBlur,
      inCustomerForm: inCustomerForm
    })));
  }

}

FormGenerator.propTypes = {
  className: PropTypes__default.string,
  formShape: PropTypes__default.object.isRequired,
  isFormValid: PropTypes__default.func,
  updateFormValues: PropTypes__default.func.isRequired,
  existentFormValues: PropTypes__default.object,
  extraItemTicker: PropTypes__default.string,
  startDate: PropTypes__default.instanceOf(Date),
  endDate: PropTypes__default.instanceOf(Date),
  datesList: PropTypes__default.array,
  touch: PropTypes__default.bool.isRequired,
  inCustomerForm: PropTypes__default.bool
};
FormGenerator.defaultProps = {
  className: "",
  isFormValid: () => {},
  existentFormValues: undefined,
  extraItemTicker: undefined,
  datesList: undefined,
  inCustomerForm: false
};

function _templateObject4$n() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  font-weight: 700;\n"]);

  _templateObject4$n = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$p() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject3$p = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$v() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  font-weight: 700;\n"]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px 20px;\n  font-size: 13px;\n  font-weight: 400;\n  text-transform: uppercase;\n  border-radius: 5px;\n  text-align: center;\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}
var Button = styled__default.div(_templateObject$z());
var GreenButton = styled__default(Button)(_templateObject2$v(), wbGreen, white);
var GreyButton = styled__default(Button)(_templateObject3$p(), greyLight, white, greyLight);
var RedButton = styled__default(Button)(_templateObject4$n(), wbRed, white);

function WitButton(_ref) {
  var {
    type,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, ["type", "children"]);

  switch (type) {
    case "green":
      return /*#__PURE__*/React__default.createElement(GreenButton, props, children);

    case "grey":
      return /*#__PURE__*/React__default.createElement(GreyButton, props, children);

    case "red":
      return /*#__PURE__*/React__default.createElement(RedButton, props, children);

    default:
      return null;
  }
}

WitButton.propTypes = {
  type: PropTypes__default.string,
  children: PropTypes__default.node
};

function _templateObject$A() {
  var data = _taggedTemplateLiteral([".wbkv9-Loader {.container {\n    .loader {\n      position: fixed;\n      margin: -23px 0 0 5px;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%,-50%);\n      width: 150px;\n      &:before {\n        content: '';\n        display: block;\n        padding-top: 100%;\n      }\n    }\n\n    .circular {\n      animation: rotate 2s linear infinite;\n      height: 100%;\n      transform-origin: center center;\n      width: 100%;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      margin: auto;\n    }\n\n    .path {\n      stroke-dasharray: 1, 200;\n      stroke-dashoffset: 0;\n      animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n      stroke-linecap: round;\n      stroke: red;\n    }\n\n    @keyframes rotate {\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes dash {\n      0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n      }\n      50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n      }\n      100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n      }\n    }\n\n    @keyframes color {\n      100%,\n      0% {\n        stroke: #d62d20;\n      }\n      40% {\n        stroke: #0057e7;\n      }\n      66% {\n        stroke: #008744;\n      }\n      80%,\n      90% {\n        stroke: #ffa700;\n      }\n    }\n\n}}"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}
var GlobalStyle$1 = styled.createGlobalStyle(_templateObject$A());

function Loader(props) {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GlobalStyle$1, null), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-Loader ".concat(props.className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "loader"
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: "circular",
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React__default.createElement("circle", {
    className: "path",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }))))));
}

Loader.defaultProps = {
  className: ""
};
Loader.propTypes = {
  className: PropTypes__default.string
};

function _templateObject16$1() {
  var data = _taggedTemplateLiteral(["\n    position: initial;\n    padding: 20px 23px 23px 23px;\n    & > *:not(:last-child) {\n      margin-bottom: 20px;\n    }"]);

  _templateObject16$1 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$2() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  font-size: 14px;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  ", ";\n"]);

  _templateObject15$2 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$2() {
  var data = _taggedTemplateLiteral(["\n  > div {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject14$2 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$2() {
  var data = _taggedTemplateLiteral(["\n  width: 150px;\n  margin-bottom: 0 !important;\n"]);

  _templateObject13$2 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n  display: flex;\n  justify-content: center;\n  padding: 15px;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 5px;\n"]);

  _templateObject12$2 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$3() {
  var data = _taggedTemplateLiteral(["\n       height: auto;\n       margin-right: 0;\n    "]);

  _templateObject11$3 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$3() {
  var data = _taggedTemplateLiteral(["\n       margin-left: 0;\n    "]);

  _templateObject10$3 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  & input {\n    margin-right: 10px;\n    cursor: pointer;\n    margin-left: 23px;\n    ", ";\n  }\n  & label {\n    cursor: pointer;\n    width: 100%;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    margin-right: 23px;\n    ", ";\n  }\n  display: flex;\n  align-items: center;\n"]);

  _templateObject9$4 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$5() {
  var data = _taggedTemplateLiteral(["\n    & > :first-child {\n    border-radius: 5px;\n    width: auto;\n    }\n    justify-content: flex-end;\n  "]);

  _templateObject8$5 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  align-items: center;\n  & > :first-child {\n    border-radius: 0;\n    width: 100%;\n  }\n  ", ";\n"]);

  _templateObject7$8 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$9() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin-bottom: 0;\n"]);

  _templateObject6$9 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$h() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 40px;\n  & input {\n    font-weight: 400;\n  }\n  & select {\n    font-weight: 400;\n  }\n  & label {\n    font-size: 15px;\n    color: ", ";\n  }\n"]);

  _templateObject5$h = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$o() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 15px;\n"]);

  _templateObject4$o = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$q() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 30px;\n  font-size: 15px;\n"]);

  _templateObject3$q = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$w() {
  var data = _taggedTemplateLiteral(["\n    max-height: 500px;\n  "]);

  _templateObject2$w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 14px;\n  padding: 23px 23px 0 23px;\n  position: relative;\n\n  ", ";\n  overflow: auto;\n\n  ", ";\n\n  & > *:not(:last-child) {\n    margin-bottom: 20px;\n  }\n\n  ", ";\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$5 = reactIntl.defineMessages({
  penalty: {
    id: "reservation_confirmed.cancellation.penalty",
    description: "Cancellation penalty",
    defaultMessage: "Cancellation penalty"
  },
  noPenalty: {
    id: "reservation_confirmed.cancellation.noPenalty",
    description: "No cancellation penalty",
    defaultMessage: "No cancellation penalty"
  },
  acceptCancelTerms: {
    id: "reservation_confirmed.cancellation.acceptCancelTerms",
    description: "I have a read and accepted the cancellation terms",
    defaultMessage: "I have a read and accepted the cancellation terms"
  },
  confirm: {
    id: "reservation_confirmed.cancellation.confirm",
    description: "Confirm cancellation",
    defaultMessage: "Confirm cancellation"
  },
  errorConditions: {
    id: "reservation_confirmed.cancellation.errorConditions",
    description: "You must accept the cancellation terms",
    defaultMessage: "You must accept the cancellation terms"
  },
  cannotBeEmpty: {
    id: "modalCancelation.emptyFields",
    description: "Check the fields in red",
    defaultMessage: "Check the fields in red"
  },
  cancellationError: {
    id: "reservation_confirmed.cancellation.cancellationError",
    description: "An error has occurred during cancellation. Please try again",
    defaultMessage: "An error has occurred during cancellation. Please try again"
  },
  multipleBooking: {
    id: "reservation_confirmed.cancellation.multipleBooking",
    description: "This is a multiple booking",
    defaultMessage: "This is a multiple booking"
  },
  bookings: {
    id: "reservation_confirmed.bookings",
    description: "bookings",
    defaultMessage: "bookings"
  },
  makeSure: {
    id: "reservation_confirmed.cancellation.makeSure",
    description: "Make sure you cancel all the undesired",
    defaultMessage: "Make sure you cancel all the undesired"
  }
});
var StyledCancellation = styled__default.div(_templateObject$B(), props => "max-height: calc(100vh - ".concat(props.bottomBoxHeight, "px - 55px);"), media.up.mdm(_templateObject2$w()), props => props.loading ? "::before {\n    content: \"\";\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: white;\n  }" : undefined);
var Penalty = styled__default.div(_templateObject3$q(), wbRed);
var NoPenalty = styled__default.div(_templateObject4$o(), wbGreen);
var StyledFormGenerator = styled__default(FormGenerator)(_templateObject5$h(), wbBlack);
var StyledConditions = styled__default(Conditions$1)(_templateObject6$9());
var FooterWrapper = styled__default.div(_templateObject7$8(), wbRed, media.up.sml(_templateObject8$5()));
var CheckboxContainer = styled__default.div(_templateObject9$4(), props => props.error ? 700 : 400, props => props.error ? wbRed : greyLight, media.up.sml(_templateObject10$3()), media.up.sml(_templateObject11$3()));
var ErrorMessage$1 = styled__default.div(_templateObject12$2(), wbRed, wbPink);
var StyledLoader = styled__default(Loader)(_templateObject13$2());
var StyledConditionItem = styled__default(ConditionItem)(_templateObject14$2());
var CheckboxButton = styled__default.div(_templateObject15$2(), media.up.sml(_templateObject16$1()));

function customFormObjectToString(customFormObject) {
  if (customFormObject) {
    var customFormString = "";
    Object.keys(customFormObject).forEach(key => {
      if (customFormObject[key].value) {
        customFormString += "".concat(customFormObject[key].value);
      }
    });
    return "".concat(customFormString, "\n    ");
  }

  return "";
}

class Cancellation extends React__default.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "updateCustomFormValues", (_ref) => {
      var {
        field,
        value,
        label,
        fieldObject
      } = _ref;

      var customFormValues = _objectSpread2({}, this.state.customFormValues);

      customFormValues[field] = {
        value,
        label,
        fieldObject
      };
      this.setState({
        customFormValues
      });
    });

    _defineProperty(this, "isFormValid", (formTicker, isValid) => {
      var formsValid = _objectSpread2({}, this.state.isFormValid);

      formsValid[formTicker] = isValid;
      this.setState({
        formsValid
      });
    });

    _defineProperty(this, "handleAcceptConditions", () => {
      this.setState({
        acceptedConditions: !this.state.acceptedConditions
      });
    });

    _defineProperty(this, "handleCancellation", () => {
      if (!this.state.buttonTouched) {
        this.setState({
          buttonTouched: true,
          touchAllChildren: true
        });
      }

      if (this.state.acceptedConditions && !Object.values(this.state.formsValid).includes(false)) {
        var cancellationReason = customFormObjectToString(this.state.customFormValues);
        this.props.handleCancellation(cancellationReason);
      }
    });

    this.state = {
      customFormValues: {},
      formsValid: {},
      acceptedConditions: false,
      buttonTouched: false,
      touchAllChildren: false,
      bottomBoxHeight: 70
    };
  }

  render() {
    var {
      conditions,
      checkIn,
      checkOut,
      amount,
      restrictions,
      currency,
      firstNightCost,
      cancellationFormQuestionnaire,
      cancellationError,
      loading,
      cancellationPoliciesInfo,
      totalActiveReservations
    } = this.props;
    var sortedRestrictions = restrictions && restrictions.length > 0 && JSON.parse(JSON.stringify(restrictions));

    if (sortedRestrictions && sortedRestrictions.length > 0) {
      sortedRestrictions.sort((first, second) => moment(first.maxRelease).isBefore(second.maxRelease) ? -1 : moment(first.maxRelease).isAfter(second.maxRelease) ? 1 : 0);
    }

    var currentDate = moment(Date.now()).format("YYYY-MM-DD");
    var currentRestriction = sortedRestrictions.find(restriction => (moment(currentDate).isAfter(moment(restriction.maxRelease)) || moment(currentDate).isSame(moment(restriction.maxRelease))) && (moment(currentDate).isBefore(moment(restriction.minRelease)) || moment(currentDate).isSame(moment(restriction.minRelease))));
    var penaltyAmount;

    if (currentRestriction && (currentRestriction.penalty || currentRestriction.type === constants.CANCELLATION_POLICY_RESTRICTION_TYPE.CHARGE_FIRST_NIGHT)) {
      switch (currentRestriction.type) {
        case constants.CANCELLATION_POLICY_RESTRICTION_TYPE.FIX_AMOUNT:
          penaltyAmount = currentRestriction.penalty;
          break;

        case constants.CANCELLATION_POLICY_RESTRICTION_TYPE.PERCENTAGE:
          penaltyAmount = currentRestriction.penalty / 100 * amount;
          break;

        case constants.CANCELLATION_POLICY_RESTRICTION_TYPE.CHARGE_FIRST_NIGHT:
          penaltyAmount = firstNightCost;
          break;

        default:
          return undefined;
      }
    }

    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledCancellation, {
      loading: loading,
      bottomBoxHeight: this.state.bottomBoxHeight
    }, loading && /*#__PURE__*/React__default.createElement(StyledLoader, null), window.showCancelMsg && (penaltyAmount ? /*#__PURE__*/React__default.createElement(Penalty, null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.penalty), ": ", /*#__PURE__*/React__default.createElement("span", null, currency), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
      value: penaltyAmount,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })) : /*#__PURE__*/React__default.createElement(NoPenalty, null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.noPenalty), " ")), cancellationFormQuestionnaire && cancellationFormQuestionnaire.map((form, idx) => /*#__PURE__*/React__default.createElement(StyledFormGenerator, {
      key: idx,
      updateFormValues: this.updateCustomFormValues,
      formShape: form,
      startDate: checkIn,
      endDate: checkOut,
      isFormValid: this.isFormValid,
      touch: this.state.touchAllChildren
    })), cancellationPoliciesInfo && /*#__PURE__*/React__default.createElement(StyledConditionItem, {
      className: "cancellationPoliciesInfo",
      text: cancellationPoliciesInfo,
      title: conditions.name
    }), /*#__PURE__*/React__default.createElement(StyledConditions, {
      conditions: conditions,
      checkIn: checkIn,
      amount: amount,
      restrictions: restrictions,
      currency: currency,
      firstNightCost: firstNightCost
    })), /*#__PURE__*/React__default.createElement(CheckboxButton, {
      ref: element => {
        if (element && element.offsetHeight !== this.state.bottomBoxHeight) {
          this.setState({
            bottomBoxHeight: element.offsetHeight
          });
        }
      }
    }, /*#__PURE__*/React__default.createElement(CheckboxContainer, {
      error: this.state.buttonTouched && !this.state.acceptedConditions
    }, /*#__PURE__*/React__default.createElement("input", {
      type: "checkbox",
      checked: this.state.acceptedConditions,
      onClick: this.handleAcceptConditions,
      id: "conditions"
    }), /*#__PURE__*/React__default.createElement("label", {
      htmlFor: "conditions"
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.acceptCancelTerms))), this.state.buttonTouched && (!this.state.acceptedConditions || cancellationError || Object.values(this.state.formsValid).includes(false)) && /*#__PURE__*/React__default.createElement(ErrorMessage$1, null, !this.state.acceptedConditions ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.errorConditions) : Object.values(this.state.formsValid).includes(false) ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.cannotBeEmpty) : /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.cancellationError)), /*#__PURE__*/React__default.createElement(FooterWrapper, null, totalActiveReservations > 1 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.multipleBooking), "\xA0(", totalActiveReservations, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.bookings), ").\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.makeSure), "."), /*#__PURE__*/React__default.createElement(WitButton, {
      type: "red",
      onClick: this.handleCancellation
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$5.confirm)))));
  }

}

Cancellation.defaultProps = {
  conditions: {},
  cancellationPoliciesInfo: ""
}; //TODO: Correct proptypes
// Cancellation.propTypes = {
//   currency: PropTypes.string.isRequired,
//   checkIn: PropTypes.string.isRequired,
//   checkOut: PropTypes.string.isRequired,
//   amount: PropTypes.number.isRequired,
//   restrictions: PropTypes.array.isRequired,
//   firstNightCost: PropTypes.number.isRequired,
//   conditions: PropTypes.object,
//   cancellationFormQuestionnaire: PropTypes.array.isRequired,
//   handleCancellation: PropTypes.func.isRequired,
//   cancellationError: PropTypes.bool.isRequired,
//   loading: PropTypes.bool.isRequired,
//   cancellationPoliciesInfo: PropTypes.string
// };

var Cancellation$1 = pure(Cancellation);

var Info = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
})), "Info");

var msgs$6 = reactIntl.defineMessages({
  cancellationTitle: {
    id: "cancellation.title",
    description: "Cancel reservation",
    defaultMessage: "Cancel reservation"
  }
});

function PopupCancellation(_ref) {
  var {
    closeWindow,
    data,
    checkIn,
    checkOut,
    amount,
    restrictions,
    currency,
    firstNightCost,
    showCancellationTable,
    cutOffDate,
    cancellationFormQuestionnaire,
    handleCancellation,
    cancellationError,
    loading,
    cancellationPoliciesInfo,
    totalActiveReservations
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "Conditions"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$6.cancellationTitle),
    srcLogo: /*#__PURE__*/React__default.createElement(Info, null),
    closeWindow: closeWindow
  }, data && /*#__PURE__*/React__default.createElement(Cancellation$1, {
    conditions: data,
    checkIn: checkIn,
    checkOut: checkOut,
    amount: amount,
    restrictions: restrictions,
    currency: currency,
    firstNightCost: firstNightCost,
    showCancellationTable: showCancellationTable,
    cutOffDate: cutOffDate,
    cancellationFormQuestionnaire: cancellationFormQuestionnaire,
    handleCancellation: handleCancellation,
    cancellationError: cancellationError,
    loading: loading,
    cancellationPoliciesInfo: cancellationPoliciesInfo,
    totalActiveReservations: totalActiveReservations
  })));
}

PopupCancellation.defaultProps = {
  showCancellationTable: false,
  cutOffDate: Date.now(),
  cancellationPoliciesInfo: ""
};
PopupCancellation.propTypes = {
  /** method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,

  /** The data of tariff which will be rendered as a child in the Popup */
  data: PropTypes__default.object.isRequired,
  currency: PropTypes__default.string.isRequired,
  cancellationPoliciesInfo: PropTypes__default.string,
  checkIn: PropTypes__default.string.isRequired,
  checkOut: PropTypes__default.string.isRequired,
  amount: PropTypes__default.number.isRequired,
  restrictions: PropTypes__default.array.isRequired,
  firstNightCost: PropTypes__default.number.isRequired,
  showCancellationTable: PropTypes__default.bool,
  cutOffDate: PropTypes__default.instanceOf(Date),
  cancellationFormQuestionnaire: PropTypes__default.array.isRequired,
  handleCancellation: PropTypes__default.func.isRequired,
  cancellationError: PropTypes__default.bool.isRequired,
  loading: PropTypes__default.bool.isRequired
};
var PopupCancellation$1 = pure(PopupCancellation);

var ThumbUpIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
})), "ThumbUpIcon");

function _templateObject2$x() {
  var data = _taggedTemplateLiteral(["    \n      font-size: inherit;\n  "]);

  _templateObject2$x = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$C() {
  var data = _taggedTemplateLiteral(["\n  color: #329911;\n  font-weight: 700;\n  & svg {\n    width: 14px;\n    height: 14px;\n    margin: 0 4px 3px 0;\n  }\n  font-size: ", " ", ";\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$7 = reactIntl.defineMessages({
  cancelableUntil: {
    id: "cancellationMessage.text.cancelableUntilDate",
    description: "Notify the date until the element is cancelable",
    defaultMessage: "Can be cancelled online until"
  }
});
var CancellationMessageWrapper = styled__default.span(_templateObject$C(), props => props.staticFont ? "12px" : "14px", media.up.md(_templateObject2$x()));
function cancellationMessageData(restrictions, cutOffDate) {
  var freeCancellation = restrictions && restrictions.find(restriction => restriction.type !== constants.CANCELLATION_POLICY_RESTRICTION_TYPE.CHARGE_FIRST_NIGHT && !restriction.penalty);
  return freeCancellation && cutOffDate && moment(freeCancellation.minRelease).isBefore(moment(moment(cutOffDate).format("YYYY-MM-DD"))) ? undefined : freeCancellation;
}

function CancellationMessage(_ref) {
  var _freeCancellation$min, _freeCancellation$min2;

  var {
    restrictions,
    includeIcon,
    staticFont,
    cutOffDate,
    className,
    yearFirst
  } = _ref;
  var freeCancellation = cancellationMessageData(restrictions, cutOffDate);
  var minReleaseTimeLimit = "";

  if ((freeCancellation === null || freeCancellation === void 0 ? void 0 : freeCancellation.minReleaseTimeLimit) && typeof (freeCancellation === null || freeCancellation === void 0 ? void 0 : freeCancellation.minReleaseTimeLimit) === "string" && (freeCancellation === null || freeCancellation === void 0 ? void 0 : freeCancellation.minReleaseTimeLimit) !== "23:59") {
    minReleaseTimeLimit = freeCancellation.minReleaseTimeLimit;
  } else if ((freeCancellation === null || freeCancellation === void 0 ? void 0 : (_freeCancellation$min = freeCancellation.minReleaseTimeLimit) === null || _freeCancellation$min === void 0 ? void 0 : _freeCancellation$min.timeLimit) && (freeCancellation === null || freeCancellation === void 0 ? void 0 : (_freeCancellation$min2 = freeCancellation.minReleaseTimeLimit) === null || _freeCancellation$min2 === void 0 ? void 0 : _freeCancellation$min2.timeLimit) !== "23:59") {
    minReleaseTimeLimit = freeCancellation.minReleaseTimeLimit.timeLimit;
  }

  var date = null;

  if (freeCancellation && yearFirst) {
    date = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDateParts, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      value: moment(freeCancellation.minRelease).toDate()
    }, parts => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, parts[4].value, "-", parts[2].value && parts[2].value.padStart(2, "0"), "-", parts[0].value && parts[0].value.padStart(2, "0"))), minReleaseTimeLimit && /*#__PURE__*/React__default.createElement(reactIntl.FormattedTimeParts, {
      value: moment("".concat(freeCancellation.minRelease, " ").concat(minReleaseTimeLimit)).toDate()
    }, parts => {
      var _parts$, _parts$2, _parts$3, _parts$4;

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", (_parts$ = parts[0]) === null || _parts$ === void 0 ? void 0 : _parts$.value, (_parts$2 = parts[1]) === null || _parts$2 === void 0 ? void 0 : _parts$2.value, (_parts$3 = parts[2]) === null || _parts$3 === void 0 ? void 0 : _parts$3.value, " ", (_parts$4 = parts[4]) === null || _parts$4 === void 0 ? void 0 : _parts$4.value);
    }));
  }

  if (freeCancellation && !yearFirst && minReleaseTimeLimit) {
    date = /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      value: moment("".concat(freeCancellation.minRelease)).toDate()
    }), " ", minReleaseTimeLimit, " h");
  }

  if (freeCancellation && !yearFirst && !minReleaseTimeLimit) {
    date = /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      value: moment("".concat(freeCancellation.minRelease)).toDate()
    });
  }

  return /*#__PURE__*/React__default.createElement("div", null, window.showCancelMsg && freeCancellation && /*#__PURE__*/React__default.createElement(CancellationMessageWrapper, {
    staticFont: staticFont,
    className: className
  }, includeIcon && /*#__PURE__*/React__default.createElement(ThumbUpIcon, null), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$7.cancelableUntil), ": ", date));
}

CancellationMessage.propTypes = {
  cancellationRelease: PropTypes__default.number.isRequired,
  includeIcon: PropTypes__default.bool.isRequired,
  className: PropTypes__default.string,
  staticFont: PropTypes__default.bool.isRequired,
  cutOffDate: PropTypes__default.instanceOf(Date).isRequired,
  restrictions: PropTypes__default.array.isRequired
};
CancellationMessage.defaultProps = {
  className: ""
};
var CancellationMessage$1 = pure(CancellationMessage);

function _templateObject$D() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  padding: 25px;\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$8 = reactIntl.defineMessages({
  conditions: {
    id: "titles.ComunicationsTitle",
    description: "Communication policy",
    defaultMessage: "Communication policy"
  }
});
var Data = styled__default.div(_templateObject$D());

function PopupCommunicationPolicy(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "CommunicationPolicy"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$8.conditions),
    srcLogo: /*#__PURE__*/React__default.createElement(Info, null),
    closeWindow: props.closeWindow
  }, /*#__PURE__*/React__default.createElement(Data, null, props.data)));
}

PopupCommunicationPolicy.defaultProps = {};
PopupCommunicationPolicy.propTypes = {
  /** method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,
  data: PropTypes__default.object.isRequired
};
var index$3 = pure(PopupCommunicationPolicy);

var msgs$9 = reactIntl.defineMessages({
  conditions: {
    id: "condition.conditions",
    description: "conditions",
    defaultMessage: "conditions"
  }
});

function PopupConditions(_ref) {
  var {
    closeWindow,
    data,
    checkIn,
    amount,
    restrictions,
    currency,
    firstNightCost,
    showCancellationTable,
    cutOffDate,
    cancellationPoliciesInfo,
    conditionsList,
    intl
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "Conditions"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: (data === null || data === void 0 ? void 0 : data.name) || intl.formatMessage(msgs$9.conditions),
    srcLogo: /*#__PURE__*/React__default.createElement(Info, null),
    closeWindow: closeWindow
  }, (data || conditionsList) && /*#__PURE__*/React__default.createElement(Conditions$1, {
    conditions: data,
    checkIn: checkIn,
    amount: amount,
    restrictions: restrictions,
    currency: currency,
    firstNightCost: firstNightCost,
    showCancellationTable: showCancellationTable,
    cutOffDate: cutOffDate,
    cancellationPoliciesInfo: cancellationPoliciesInfo,
    conditionsList: conditionsList
  })));
}

PopupConditions.defaultProps = {
  showCancellationTable: false,
  cutOffDate: Date.now(),
  cancellationPoliciesInfo: ""
};
PopupConditions.propTypes = {
  /** method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,

  /** The data of tariff which will be rendered as a child in the Popup */
  data: PropTypes__default.object.isRequired,
  currency: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.oneOfType([PropTypes__default.instanceOf(Date).isRequired, PropTypes__default.string]),
  amount: PropTypes__default.number,
  restrictions: PropTypes__default.array,
  firstNightCost: PropTypes__default.number,
  showCancellationTable: PropTypes__default.bool,
  cutOffDate: PropTypes__default.oneOfType([PropTypes__default.instanceOf(Date), PropTypes__default.number]),
  cancellationPoliciesInfo: PropTypes__default.string
};
var PopupConditions$1 = pure(reactIntl.injectIntl(PopupConditions));



var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Conditions: Conditions$1,
  PopupConditions: PopupConditions$1
});

function _templateObject4$p() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 5px;\n  font-weight: ", ";\n"]);

  _templateObject4$p = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$r() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 5px;\n"]);

  _templateObject3$r = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$y() {
  var data = _taggedTemplateLiteral(["\n    min-height: 48px;\n    padding: 10px 20px;\n  "]);

  _templateObject2$y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$E() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  min-height: 35px;\n  padding: 0 10px;\n\n  &:not(:first-child) {\n    border-top: 1px solid ", ";\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var TableRow = styled__default.div(_templateObject$E(), greyLighter, props => props.bold && "font-size: 14px;", media.up.md(_templateObject2$y()));
var FormattedMessageWrapper = styled__default.span(_templateObject3$r());
var RowValue = styled__default.div(_templateObject4$p(), props => props.bold ? 700 : 400);

var DatesRow = (_ref) => {
  var {
    className,
    text,
    date,
    bold
  } = _ref;
  return /*#__PURE__*/React__default.createElement(TableRow, {
    className: className,
    bold: bold
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, text), ":", /*#__PURE__*/React__default.createElement(RowValue, {
    bold: bold
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    value: date,
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short"
  })));
};

DatesRow.defaultProps = {
  className: "wbkv9-DatesRow",
  text: {},
  date: "2019-08-16",
  bold: false
};
DatesRow.propTypes = {
  className: PropTypes__default.string,
  text: PropTypes__default.object,
  date: PropTypes__default.string,
  bold: PropTypes__default.bool
};

function _templateObject4$q() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    color: ", ";\n  "]);

  _templateObject4$q = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$s() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-weight: 700;\n\n  ", ";\n"]);

  _templateObject3$s = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$z() {
  var data = _taggedTemplateLiteral(["\n    flex: 1 1 auto;\n    border-radius: 0;\n    \n    &:first-child {\n      border-radius: 5px 0 0 0;\n    }\n    \n    &:last-child {\n      border-radius: 0 5px 0 0;\n    }\n    \n    &:not(:last-child) {\n      border-right: none;\n    }\n  "]);

  _templateObject2$z = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 15px;\n  font-size: 14px;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 5px;\n\n  ", ";\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$a = reactIntl.defineMessages({
  room: {
    id: "bookingModification.modal.room",
    description: "Room",
    defaultMessage: "Room"
  },
  checkIn: {
    id: "bookingModification.modal.checkIn",
    description: "Check in",
    defaultMessage: "Check in"
  },
  checkOut: {
    id: "bookingModification.modal.checkOut",
    description: "Check out",
    defaultMessage: "Check out"
  },
  price: {
    id: "bookingModification.modal.price",
    description: "Price",
    defaultMessage: "Price"
  },
  extras: {
    id: "bookingModification.modal.extras",
    description: "Extras",
    defaultMessage: "Extras"
  }
});
var Table$1 = styled__default.div(_templateObject$F(), props => props.bold ? wbBlack : greyLight, greyLighter, media.up.md(_templateObject2$z()));
var TableHeader = styled__default(TableRow)(_templateObject3$s(), greyBasic, media.up.md(_templateObject4$q(), wbBlack));

var AccommodationTable = (_ref) => {
  var {
    className,
    headerTitle,
    checkIn,
    checkOut,
    amount,
    room,
    bold,
    currency,
    extras
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Table$1, {
    className: className,
    bold: bold
  }, /*#__PURE__*/React__default.createElement(TableHeader, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, headerTitle)), room && /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$a.room), ":", /*#__PURE__*/React__default.createElement(RowValue, {
    bold: bold
  }, room)), /*#__PURE__*/React__default.createElement(DatesRow, {
    text: msgs$a.checkIn,
    date: checkIn,
    bold: bold
  }), /*#__PURE__*/React__default.createElement(DatesRow, {
    text: msgs$a.checkOut,
    date: checkOut,
    bold: bold
  }), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$a.extras), ":", /*#__PURE__*/React__default.createElement(RowValue, {
    bold: bold
  }, extras)), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$a.price), ":", /*#__PURE__*/React__default.createElement(RowValue, {
    bold: bold
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: amount,
    maximumFractionDigits: 0
  }), " ".concat(currency))));
};

AccommodationTable.defaultProps = {
  className: "wbkv9-AccommodationTable",
  headerTitle: {},
  room: "Infinity",
  checkIn: "2019-08-16",
  checkOut: "2019-08-18",
  amount: 250,
  error: false,
  bold: false,
  extras: undefined
};
AccommodationTable.propTypes = {
  className: PropTypes__default.string,
  headerTitle: PropTypes__default.object,
  room: PropTypes__default.string,
  checkIn: PropTypes__default.string,
  checkOut: PropTypes__default.string,
  amount: PropTypes__default.number,
  error: PropTypes__default.bool,
  bold: PropTypes__default.bool,
  currency: PropTypes__default.string.isRequired,
  extras: PropTypes__default.string
};

function _templateObject18$1() {
  var data = _taggedTemplateLiteral(["\n    margin-left: 10px;\n  "]);

  _templateObject18$1 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject17$1 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$2() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject16$2 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$3() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 1 auto;\n    border-radius: 5px;\n  "]);

  _templateObject15$3 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1 1 auto;\n  cursor: pointer;\n\n  ", ";\n"]);

  _templateObject14$3 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$3() {
  var data = _taggedTemplateLiteral(["\n    justify-content: flex-end;\n    margin-top: 10px;\n    position: static;\n  "]);

  _templateObject13$3 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  margin: 0 -25px;\n  & > * {\n    padding: 15px;\n  }\n  ", ";\n"]);

  _templateObject12$3 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$4() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 75px;\n  border-radius: 5px;\n  background-color: rgba(178, 14, 14, 0.1);\n  color: ", ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n\n  > span:not(:last-child) {\n    margin-right: 5px;\n  }\n"]);

  _templateObject11$4 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 10px 0 5px;\n"]);

  _templateObject10$4 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 13px;\n  "]);

  _templateObject9$5 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n\n  ", ";\n"]);

  _templateObject8$6 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$9() {
  var data = _taggedTemplateLiteral(["\n    flex: 1 1 auto;\n    text-align: center;\n    padding-right: 39px;\n  "]);

  _templateObject7$9 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$a() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject6$a = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$i() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  margin-right: 15px;\n  color: ", ";\n  cursor: pointer;\n"]);

  _templateObject5$i = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$r() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n  "]);

  _templateObject4$r = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$t() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject3$t = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$A() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  color: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n"]);

  _templateObject2$A = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$G() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 35px;\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$b = reactIntl.defineMessages({
  datesAvailable: {
    id: "bookingModification.modalDates.datesAvailable",
    description: "Dates available",
    defaultMessage: "Good news! The dates you chose are available."
  },
  datesUnavailable: {
    id: "bookingModification.modal.confirm_newBooking",
    description: "Dates unavailable",
    defaultMessage: "You're about to change your booking."
  },
  oldDates: {
    id: "bookingModification.modal.oldInformation",
    description: "Old information",
    defaultMessage: "Old information"
  },
  newDates: {
    id: "bookingModification.modal.newInformation",
    description: "New information",
    defaultMessage: "New information"
  },
  additionalInfo: {
    id: "bookingModification.modal.priceChange",
    description: "Additional info",
    defaultMessage: "Prices may change due to day of the week, seasonality or type of accommodation."
  },
  invalidModification: {
    id: "bookingModification.modificationInvalid",
    description: "Modification invalid.",
    defaultMessage: "Modification invalid."
  },
  minimumAmount: {
    id: "bookingModification.minAmount",
    description: "Minimum amount",
    defaultMessage: "Minimum amount"
  },
  cancel: {
    id: "bookingModification.modal.cancel",
    description: "Cancel",
    defaultMessage: "Cancel"
  },
  confirm: {
    id: "bookingModification.modal.confirm",
    description: "Confirm",
    defaultMessage: "Confirm"
  },
  confirmFail: {
    id: "agency.modalReport.error",
    description: "Operation could not be completed.",
    defaultMessage: "Operation could not be completed."
  }
});
var Container$6 = styled__default.div(_templateObject$G());
var Header$1 = styled__default.div(_templateObject2$A(), wbBlack);
var TablesContainer = styled__default.div(_templateObject3$t(), media.up.md(_templateObject4$r()));
var ArrowBack = styled__default(ArrowBackIcon)(_templateObject5$i(), greyLight);
var TitleText = styled__default.div(_templateObject6$a(), media.up.md(_templateObject7$9()));
var AdditionalInfo = styled__default.div(_templateObject8$6(), greyLight, media.up.md(_templateObject9$5()));
var ErrorContainer = styled__default.div(_templateObject10$4());
var ErrorMessage$2 = styled__default.div(_templateObject11$4(), wbRed);
var ButtonsContainer = styled__default.div(_templateObject12$3(), media.up.md(_templateObject13$3()));
var StyledButton$2 = styled__default.div(_templateObject14$3(), media.up.md(_templateObject15$3()));
var CancelButton = styled__default(StyledButton$2)(_templateObject16$2(), greyLight, white, greyLight);
var ConfirmButton = styled__default(StyledButton$2)(_templateObject17$1(), wbGreen, white, props => props.error && "\n      background-color: ".concat(white, ";\n      border: 1px solid rgba(144, 143, 150, 0.6);\n      color: rgba(144, 143, 150, 0.6);\n      cursor: not-allowed;\n    "), media.up.md(_templateObject18$1()));

function ConfirmModification(_ref) {
  var {
    className,
    title,
    oldRoom,
    oldCheckIn,
    oldCheckOut,
    oldAmount,
    newRoom,
    newCheckIn,
    newCheckOut,
    newAmount,
    currency,
    minimumAmount,
    error,
    handleCancel,
    handleConfirm,
    reset,
    isModificationSuccess,
    content,
    oldExtras,
    newExtras
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$6, {
    className: className
  }, /*#__PURE__*/React__default.createElement(Header$1, null, /*#__PURE__*/React__default.createElement(ArrowBack, {
    onClick: reset
  }), /*#__PURE__*/React__default.createElement(TitleText, null, title)), content || /*#__PURE__*/React__default.createElement(TablesContainer, null, /*#__PURE__*/React__default.createElement(AccommodationTable, {
    headerTitle: msgs$b.oldDates,
    room: oldRoom,
    checkIn: oldCheckIn,
    checkOut: oldCheckOut,
    amount: oldAmount,
    currency: currency,
    extras: oldExtras
  }), /*#__PURE__*/React__default.createElement(AccommodationTable, {
    headerTitle: msgs$b.newDates,
    room: newRoom,
    checkIn: newCheckIn,
    checkOut: newCheckOut,
    amount: newAmount,
    error: error,
    currency: currency,
    bold: true,
    extras: newExtras
  })), /*#__PURE__*/React__default.createElement(AdditionalInfo, null, "*", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$b.additionalInfo)), (error || isModificationSuccess === false) && /*#__PURE__*/React__default.createElement(ErrorContainer, null, error && /*#__PURE__*/React__default.createElement(ErrorMessage$2, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$b.invalidModification), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$b.minimumAmount), /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: minimumAmount,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }), /*#__PURE__*/React__default.createElement("span", null, currency), "."), isModificationSuccess === false && /*#__PURE__*/React__default.createElement(ErrorMessage$2, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$b.confirmFail))), /*#__PURE__*/React__default.createElement(ButtonsContainer, null, /*#__PURE__*/React__default.createElement(CancelButton, {
    onClick: handleCancel
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$b.cancel)), /*#__PURE__*/React__default.createElement(ConfirmButton, {
    onClick: () => !error && handleConfirm(),
    error: error
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$b.confirm))));
}

ConfirmModification.defaultProps = {
  className: "wbkv9-ConfirmModification",
  title: "",
  oldRoom: null,
  oldCheckIn: "2019-08-16",
  oldCheckOut: "2019-08-18",
  oldAmount: 250,
  newRoom: null,
  newCheckIn: "2019-10-25",
  newCheckOut: "2019-10-27",
  newAmount: 270,
  currency: "EUR",
  minimumAmount: 250,
  error: false,
  handleCancel: () => {},
  handleConfirm: () => {},
  isModificationSuccess: undefined,
  content: undefined,
  oldExtras: undefined,
  newExtras: undefined
};
ConfirmModification.propTypes = {
  className: PropTypes__default.string,
  title: PropTypes__default.string,
  oldRoom: PropTypes__default.string,
  oldCheckIn: PropTypes__default.string,
  oldCheckOut: PropTypes__default.string,
  oldAmount: PropTypes__default.number,
  newRoom: PropTypes__default.string,
  newCheckIn: PropTypes__default.string,
  newCheckOut: PropTypes__default.string,
  newAmount: PropTypes__default.number,
  currency: PropTypes__default.string,
  minimumAmount: PropTypes__default.number,
  error: PropTypes__default.bool,
  handleCancel: PropTypes__default.func,
  handleConfirm: PropTypes__default.func,
  reset: PropTypes__default.func.isRequired,
  isModificationSuccess: PropTypes__default.bool,
  content: PropTypes__default.node,
  oldExtras: PropTypes__default.string,
  newExtras: PropTypes__default.string
};

var PrintIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "Print");

function _templateObject3$u() {
  var data = _taggedTemplateLiteral(["\n  {display: flex;}\n  "]);

  _templateObject3$u = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$B() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  & > :first-child {\n    margin-right: 10px;\n  }\n  ", ";\n"]);

  _templateObject2$B = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$H() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n  fill: ", ";\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$c = reactIntl.defineMessages({
  returnHome: {
    id: "reservationConfirmed.returnHome.button",
    description: "Return home button text",
    defaultMessage: "Back home"
  }
});
var StyledPrintIcon = styled__default(PrintIcon)(_templateObject$H(), white);
var StyledConfirmationPageButtons = styled__default.div(_templateObject2$B(), media.up.mdl(_templateObject3$u()));

function ConfirmationPageButtons(_ref) {
  var {
    handlePrint,
    handleBackButton
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledConfirmationPageButtons, null, /*#__PURE__*/React__default.createElement(WitButton, {
    type: "grey",
    onClick: handleBackButton
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$c.returnHome), " "), /*#__PURE__*/React__default.createElement(WitButton, {
    type: "green",
    onClick: handlePrint
  }, /*#__PURE__*/React__default.createElement(StyledPrintIcon, null)));
}

ConfirmationPageButtons.propTypes = {
  handlePrint: PropTypes__default.func.isRequired,
  handleBackButton: PropTypes__default.func.isRequired
};

function _templateObject2$C() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  padding: 15px 20px;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n\n  & > *:not(:last-child) {\n    margin-bottom: 2px;\n  }\n\n  & > * > :nth-child(2) > :first-child {\n    margin-left: 5px;\n  }\n"]);

  _templateObject2$C = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n\n  & > :first-child {\n    text-align: left;\n    margin-right: 10px;\n  }\n\n  & > :last-child {\n    text-align: right;\n  }\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}
var Entry = styled__default.div(_templateObject$I());
var Cell = styled__default.div(_templateObject2$C(), greyBasic, greyLighter);

var msgs$d = reactIntl.defineMessages({
  stay: {
    id: "checkout.reservation_summary.stay",
    description: "Stay",
    defaultMessage: "Stay"
  }
});

function AmountTableAccommodation(_ref) {
  var {
    currency,
    dailyValues,
    subtotal,
    className
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Cell, {
    className: className
  }, /*#__PURE__*/React__default.createElement(Entry, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$d.stay)), /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: subtotal,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))), Object.entries(dailyValues).sort((_ref2, _ref3) => {
    var [dateA] = _ref2;
    var [dateB] = _ref3;
    return dateA < dateB ? -1 : 1;
  }).map((dailyValue, index) => /*#__PURE__*/React__default.createElement(Entry, {
    key: index
  }, /*#__PURE__*/React__default.createElement("span", null, dailyValue[0]), /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: dailyValue[1].amount,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })))));
}

AmountTableAccommodation.propTypes = {
  dailyValues: PropTypes__default.object.isRequired,
  subtotal: PropTypes__default.number.isRequired,
  currency: PropTypes__default.string.isRequired,
  className: PropTypes__default.string.isRequired
};

function AmountTableDiscounts(_ref) {
  var {
    currency,
    discounts,
    className
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Cell, {
    className: className
  }, discounts.map((discount, index) => /*#__PURE__*/React__default.createElement(Entry, {
    key: index
  }, /*#__PURE__*/React__default.createElement("span", null, discount.name, " ", discount.percentage && /*#__PURE__*/React__default.createElement("span", null, "(", " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: discount.value,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }), "%", ")")), /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: discount.totalDiscount.amount,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })))));
}

AmountTableDiscounts.defaultProps = {
  className: ""
};
AmountTableDiscounts.propTypes = {
  discounts: PropTypes__default.array.isRequired,
  currency: PropTypes__default.string.isRequired,
  className: PropTypes__default.string
};

var msgs$e = reactIntl.defineMessages({
  included: {
    id: "service.amountTable.included",
    description: "Included",
    defaultMessage: "Included"
  }
});

function AmountTableExtras(_ref) {
  var {
    extras,
    currency,
    className,
    addObligatoryExtrasRateToRoomSelection
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Cell, {
    className: className
  }, extras.map((extra, index) => /*#__PURE__*/React__default.createElement(Entry, {
    key: index
  }, /*#__PURE__*/React__default.createElement("span", null, "(", extra.quantity, ") ", extra.name), "\xA0", extra.obligatory && addObligatoryExtrasRateToRoomSelection && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$e.included), (!extra.obligatory || !addObligatoryExtrasRateToRoomSelection) && /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: extra.amount.amount,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })))));
}

AmountTableExtras.propTypes = {
  extras: PropTypes__default.array.isRequired,
  currency: PropTypes__default.string.isRequired,
  className: PropTypes__default.string.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes__default.bool.isRequired
};

var msgs$f = reactIntl.defineMessages({
  deposit: {
    id: "reservation_confirmed.reservation_price.advance",
    description: "advance field of reservation price",
    defaultMessage: "Deposito"
  },
  payAtProperty: {
    id: "checkout.payment_form.payAtProperty",
    description: "Label which indicates if reservation is paid at the property",
    defaultMessage: "Pay at the property"
  },
  payAccordingToConditions: {
    id: "checkout.payment_form.remainingConditions",
    description: "Label which indicates if reservation is paid at the property",
    defaultMessage: "Remainder, to be paid according to the conditions."
  },
  amountRemaining: {
    id: "checkout.payment_form.remaining",
    description: "Label which indicates if reservation is paid at the property",
    defaultMessage: "Remainder"
  },
  TAXES_INCLUDED: {
    id: "reservation_confirmed.reservation_price.totalTaxesIncluded",
    description: "Taxes included",
    defaultMessage: "Taxes included"
  },
  TAXES_EXCLUDED: {
    id: "reservation_confirmed.reservation_price.totalTaxesExcluded",
    description: "Taxes excluded",
    defaultMessage: "Taxes excluded"
  },
  TAXES_AND_FEES_INCLUDED: {
    id: "reservation_confirmed.reservation_price.totalVatAndTaxesIncluded",
    description: "Taxes and fees included",
    defaultMessage: "Taxes and fees included"
  },
  TAXES_AND_FEES_EXCLUDED: {
    id: "reservation_confirmed.reservation_price.totalVatAndTaxesExcluded",
    description: "Taxes and fees excluded",
    defaultMessage: "Taxes and fees excluded"
  },
  TAXES_INCLUDED_FEES_EXCLUDED: {
    id: "reservation_confirmed.reservation_price.totalVatIncludedTaxesExcluded",
    description: "Taxes included / fees excluded",
    defaultMessage: "Taxes included / fees excluded"
  }
});

function getPendingAmountMessage(pendingAmountTextConfiguration) {
  var message = msgs$f.payAtProperty;

  switch (pendingAmountTextConfiguration) {
    case constants.PENDING_AMOUNT_TEXT_CONFIGURATION.PAY_ACCORDING_TO_CONDITIONS:
      message = msgs$f.payAccordingToConditions;
      break;

    case constants.PENDING_AMOUNT_TEXT_CONFIGURATION.AMOUNT_REMAINING:
      message = msgs$f.amountRemaining;
      break;

    default:
      message = msgs$f.payAtProperty;
      break;
  }

  return message;
}

function AmountTableSummary(_ref) {
  var {
    currency,
    total,
    deposit,
    toPay,
    pendingAmountTextConfiguration,
    className,
    taxesText
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Cell, {
    className: className
  }, /*#__PURE__*/React__default.createElement(Entry, null, " ", taxesText && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$f[taxesText])), /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: total,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))), /*#__PURE__*/React__default.createElement(Entry, null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$f.deposit)), /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: deposit,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))), pendingAmountTextConfiguration !== constants.PENDING_AMOUNT_TEXT_CONFIGURATION.NO_TEXT && /*#__PURE__*/React__default.createElement(Entry, null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, getPendingAmountMessage(pendingAmountTextConfiguration))), /*#__PURE__*/React__default.createElement("span", null, currency, "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: toPay,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))));
}

AmountTableSummary.propTypes = {
  total: PropTypes__default.number.isRequired,
  deposit: PropTypes__default.number.isRequired,
  toPay: PropTypes__default.number.isRequired,
  currency: PropTypes__default.string.isRequired,
  pendingAmountTextConfiguration: PropTypes__default.string.isRequired,
  className: PropTypes__default.string.isRequired
};

function _templateObject5$j() {
  var data = _taggedTemplateLiteral(["\n   padding: 15px 20px; \n"]);

  _templateObject5$j = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$s() {
  var data = _taggedTemplateLiteral(["\n  & > * {\n    padding: 15px 10px;\n    ", ";\n  }\n"]);

  _templateObject4$s = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$v() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n"]);

  _templateObject3$v = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$D() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2$D = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$J() {
  var data = _taggedTemplateLiteral(["\n  & > :first-child {\n    font-weight: 700;\n  }\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}
var StyledAmountTableAccommodation = styled__default(AmountTableAccommodation)(_templateObject$J());
var StyledAmountTableExtras = styled__default(AmountTableExtras)(_templateObject2$D(), wbBlue);
var StyledAmountTableSummary = styled__default(AmountTableSummary)(_templateObject3$v());
var StyledAmountTable = styled__default.div(_templateObject4$s(), media.up.sml(_templateObject5$j()));

function AmountTable(_ref) {
  var {
    dailyValues,
    subtotal,
    total,
    deposit,
    toPay,
    extras,
    discounts,
    currency,
    pendingAmountTextConfiguration,
    addObligatoryExtrasRateToRoomSelection,
    taxesText
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledAmountTable, null, /*#__PURE__*/React__default.createElement(StyledAmountTableAccommodation, {
    currency: currency,
    dailyValues: dailyValues,
    subtotal: subtotal,
    discounts: discounts
  }), discounts.length > 0 && /*#__PURE__*/React__default.createElement(AmountTableDiscounts, {
    currency: currency,
    discounts: discounts
  }), extras.length > 0 && /*#__PURE__*/React__default.createElement(StyledAmountTableExtras, {
    currency: currency,
    extras: extras,
    addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection
  }), /*#__PURE__*/React__default.createElement(StyledAmountTableSummary, {
    currency: currency,
    total: total,
    deposit: deposit,
    toPay: toPay,
    pendingAmountTextConfiguration: pendingAmountTextConfiguration,
    taxesText: taxesText
  }));
}

AmountTable.propTypes = {
  dailyValues: PropTypes__default.object.isRequired,
  subtotal: PropTypes__default.number.isRequired,
  total: PropTypes__default.number.isRequired,
  deposit: PropTypes__default.number.isRequired,
  toPay: PropTypes__default.number.isRequired,
  extras: PropTypes__default.array.isRequired,
  discounts: PropTypes__default.array.isRequired,
  currency: PropTypes__default.string.isRequired,
  pendingAmountTextConfiguration: PropTypes__default.string.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes__default.bool.isRequired
};

var msgs$g = reactIntl.defineMessages({
  status: {
    id: "reservation_confirmed.reservation_detail.status",
    description: "status for reservation detail",
    defaultMessage: "State"
  },
  reserva: {
    id: "reservation_confirmed.reservation_detail.confirmed",
    description: "Reservation status confirmed",
    defaultMessage: "Confirmed"
  },
  cancelada: {
    id: "reservation_confirmed.reservation_detail.canceled",
    description: "Reservation status canceled",
    defaultMessage: "Cancelled"
  },
  prereserva: {
    id: "reservation_confirmed.reservation_detail.pending",
    description: "Reservation status pending to confirm",
    defaultMessage: "Pending confirmation"
  }
});

function BookingInfoStatus(_ref) {
  var {
    status
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$g.status)), ": ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$g[status]));
}

BookingInfoStatus.propTypes = {
  status: PropTypes__default.string.isRequired
};

var msgs$h = reactIntl.defineMessages({
  hotel: {
    id: "reservation_confirmed.reservation_detail.hotel",
    description: "hotel for reservation detail",
    defaultMessage: "Hotel"
  }
});

function BookingInfoProperty(_ref) {
  var {
    property
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$h.hotel)), ": ", property);
}

BookingInfoProperty.propTypes = {
  property: PropTypes__default.string.isRequired
};

var msgs$i = reactIntl.defineMessages({
  reference: {
    id: "reservation_confirmed.reservation_detail.reference",
    description: "reference for reservation detail",
    defaultMessage: "REF"
  }
});

function BookingInfoRef(_ref) {
  var {
    reference
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$i.reference)), ": ", reference);
}

BookingInfoRef.propTypes = {
  reference: PropTypes__default.string.isRequired
};

var msgs$j = reactIntl.defineMessages({
  dateReceived: {
    id: "reservation_confirmed.reservation_detail.dateReceived",
    description: "dateReceived for reservation detail",
    defaultMessage: "Recibida"
  }
});

function BookingInfoReceived(_ref) {
  var {
    received
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$j.dateReceived)), ": ", received);
}

BookingInfoReceived.propTypes = {
  received: PropTypes__default.string.isRequired
};

var msgs$k = reactIntl.defineMessages({
  arriveAt: {
    id: "reservation_confirmed.reservation_information.arriveAt",
    description: "arriveAt field of reservation information",
    defaultMessage: "Llegada"
  }
});

function BookingInfoCheckIn(_ref) {
  var {
    checkIn
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$k.arriveAt)), ": ", checkIn);
}

BookingInfoCheckIn.propTypes = {
  checkIn: PropTypes__default.string.isRequired
};

var msgs$l = reactIntl.defineMessages({
  leaveAt: {
    id: "reservation_confirmed.reservation_information.leaveAt",
    description: "leaveAt field of reservation information",
    defaultMessage: "Salida"
  }
});

function BookingInfoCheckOut(_ref) {
  var {
    checkOut
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$l.leaveAt)), ": ", checkOut);
}

BookingInfoCheckOut.propTypes = {
  checkOut: PropTypes__default.string.isRequired
};

var msgs$m = reactIntl.defineMessages({
  numGuests: {
    id: "reservation_confirmed.reservation_information.numGuests",
    description: "numGuests field of reservation information",
    defaultMessage: "Total de personas"
  }
});

function BookingInfoGuests(_ref) {
  var {
    guests
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$m.numGuests)), ": ", guests);
}

BookingInfoGuests.propTypes = {
  guests: PropTypes__default.number.isRequired
};

function BookingInfoMealPlanConditions(_ref) {
  var {
    accommodationType,
    packageName,
    mealPlan,
    conditions
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, packageName && /*#__PURE__*/React__default.createElement("span", null, accommodationType, ", "), /*#__PURE__*/React__default.createElement("span", null, mealPlan), ", ", /*#__PURE__*/React__default.createElement("span", null, conditions.name));
}

BookingInfoMealPlanConditions.propTypes = {
  mealPlan: PropTypes__default.string.isRequired,
  conditions: PropTypes__default.object.isRequired
};

var msgs$n = reactIntl.defineMessages({
  reservationNumber: {
    id: "reservation_confirmed.reservation_detail.reservationNumber",
    description: "reservationNumber for reservation detail",
    defaultMessage: "RESERVA"
  }
});

function BookingInfoBooking(_ref) {
  var {
    bookingId
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$n.reservationNumber)), ": ", bookingId);
}

BookingInfoBooking.propTypes = {
  bookingId: PropTypes__default.string.isRequired
};

function _templateObject3$w() {
  var data = _taggedTemplateLiteral(["\n   .ReactModal__Content__Library {\n    width: 100%;\n    height: 100%;\n   }\n  "]);

  _templateObject3$w = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$E() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n        height: auto;\n        max-height: 95%;\n        max-width: 700px;\n      "]);

  _templateObject2$E = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$K() {
  var data = _taggedTemplateLiteral(["\n  .ReactModal__Overlay__Library {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: transparent;\n    z-index: 9999;\n    transition: background-color 0.3s ease-in-out;\n  }\n  .ReactModal__Overlay__Library--after-open {\n    background-color: rgba(0, 0, 0, 0.75);\n  }\n  .ReactModal__Content__Library {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    background: #fff;\n    outline: none;\n    opacity: 0;\n    box-shadow: rgba(0, 0, 0, 0.75) 0 0 14px 2px;\n    transition: top 0.3s ease-in-out, opacity 0.3s ease-in-out;\n    transform: translate(-50%, -50%);\n    overflow: auto;\n      ", ";\n\n  }\n  .ReactModal__Content__Library--after-open {\n    opacity: 1;\n  }\n\n  ", ";\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}
var GlobalStyle$2 = styled.createGlobalStyle(_templateObject$K(), media.up.mdm(_templateObject2$E()), media.down.mdm(_templateObject3$w()));

function WitModal(props) {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(GlobalStyle$2, null), /*#__PURE__*/React__default.createElement(Modal$1, _extends({}, props, {
    className: {
      base: "ReactModal__Content__Library",
      afterOpen: "ReactModal__Content__Library--after-open",
      beforeClose: ""
    },
    overlayClassName: {
      base: "ReactModal__Overlay__Library",
      afterOpen: "ReactModal__Overlay__Library--after-open",
      beforeClose: ""
    }
  })));
}

WitModal.propTypes = {
  showCancellationTable: PropTypes__default.bool,
  currency: PropTypes__default.string,
  checkIn: PropTypes__default.instanceOf(Date),
  amount: PropTypes__default.number,
  restrictions: PropTypes__default.array,
  firstNightCost: PropTypes__default.number,
  cutOffDate: PropTypes__default.instanceOf(Date),
  isConditionsModalOpen: PropTypes__default.bool,
  conditions: PropTypes__default.object,
  closeWindow: PropTypes__default.func
};

var msgs$o = reactIntl.defineMessages({
  seeConditions: {
    id: "reservation_confirmed.reservation_information.seeConditions",
    description: "seeConditions field of reservation information",
    defaultMessage: "ver condiciones"
  }
});

class BookingInfoSeeConditions extends React.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleOpenConditionsModal", () => {
      this.setState({
        isConditionsModalOpen: true
      });
    });

    _defineProperty(this, "handleCloseConditionsModal", () => {
      this.setState({
        isConditionsModalOpen: false
      });
    });

    this.state = {
      isConditionsModalOpen: false
    };
  }

  render() {
    var {
      conditions,
      checkIn,
      amount,
      restrictions,
      currency,
      firstNightCost,
      showCancellationTable,
      cutOffDate,
      cancellationPoliciesInfo
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      onClick: this.handleOpenConditionsModal
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
      tagName: "span"
    }, msgs$o.seeConditions)), " "), /*#__PURE__*/React__default.createElement(WitModal, {
      isOpen: this.state.isConditionsModalOpen,
      onRequestClose: this.handleCloseConditionsModal
    }, /*#__PURE__*/React__default.createElement(PopupConditions$1, {
      data: conditions,
      checkIn: checkIn,
      amount: amount,
      restrictions: restrictions,
      currency: currency,
      firstNightCost: firstNightCost,
      showCancellationTable: showCancellationTable,
      cutOffDate: cutOffDate,
      closeWindow: this.handleCloseConditionsModal,
      cancellationPoliciesInfo: cancellationPoliciesInfo
    })));
  }

}

BookingInfoSeeConditions.defaultProps = {
  cancellationPoliciesInfo: ""
};
BookingInfoSeeConditions.propTypes = {
  cancellationPoliciesInfo: PropTypes__default.string,
  showCancellationTable: PropTypes__default.bool.isRequired,
  currency: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.oneOfType([PropTypes__default.instanceOf(Date), PropTypes__default.string]),
  amount: PropTypes__default.number.isRequired,
  restrictions: PropTypes__default.array.isRequired,
  firstNightCost: PropTypes__default.number.isRequired,
  cutOffDate: PropTypes__default.instanceOf(Date).isRequired,
  conditions: PropTypes__default.object.isRequired
};

function _templateObject$L() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  & > * {\n    margin-bottom: 2px;\n  }\n  & > *:last-child {\n    margin-bottom: 15px;\n  }\n  & > *:nth-child(5) {\n    margin-bottom: 30px;\n  }\n  & > *:nth-child(10) * {\n  font-weight: 400;\n  font-size:14px;  \n  }\n  & > div:not(:nth-child(n+11)) > *:first-child {\n    font-weight: 700;\n  }\n  & > *:last-child > *:first-child {\n    text-decoration: underline;\n    color: ", ";\n    cursor: pointer;\n  }\n  }\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}
var StyledBookingInfo = styled__default.div(_templateObject$L(), greyLight);

function BookingInfo(_ref) {
  var {
    bookingId,
    status,
    property,
    reference,
    received,
    checkIn,
    checkOut,
    guests,
    mealPlan,
    conditions,
    restrictions,
    cutOffDate,
    amount,
    currency,
    firstNightCost,
    showCancellationTable,
    cancellationPoliciesInfo,
    accommodationType,
    packageName,
    additionalRequests,
    hotelSiteURL
  } = _ref;
  var POSMerchantCode = additionalRequests === null || additionalRequests === void 0 ? void 0 : additionalRequests.POSMerchantCode;
  return /*#__PURE__*/React__default.createElement(StyledBookingInfo, null, /*#__PURE__*/React__default.createElement(BookingInfoBooking, {
    bookingId: bookingId
  }), /*#__PURE__*/React__default.createElement(BookingInfoStatus, {
    status: status
  }), /*#__PURE__*/React__default.createElement(BookingInfoProperty, {
    property: property
  }), /*#__PURE__*/React__default.createElement(BookingInfoRef, {
    reference: reference
  }), /*#__PURE__*/React__default.createElement(BookingInfoReceived, {
    received: received
  }), POSMerchantCode ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Merchant"), ": ", hotelSiteURL) : /*#__PURE__*/React__default.createElement("div", null), POSMerchantCode ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Terminal"), ": ", POSMerchantCode) : /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement(BookingInfoCheckIn, {
    checkIn: checkIn
  }), /*#__PURE__*/React__default.createElement(BookingInfoCheckOut, {
    checkOut: checkOut
  }), /*#__PURE__*/React__default.createElement(BookingInfoGuests, {
    guests: guests
  }), /*#__PURE__*/React__default.createElement(BookingInfoMealPlanConditions, {
    accommodationType: accommodationType,
    packageName: packageName,
    mealPlan: mealPlan,
    conditions: conditions
  }), /*#__PURE__*/React__default.createElement(CancellationMessage$1, {
    restrictions: restrictions,
    cutOffDate: cutOffDate,
    yearFirst: true
  }), /*#__PURE__*/React__default.createElement(BookingInfoSeeConditions, {
    conditions: conditions,
    checkIn: checkIn,
    amount: amount,
    restrictions: restrictions,
    currency: currency,
    firstNightCost: firstNightCost,
    showCancellationTable: showCancellationTable,
    cutOffDate: cutOffDate,
    cancellationPoliciesInfo: cancellationPoliciesInfo
  }));
}

BookingInfo.defaultProps = {
  cancellationPoliciesInfo: ""
};
BookingInfo.propTypes = {
  cancellationPoliciesInfo: PropTypes__default.string,
  bookingId: PropTypes__default.string.isRequired,
  status: PropTypes__default.string.isRequired,
  property: PropTypes__default.string.isRequired,
  reference: PropTypes__default.string.isRequired,
  received: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.string.isRequired,
  checkOut: PropTypes__default.string.isRequired,
  guests: PropTypes__default.number.isRequired,
  mealPlan: PropTypes__default.string.isRequired,
  conditions: PropTypes__default.object.isRequired,
  restrictions: PropTypes__default.array.isRequired,
  cutOffDate: PropTypes__default.instanceOf(Date).isRequired,
  firstNightCost: PropTypes__default.number.isRequired,
  amount: PropTypes__default.number.isRequired,
  showCancellationTable: PropTypes__default.bool.isRequired,
  currency: PropTypes__default.string.isRequired
};

function _templateObject4$t() {
  var data = _taggedTemplateLiteral(["\n    & > * {\n    margin-bottom: 0;\n    }\n    flex-direction: row;\n    padding: 20px\n    border: 1px solid ", ";\n    border-top: 1px;\n"]);

  _templateObject4$t = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$x() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid ", ";\n  & > * {\n    flex: 1 1 auto;\n  }\n  & > :first-child {\n    margin-right: 10px;\n  }\n  ", ";\n"]);

  _templateObject3$x = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$F() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n"]);

  _templateObject2$F = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  padding: 8px;\n  font-size: 20px;\n  font-weight: 700;\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  ", ";\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}
var ConfirmationCardHeader = styled__default.div(_templateObject$M(), props => props.backgroundColor, props => props.textColor, greyLighter, greyLighter, media.up.sml(_templateObject2$F(), greyLighter));
var ConfirmationCardBody = styled__default.div(_templateObject3$x(), greyLighter, media.up.sml(_templateObject4$t(), greyLighter));

function _templateObject13$4() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n"]);

  _templateObject13$4 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$4() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  border: 0;\n  ", ";\n"]);

  _templateObject12$4 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$5() {
  var data = _taggedTemplateLiteral(["\n  & > *:first-child {\n    margin-right: 10px;\n  }\n"]);

  _templateObject11$5 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  text-decoration: underline;\n  padding: 10px 0;\n  cursor: pointer;\n"]);

  _templateObject10$5 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid ", ";\n  border-radius: 5px;\n  color: ", ";\n  padding: 10px 0;\n  cursor: pointer;\n"]);

  _templateObject9$6 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$7() {
  var data = _taggedTemplateLiteral(["\n    display:none;\n"]);

  _templateObject8$7 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$a() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  ", ";\n  & > :first-child {\n    font-weight: 700;\n  }\n"]);

  _templateObject7$a = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$b() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 10px;\n"]);

  _templateObject6$b = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$k() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  cursor: pointer;\n  color: ", ";\n"]);

  _templateObject5$k = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$u() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: underline;\n  cursor: pointer;\n"]);

  _templateObject4$u = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$y() {
  var data = _taggedTemplateLiteral(["\n    display:block;\n"]);

  _templateObject3$y = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$G() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  display: none;\n  font-size: 13px;\n  ", ";\n"]);

  _templateObject2$G = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$p = reactIntl.defineMessages({
  cancel: {
    id: "reservation_confirmed.reservation_information.cancel",
    description: "cancel field of reservation information",
    defaultMessage: "Cancel"
  },
  modify: {
    id: "bookingConfirmation.modify.button",
    description: "Modify reservation",
    defaultMessage: "Modify"
  }
});
var StyledConfirmationCard = styled__default.div(_templateObject$N(), wbBlack);
var ControlsDesktop = styled__default.div(_templateObject2$G(), media.up.sml(_templateObject3$y()));
var ModifyDesktop = styled__default.span(_templateObject4$u(), greyLight);
var CancelDesktop = styled__default.span(_templateObject5$k(), wbRed);
var Separator = styled__default.span(_templateObject6$b());
var ControlsMobile = styled__default.div(_templateObject7$a(), media.up.sml(_templateObject8$7()));
var ModifyMobile = styled__default.div(_templateObject9$6(), wbGreen, wbGreen);
var CancelMobile = styled__default.div(_templateObject10$5(), greyLight);
var AccommodationQuantityName = styled__default.span(_templateObject11$5());
var StyledConfirmationCardHeader = styled__default(ConfirmationCardHeader)(_templateObject12$4(), media.up.sml(_templateObject13$4(), greyLighter));

class ConfirmationCard extends React.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleOpenCancellationModal", () => {
      this.setState({
        isCancellationModalOpen: true
      });
    });

    _defineProperty(this, "handleCloseCancellationModal", () => {
      this.setState({
        isCancellationModalOpen: false
      });
    });

    this.state = {
      isCancellationModalOpen: false
    };
  }

  render() {
    var {
      dailyValues,
      subtotal,
      total,
      deposit,
      toPay,
      extras,
      discounts,
      currency,
      pendingAmountTextConfiguration,
      bookingId,
      status,
      property,
      reference,
      received,
      checkIn,
      checkOut,
      guests,
      mealPlan,
      conditions,
      accommodationQuantity,
      accommodationType,
      packageName,
      restrictions,
      cutOffDate,
      handleModification,
      backgroundColor,
      textColor,
      firstNightCost,
      showCancellationTable,
      cancellationFormQuestionnaire,
      handleCancellation,
      cancellationError,
      loading,
      hasModificationPolicies,
      cancellationPoliciesInfo,
      currentPolicyAllowsCancel,
      addObligatoryExtrasRateToRoomSelection,
      totalActiveReservations,
      additionalRequests,
      hotelSiteURL
    } = this.props;
    var pastCheckIn = moment$1(new Date()).isAfter(checkIn);
    return /*#__PURE__*/React__default.createElement(StyledConfirmationCard, null, /*#__PURE__*/React__default.createElement(StyledConfirmationCardHeader, {
      backgroundColor: backgroundColor,
      textColor: textColor
    }, /*#__PURE__*/React__default.createElement(AccommodationQuantityName, null, /*#__PURE__*/React__default.createElement("span", null, accommodationQuantity), /*#__PURE__*/React__default.createElement("span", null, packageName || accommodationType))), /*#__PURE__*/React__default.createElement(ConfirmationCardBody, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BookingInfo, {
      bookingId: bookingId,
      status: status,
      property: property,
      reference: reference,
      received: received,
      checkIn: checkIn,
      checkOut: checkOut,
      accommodationType: accommodationType,
      packageName: packageName,
      guests: guests,
      mealPlan: mealPlan,
      conditions: conditions,
      restrictions: restrictions,
      cutOffDate: cutOffDate,
      amount: total,
      currency: currency,
      firstNightCost: firstNightCost,
      showCancellationTable: showCancellationTable,
      cancellationPoliciesInfo: cancellationPoliciesInfo,
      additionalRequests: additionalRequests,
      hotelSiteURL: hotelSiteURL
    }), status !== constants.RESERVATION_STATUS.CANCELED && !pastCheckIn && /*#__PURE__*/React__default.createElement(ControlsDesktop, null, hasModificationPolicies && /*#__PURE__*/React__default.createElement(ModifyDesktop, {
      onClick: () => handleModification()
    }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$p.modify)), hasModificationPolicies && currentPolicyAllowsCancel && /*#__PURE__*/React__default.createElement(Separator, null, " | "), currentPolicyAllowsCancel && /*#__PURE__*/React__default.createElement(CancelDesktop, {
      onClick: this.handleOpenCancellationModal
    }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$p.cancel)))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(AmountTable, {
      dailyValues: dailyValues,
      subtotal: subtotal,
      total: total,
      deposit: deposit,
      toPay: toPay,
      extras: extras,
      discounts: discounts,
      currency: currency,
      pendingAmountTextConfiguration: pendingAmountTextConfiguration,
      addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection,
      taxesText: this.props.taxesText
    }), status !== constants.RESERVATION_STATUS.CANCELED && !pastCheckIn && /*#__PURE__*/React__default.createElement(ControlsMobile, null, hasModificationPolicies && /*#__PURE__*/React__default.createElement(ModifyMobile, {
      onClick: () => handleModification()
    }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$p.modify)), currentPolicyAllowsCancel && /*#__PURE__*/React__default.createElement(CancelMobile, {
      onClick: this.handleOpenCancellationModal
    }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$p.cancel))), /*#__PURE__*/React__default.createElement(WitModal, {
      isOpen: this.state.isCancellationModalOpen,
      onRequestClose: this.handleCloseCancellationModal
    }, /*#__PURE__*/React__default.createElement(PopupCancellation$1, {
      data: conditions,
      checkIn: checkIn,
      checkOut: checkOut,
      amount: total,
      restrictions: restrictions,
      currency: currency,
      firstNightCost: firstNightCost,
      showCancellationTable: showCancellationTable,
      cutOffDate: cutOffDate,
      closeWindow: this.handleCloseCancellationModal,
      cancellationFormQuestionnaire: cancellationFormQuestionnaire,
      handleCancellation: handleCancellation,
      cancellationError: cancellationError,
      loading: loading,
      cancellationPoliciesInfo: cancellationPoliciesInfo,
      totalActiveReservations: totalActiveReservations
    })))));
  }

}

ConfirmationCard.defaultProps = {
  showCancellationTable: false,
  cancellationPoliciesInfo: ""
};
ConfirmationCard.propTypes = {
  dailyValues: PropTypes__default.object.isRequired,
  cancellationPoliciesInfo: PropTypes__default.string,
  subtotal: PropTypes__default.number.isRequired,
  total: PropTypes__default.number.isRequired,
  deposit: PropTypes__default.number.isRequired,
  toPay: PropTypes__default.number.isRequired,
  extras: PropTypes__default.array.isRequired,
  discounts: PropTypes__default.array.isRequired,
  currency: PropTypes__default.string.isRequired,
  pendingAmountTextConfiguration: PropTypes__default.string.isRequired,
  bookingId: PropTypes__default.string.isRequired,
  status: PropTypes__default.string.isRequired,
  property: PropTypes__default.string.isRequired,
  reference: PropTypes__default.string.isRequired,
  received: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.string.isRequired,
  checkOut: PropTypes__default.string.isRequired,
  guests: PropTypes__default.number.isRequired,
  mealPlan: PropTypes__default.string.isRequired,
  conditions: PropTypes__default.object.isRequired,
  accommodationQuantity: PropTypes__default.number.isRequired,
  accommodationType: PropTypes__default.string.isRequired,
  packageName: PropTypes__default.string,
  restrictions: PropTypes__default.array.isRequired,
  cutOffDate: PropTypes__default.instanceOf(Date).isRequired,
  handleCancellation: PropTypes__default.func.isRequired,
  handleModification: PropTypes__default.func.isRequired,
  backgroundColor: PropTypes__default.string.isRequired,
  textColor: PropTypes__default.string.isRequired,
  firstNightCost: PropTypes__default.number.isRequired,
  showCancellationTable: PropTypes__default.bool,
  cancellationFormQuestionnaire: PropTypes__default.array.isRequired,
  cancellationError: PropTypes__default.bool.isRequired,
  loading: PropTypes__default.bool.isRequired,
  currentPolicyAllowsCancel: PropTypes__default.bool.isRequired,
  hasModificationPolicies: PropTypes__default.bool.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes__default.bool.isRequired
};

var msgs$q = reactIntl.defineMessages({
  email: {
    id: "reservation_confirmed.contact_information.email",
    description: "Email label for contact information on reservation confirmed",
    defaultMessage: "Email"
  }
});

function CustomerInfoEmail(_ref) {
  var {
    email
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$q.email)), ":", " ", /*#__PURE__*/React__default.createElement("span", {
    className: "customer-email"
  }, email));
}

CustomerInfoEmail.propTypes = {
  name: PropTypes__default.string,
  email: PropTypes__default.string,
  address: PropTypes__default.string,
  phone: PropTypes__default.string,
  country: PropTypes__default.string
};

var msgs$r = reactIntl.defineMessages({
  address: {
    id: "reservation_confirmed.contact_information.address",
    description: "Address label for contact information on reservation confirmed",
    defaultMessage: "Address"
  }
});

function CustomerInfoAddress(_ref) {
  var {
    address
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$r.address)), ": ", address);
}

CustomerInfoAddress.propTypes = {
  address: PropTypes__default.string.isRequired
};

var msgs$s = reactIntl.defineMessages({
  phoneNumber: {
    id: "reservation_confirmed.contact_information.phoneNumber",
    description: "PhoneNumber label for contact information on reservation confirmed",
    defaultMessage: "Tel"
  }
});

function CustomerInfoPhone(_ref) {
  var {
    phone
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$s.phoneNumber)), ": ", phone);
}

CustomerInfoPhone.propTypes = {
  phone: PropTypes__default.string.isRequired
};

var msgs$t = reactIntl.defineMessages({
  country: {
    id: "reservation_confirmed.contact_information.country",
    description: "Country for contact information on reservation confirmed",
    defaultMessage: "País"
  }
});

function CustomerInfoCountry(_ref) {
  var {
    country
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$t.country)), ": ", country);
}

CustomerInfoCountry.propTypes = {
  country: PropTypes__default.string.isRequired
};

var msgs$u = reactIntl.defineMessages({
  personalId: {
    id: "reservation_confirmed.contact_information.personalId",
    description: "Personal ID label for contact information on reservation confirmed",
    defaultMessage: "DNI"
  }
});

function CustomerInfoPersonalId(_ref) {
  var {
    personalId
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({
    tagName: "span"
  }, msgs$u.personalId)), ": ", personalId);
}

CustomerInfoPersonalId.propTypes = {
  personalId: PropTypes__default.string.isRequired
};

function _templateObject3$z() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  color: ", ";\n"]);

  _templateObject3$z = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$H() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n    display: flex;\n  "]);

  _templateObject2$H = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$O() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  ", ";\n  & > * :first-child {\n    font-weight: 700;\n  }\n  & :not(:last-child) {\n    margin-bottom: 5px;\n  }\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}
var StyledConfirmationCardBody = styled__default(ConfirmationCardBody)(_templateObject$O(), media.up.sml(_templateObject2$H()));
var StyledConfirmationPageCustomerInfo = styled__default.div(_templateObject3$z(), wbBlack);

function ConfirmationPageCustomerInfo(_ref) {
  var {
    name,
    email,
    address,
    phone,
    country,
    personalId,
    surname,
    backgroundColor,
    textColor
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledConfirmationPageCustomerInfo, null, /*#__PURE__*/React__default.createElement(ConfirmationCardHeader, {
    backgroundColor: backgroundColor,
    textColor: textColor
  }, name, " ", surname), /*#__PURE__*/React__default.createElement(StyledConfirmationCardBody, null, email && /*#__PURE__*/React__default.createElement(CustomerInfoEmail, {
    email: email
  }), address && /*#__PURE__*/React__default.createElement(CustomerInfoAddress, {
    address: address
  }), phone && /*#__PURE__*/React__default.createElement(CustomerInfoPhone, {
    phone: phone
  }), country && /*#__PURE__*/React__default.createElement(CustomerInfoCountry, {
    country: country
  }), personalId && /*#__PURE__*/React__default.createElement(CustomerInfoPersonalId, {
    personalId: personalId
  })));
}

ConfirmationPageCustomerInfo.defaultProps = {
  phone: undefined,
  country: undefined,
  personalId: undefined
};
ConfirmationPageCustomerInfo.propTypes = {
  name: PropTypes__default.string.isRequired,
  surname: PropTypes__default.string.isRequired,
  email: PropTypes__default.string.isRequired,
  address: PropTypes__default.string,
  phone: PropTypes__default.string,
  country: PropTypes__default.string,
  personalId: PropTypes__default.string,
  backgroundColor: PropTypes__default.string.isRequired,
  textColor: PropTypes__default.string.isRequired
};

function _templateObject5$l() {
  var data = _taggedTemplateLiteral(["\n  font-size: 25px;\n  color: ", ";\n  line-height: 30px;\n  margin-bottom: 5px;\n"]);

  _templateObject5$l = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$v() {
  var data = _taggedTemplateLiteral(["\n  font-size: 25px;\n  color: ", ";\n  line-height: 30px;\n"]);

  _templateObject4$v = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$A() {
  var data = _taggedTemplateLiteral(["\n  font-size: 25px;\n  color: ", ";\n  line-height: 30px;\n"]);

  _templateObject3$A = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$I() {
  var data = _taggedTemplateLiteral(["\n    margin: 10px 0 !important;\n  "]);

  _templateObject2$I = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$P() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 10px;\n  text-align: left;\n  font-size: 14px;\n  color: ", ";\n  ", ";\n"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$v = reactIntl.defineMessages({
  thankYou: {
    id: "bookingConfirmation.thankU",
    description: "Thank you Title",
    defaultMessage: "Thank you for your reservation!"
  },
  thankYouSubtitle: {
    id: "bookingConfirmation.thankU_subtitle",
    description: "Thank you subtitle",
    defaultMessage: "Your reservation has been confirmed correctly"
  },
  cancelled: {
    id: "bookingConfirmation.cancelled",
    description: "Thank you Title",
    defaultMessage: "Your reservation has been cancelled"
  },
  cancelledSubtitle: {
    id: "bookingConfirmation.cancelledSubtitle",
    description: "Thank you subtitle",
    defaultMessage: "Your reservation has been cancelled correctly"
  },
  pending: {
    id: "bookingConfirmation.pending",
    description: "Thank you Title",
    defaultMessage: "Your reservation is pending"
  },
  pendingSubtitle: {
    id: "bookingConfirmation.pendingSubtitle",
    description: "Thank you subtitle",
    defaultMessage: "Your reservation is pending"
  },
  deferred: {
    id: "deferred.completePayment",
    description: "Complete your payment",
    defaultMessage: "Complete your payment"
  },
  holdUntil: {
    id: "deferred.holdUntil",
    description: "We'll hold the booking until",
    defaultMessage: "We'll hold the booking until"
  },
  propertyTime: {
    id: "deferred.propertyTime",
    description: "property time",
    defaultMessage: " "
  },
  on: {
    id: "deferred.on",
    description: "on",
    defaultMessage: "on"
  }
});
var StyledConfirmationPageMessage = styled__default.div(_templateObject$P(), greyLight, media.up.sml(_templateObject2$I()));
var Confirmed = styled__default.div(_templateObject3$A(), wbGreen);
var Cancelled = styled__default.div(_templateObject4$v(), wbRed);
var Pending = styled__default.div(_templateObject5$l(), wbOrange);

function ConfirmationPageMessage(_ref) {
  var {
    reservationStatus,
    deferredDeadline,
    className
  } = _ref;

  switch (reservationStatus) {
    case constants.RESERVATION_STATUS.CANCELED:
      return /*#__PURE__*/React__default.createElement(StyledConfirmationPageMessage, {
        className: className
      }, /*#__PURE__*/React__default.createElement(Cancelled, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.cancelled)), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.cancelledSubtitle));

    case constants.RESERVATION_STATUS.CONFIRMED:
      return /*#__PURE__*/React__default.createElement(StyledConfirmationPageMessage, {
        className: className
      }, /*#__PURE__*/React__default.createElement(Confirmed, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.thankYouSubtitle)), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.thankYou));

    case constants.RESERVATION_STATUS.PRE_RESERVATION:
      return /*#__PURE__*/React__default.createElement(StyledConfirmationPageMessage, {
        className: className
      }, /*#__PURE__*/React__default.createElement(Pending, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.pending)), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.pendingSubtitle));

    case constants.RESERVATION_STATUS.DEFERRED:
      return /*#__PURE__*/React__default.createElement(StyledConfirmationPageMessage, {
        className: className
      }, /*#__PURE__*/React__default.createElement(Pending, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.deferred)), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.holdUntil), " ", deferredDeadline && moment(deferredDeadline).format("DD MMMM YYYY"), "\xA0", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$v.propertyTime)));

    default:
      return null;
  }
}

ConfirmationPageMessage.propTypes = {
  reservationStatus: PropTypes__default.oneOf([constants.RESERVATION_STATUS.CANCELED, constants.RESERVATION_STATUS.CONFIRMED, constants.RESERVATION_STATUS.PENDING]).isRequired
};

function HotelInfoAddress(_ref) {
  var {
    address
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, address);
}

HotelInfoAddress.propTypes = {
  address: PropTypes__default.string.isRequired
};

function HotelInfoPhone(_ref) {
  var {
    phone
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, phone);
}

HotelInfoPhone.propTypes = {
  phone: PropTypes__default.string.isRequired
};

function HotelInfoEmail(_ref) {
  var {
    email
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, email);
}

HotelInfoEmail.propTypes = {
  email: PropTypes__default.string.isRequired
};

var glass = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2252.997%22%20height%3D%2269.441%22%20viewBox%3D%220%200%2052.997%2069.441%22%3E%3Cpath%20fill%3D%22%23EBEBEB%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M43.332%2C31.914c-2.16%2C3.629-5.599%2C6.176-9.686%2C7.176%20c-4.096%2C0.998-8.356%2C0.328-11.999-1.908c-7.525-4.613-9.983-14.517-5.457-22.037c2.195-3.641%2C5.664-6.174%2C9.779-7.144%20c4.105-0.967%2C8.354-0.254%2C11.969%2C1.996c3.594%2C2.244%2C6.142%2C5.765%2C7.158%2C9.894C46.115%2C24.028%2C45.484%2C28.298%2C43.332%2C31.914z%20M41.775%2C3.58c-5.496-3.438-11.83-4.33-17.63-2.976C18.318%2C1.964%2C13.039%2C5.58%2C9.689%2C11.131c-5.779%2C9.574-3.883%2C21.732%2C3.879%2C29.281%20L0.543%2C62.129c-1.085%2C1.801-0.493%2C4.162%2C1.304%2C5.242L4.382%2C68.9c1.795%2C1.082%2C4.144%2C0.49%2C5.215-1.311l12.972-21.68%20c4.253%2C1.424%2C8.722%2C1.566%2C12.894%2C0.537c5.766-1.42%2C10.965-5.066%2C14.246-10.588C56.258%2C24.848%2C52.725%2C10.425%2C41.775%2C3.58z%22%2F%3E%3C%2Fsvg%3E";

function _templateObject$Q() {
  var data = _taggedTemplateLiteral(["\n  width: 190px;\n  height: 130px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  &:after {\n    content: \"\";\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-size: 9%;\n    background-image: url(", ");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: initial;\n    background-color: rgba(0, 0, 0, 0.6);\n    opacity: 0;\n    transition: opacity 0.5s;\n    backface-visibility: hidden;\n  }\n  &:hover:after {\n    opacity: 1;\n  }\n  & img {\n    height: inherit;\n    width: inherit;\n    object-fit: cover;\n    font-family: \"object-fit: cover;\";\n  }\n\n  @media (max-width: 639px) {\n    width: 50px;\n    height: 50px;\n    margin-right: 10px;\n    & img {\n      border-radius: 100px;\n    }\n  }\n"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}
var ThumbnailWrapper = styled__default.div(_templateObject$Q(), glass);

class Thumbnail extends React.PureComponent {
  componentDidMount() {
    objectFitImages();
  }

  render() {
    return /*#__PURE__*/React__default.createElement(ThumbnailWrapper, {
      onClick: this.props.onClickProp,
      className: "".concat(this.props.className, " wbkv9-Thumbnail")
    }, /*#__PURE__*/React__default.createElement("img", {
      src: this.props.src,
      alt: "thumbnail"
    }));
  }

}

Thumbnail.defaultProps = {
  className: ""
};
Thumbnail.propTypes = {
  onClickProp: PropTypes__default.func,
  src: PropTypes__default.string.isRequired,
  className: PropTypes__default.string
};

function _templateObject4$w() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  color: ", ";\n"]);

  _templateObject4$w = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$B() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  margin-bottom: 20px;\n  & img {\n    border-radius: 0;\n    cursor: default;\n  }\n  &:hover:after {\n    opacity: 0;\n    cursor: default;\n  }\n"]);

  _templateObject3$B = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$J() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: column;\n    display: flex;\n  "]);

  _templateObject2$J = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$R() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  display: flex;\n  flex-direction: column;\n  ", ";\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}
var StyledConfirmationCardBody$1 = styled__default(ConfirmationCardBody)(_templateObject$R(), media.up.sml(_templateObject2$J()));
var StyledThumbnail = styled__default(Thumbnail)(_templateObject3$B());
var StyledConfirmationPagePropertyInfo = styled__default.div(_templateObject4$w(), wbBlack);

function ConfirmationPagePropertyInfo(_ref) {
  var {
    email,
    address,
    phone,
    name,
    src,
    backgroundColor,
    textColor
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledConfirmationPagePropertyInfo, null, /*#__PURE__*/React__default.createElement(ConfirmationCardHeader, {
    backgroundColor: backgroundColor,
    textColor: textColor
  }, name), /*#__PURE__*/React__default.createElement(StyledConfirmationCardBody$1, null, /*#__PURE__*/React__default.createElement(StyledThumbnail, {
    className: "wbk-ConfirmationPagePropertyInfoImage",
    src: src
  }), /*#__PURE__*/React__default.createElement(HotelInfoAddress, {
    address: address
  }), /*#__PURE__*/React__default.createElement(HotelInfoEmail, {
    email: email
  }), /*#__PURE__*/React__default.createElement(HotelInfoPhone, {
    phone: phone
  })));
}

ConfirmationPagePropertyInfo.propTypes = {
  src: PropTypes__default.string.isRequired,
  name: PropTypes__default.string.isRequired,
  phone: PropTypes__default.string.isRequired,
  email: PropTypes__default.string.isRequired,
  address: PropTypes__default.string.isRequired,
  backgroundColor: PropTypes__default.string.isRequired,
  textColor: PropTypes__default.string.isRequired
};

/**
  This file is autogenerated by indexr.
  Check this file into source control.
  Do not edit this file.
  For more information: http://github.com/ryardley/indexr
**/
/** End autogenerated content **/

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ConfirmationPageButtons: ConfirmationPageButtons,
  ConfirmationPageCard: ConfirmationCard,
  ConfirmationPageCustomerInfo: ConfirmationPageCustomerInfo,
  ConfirmationPageMessage: ConfirmationPageMessage,
  ConfirmationPagePropertyInfo: ConfirmationPagePropertyInfo
});

function _templateObject6$c() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n  & ul {\n    padding-left: 20px;\n  }\n"]);

  _templateObject6$c = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$m() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 30px;\n  font-weight: 600;\n"]);

  _templateObject5$m = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$x() {
  var data = _taggedTemplateLiteral(["\n  font-size: 25px;\n  font-weight: 700;\n"]);

  _templateObject4$x = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$C() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject3$C = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$K() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  width: ", ";\n  max-width: inherit;\n  flex-wrap: wrap;\n  display: flex;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 13px;\n  margin: 0 4px 0 4px;\n  text-transform: capitalize;\n  span {\n    line-height: 115%;\n  }\n"]);

  _templateObject2$K = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$S() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  margin-bottom: ", ";\n  cursor: pointer;\n  color: ", ";\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}
var messages$3 = reactIntl.defineMessages({
  benefits: {
    id: "loyalty.accountBanner.benefits",
    description: "Benefits",
    defaultMessage: "Beneficios"
  }
});
var Container$7 = styled__default.div(_templateObject$S(), (_ref) => {
  var {
    isMobile,
    isInventory
  } = _ref;
  return isMobile && !isInventory && "5px";
}, (_ref2) => {
  var {
    color
  } = _ref2;
  return color;
});
var HighlightedContainer = styled__default.span(_templateObject2$K(), (_ref3) => {
  var {
    width
  } = _ref3;
  return width;
});
var Amount = styled__default.span(_templateObject3$C());
var AmountInteger = styled__default.span(_templateObject4$x());
var AmountDecimal = styled__default.span(_templateObject5$m());
var PopupContainer$2 = styled__default.div(_templateObject6$c());

function Text$1(_ref4) {
  var {
    highlightedNameTop,
    highlightedNameBottom
  } = _ref4;
  return /*#__PURE__*/React__default.createElement(HighlightedContainer, null, /*#__PURE__*/React__default.createElement("span", null, highlightedNameTop.toLowerCase()), /*#__PURE__*/React__default.createElement("span", null, highlightedNameBottom.toLowerCase()));
}

function Tier(_ref5) {
  var {
    color,
    benefitDescription,
    description,
    deviceType,
    handleCloseModal,
    handleModalContent,
    highlightedNameTop,
    highlightedNameBottom,
    isInventory,
    price = 0,
    userLoyaltyTier,
    linkToLoyaltyLogin
  } = _ref5;
  var intl = reactIntl.useIntl();
  var isMobileResolution = React.useMemo(() => deviceType === constants.DEVICE_TYPE.MOBILE && window.screen.availWidth < 767, [deviceType]);
  var amountInteger = React.useMemo(() => price.toFixed(2).split(".")[0], [price]);
  var amountDecimal = React.useMemo(() => price.toFixed(2).split(".")[1], [price]);

  var TiersModal = () => /*#__PURE__*/React__default.createElement(Popup, {
    headerText: intl.formatMessage(messages$3.benefits),
    closeWindow: handleCloseModal
  }, /*#__PURE__*/React__default.createElement(PopupContainer$2, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: benefitDescription
    }
  })));

  var handleModal = React.useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    handleModalContent( /*#__PURE__*/React__default.createElement(TiersModal, null), {
      modalWidth: "900px",
      hideCloseButton: true
    });
  }, [handleModalContent, benefitDescription, description]);

  var handleLoginRedirect = () => {
    location.href = linkToLoyaltyLogin;
  };

  return /*#__PURE__*/React__default.createElement(Container$7, {
    isMobile: isMobileResolution,
    isInventory: isInventory,
    color: color,
    onClick: userLoyaltyTier ? handleModal : handleLoginRedirect
  }, /*#__PURE__*/React__default.createElement(Text$1, {
    highlightedNameTop: highlightedNameTop,
    highlightedNameBottom: highlightedNameBottom
  }), !userLoyaltyTier && /*#__PURE__*/React__default.createElement(Amount, null, /*#__PURE__*/React__default.createElement(AmountInteger, null, amountInteger), /*#__PURE__*/React__default.createElement(AmountDecimal, null, amountDecimal)));
}

var ArrowIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
})), "ArrowLeft");

function _templateObject27$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  display: block;\n  color: #ed5f3a;\n  a {\n    color: #ed5f3a;\n    font-weight: bold;\n  }\n"]);

  _templateObject27$1 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26$1() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject26$1 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25$1() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 5px;\n"]);

  _templateObject25$1 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24$1() {
  var data = _taggedTemplateLiteral(["\n  > div > span {\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject24$1 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23$1() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  color: ", ";\n  transform: rotate(180deg);\n"]);

  _templateObject23$1 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22$1() {
  var data = _taggedTemplateLiteral(["\n  min-height: 40px;\n  min-width: 40px;\n  max-height: 40px;\n  max-width: 40px;\n  border: 1px solid ", ";\n  color: ", ";\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  cursor: pointer;\n"]);

  _templateObject22$1 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21$1() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: 36px;\n  "]);

  _templateObject21$1 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 115px;\n  max-width: 130px;\n  height: 40px;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  ", "\n  ", ";\n"]);

  _templateObject20$1 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: ", ";\n"]);

  _templateObject19$1 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: ", ";\n  text-decoration: underline;\n  align-self: flex-end;\n  cursor: pointer;\n"]);

  _templateObject18$2 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 30px;\n"]);

  _templateObject17$2 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 25px;\n"]);

  _templateObject16$3 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  display: flex;\n"]);

  _templateObject15$4 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$4() {
  var data = _taggedTemplateLiteral(["display: none;"]);

  _templateObject14$4 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject13$5 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$5() {
  var data = _taggedTemplateLiteral(["display: none"]);

  _templateObject12$5 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject11$6 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$6() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 13px;\n  color: #8f8f8f;\n"]);

  _templateObject10$6 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$7() {
  var data = _taggedTemplateLiteral(["flex-direction: column;"]);

  _templateObject9$7 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: 12px;\n  ", "\n"]);

  _templateObject8$8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$b() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject7$b = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$d() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject6$d = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$n() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject5$n = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$y() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject4$y = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$D() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject3$D = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$L() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  max-height: 45px;\n  overflow: hidden;\n  cursor: pointer;\n ", ";\n  margin-bottom :9px;\n", " ", " ", " ", " ", ";\n;\n"]);

  _templateObject2$L = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$T() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  height: 100%;\n"]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$w = reactIntl.defineMessages({
  select: {
    id: "room_selection.entity.select",
    description: "Select",
    defaultMessage: "Select"
  },
  view: {
    id: "room_selection.entity.view",
    description: "View button",
    defaultMessage: "Ver"
  },
  seeOptions: {
    id: "room_selecton.entity.seeOptions",
    description: "seeOptions",
    defaultMessage: "view options"
  },
  unavailable: {
    id: "room_selection.entity.agotada",
    description: "agotada",
    defaultMessage: "Sold Out"
  },
  from: {
    id: "room_selection.entity.from",
    description: "From",
    defaultMessage: "from"
  },
  night: {
    id: "room_selection.entity.night",
    description: "Night",
    defaultMessage: "night"
  }
});
var StyledAriContainer = styled__default.div(_templateObject$T());
var big = "font-size: 17px; line-height 21px;";
var small = "font-size: 14px; line-height: 19px;";
var Title$1 = styled__default.div(_templateObject2$L(), props => props.length <= 40 ? big : small, media.up.sm(_templateObject3$D(), props => props.length <= 40 ? big : small), media.up.md(_templateObject4$y(), props => props.length <= 38 ? big : small), media.up.mdl(_templateObject5$n(), props => props.length <= 40 ? big : small), media.up.lg(_templateObject6$d(), props => props.length <= 29 ? big : small), media.up.xl(_templateObject7$b(), props => props.length <= 33 ? big : small));
var FromAmount = styled__default.span(_templateObject8$8(), media.down.md(_templateObject9$7()));
var FromNight = styled__default.span(_templateObject10$6());
var FromNightDesktop = styled__default(FromNight)(_templateObject11$6(), media.down.md(_templateObject12$5()));
var FromNightMobile = styled__default(FromNight)(_templateObject13$5(), media.up.md(_templateObject14$4()));
var Amount$1 = styled__default.span(_templateObject15$4());
var AmountInteger$1 = styled__default.span(_templateObject16$3());
var AmountDecimal$1 = styled__default.span(_templateObject17$2());
var SeeOptions = styled__default.span(_templateObject18$2(), greyLight);
var AriAndButton = styled__default.div(_templateObject19$1(), (_ref) => {
  var {
    loyalty,
    userLoyaltyTier
  } = _ref;
  return userLoyaltyTier ? "center" : loyalty ? "flex-end" : "flex-start";
});
var Button$1 = styled__default.span(_templateObject20$1(), media.down.md(_templateObject21$1(), props => props.statusCode === constants.BOOKABLE_STATUS.RESTRICTED ? "auto" : "81px"), props => props.statusCode === constants.BOOKABLE_STATUS.AVAILABLE ? "\n      border: 1px solid ".concat(wbGreen, ";\n      color: ").concat(wbGreen, ";\n      &:hover {\n      color:").concat(white, ";\n      background-color: ").concat(wbGreen, ";\n      }\n      ") : props.statusCode === constants.BOOKABLE_STATUS.RESTRICTED ? "\n        font-size: 9px;\n        width: auto;\n        border: 1px solid ".concat(wbOrange, "\n        color: ").concat(wbOrange, "\n        &:hover {\n        color:").concat(white, ";\n        background-color: ").concat(wbOrange, "\n      }\n        ") : props.statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE ? "\n          border: 1px solid ".concat(greyLight, ";\n          color: ").concat(greyLight, ";\n          ") : undefined);
var ButtonArrow = styled__default.span(_templateObject22$1(), wbGreen, wbGreen, wbGreen);
var ArrowForward = styled__default(ArrowIcon)(_templateObject23$1(), white);
var StyledBookableErrorMessage = styled__default.span(_templateObject24$1());
var TierContainer = styled__default.div(_templateObject25$1());
var OptionsContainer = styled__default.div(_templateObject26$1());
var UnavailableRoomMessage = styled__default.div(_templateObject27$1());

var ViewButton = (_ref2) => {
  var {
    loyalty,
    statusCode,
    handleSelect,
    msgs,
    bookableErrorMessage,
    isMDResolution
  } = _ref2;

  if (isMDResolution && loyalty && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE) {
    return /*#__PURE__*/React__default.createElement(ButtonArrow, {
      onClick: handleSelect
    }, /*#__PURE__*/React__default.createElement(ArrowForward, null));
  } else {
    return /*#__PURE__*/React__default.createElement(Button$1, {
      statusCode: statusCode,
      onClick: handleSelect
    }, statusCode === constants.BOOKABLE_STATUS.AVAILABLE ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs.view) : statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs.unavailable) : statusCode === constants.BOOKABLE_STATUS.RESTRICTED ? /*#__PURE__*/React__default.createElement(StyledBookableErrorMessage, null, bookableErrorMessage) : null);
  }
};

function AriContainer(_ref3) {
  var {
    title,
    currency,
    amount,
    statusCode,
    bookableErrorMessage,
    propertyTicker,
    onSelect,
    ticker,
    loyalty,
    userLoyaltyTier,
    handleModalContent,
    handleCloseModal,
    loyaltyRate,
    linkToLoyaltyLogin,
    showUnavailableRoomQueryMessage,
    textUnavailableRoom,
    onlineStoreHidePrice
  } = _ref3;
  var [isMDResolution, setIsMDResolution] = React.useState(window.screen.availWidth > 1279 && window.screen.availWidth < 1524);
  React.useEffect(() => {
    function handleResize() {
      setIsMDResolution(window.screen.availWidth > 1279 && window.screen.availWidth < 1524);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  var amountInteger = amount.toFixed(2).split(".")[0];
  var amountDecimal = amount.toFixed(2).split(".")[1];
  var handleSelect = React.useCallback(() => onSelect({
    propertyTicker,
    accommodation: ticker
  }), [propertyTicker, ticker]); // FIXME: onClick anonymous function to useCallback when hooks become available

  return /*#__PURE__*/React__default.createElement(StyledAriContainer, null, /*#__PURE__*/React__default.createElement(Title$1, {
    length: title.length,
    onClick: handleSelect
  }, title), /*#__PURE__*/React__default.createElement(AriAndButton, {
    loyalty: loyalty,
    userLoyaltyTier: userLoyaltyTier
  }, statusCode === constants.BOOKABLE_STATUS.AVAILABLE ? /*#__PURE__*/React__default.createElement(FromAmount, null, /*#__PURE__*/React__default.createElement(FromNightMobile, null, /*#__PURE__*/React__default.createElement("div", null, currency, "/", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$w.night))), /*#__PURE__*/React__default.createElement(FromNightDesktop, null, /*#__PURE__*/React__default.createElement("div", null, currency), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$w.night))), /*#__PURE__*/React__default.createElement(Amount$1, null, /*#__PURE__*/React__default.createElement(AmountInteger$1, null, amountInteger), /*#__PURE__*/React__default.createElement(AmountDecimal$1, null, amountDecimal))) : /*#__PURE__*/React__default.createElement(OptionsContainer, null, showUnavailableRoomQueryMessage && /*#__PURE__*/React__default.createElement(UnavailableRoomMessage, {
    dangerouslySetInnerHTML: {
      __html: textUnavailableRoom
    }
  }), /*#__PURE__*/React__default.createElement(SeeOptions, {
    onClick: handleSelect
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$w.seeOptions))), loyalty && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE && !onlineStoreHidePrice && /*#__PURE__*/React__default.createElement(TierContainer, null, /*#__PURE__*/React__default.createElement(Tier, _extends({}, loyalty, {
    price: loyaltyRate,
    userLoyaltyTier: userLoyaltyTier,
    handleModalContent: handleModalContent,
    handleCloseModal: handleCloseModal,
    isMDResolution: isMDResolution,
    linkToLoyaltyLogin: linkToLoyaltyLogin
  }))), /*#__PURE__*/React__default.createElement(ViewButton, {
    loyalty: loyalty,
    statusCode: statusCode,
    handleSelect: handleSelect,
    msgs: msgs$w,
    bookableErrorMessage: bookableErrorMessage,
    isMDResolution: isMDResolution
  })));
}
// AriContainer.propTypes = {
//   title: PropTypes.string.isRequired,
//   currency: PropTypes.string.isRequired,
//   amount: PropTypes.number.isRequired,
//   statusCode: PropTypes.oneOf([
//     constants.BOOKABLE_STATUS.AVAILABLE,
//     constants.BOOKABLE_STATUS.RESTRICTED,
//     constants.BOOKABLE_STATUS.UNAVAILABLE
//   ]).isRequired,
//   bookableErrorMessage: PropTypes.func.isRequired,
//   propertyTicker: PropTypes.string.isRequired,
//   ticker: PropTypes.string.isRequired,
//   onSelect: PropTypes.func.isRequired
// };

function _templateObject17$3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject17$3 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject16$4 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject15$5 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject14$5 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  "]);

  _templateObject13$6 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$6() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  text-align: left;\n", ";\n  margin-bottom: 10px;\n\n", " ", " ", " ", " ", ";\n"]);

  _templateObject12$6 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 115px;\n  max-width: 150px;\n  min-height: 30px;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 5px;\n  padding: 10px 20px;\n  align-self: flex-end;\n  ", ";\n"]);

  _templateObject11$7 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$7() {
  var data = _taggedTemplateLiteral(["\n  > div > span {\n    display: flex;\n    flex-direction: column;\n  }\n"]);

  _templateObject10$7 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject9$8 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$9() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n"]);

  _templateObject8$9 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$c() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n"]);

  _templateObject7$c = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-right: 25px;\n"]);

  _templateObject6$e = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$o() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: baseline;\n"]);

  _templateObject5$o = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$z() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  display: flex;\n  font-size: 17px;\n"]);

  _templateObject4$z = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$E() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n  font-size: 11px;\n  margin-bottom: 10px;\n  line-height: 18px;\n"]);

  _templateObject3$E = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$M() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  color: #908f96;\n  text-decoration: underline;\n  text-align: left;\n  font-size: 13px;\n"]);

  _templateObject2$M = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$U() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n  cursor: pointer;\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$x = reactIntl.defineMessages({
  availability: {
    id: "room_selection.hotel_card.viewAvailability",
    description: "view availability",
    defaultMessage: "view availability"
  },
  from: {
    id: "room_selection.entity.from",
    description: "From",
    defaultMessage: "from"
  },
  night: {
    id: "room_selection.entity.night",
    description: "Night",
    defaultMessage: "night"
  },
  bookNow: {
    id: "room_selection.hotel_card.bookNow",
    description: "bookNow",
    defaultMessage: "BOOK NOW"
  },
  unavailable: {
    id: "room_selection.hotel_card.unavailable",
    description: "unavailable",
    defaultMessage: "Sold Out"
  },
  requires: {
    id: "room_selection.hotel_card.requires",
    description: "Requires",
    defaultMessage: "Requires"
  },
  twoPlus: {
    id: "room_selection.hotel_card.twoPlus",
    description: "2+",
    defaultMessage: "2+"
  },
  rooms: {
    id: "room_selection.hotel_card.rooms",
    description: "Rooms",
    defaultMessage: "Rooms"
  }
});
var StyledChainAriContainer = styled__default.div(_templateObject$U());
var Availability = styled__default.div(_templateObject2$M());
var FromCurrency = styled__default.span(_templateObject3$E());
var Amount$2 = styled__default.span(_templateObject4$z());
var AmountNight = styled__default.div(_templateObject5$o());
var TitleAvailability = styled__default.span(_templateObject6$e());
var FromAmountButton = styled__default.span(_templateObject7$c());
var Requires = styled__default.div(_templateObject8$9());
var TwoPlusRooms = styled__default.div(_templateObject9$8());
var StyledBookableErrorMessage$1 = styled__default.span(_templateObject10$7());
var Button$2 = styled__default.span(_templateObject11$7(), props => props.statusCode === constants.BOOKABLE_STATUS.AVAILABLE ? " \n      color: ".concat(white, ";\n      background-color: ").concat(wbGreen, ";\n      ") : props.statusCode === constants.BOOKABLE_STATUS.RESTRICTED ? "\n        color: white;\n        background-color: ".concat(wbOrange, ";\n        ") : props.statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE ? "\n          border: 1px solid ".concat(greyLight, ";\n          color: ").concat(greyLight, "\n          background-color: ").concat(white, ";\n          ") : undefined);

function ChainAriContainer(_ref) {
  var {
    title,
    bookableErrorMessage,
    propertyTicker,
    onSelect,
    handleCalendar,
    currency,
    amount,
    statusCode,
    occupancyNotPossible
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledChainAriContainer, {
    onClick: event => onSelect({
      event,
      propertyTicker
    })
  }, /*#__PURE__*/React__default.createElement(TitleAvailability, null, /*#__PURE__*/React__default.createElement(Title$2, null, " ", title, " "), /*#__PURE__*/React__default.createElement(Availability, {
    onClick: event => {
      event.stopPropagation();
      return handleCalendar();
    },
    className: "wbkv9-availability"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.availability))), /*#__PURE__*/React__default.createElement(FromAmountButton, null, statusCode === constants.BOOKABLE_STATUS.AVAILABLE && !occupancyNotPossible && /*#__PURE__*/React__default.createElement(FromCurrency, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.from), " ", currency), /*#__PURE__*/React__default.createElement(AmountNight, null, /*#__PURE__*/React__default.createElement(Amount$2, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: amount,
    maximumFractionDigits: 0
  })), /*#__PURE__*/React__default.createElement("span", null, " ", "/", " "), /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.night)))), /*#__PURE__*/React__default.createElement(Button$2, {
    statusCode: statusCode
  }, statusCode === constants.BOOKABLE_STATUS.AVAILABLE && !occupancyNotPossible ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.bookNow) : statusCode === constants.BOOKABLE_STATUS.AVAILABLE && occupancyNotPossible ? /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Requires, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.requires)), /*#__PURE__*/React__default.createElement(TwoPlusRooms, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.twoPlus), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.rooms))) : statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$x.unavailable) : statusCode === constants.BOOKABLE_STATUS.RESTRICTED ? /*#__PURE__*/React__default.createElement(StyledBookableErrorMessage$1, null, bookableErrorMessage) : null)));
}

ChainAriContainer.propTypes = {
  title: PropTypes__default.string.isRequired,
  bookableErrorMessage: PropTypes__default.func.isRequired,
  propertyTicker: PropTypes__default.string.isRequired,
  onSelect: PropTypes__default.func.isRequired,
  handleCalendar: PropTypes__default.func.isRequired,
  currency: PropTypes__default.string.isRequired,
  amount: PropTypes__default.number.isRequired,
  statusCode: PropTypes__default.oneOf([constants.BOOKABLE_STATUS.AVAILABLE, constants.BOOKABLE_STATUS.RESTRICTED, constants.BOOKABLE_STATUS.UNAVAILABLE]).isRequired,
  occupancyNotPossible: PropTypes__default.number.isRequired
};
var big$1 = "font-size: 17px; line-height 21px;";
var small$1 = "font-size: 14px; line-height: 19px;";
var Title$2 = styled__default.div(_templateObject12$6(), props => props.length <= 19 ? big$1 : small$1, media.up.sm(_templateObject13$6(), props => props.length <= 19 ? big$1 : small$1), media.up.md(_templateObject14$5(), props => props.length <= 25 ? big$1 : small$1), media.up.mdl(_templateObject15$5(), props => props.length <= 19 ? big$1 : small$1), media.up.lg(_templateObject16$4(), props => props.length <= 25 ? big$1 : small$1), media.up.xl(_templateObject17$3(), props => props.length <= 19 ? big$1 : small$1));

var NavigateNext = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "NavigateNext");

var NavigatePrevious = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "NavigatePrevious");

function _templateObject9$9() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  & svg {\n    fill: white;\n    width: 44px;\n    height: 44px;\n  }\n"]);

  _templateObject9$9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$a() {
  var data = _taggedTemplateLiteral(["\n  z-index: 1;\n  & svg {\n    fill: white;\n    width: 44px;\n    height: 44px;\n  }\n"]);

  _templateObject8$a = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$d() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding-bottom: 56%;\n  margin-bottom: 13px;\n"]);

  _templateObject7$d = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$f() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  margin-bottom: 10px;\n  border-radius: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n\n  .slick-slide {\n    height: auto;\n    width: 200px;\n  }\n\n  .slick-slide div,\n  span {\n    height: 100%;\n  }\n\n  .slick-track {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    height: 100%;\n    width: 100%;\n  }\n\n  .slick-list {\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject6$f = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$p() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  margin-bottom: 10px;\n  border-radius: 0;\n  & img {\n    border-radius: 0;\n    height: 100%;\n  }\n  &:after {\n    content: \"\";\n    width: 100%;\n    position: absolute;\n    height: ", "px;\n    top: 0;\n    left: 0;\n    background-size: 9%;\n    background-image: url(", ");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: initial;\n    background-color: rgba(0, 0, 0, 0.6);\n    opacity: 0;\n    transition: opacity 0.5s;\n    backface-visibility: hidden;\n  }\n  &:hover:after {\n    opacity: 1;\n  }\n"]);

  _templateObject5$p = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$A() {
  var data = _taggedTemplateLiteral(["\n.slick-initialized {\n    height: 100%\n  }\n.slick-slider {\n    height: 100%\n  }\n.slick-list {\n    height: 100%\n  }\n"]);

  _templateObject4$A = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$F() {
  var data = _taggedTemplateLiteral(["\n   ", "\n       ", "\n  "]);

  _templateObject3$F = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$N() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  padding: ", ";\n  ", ";\n"]);

  _templateObject2$N = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$V() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  font-style: italic;\n  line-height: 16px;\n  color: #8f8f8f;\n  text-align: left;\n"]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$y = reactIntl.defineMessages({
  TAXES_INCLUDED_FEES_EXCLUDED: {
    id: "checkout.booking_total.VatIncludedTaxesExcluded",
    description: "Taxes included / city tax excluded",
    defaultMessage: "Taxes included / city tax excluded"
  },
  TAXES_AND_FEES_INCLUDED: {
    id: "checkout.booking_total.VatAndTaxesIncluded",
    description: "Taxes and fees included",
    defaultMessage: "Taxes and fees included"
  }
});
var StyledTaxesIncludedFeesExcluded = styled__default.div(_templateObject$V());
var StyledEntityCard = styled__default.div(_templateObject2$N(), props => props.isChain ? "10px" : "0 10px 10px 10px", media.up.lg(_templateObject3$F(), props => props.isChain ? "&:hover{color: white; background-color: black; & .wbkv9-availability {color: white;}}" : undefined, props => props.markerSelected ? "{color: white; background-color: black; & .wbkv9-availability {color: white;}}" : undefined));
var GlobalStyle$3 = styled.createGlobalStyle(_templateObject4$A());
var Image = styled__default(Thumbnail)(_templateObject5$p(), props => props.height, glass);
var SliderWrapper = styled__default.div(_templateObject6$f());
var TopWrapper = styled__default.div(_templateObject7$d());
var NavigateNextWrapper = styled__default.span(_templateObject8$a());
var NavigatePreviousWrapper = styled__default.span(_templateObject9$9());

class EntityCard extends React__default.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "height", 0);

    _defineProperty(this, "handleMouseEnter", () => {
      this.props.onMouseEnter(this.props.propertyTicker);
    });
  }

  render() {
    var {
      handleGallery,
      title,
      currency,
      amount,
      statusCode,
      bookableErrorMessage,
      propertyTicker,
      onSelect,
      ticker,
      isChain,
      handleCalendar,
      onMouseEnter,
      onMouseLeave,
      occupancyNotPossible,
      mediaArray,
      markerSelected,
      buildImgUrl,
      loyalty,
      userLoyaltyTier,
      handleModalContent,
      handleCloseModal,
      loyaltyRate,
      linkToLoyaltyLogin,
      showUnavailableRoomQueryMessage,
      textUnavailableRoom,
      onlineStoreHidePrice,
      taxesText
    } = this.props;
    var isTaxesTextShowable = taxesText && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE;
    var sliderSettings = {
      autoplay: false,
      centerMode: false,
      infinite: true,
      lazyLoad: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 500,
      swipe: false,
      nextArrow: /*#__PURE__*/React__default.createElement(NavigateNextWrapper, null, /*#__PURE__*/React__default.createElement(NavigateNext, null)),
      prevArrow: /*#__PURE__*/React__default.createElement(NavigatePreviousWrapper, null, /*#__PURE__*/React__default.createElement(NavigatePrevious, null))
    };
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GlobalStyle$3, null), /*#__PURE__*/React__default.createElement(StyledEntityCard, {
      isChain: isChain,
      onMouseEnter: onMouseEnter && this.handleMouseEnter,
      onMouseLeave: onMouseLeave,
      markerSelected: markerSelected === propertyTicker
    }, /*#__PURE__*/React__default.createElement(TopWrapper, null, /*#__PURE__*/React__default.createElement(SliderWrapper, {
      ref: el => {
        this.height = el && el.offsetHeight;
      }
    }, /*#__PURE__*/React__default.createElement(Slider, _extends({}, sliderSettings, {
      arrows: mediaArray.length > 1
    }), mediaArray.length > 0 ? mediaArray.map(img => /*#__PURE__*/React__default.createElement("span", {
      key: img.url
    }, /*#__PURE__*/React__default.createElement(Image, {
      src: buildImgUrl(img.url, 500, 750, "https://placehold.it/750x421"),
      onClickProp: handleGallery,
      height: this.height
    }))) : /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Image, {
      src: "https://placehold.it/750x421",
      onClickProp: handleGallery,
      height: this.height
    }))))), isChain ? /*#__PURE__*/React__default.createElement(ChainAriContainer, {
      title: title,
      statusCode: statusCode,
      bookableErrorMessage: bookableErrorMessage,
      propertyTicker: propertyTicker,
      onSelect: onSelect,
      ticker: ticker,
      handleCalendar: handleCalendar,
      currency: currency,
      amount: amount,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      occupancyNotPossible: occupancyNotPossible
    }) : /*#__PURE__*/React__default.createElement(AriContainer, {
      title: title,
      currency: currency,
      amount: amount,
      statusCode: statusCode,
      bookableErrorMessage: bookableErrorMessage,
      propertyTicker: propertyTicker,
      onSelect: onSelect,
      ticker: ticker,
      loyalty: loyalty,
      userLoyaltyTier: userLoyaltyTier,
      loyaltyRate: loyaltyRate,
      handleModalContent: handleModalContent,
      handleCloseModal: handleCloseModal,
      linkToLoyaltyLogin: linkToLoyaltyLogin,
      showUnavailableRoomQueryMessage: showUnavailableRoomQueryMessage,
      textUnavailableRoom: textUnavailableRoom,
      onlineStoreHidePrice: onlineStoreHidePrice
    }), isTaxesTextShowable && /*#__PURE__*/React__default.createElement(StyledTaxesIncludedFeesExcluded, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({}, msgs$y[taxesText], {
      values: {
        taxes: null,
        fees: null
      }
    })))));
  }

}
// EntityCard.propTypes = {
//   thumbnail: PropTypes.string.isRequired,
//   handleGallery: PropTypes.func.isRequired,
//   title: PropTypes.string.isRequired,
//   currency: PropTypes.string.isRequired,
//   amount: PropTypes.number.isRequired,
//   statusCode: PropTypes.string.isRequired,
//   ticker: PropTypes.string.isRequired,
//   bookableErrorMessage: PropTypes.func.isRequired,
//   propertyTicker: PropTypes.string.isRequired,
//   onSelect: PropTypes.func.isRequired,
//   handleCalendar: PropTypes.func.isRequired,
//   isChain: PropTypes.bool.isRequired,
//   onMouseEnter: PropTypes.func.isRequired,
//   onMouseLeave: PropTypes.func.isRequired,
//   occupancyNotPossible: PropTypes.bool.isRequired,
//   mediaArray: PropTypes.array.isRequired
// };

function _templateObject2$O() {
  var data = _taggedTemplateLiteral(["\n   grid-template-columns: 1fr 1fr;\n    ", ";\n  "]);

  _templateObject2$O = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$W() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(285px, 1fr));\n  ", ";\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}
var StyledGrid = styled__default.div(_templateObject$W(), media.up.sml(_templateObject2$O(), props => props.propertyTicker ? "margin-left: -10px;\n           margin-right: -10px;" : ""));

function EntityGrid(_ref) {
  var {
    locale,
    entities,
    handleGallery,
    propertyTicker,
    BookableErrorMessage,
    onSelect: _onSelect,
    handleCalendar: _handleCalendar,
    numberOfNights,
    onMouseEnter,
    onMouseLeave,
    buildImgUrl,
    propertiesWithInvalidOccupations,
    loyalty,
    markerSelected,
    deviceType,
    userLoyaltyTier,
    handleModalContent,
    handleCloseModal,
    linkToLoyaltyLogin,
    showUnavailableRoomQueryMessage,
    textUnavailableRoom,
    occupants,
    onlineStoreHidePrice = false,
    taxesText = null
  } = _ref;
  var handlegalleryCallback = React.useCallback(entity => handleGallery(entity.media, entity.title, entity.description, propertyTicker || entity.ticker, () => _onSelect(_objectSpread2({}, entity, {
    accommodation: entity.ticker,
    displayElementTicker: entity.ticker,
    propertyTicker: entity.ticker
  }))), [propertyTicker, _onSelect]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledGrid, {
    propertyTicker: propertyTicker
  }, entities.map(entity => {
    var WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE = window.WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE || {};
    var WIT_UNAVAILABLE_ROOM_QUERY_HOTEL = [...(window.WIT_UNAVAILABLE_ROOM_QUERY_HOTEL || [])];
    var showUnavailableRoomQueryMessage = entity.statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE && WIT_UNAVAILABLE_ROOM_QUERY_HOTEL.includes(entity.ticker);
    var textUnavailableRoom = "";

    if (WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE[locale]) {
      textUnavailableRoom = WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE[locale].replace("{{checkin}}", window.wbkStartDate).replace("{{checkout}}", window.wbkEndDate).replace("{{adult}}", occupants.ADULT).replace("{{junior}}", occupants.TEENAGER).replace("{{child}}", occupants.CHILD).replace("{{baby}}", occupants.BABY).replace("{{room}}", entity.ticker);
    }

    return /*#__PURE__*/React__default.createElement(EntityCard, {
      key: entity.ticker,
      propertyTicker: propertyTicker || entity.ticker,
      thumbnail: entity.thumbnail || entity.media[0] && entity.media[0].url,
      handleGallery: () => handlegalleryCallback(entity),
      title: entity.name || entity.title,
      currency: entity.currency,
      amount: entity.totalRate && entity.totalRate / numberOfNights || entity.minPrice,
      loyaltyRate: entity.loyaltyRate,
      statusCode: entity.lastStatus && entity.lastStatus.code || entity.statusCode,
      ticker: entity.ticker,
      bookableErrorMessage: /*#__PURE__*/React__default.createElement(BookableErrorMessage, {
        status: entity.lastStatus && entity.lastStatus.code || entity.statusCode,
        valueType: entity.lastStatus && entity.lastStatus.filterType || entity.statusFilterType,
        value: entity.lastStatus && entity.lastStatus.value || entity.statusValue,
        hotelCard: true
      }),
      onSelect: props => _onSelect(_objectSpread2({}, props, {
        type: entity.type
      })),
      isChain: !propertyTicker,
      handleCalendar: () => _handleCalendar({
        propertyTicker: entity.ticker,
        property: entity
      }),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      occupancyNotPossible: propertiesWithInvalidOccupations && propertiesWithInvalidOccupations.includes(entity.ticker),
      mediaArray: entity.media,
      buildImgUrl: buildImgUrl,
      loyalty: loyalty,
      deviceType: deviceType,
      userLoyaltyTier: userLoyaltyTier,
      handleModalContent: handleModalContent,
      handleCloseModal: handleCloseModal,
      markerSelected: markerSelected,
      linkToLoyaltyLogin: linkToLoyaltyLogin,
      showUnavailableRoomQueryMessage: showUnavailableRoomQueryMessage,
      textUnavailableRoom: textUnavailableRoom,
      onlineStoreHidePrice: onlineStoreHidePrice,
      taxesText: taxesText
    });
  })));
}
EntityGrid.propTypes = {
  locale: PropTypes__default.string,
  entities: PropTypes__default.object,
  handleGallery: PropTypes__default.func.isRequired,
  propertyTicker: PropTypes__default.string,
  BookableErrorMessage: PropTypes__default.func.isRequired,
  onSelect: PropTypes__default.func.isRequired,
  handleCalendar: PropTypes__default.func,
  onMouseEnter: PropTypes__default.func,
  onMouseLeave: PropTypes__default.func,
  buildImgUrl: PropTypes__default.func,
  numberOfNights: PropTypes__default.number,
  propertiesWithInvalidOccupations: PropTypes__default.array,
  occupants: PropTypes__default.array,
  onlineStoreHidePrice: PropTypes__default.bool,
  taxesText: PropTypes__default.string
};
EntityGrid.defaultProps = {
  buildImgUrl: url => url
};

function Dropdown(_ref) {
  var {
    filter,
    selected,
    handleChange
  } = _ref;
  var dropdownOptions = filter && filter.options;

  if (!dropdownOptions || !handleChange || Array.isArray(dropdownOptions) && dropdownOptions.length < 1) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("select", {
    value: selected,
    onChange: event => {
      var _a;

      return handleChange({
        event,
        filterTicker: filter === null || filter === void 0 ? void 0 : filter.filterTicker,
        optionTicker: (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value
      });
    }
  }, dropdownOptions.map((dropdownOption, index) => /*#__PURE__*/React__default.createElement("option", {
    value: dropdownOption === null || dropdownOption === void 0 ? void 0 : dropdownOption.optionTicker,
    key: index
  }, dropdownOption === null || dropdownOption === void 0 ? void 0 : dropdownOption.optionName)));
}

function Radio(_ref) {
  var {
    filter,
    selected,
    handleChange
  } = _ref;
  var radioOptions = filter && filter.options;

  if (!radioOptions || !handleChange || Array.isArray(radioOptions) && radioOptions.length < 1) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", null, radioOptions.map((radioOption, index) => /*#__PURE__*/React__default.createElement("label", {
    key: index
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "radio",
    name: filter === null || filter === void 0 ? void 0 : filter.filterTicker,
    value: radioOption === null || radioOption === void 0 ? void 0 : radioOption.pattern,
    checked: selected === (radioOption === null || radioOption === void 0 ? void 0 : radioOption.optionTicker),
    onChange: event => {
      var _a;

      return handleChange({
        event,
        filterTicker: filter === null || filter === void 0 ? void 0 : filter.filterTicker,
        optionTicker: (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value
      });
    }
  }), radioOption === null || radioOption === void 0 ? void 0 : radioOption.optionName)));
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@media only screen and (min-width: 768px) {\n  .Tab_container__ly3Ev .Tab_element__1H9ws {\n    font-size: 12px;\n    margin: 0;\n    padding: 10px 15px 8px; }\n    .Tab_container__ly3Ev .Tab_element__1H9ws:hover:not(.Tab_active__21GJd) {\n      opacity: 0.7; } }\n\n.Tab_container__ly3Ev {\n  margin-top: 10px; }\n  .Tab_container__ly3Ev .Tab_element__1H9ws {\n    display: inline-block;\n    padding: 10px 10px 4px;\n    margin: 0 5px;\n    font-weight: 400;\n    text-transform: uppercase;\n    cursor: pointer;\n    opacity: 0.6;\n    transition: opacity 0.4s, background-color 0.4s, border 0.4s; }\n    .Tab_container__ly3Ev .Tab_element__1H9ws:hover:not(.Tab_active__21GJd) {\n      opacity: 0.85; }\n    .Tab_container__ly3Ev .Tab_element__1H9ws.Tab_active__21GJd {\n      opacity: 1; }\n\n.Tab_wrapper__1EL6v {\n  display: flex;\n  align-items: center; }\n\n.Tab_title__7yS8H {\n  margin-right: 10px;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 18px;\n  text-transform: uppercase; }\n\n.Tab_selectorContainer__aBcWL {\n  display: flex;\n  align-items: center;\n  margin-right: 15px; }\n\n.Tab_selector__3agA- {\n  padding: 3.5px 35px 3.5px 9px;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12.96px;\n  border-radius: 9px;\n  text-transform: uppercase;\n  cursor: pointer; }\n\n.Tab_arrowDown__2E0m0 {\n  width: 0;\n  height: 0;\n  margin-left: -17px;\n  margin-bottom: 25px;\n  cursor: pointer; }\n  .Tab_arrowDown__2E0m0 svg {\n    width: 7px;\n    height: 7px; }\n\n@media only screen and (min-width: 768px) {\n  .Tab_container__ly3Ev .Tab_element__1H9ws {\n    display: flex;\n    align-items: center;\n    min-height: 25px;\n    height: 100%;\n    padding: 2px 20px;\n    font-size: 11px;\n    line-height: 18px;\n    border-radius: 11px; }\n  .Tab_selector__3agA- {\n    padding: 2px 48px 2px 20px;\n    font-size: 11px;\n    height: 25px; }\n  .Tab_arrowDown__2E0m0 {\n    margin-left: -25px; } }\n";
var styles = {"container":"Tab_container__ly3Ev","element":"Tab_element__1H9ws","active":"Tab_active__21GJd","wrapper":"Tab_wrapper__1EL6v","title":"Tab_title__7yS8H","selectorContainer":"Tab_selectorContainer__aBcWL","selector":"Tab_selector__3agA-","arrowDown":"Tab_arrowDown__2E0m0"};
styleInject(css_248z);

function _templateObject2$P() {
  var data = _taggedTemplateLiteral(["\n  & select {\n    color: ", " !important;\n    background-color: ", " !important;\n  }\n"]);

  _templateObject2$P = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$X() {
  var data = _taggedTemplateLiteral(["\n  justify-content: center;\n  min-width: 180px;\n  color: ", " !important;\n  border: 1px solid ", " !important;\n  background-color: ", " !important;\n"]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$z = reactIntl.defineMessages({
  filter: {
    id: "booking_form.tabs_filter.filter",
    description: "Filter",
    defaultMessage: "Filter"
  }
});
var StyledTab = styled__default.div(_templateObject$X(), props => props.active ? props.textColor : "#404040", props => props.active ? props.backgroundColor : "#404040", props => props.active ? props.backgroundColor : "none");
var StyledSelectContainer = styled__default.div(_templateObject2$P(), props => props.textColor, props => props.backgroundColor);
var maxTitleLength = 16;

function Tab(_ref) {
  var {
    filter,
    selected,
    handleChange,
    handleSelectorChange,
    isTabFiltersCollapsed,
    backgroundColor,
    textColor
  } = _ref;
  var propertyTabs = filter && (filter === null || filter === void 0 ? void 0 : filter.options);

  if (!propertyTabs || !handleChange || propertyTabs.length < 1) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: " ".concat(styles.container)
  }, !isTabFiltersCollapsed && /*#__PURE__*/React__default.createElement("div", {
    className: " ".concat(styles.wrapper)
  }, propertyTabs.map((tab, idx) => {
    var active = selected === (tab === null || tab === void 0 ? void 0 : tab.optionTicker);

    if ((tab === null || tab === void 0 ? void 0 : tab.optionName) && (tab === null || tab === void 0 ? void 0 : tab.optionName.length) > maxTitleLength) {
      tab.optionName = tab.optionName.substring(0, maxTitleLength) + "...";
    }

    return /*#__PURE__*/React__default.createElement(StyledTab, {
      backgroundColor: backgroundColor,
      textColor: textColor,
      active: active,
      key: idx,
      className: " ".concat(styles.element, " ").concat(active && "active", " ").concat(active && styles.active, " "),
      onClick: () => handleChange({
        optionTicker: tab === null || tab === void 0 ? void 0 : tab.optionTicker
      })
    }, tab === null || tab === void 0 ? void 0 : tab.optionName);
  })), isTabFiltersCollapsed && /*#__PURE__*/React__default.createElement(StyledSelectContainer, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    className: "".concat(styles.selectorContainer)
  }, /*#__PURE__*/React__default.createElement("select", {
    className: "".concat(styles.selector),
    value: selected,
    onChange: event => handleSelectorChange(event)
  }, propertyTabs.map((tab, idx) => /*#__PURE__*/React__default.createElement("option", {
    key: idx,
    value: tab === null || tab === void 0 ? void 0 : tab.optionTicker
  }, tab === null || tab === void 0 ? void 0 : tab.optionName))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles.arrowDown)
  }, /*#__PURE__*/React__default.createElement(ArrowKeyboardDown, null))));
}

function Filter$1(_ref) {
  var {
    filter,
    selected,
    handleChange,
    handleSelectorChange,
    isTabFiltersCollapsed,
    backgroundColor,
    textColor
  } = _ref;

  if (!filter) {
    return null;
  }

  var FilterElem = null;

  switch (filter.representation) {
    case constants.PROPERTY_FILTER.REPRESENTATION.DROPDOWN:
      FilterElem = Dropdown;
      break;

    case constants.PROPERTY_FILTER.REPRESENTATION.RADIO:
      FilterElem = Radio;
      break;

    case constants.PROPERTY_FILTER.REPRESENTATION.TAB:
      FilterElem = Tab;
      break;
  }

  if (!FilterElem) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(FilterElem, {
    filter: filter,
    selected: selected,
    handleChange: handleChange,
    handleSelectorChange: handleSelectorChange,
    isTabFiltersCollapsed: isTabFiltersCollapsed,
    backgroundColor: backgroundColor,
    textColor: textColor
  });
}

function _templateObject$Y() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 15px;\n  display: flex;\n"]);

  _templateObject$Y = function _templateObject() {
    return data;
  };

  return data;
}
var Container$8 = styled__default.div(_templateObject$Y());

function TabFilters(_ref) {
  var {
    tabFilters,
    propertyActiveTab,
    onChange,
    onSelectorChange,
    isTabFiltersCollapsed,
    backgroundColor,
    textColor
  } = _ref;

  if (!tabFilters) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Container$8, {
    className: "wbkv9-RoomSelection-TabFilter"
  }, tabFilters.map((tabFilter, idx) => /*#__PURE__*/React__default.createElement(Filter$1, {
    key: idx,
    filter: tabFilter,
    selected: propertyActiveTab,
    handleChange: onChange,
    isTabFiltersCollapsed: isTabFiltersCollapsed,
    handleSelectorChange: onSelectorChange,
    backgroundColor: backgroundColor,
    textColor: textColor
  })));
}

function _templateObject4$B() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-weight: 700;\n  text-decoration: underline;\n  color: #908f96;\n  cursor: pointer;\n  @media (max-width: 639px) {\nfont-size: 12px;\n"]);

  _templateObject4$B = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$G() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 20px;\n  max-height: 80px;\n  word-wrap: break-word;\n  overflow: hidden;\n  color: #908f96;\n        @media (max-width: 639px) {\nfont-size: 12px;\n"]);

  _templateObject3$G = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$Q() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  color: #222222;\n  font-weight: 700;\n  @media (max-width: 639px) {\n    display: none;\n  }\n"]);

  _templateObject2$Q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Z() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #908f96;\n  @media (max-width: 639px) {\n  }\n"]);

  _templateObject$Z = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$A = reactIntl.defineMessages({
  readMore: {
    id: "checkout.customer_form.readMore",
    description: "readMore",
    defaultMessage: "Read more"
  }
});
var DescriptionWrapper = styled__default.div(_templateObject$Z());
var DescriptionHeader = styled__default.div(_templateObject2$Q());
var DescriptionText = styled__default.div(_templateObject3$G());
var ReadMore$2 = styled__default.div(_templateObject4$B());
var maxHeight = 80;

class DescriptionEllipsis extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      readMore: false
    };
  }

  componentDidMount() {
    /* eslint-disable-next-line */
    this.setState({
      readMore: this.description.scrollHeight > maxHeight
    });
  }

  render() {
    return /*#__PURE__*/React__default.createElement(DescriptionWrapper, {
      className: "wbkv9-DescriptionEllipsis"
    }, /*#__PURE__*/React__default.createElement(DescriptionHeader, null, /*#__PURE__*/React__default.createElement("div", null, this.props.title)), /*#__PURE__*/React__default.createElement(DescriptionText, {
      ref: element => {
        this.description = element;
      },
      dangerouslySetInnerHTML: {
        __html: this.props.description
      }
    }), this.state.readMore && /*#__PURE__*/React__default.createElement(ReadMore$2, {
      onClick: this.props.handleModal
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$A.readMore)));
  }

}

DescriptionEllipsis.propTypes = {
  description: PropTypes__default.string.isRequired,
  handleModal: PropTypes__default.func.isRequired,
  title: PropTypes__default.string.isRequired
};

var generatedSizes = [50, 75, 100, 150, 190, 285, 380, 480, 570, 640, 768, 960, 1152, 1280, 1536, 2048, 2304, 2560, 3072, 3840];
var formats = {
  JP2: {
    extension: "jp2",
    contentType: "image/jp2"
  },
  WEBP: {
    extension: "webp",
    contentType: "image/webp"
  },
  JPEG: {
    extension: "jpeg",
    contentType: "image/jpeg"
  }
};

var SmartImage = (_ref) => {
  var {
    imageUrl,
    sizes,
    contentBucketBaseUrl,
    className,
    alt
  } = _ref,
      props = _objectWithoutProperties(_ref, ["imageUrl", "sizes", "contentBucketBaseUrl", "className", "alt"]);

  var baseImage;

  if (!imageUrl.startsWith(contentBucketBaseUrl)) {
    if (imageUrl.startsWith("http")) {
      return /*#__PURE__*/React__default.createElement("img", _extends({
        src: imageUrl,
        className: className,
        alt: alt
      }, props));
    }

    baseImage = contentBucketBaseUrl + imageUrl;
  } else {
    baseImage = imageUrl;
  }

  var generatedPrefix = "generated";
  var url = new Url(baseImage);
  var originalFilename = url.pathname.substring(url.pathname.lastIndexOf("/") + 1);
  var originalId = originalFilename.substring(0, originalFilename.lastIndexOf("."));
  var originalPath = url.pathname.substring(0, url.pathname.lastIndexOf("/"));
  return /*#__PURE__*/React__default.createElement("picture", {
    className: className
  }, " ", Object.keys(formats).map(format => /*#__PURE__*/React__default.createElement("source", {
    sizes: sizes.reduce((acc, next) => "".concat(acc, ", ").concat(next)),
    type: formats[format].contentType,
    key: format,
    srcSet: generatedSizes.map(size => "".concat(url.protocol, "//").concat(url.host, "/").concat(generatedPrefix).concat(originalPath, "/").concat(originalId, "-").concat(size, ".").concat(formats[format].extension, " ").concat(size, "w")).reduce((acc, current) => "".concat(acc, ", ").concat(current))
  })), /*#__PURE__*/React__default.createElement("img", _extends({
    src: baseImage,
    alt: alt
  }, props)));
};

SmartImage.propTypes = {
  imageUrl: PropTypes__default.string.isRequired,
  sizes: PropTypes__default.arrayOf(PropTypes__default.string).isRequired,
  contentBucketBaseUrl: PropTypes__default.string.isRequired,
  className: PropTypes__default.string,
  alt: PropTypes__default.string
};
SmartImage.defaultProps = {
  className: "",
  alt: ""
};
class SmartImageContainer extends React__default.PureComponent {
  render() {
    return /*#__PURE__*/React__default.createElement(SmartImage, _extends({
      contentBucketBaseUrl: this.context.contentBucketBaseUrl
    }, this.props));
  }

}
SmartImageContainer.contextTypes = {
  contentBucketBaseUrl: PropTypes__default.string.isRequired
};

function _templateObject$_() {
  var data = _taggedTemplateLiteral(["\n  width: 190px;\n  height: 130px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  &:after {\n    content: \"\";\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-size: 9%;\n    background-image: url(", ");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-attachment: initial;\n    background-color: rgba(0, 0, 0, 0.6);\n    opacity: 0;\n    transition: opacity 0.5s;\n    backface-visibility: hidden;\n  }\n  &:hover:after {\n    opacity: 1;\n  }\n  & img {\n    height: inherit;\n    width: inherit;\n    object-fit: cover;\n    font-family: \"object-fit: cover;\";\n  }\n  & picture {\n    width: inherit;\n    height: inherit;\n  }\n\n  @media (max-width: 639px) {\n    width: 50px;\n    height: 50px;\n    margin-right: 10px;\n    & img {\n      border-radius: 100px;\n    }\n  }\n"]);

  _templateObject$_ = function _templateObject() {
    return data;
  };

  return data;
}
var ThumbnailWrapper$1 = styled__default.div(_templateObject$_(), glass);

function buildImgUrl(path, height, width, placeholder) {
  if (!path) {
    return placeholder;
  }

  var lastDotIndex = path.lastIndexOf(".");
  var filenameWithoutExtension = path.substr(0, lastDotIndex);
  var filenameExtension = path.substr(lastDotIndex);
  var urlThumbnail = "";

  if (height && width) {
    urlThumbnail = "".concat(filenameWithoutExtension, "_").concat(width, "x").concat(height).concat(filenameExtension);
  } else {
    urlThumbnail = path;
  }

  return urlThumbnail;
}

class SmartThumbnail extends React.PureComponent {
  componentDidMount() {
    objectFitImages();
  }

  render() {
    var imgComponent = this.props.src ? this.props.src.startsWith(this.props.contentBucketBaseUrl) || this.props.src.startsWith(this.props.oldContentBucketBaseUrl) ? /*#__PURE__*/React__default.createElement(SmartImageContainer, {
      imageUrl: this.props.src,
      sizes: this.props.sizes,
      alt: "thumbnail",
      contentBucketBaseUrl: this.props.contentBucketBaseUrl
    }) : /*#__PURE__*/React__default.createElement("img", {
      src: buildImgUrl(this.props.src, this.props.legacyParams.height, this.props.legacyParams.width, this.props.legacyParams.placeholder),
      alt: this.props.title
    }) : this.props.extraThumbnailPlaceholder;
    return /*#__PURE__*/React__default.createElement(ThumbnailWrapper$1, {
      onClick: this.props.onClickProp,
      className: "".concat(this.props.className, " wbkv9-Thumbnail")
    }, imgComponent);
  }

}

SmartThumbnail.defaultProps = {
  className: "",
  title: "thumbnail"
};
SmartThumbnail.propTypes = {
  onClickProp: PropTypes__default.func.isRequired,
  extraThumbnailPlaceholder: PropTypes__default.node.isRequired,
  src: PropTypes__default.string,
  title: PropTypes__default.string,
  className: PropTypes__default.string,
  contentBucketBaseUrl: PropTypes__default.string.isRequired,
  oldContentBucketBaseUrl: PropTypes__default.string.isRequired,
  sizes: PropTypes__default.arrayOf(PropTypes__default.string).isRequired,
  legacyParams: PropTypes__default.shape({
    width: PropTypes__default.number.isRequired,
    height: PropTypes__default.number.isRequired,
    placeholder: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element])
  }).isRequired
}; // eslint-disable-next-line react/no-multi-comp

class SmartThumbnailWrapper extends React.PureComponent {
  render() {
    return /*#__PURE__*/React__default.createElement(SmartThumbnail, _extends({
      extraThumbnailPlaceholder: this.context.extraThumbnailPlaceholder,
      contentBucketBaseUrl: this.context.contentBucketBaseUrl,
      oldContentBucketBaseUrl: this.context.oldContentBucketBaseUrl
    }, this.props));
  }

}
SmartThumbnailWrapper.contextTypes = {
  contentBucketBaseUrl: PropTypes__default.string.isRequired,
  oldContentBucketBaseUrl: PropTypes__default.string.isRequired,
  extraThumbnailPlaceholder: PropTypes__default.node.isRequired
};

function _templateObject24$2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 12px;\n  color: ", ";\n"]);

  _templateObject24$2 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23$2() {
  var data = _taggedTemplateLiteral(["\n    max-width: ", ";\n  "]);

  _templateObject23$2 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: ", ";\n  font-size: 12px;\n\n  ", ";\n"]);

  _templateObject22$2 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21$2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: auto auto auto;\n    grid-row-gap: ", ";\n  "]);

  _templateObject21$2 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20$2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: auto auto;\n  "]);

  _templateObject20$2 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19$2() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: auto;\n  grid-row-gap: ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject19$2 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  justify-content: center;\n  display: ", ";\n  margin: ", ";\n  padding: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject18$3 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 auto;\n  justify-content: space-between;\n"]);

  _templateObject17$4 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  @media (max-width: 639px) {\n    margin-bottom: 10px;\n  }\n"]);

  _templateObject16$5 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$6() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  font-size: 15px;\n  font-weight: 700;\n  @media (max-width: 639px) {\n    display: block;\n  }\n"]);

  _templateObject15$6 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$6() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 0 15px;\n    height: 15px;\n    width: 15px;\n  "]);

  _templateObject14$6 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$7() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 4px;\n  flex: 0 0 20px;\n  height: 20px;\n  width: 20px;\n\n  ", ";\n"]);

  _templateObject13$7 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$7() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 15px;\n  flex: 0 0 22px;\n  height: 22px;\n  width: 22px;\n"]);

  _templateObject12$7 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$8() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0;\n"]);

  _templateObject11$8 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$8() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 15px;\n  padding-right: 25px;\n  cursor: pointer;\n  height: 30px;\n  border-radius: 3px;\n  border: 1px solid #e1e1e1;\n  background: #f6f6f6 !important;\n  color: ", ";\n  font-size: 13px;\n  font-weight: 400;\n  background-image: url(", ") !important;\n  background-position: right !important;\n  background-repeat: no-repeat !important;\n"]);

  _templateObject10$8 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$a() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 100px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  @media (max-width: 639px) {\n    flex: 0 0 85px;\n  }\n"]);

  _templateObject9$a = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$b() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  color: #222222;\n"]);

  _templateObject8$b = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$e() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: #908f96;\n  text-align: center;\n  @media (max-width: 639px) {\n    font-size: 12px;\n  }\n"]);

  _templateObject7$e = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$g() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 700;\n  @media (max-width: 639px) {\n    font-size: 15px;\n  }\n"]);

  _templateObject6$g = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$q() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  @media (max-width: 639px) {\n    font-size: 12px;\n  }\n"]);

  _templateObject5$q = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$C() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"]);

  _templateObject4$C = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$H() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject3$H = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$R() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 0 0 0 20px;\n  flex: 1;\n  min-width: 0;\n\n  @media (max-width: 639px) {\n    display: block;\n    padding: 0 40px 0 0;\n  }\n"]);

  _templateObject2$R = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$$() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 20px 0 20px 0;\n  border-bottom: solid 1px #e1e1e1;\n  @media (max-width: 639px) {\n    display: block;\n  }\n"]);

  _templateObject$$ = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$B = reactIntl.defineMessages({
  unavailable: {
    id: "room_selecton.service.agotada",
    description: "agotada",
    defaultMessage: "Sold Out"
  },
  restricted: {
    id: "room_selecton.service.restricted",
    description: "restricted",
    defaultMessage: "Restricted"
  },
  seeAvailability: {
    id: "room_selecton.service.seeAvailability",
    description: "seeAvailability",
    defaultMessage: "See Availabilty"
  },
  since: {
    id: "room_selecton.service.since",
    description: "since",
    defaultMessage: "From"
  },
  free: {
    id: "room_selecton.service.free",
    description: "free",
    defaultMessage: "Free"
  },
  included: {
    id: "service_selection.service.included",
    description: "included",
    defaultMessage: "Included"
  },
  day: {
    id: "service_selection.service.day",
    description: "day",
    defaultMessage: "day"
  },
  date: {
    id: "service_selection.service.date",
    description: "date",
    defaultMessage: "date"
  },
  moreDates: {
    id: "service_selection.service.moreDates",
    description: "Ver más fechas",
    defaultMessage: "Ver más fechas"
  },
  unitsPerStay: {
    id: "service_selection.service.unitsPerStay",
    description: "Units to enjoy per day of stay",
    defaultMessage: "Units to enjoy per day of stay"
  },
  daysOfStay: {
    id: "service_selection.service.daysOfStay",
    description: "Select days of stay",
    defaultMessage: "Select days of stay"
  },
  UNIT: {
    id: "service_selection.service.unit",
    description: "unit",
    defaultMessage: "per unit"
  },
  PERSON: {
    id: "service_selection.service.person",
    description: "person",
    defaultMessage: "per person"
  },
  ROOM: {
    id: "service_selection.service.room",
    description: "room",
    defaultMessage: "per room"
  },
  NIGHT: {
    id: "room_selection.service.night",
    description: "room",
    defaultMessage: "per night"
  },
  PERCENTAGE: {
    id: "room_selection.service.percentage",
    description: "percentage",
    defaultMessage: "percentage"
  }
});
var ExtraItemWrapper = styled__default.div(_templateObject$$());
var ExtraItemTextWrapper = styled__default.div(_templateObject2$R());
var Controls = styled__default.div(_templateObject3$H());
var AmountWrapper = styled__default.div(_templateObject4$C());
var Currency = styled__default.span(_templateObject5$q());
var Amount$3 = styled__default.span(_templateObject6$g());
var Type = styled__default.div(_templateObject7$e());
var SpecialType = styled__default.div(_templateObject8$b());
var ControlPanelWrapper = styled__default.div(_templateObject9$a());
var Select$2 = styled__default.select(_templateObject10$8(), greyLight, dropDown);
var StyleDateSelect = styled__default(Select$2)(_templateObject11$8());
var Checkbox = styled__default.input(_templateObject12$7());
var StyledDateCheckbox = styled__default.input(_templateObject13$7(), media.up.mdl(_templateObject14$6()));
var MobileHeader = styled__default.div(_templateObject15$6());
var ThumbnailHeaderWrapper = styled__default.div(_templateObject16$5());
var TextControlsWrapper = styled__default.div(_templateObject17$4());
var StyledDaysListTitle = styled__default.div(_templateObject18$3(), props => props.error ? "inline-block" : "block", props => props.error ? "10px 0 10px -10px" : "10px 0", props => props.error ? "0 10px" : "0", props => props.error ? wbRed : "inherit", props => props.error ? "#f5dada" : "transparent", props => props.error ? "5px" : 0);
var StyledDaysListContainer = styled__default.div(_templateObject19$2(), props => props.isSelect ? "5px" : "10px", media.up.sml(_templateObject20$2()), media.up.mdm(_templateObject21$2(), props => props.isSelect ? "5px" : "0"));
var StyledDayContainer = styled__default.div(_templateObject22$2(), props => props.isSelect ? "135px" : "110px", media.up.mdl(_templateObject23$2(), props => props.isSelect ? "135px" : "100px"));
var StyledMoreDates = styled__default.div(_templateObject24$2(), greyLight);

class ExtraItem extends React__default.PureComponent {
  constructor() {
    super();

    _defineProperty(this, "touchAllOnSubmit", () => {
      if (this.child && this.child.touchAllOnSubmit) {
        this.child.touchAllOnSubmit();
      }
    });

    _defineProperty(this, "handleClickMoreDates", () => {
      this.setState({
        maxShowingDates: this.props.totalRatePerDay.size
      });
    });

    this.child = null;
    this.state = {
      maxShowingDates: 6
    };
  }

  render() {
    var {
      addObligatoryExtrasRateToRoomSelection,
      currency,
      deleteInParentState,
      description,
      elem,
      formShape,
      formValues,
      handleGallery,
      handleOnChange,
      hasCheckBox,
      inputVal,
      dateInputVal,
      hasErrors,
      isFormValid,
      minPrice,
      onExpand: onExpandAlias,
      selectOptions,
      showForm,
      showInfo,
      thumbnail,
      title,
      unit,
      updateFormValues,
      updateDateValues,
      startDate,
      endDate,
      touch,
      totalRatePerDay,
      dateSelectionType,
      errors
    } = this.props;
    var onExpand = onExpandAlias;

    if (showInfo) {
      onExpand = undefined;
    }

    var {
      obligatory
    } = elem;
    var isPercentageType = elem.type === constants.SERVICE_TYPE.PERCENTAGE;
    var isFree = minPrice === 0;
    var isIncluded = !isFree && addObligatoryExtrasRateToRoomSelection && obligatory && !isPercentageType;
    var hasPrice = !isFree && !isIncluded && !isPercentageType;
    var hasPercentage = !isFree && !isIncluded && isPercentageType;
    var sortedTotalRatePerDay = [];
    totalRatePerDay.map((rate, date) => sortedTotalRatePerDay.push(date));
    sortedTotalRatePerDay.sort((a, b) => a < b ? -1 : 1);
    return /*#__PURE__*/React__default.createElement(ExtraItemWrapper, {
      onClick: onExpand,
      className: "wbkv9-ExtraItem"
    }, /*#__PURE__*/React__default.createElement(ThumbnailHeaderWrapper, null, /*#__PURE__*/React__default.createElement(SmartThumbnailWrapper, {
      sizes: ["194px"],
      legacyParams: {
        width: 194,
        height: 129,
        placeholder: this.context.extraThumbnailPlaceholder
      },
      onClickProp: () => {
        handleGallery(elem);
      },
      title: title,
      src: thumbnail
    }), /*#__PURE__*/React__default.createElement(MobileHeader, null, /*#__PURE__*/React__default.createElement("div", null, title))), /*#__PURE__*/React__default.createElement(TextControlsWrapper, null, /*#__PURE__*/React__default.createElement(ExtraItemTextWrapper, null, description && /*#__PURE__*/React__default.createElement(DescriptionEllipsis, {
      title: title,
      description: description,
      handleModal: () => {
        handleGallery(elem);
      }
    }), dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC && inputVal > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledDaysListTitle, {
      error: hasErrors || errors && errors.includes(elem.ticker)
    }, !!selectOptions && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.unitsPerStay), !!hasCheckBox && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.daysOfStay)), /*#__PURE__*/React__default.createElement(StyledDaysListContainer, {
      isSelect: !!selectOptions
    }, sortedTotalRatePerDay.slice(0, this.state.maxShowingDates).map((date, idx) => /*#__PURE__*/React__default.createElement(StyledDayContainer, {
      key: idx,
      isSelect: !!selectOptions
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
      month: "short",
      day: "2-digit",
      weekday: "short",
      value: date
    }), !!hasCheckBox && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledDateCheckbox, {
      type: "checkbox",
      disabled: obligatory,
      value: dateInputVal[date] > 0,
      checked: dateInputVal[date] > 0,
      onChange: event => updateDateValues({
        event,
        value: event.target.checked ? 1 : 0,
        ticker: elem.ticker,
        date
      })
    })), !!selectOptions && selectOptions.length > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyleDateSelect, {
      value: dateInputVal[date],
      defaultValue: dateInputVal[date] || 1,
      onChange: event => updateDateValues({
        event,
        value: event.target.value,
        ticker: elem.ticker,
        date
      })
    }, /*#__PURE__*/React__default.createElement("option", {
      value: "0"
    }, "0"), selectOptions.map(selectOption => /*#__PURE__*/React__default.createElement("option", {
      value: selectOption.key,
      key: selectOption.key
    }, selectOption.value))))))), totalRatePerDay.size > this.state.maxShowingDates && /*#__PURE__*/React__default.createElement(StyledMoreDates, {
      onClick: this.handleClickMoreDates
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.moreDates))), formShape && showForm && /*#__PURE__*/React__default.createElement(FormGenerator, {
      ref: instance => {
        this.child = instance;
      },
      isFormValid: isFormValid,
      deleteInParentState: deleteInParentState,
      updateFormValues: updateFormValues,
      existentFormValues: formValues,
      formShape: formShape,
      extraItemTicker: elem.ticker,
      startDate: startDate,
      endDate: endDate,
      touch: touch
    })), /*#__PURE__*/React__default.createElement(ControlPanelWrapper, null, /*#__PURE__*/React__default.createElement(Controls, null, isFree && /*#__PURE__*/React__default.createElement(Type, null, /*#__PURE__*/React__default.createElement(SpecialType, null, /*#__PURE__*/React__default.createElement("b", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.free)))), isIncluded && /*#__PURE__*/React__default.createElement(Type, null, /*#__PURE__*/React__default.createElement(SpecialType, null, /*#__PURE__*/React__default.createElement("b", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.included)))), hasPrice && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(AmountWrapper, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Currency, null, currency), " ", /*#__PURE__*/React__default.createElement(Amount$3, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
      value: minPrice,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })))), /*#__PURE__*/React__default.createElement(Type, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B[unit]), dateSelectionType === constants.DATE_SELECTION_TYPE.ALL && /*#__PURE__*/React__default.createElement("span", null, "/", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.day)), dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC && /*#__PURE__*/React__default.createElement("span", null, "/", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$B.date))))), hasPercentage && /*#__PURE__*/React__default.createElement(AmountWrapper, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Amount$3, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
      value: minPrice,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }), "%"))), /*#__PURE__*/React__default.createElement("div", null, (!!hasCheckBox || dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Checkbox, {
      type: "checkbox",
      disabled: obligatory,
      value: inputVal > 0,
      checked: inputVal > 0,
      onChange: event => handleOnChange(event, event.target.checked, elem.ticker)
    })), dateSelectionType !== constants.DATE_SELECTION_TYPE.SPECIFIC && !!selectOptions && selectOptions.length > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Select$2, {
      value: inputVal,
      onChange: event => handleOnChange(event, event.target.value, elem.ticker)
    }, /*#__PURE__*/React__default.createElement("option", {
      value: ""
    }), selectOptions.map(selectOption => /*#__PURE__*/React__default.createElement("option", {
      value: selectOption.key,
      key: selectOption.key
    }, selectOption.value)))))))));
  }

} // ExtraItem.propTypes = {
//   addObligatoryExtrasRateToRoomSelection: PropTypes.bool.isRequired,
//   currency: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired,
//   elem: PropTypes.object.isRequired,
//   handleGallery: PropTypes.func.isRequired,
//   handleModalContent: PropTypes.func.isRequired,
//   handleOnChange: PropTypes.func.isRequired,
//   hasCheckBox: PropTypes.bool.isRequired,
//   hasImage: PropTypes.bool.isRequired,
//   inputVal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   dateInputVal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   hasErrors: PropTypes.bool.isRequired,
//   selectOptions: PropTypes.array.isRequired,
//   serviceHasImage: PropTypes.bool.isRequired,
//   showInfo: PropTypes.bool.isRequired,
//   thumbnail: PropTypes.string.isRequired,
//   title: PropTypes.string.isRequired,
//   type: PropTypes.string.isRequired,
//   unit: PropTypes.string.isRequired,
//   onExpand: PropTypes.func.isRequired,
//   minPrice: PropTypes.number.isRequired,
//   isFormValid: PropTypes.func.isRequired,
//   updateFormValues: PropTypes.func.isRequired,
//   updateDateValues: PropTypes.func.isRequired,
//   formValues: PropTypes.object.isRequired,
//   formShape: PropTypes.object.isRequired,
//   showForm: PropTypes.bool.isRequired,
//   deleteInParentState: PropTypes.func.isRequired,
//   startDate: PropTypes.instanceOf(Date).isRequired,
//   endDate: PropTypes.instanceOf(Date).isRequired,
//   touch: PropTypes.bool.isRequired,
//   totalRatePerDay: PropTypes.object,
//   dateSelectionType: PropTypes.string.isRequired,
//   errors: PropTypes.array.isRequired
// };


ExtraItem.defaultProps = {
  inputVal: undefined,
  dateInputVal: undefined,
  totalRatePerDay: undefined
};
ExtraItem.contextTypes = {
  extraThumbnailPlaceholder: PropTypes__default.node.isRequired
};

function _templateObject4$D() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 50vw;\n  padding: 10px 40px 10px 40px;\n  background-color: #329911;\n  color: #ffffff;\n  font-weight: 700;\n  text-transform: uppercase;\n"]);

  _templateObject4$D = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$I() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 50vw;\n  padding: 10px 40px 10px 40px;\n  color: #908f96;\n\n  text-transform: uppercase;\n  border-top: 1px solid #908f96;\n  background-color: #ffffff;\n  ", ";\n"]);

  _templateObject3$I = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$S() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  font-size: 13px;\n  @media (max-width: 639px) {\n    font-size: 10px;\n  }\n"]);

  _templateObject2$S = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$10() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 20px 0 20px;\n  overflow: auto;\n  max-height: 78vh;\n  @media (max-width: 940px) {\n    max-height: 91vh;\n    & > div:last-child {\n      padding-bottom: 106px;\n    }\n  }\n"]);

  _templateObject$10 = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$C = reactIntl.defineMessages({
  close: {
    id: "reservation_summary.extras.cancel.button",
    description: "close",
    defaultMessage: "I don't want extras"
  },
  confirm: {
    id: "reservation_summary.extras.confirm.button",
    description: "confirm",
    defaultMessage: "Confirm"
  }
});
var ExtraListWrapper = styled__default.div(_templateObject$10());
var ButtonContainer = styled__default.div(_templateObject2$S());
var CloseButton = styled__default.button(_templateObject3$I(), props => props.allowClose ? undefined : "cursor: not-allowed");
var ConfirmButton$1 = styled__default.button(_templateObject4$D());

class ExtraList extends React.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onChangeSubmit", () => {
      if (this.state.touchAllChildren === false) {
        this.setState({
          touchAllChildren: true
        });
      }

      if (this.areFormsValid()) {
        var quantity = {};
        var showedQuantity = {};
        var errors = [];
        this.props.extras.map(extra => {
          quantity[extra.ticker] = undefined;
          showedQuantity[extra.ticker] = 0;

          if (this.state.selectedService[extra.ticker]) {
            quantity[extra.ticker] = {};
            extra.totalRatePerDay.map((rate, date) => {
              if (extra.dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC) {
                quantity[extra.ticker][date] = this.state.dateValues && this.state.dateValues[extra.ticker] && (this.state.dateValues[extra.ticker][date] || this.state.dateValues[extra.ticker][date] === 0) ? parseInt(this.state.dateValues[extra.ticker][date], 10) : extra.selectOptions ? 1 : 0;
              } else {
                quantity[extra.ticker][date] = parseInt(this.state.selectedService[extra.ticker], 10);
              }

              showedQuantity[extra.ticker] += quantity[extra.ticker][date];
              return null;
            });

            if (extra.type === constants.SERVICE_TYPE.UNIT && extra.dateSelectionType !== constants.DATE_SELECTION_TYPE.SPECIFIC) {
              showedQuantity[extra.ticker] = parseInt(this.state.selectedService[extra.ticker], 10);
            }

            if (extra.type === constants.SERVICE_TYPE.ROOM && extra.dateSelectionType === constants.DATE_SELECTION_TYPE.NONE) {
              showedQuantity[extra.ticker] = 1;
            }

            if (extra.type === constants.SERVICE_TYPE.PERSON) {
              showedQuantity[extra.ticker] = extra.appliesToGuests.reduce((accumulator, guest) => accumulator + this.props.guestsList[guest], 0);

              if (extra.dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC) {
                showedQuantity[extra.ticker] *= Object.values(quantity[extra.ticker]).reduce((accumulator, value) => accumulator + value, 0);
              }
            }

            if (extra.type !== constants.SERVICE_TYPE.ROOM && extra.dateSelectionType === constants.DATE_SELECTION_TYPE.ALL) {
              showedQuantity[extra.ticker] *= extra.totalRatePerDay.size;
            }

            var isQuantityDatesValid = Object.values(quantity[extra.ticker]).some(value => value > 0);

            if (!isQuantityDatesValid) {
              errors.push(extra.ticker);
            }
          }

          return null;
        });
        quantity = Object.fromEntries(Object.entries(quantity).map((_ref) => {
          var [ticker, dateValues] = _ref;
          return dateValues === undefined || Object.values(dateValues).every(value => value === 0) ? [ticker, undefined] : [ticker, dateValues];
        }));

        if (errors.length > 0) {
          this.setState({
            errors
          });
        } else {
          this.props.onSubmit({
            quantity,
            showedQuantity,
            forms: this.state.formsValues
          });
          this.props.closeWindow();
        }
      }
    });

    _defineProperty(this, "setQuantity", (event, value, ticker) => {
      if (!event) {
        return;
      }

      var amount = value === true ? 1 : value === false ? 0 : value;
      var quant = Object.assign({}, this.state.selectedService);
      quant[ticker] = amount;
      var allowClose = this.allowClose(quant); // If no extras are selected, delete ticker form validity and values from the state

      if (!amount) {
        var formsValid = Object.assign(this.state.formsValid, {});
        delete formsValid[ticker];
        var formsValues = Object.assign(this.state.formsValues, {});
        delete formsValues[ticker];
        this.setState({
          selectedService: quant,
          formsValid,
          formsValues,
          allowClose
        }, this.props.allowCloseExtrasModal && this.props.allowCloseExtrasModal(allowClose));
        return;
      }

      this.setState({
        selectedService: quant,
        allowClose
      }, this.props.allowCloseExtrasModal && this.props.allowCloseExtrasModal(allowClose));
    });

    _defineProperty(this, "isFormValid", (formTicker, isValid) => {
      var formsValid = Object.assign(this.state.formsValid, {});
      formsValid[formTicker] = isValid;
      this.setState({
        formsValid
      });
    });

    _defineProperty(this, "updateFormValues", (_ref2) => {
      var {
        field,
        value,
        label,
        fieldObject,
        ticker
      } = _ref2;
      var formsValues = Object.assign(this.state.formsValues, {});
      formsValues[ticker] = formsValues[ticker] || {};
      formsValues[ticker][field] = {
        value,
        label,
        fieldObject
      };
      this.setState({
        formsValues
      });
    });

    _defineProperty(this, "updateDateValues", (_ref3) => {
      var {
        event,
        value,
        ticker,
        date
      } = _ref3;

      if (!event) {
        return;
      }

      var dateValues = _objectSpread2({}, this.state.dateValues);

      dateValues[ticker] = _objectSpread2({}, dateValues[ticker]) || {};
      dateValues[ticker][date] = parseInt(value, 10);
      var {
        errors
      } = this.state;
      var errorIndex = errors.indexOf(ticker);

      if (errorIndex >= 0) {
        delete errors[errorIndex];
      }

      this.setState({
        dateValues,
        errors
      });
    });

    _defineProperty(this, "areFormsValid", () => !Object.values(this.state.formsValid).includes(false));

    _defineProperty(this, "allowClose", quant => this.props.questionnaires ? !this.props.questionnaires.some( // Does any of the questionnaires contains a restriction?
    questionnaire => questionnaire.fields.some(field => Object.keys(field.constraints).length !== 0) && // Is any of questionnaires is rendered? If it's rendered it will be in this.state.selectedService
    // and will have a value (not be undefined)
    questionnaire.dependers.some(depender => depender.type === "EXTRA" && // iterates updated selectedService before setting updated state in another function
    // or default qunatity when called from the constructor
    Object.keys(quant || this.state.selectedService).filter(key => quant ? !!quant[key] : !!this.state.selectedService[key]).some(key => depender.tickers.includes(key)))) : true);

    this.state = {
      selectedService: {},
      formsValid: {},
      formsValues: {},
      dateValues: {},
      touchAllChildren: false,
      allowClose: true,
      errors: []
    };
    props.extras.forEach(service => {
      var dateQuantity = props.selectedServices && props.selectedServices[service.ticker] && props.selectedServices[service.ticker].dateQuantity;

      if (!dateQuantity && service.dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC || service.obligatory) {
        this.state.dateValues[service.ticker] = {};
        service.totalRatePerDay.map((rate, date) => {
          this.state.dateValues[service.ticker][date] = 1;
          this.state.selectedService[service.ticker] = service.obligatory ? 1 : 0;
          return null;
        });
      } else {
        this.state.dateValues[service.ticker] = dateQuantity;
        this.state.selectedService[service.ticker] = dateQuantity && Object.values(dateQuantity).find(value => value) || undefined;
      }

      if (props.selectedServices && props.selectedServices[service.ticker] && props.selectedServices[service.ticker].formValues) {
        this.state.formsValues[service.ticker] = Object.keys(props.selectedServices[service.ticker].formValues).reduce((accum, it) => _objectSpread2({}, accum, {
          [it]: props.selectedServices[service.ticker].formValues[it]
        }), {});
      }
    }); // Needs to be called separately since it uses state.

    this.state.allowClose = this.allowClose();

    if (this.props.allowCloseExtrasModal) {
      this.props.allowCloseExtrasModal(this.state.allowClose);
    }
  }

  render() {
    var {
      extras,
      type,
      addObligatoryExtrasRateToRoomSelection,
      closeWindow,
      handleGallery,
      startDate,
      endDate,
      onCancel,
      className,
      hideObligatoryExtras
    } = this.props;

    var handleCloseButton = () => {
      if (this.state.touchAllChildren === false) {
        this.setState({
          touchAllChildren: true
        });
      }

      if (this.state.allowClose) {
        if (onCancel) {
          onCancel();
        } else {
          closeWindow();
        }
      }
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "wbkv9-ExtraList ".concat(className)
    }, /*#__PURE__*/React__default.createElement(ExtraListWrapper, null, extras.map(elem => {
      var formValues = this.props.selectedServices[elem.ticker] && this.props.selectedServices[elem.ticker].formValues && Object.keys(this.props.selectedServices[elem.ticker].formValues).reduce((accum, it) => _objectSpread2({}, accum, {
        [it]: this.props.selectedServices[elem.ticker].formValues[it].value
      }), {});
      var formShape = this.props.questionnaires && this.props.questionnaires.find(questionnaire => questionnaire.dependers.find(depender => depender.type === "EXTRA" && depender.tickers && depender.tickers.includes(elem.ticker)));
      return elem.obligatory && hideObligatoryExtras ? null : /*#__PURE__*/React__default.createElement(ExtraItem, {
        addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection,
        currency: elem.currency,
        deleteInParentState: this.deleteInParentState,
        description: elem.description,
        elem: elem,
        formValues: formValues,
        handleGallery: handleGallery,
        handleOnChange: this.setQuantity,
        hasCheckBox: elem.hasCheckBox,
        inputVal: this.state.selectedService[elem.ticker],
        dateInputVal: this.state.dateValues[elem.ticker] || {},
        hasErrors: this.state.dateValues[elem.ticker] && Object.values(this.state.dateValues[elem.ticker]).every(value => value === 0),
        isFormValid: this.isFormValid,
        key: elem.ticker,
        minPrice: elem.minPrice,
        onExpand: elem.onExpand,
        selectOptions: elem.selectOptions,
        showForm: !!this.state.selectedService[elem.ticker],
        showInfo: elem.showInfo,
        thumbnail: elem.thumbnail,
        title: elem.title,
        type: type,
        unit: elem.unit,
        updateFormValues: this.updateFormValues,
        updateDateValues: this.updateDateValues,
        startDate: startDate,
        endDate: endDate,
        formShape: formShape,
        touch: this.state.touchAllChildren,
        totalRatePerDay: elem.totalRatePerDay,
        dateSelectionType: elem.dateSelectionType,
        errors: this.state.errors
      });
    })), /*#__PURE__*/React__default.createElement(ButtonContainer, null, " ", /*#__PURE__*/React__default.createElement(CloseButton, {
      onClick: handleCloseButton,
      allowClose: this.state.allowClose
    }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$C.close)), " ", /*#__PURE__*/React__default.createElement(ConfirmButton$1, {
      onClick: this.onChangeSubmit
    }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$C.confirm), " "), " "));
  }

} // ExtraList.propTypes = {
//   className: PropTypes.string,
//   addObligatoryExtrasRateToRoomSelection: PropTypes.bool.isRequired,
//   closeWindow: PropTypes.func.isRequired,
//   extras: PropTypes.array.isRequired,
//   handleGallery: PropTypes.func.isRequired,
//   handleModalContent: PropTypes.func.isRequired,
//   onSubmit: PropTypes.func.isRequired,
//   selectedServices: PropTypes.object.isRequired,
//   serviceRatesInfo: PropTypes.object.isRequired,
//   serviceHasImage: PropTypes.bool.isRequired,
//   onCancel: PropTypes.func,
//   type: PropTypes.string.isRequired,
//   startDate: PropTypes.instanceOf(Date).isRequired,
//   endDate: PropTypes.instanceOf(Date).isRequired,
//   questionnaires: PropTypes.array.isRequired,
//   allowCloseExtrasModal: PropTypes.func,
//   hideObligatoryExtras: PropTypes.bool.isRequired,
//   guestsList: PropTypes.object.isRequired
// };


ExtraList.defaultProps = {
  className: "",
  onCancel: undefined,
  allowCloseExtrasModal: undefined
};

function _templateObject2$T() {
  var data = _taggedTemplateLiteral(["\n  height: 100vh;\n"]);

  _templateObject2$T = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$11() {
  var data = _taggedTemplateLiteral(["\n  min-height: 65px;\n"]);

  _templateObject$11 = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$D = reactIntl.defineMessages({
  improve: {
    id: "checkout.reservation_summary.improveStay",
    description: "Header title",
    defaultMessage: "Improve your stay"
  }
});
var Placeholder = styled__default.div(_templateObject$11());
var ExtrasWrapper = styled__default.div(_templateObject2$T());

function Extras(props) {
  var [selectedFilterOption, setSelectedFilterOption] = React.useState("");
  React.useEffect(() => {
    if (!selectedFilterOption) {
      var _props$extraFilters$, _props$extraFilters$$;

      setSelectedFilterOption(props === null || props === void 0 ? void 0 : (_props$extraFilters$ = props.extraFilters[0]) === null || _props$extraFilters$ === void 0 ? void 0 : (_props$extraFilters$$ = _props$extraFilters$.options[0]) === null || _props$extraFilters$$ === void 0 ? void 0 : _props$extraFilters$$.optionTicker);
    }
  }, [setSelectedFilterOption, props.extraFilters]);
  var filteredExtras = React.useMemo(() => {
    if (Array.isArray(props.extraFilters) && props.extraFilters[0] && props.extraFilters[0].options) {
      var filterKeys = props.extraFilters[0].options.map(option => option.optionTicker);
      return filterKeys.reduce((accum, curr) => {
        var extras;

        if (Array.isArray(props.extras) && Array.isArray(props.extraFilters) && props.extraFilters.length > 0) {
          var option = props.extraFilters[0].options.find(option => option.optionTicker === curr);

          if (option) {
            var patternArr = option.pattern.split(",");

            if (option.pattern === ",") {
              extras = props.extras;
            } else {
              extras = props.extras.filter(extra => patternArr.some(it => it === extra.ticker));
            }
          }
        }

        return _objectSpread2({
          [curr]: extras
        }, accum);
      }, {});
    }
  }, [props.extras]);
  var extraFilters = React.useMemo(() => {
    var xtraFilters = lodash.cloneDeep(props.extraFilters);

    if (xtraFilters && xtraFilters[0]) {
      xtraFilters[0].options = xtraFilters[0] && Array.isArray(xtraFilters[0].options) && xtraFilters[0].options.filter(option => {
        return Array.isArray(filteredExtras[option === null || option === void 0 ? void 0 : option.optionTicker]) && filteredExtras[option === null || option === void 0 ? void 0 : option.optionTicker].length;
      });
    }

    return xtraFilters;
  }, [props.extraFilters, filteredExtras]);
  var handleChangeTab = React.useCallback(it => {
    var _it$target;

    var val = (it === null || it === void 0 ? void 0 : it.target) ? it === null || it === void 0 ? void 0 : (_it$target = it.target) === null || _it$target === void 0 ? void 0 : _it$target.value : it === null || it === void 0 ? void 0 : it.optionTicker;
    setSelectedFilterOption(val);
  }, [props.extras]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-Extras"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$D.improve),
    srcLogo: /*#__PURE__*/React__default.createElement(Info, null),
    closeWindow: props.allowClose && props.closeWindow,
    allowClose: props.allowClose
  }, /*#__PURE__*/React__default.createElement(ExtrasWrapper, null, /*#__PURE__*/React__default.createElement(TabFilters, {
    tabFilters: extraFilters,
    propertyActiveTab: selectedFilterOption,
    isTabFiltersCollapsed: props.isTabFiltersCollapsed,
    onChange: handleChangeTab,
    onSelectorChange: handleChangeTab,
    backgroundColor: props.backgroundColor,
    textColor: props.textColor
  }), Array.isArray(filteredExtras) && !filteredExtras.length && /*#__PURE__*/React__default.createElement(Placeholder, null), /*#__PURE__*/React__default.createElement(ExtraList, {
    extras: filteredExtras && filteredExtras[selectedFilterOption] ? filteredExtras[selectedFilterOption] : props.extras,
    type: "service",
    addObligatoryExtrasRateToRoomSelection: props.addObligatoryExtrasRateToRoomSelection,
    selectedServices: props.selectedServices,
    serviceRatesInfo: props.serviceRatesInfo,
    onSubmit: props.onChangeService,
    serviceHasImage: props.serviceHasImage,
    handleModalContent: props.handleModalContent,
    handleGallery: props.handleGallery,
    closeWindow: props.closeWindow,
    startDate: props.startDate,
    endDate: props.endDate,
    questionnaires: props.questionnaires,
    allowCloseExtrasModal: props.allowCloseExtrasModal,
    hideObligatoryExtras: props.hideObligatoryExtras,
    guestsList: props.guestsList
  }))));
} // Extras.propTypes = {
//   /** method to close the Popup */
//   closeWindow: PropTypes.func.isRequired,
//   /** The data of tariff which will be rendered as a child in the Popup */
//   data: PropTypes.object.isRequired,
//   extras: PropTypes.array.isRequired,
//   addObligatoryExtrasRateToRoomSelection: PropTypes.bool.isRequired,
//   selectedServices: PropTypes.object.isRequired,
//   serviceRatesInfo: PropTypes.object.isRequired,
//   onChangeService: PropTypes.func.isRequired,
//   serviceHasImage: PropTypes.bool.isRequired,
//   handleModalContent: PropTypes.func.isRequired,
//   handleGallery: PropTypes.func.isRequired,
//   startDate: PropTypes.instanceOf(Date).isRequired,
//   endDate: PropTypes.instanceOf(Date).isRequired,
//   questionnaires: PropTypes.array,
//   allowCloseExtrasModal: PropTypes.func,
//   allowClose: PropTypes.bool.isRequired,
//   hideObligatoryExtras: PropTypes.bool.isRequired,
//   guestsList: PropTypes.object.isRequired
// };


Extras.defaultProps = {
  questionnaires: undefined,
  allowCloseExtrasModal: undefined
};
var index$6 = pure(Extras);

function _templateObject2$U() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n"]);

  _templateObject2$U = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$12() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 3px;\n  border: 1px solid #e1e1e1;\n  background-color: #f6f6f6;\n  font-size: 13px;\n  padding: 10px;\n  margin: 7.5px;\n  word-wrap: break-word;\n"]);

  _templateObject$12 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledExtrasAdditionalinfo = styled__default.div(_templateObject$12());
var Bold = styled__default.div(_templateObject2$U());

function ExtrasAdditionalinfo(_ref) {
  var {
    accomodationName,
    selectedServices
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledExtrasAdditionalinfo, null, /*#__PURE__*/React__default.createElement(Bold, null, accomodationName), Object.keys(selectedServices).map(selectedService => {
    var sortedDateQuantity = [];

    if (selectedServices[selectedService].dateQuantity) {
      Object.keys(selectedServices[selectedService].dateQuantity).map(date => selectedServices[selectedService].dateQuantity[date] && sortedDateQuantity.push(date));
      sortedDateQuantity.sort((a, b) => a < b ? -1 : 1);
    } // If current selectedService has formValues down its hierarchy, render it


    return (selectedServices[selectedService].formValues || selectedServices[selectedService].dateSelectionType === constants.DATE_SELECTION_TYPE.SPECIFIC) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Bold, null, selectedServices[selectedService].name, ":"), sortedDateQuantity && sortedDateQuantity.map(date => selectedServices[selectedService].dateQuantity[date] && /*#__PURE__*/React__default.createElement("div", null, "(x", selectedServices[selectedService].type === constants.SERVICE_TYPE.PERSON ? selectedServices[selectedService].showedQuantity : selectedServices[selectedService].dateQuantity[date], ") ", date)), selectedServices[selectedService].formValues && Object.values(selectedServices[selectedService].formValues).map(form => form.value && /*#__PURE__*/React__default.createElement("div", null, form.value, ".")));
  }));
}

ExtrasAdditionalinfo.propTypes = {
  accomodationName: PropTypes__default.string.isRequired,
  selectedServices: PropTypes__default.array.isRequired
};
var index$7 = pure(ExtrasAdditionalinfo);

var ShoppingCart = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
})), "ShoppingCart");

function _templateObject3$J() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 10px;\n"]);

  _templateObject3$J = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$V() {
  var data = _taggedTemplateLiteral(["\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n"]);

  _templateObject2$V = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$13() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  position: fixed;\n  bottom: 0;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: ", ";\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n"]);

  _templateObject$13 = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$E = reactIntl.defineMessages({
  buttonBook: {
    id: "groupedinventoryList.button.book",
    description: "text for booking",
    defaultMessage: "book"
  }
});
var DivFather$1 = styled__default.div(_templateObject$13(), props => props.bColor, props => props.color);
var SvgContainer$1 = styled__default.div(_templateObject2$V());
var BasketContainer = styled__default.div(_templateObject3$J());

function FixedCart(props) {
  return /*#__PURE__*/React__default.createElement(DivFather$1, {
    className: "wbkv9-Lib-StyckyCheckout",
    bColor: props.backgroundColor,
    color: props.color,
    onClick: props.functionOnClick
  }, /*#__PURE__*/React__default.createElement(SvgContainer$1, null, /*#__PURE__*/React__default.createElement(ShoppingCart, null)), /*#__PURE__*/React__default.createElement(BasketContainer, null, props.currency, " ", props.totalInBasket, " - ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$E.buttonBook)));
}

FixedCart.defaultProps = {
  functionOnClick: () => null,
  backgroundColor: "black",
  color: "white",
  currency: "EUR",
  totalInBasket: "0"
}; //TODO: Correct proptypes
// FixedCart.propTypes = {
//   backgroundColor: PropTypes.string,
//   color: PropTypes.string,
//   functionOnClick: PropTypes.func,
//   currency: PropTypes.string,
//   totalInBasket: PropTypes.number,
// };

var index$8 = pure(FixedCart);

var generateColor = () => "#".concat((0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6));

class HelloWorld extends React.PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      color: this.props.initialColor
    });

    _defineProperty(this, "handleClick", () => {
      this.setState({
        color: generateColor()
      });
    });
  }

  componentWillReceiveProps(_ref) {
    var {
      initialColor
    } = _ref;

    if (initialColor !== this.props.initialColor) {
      this.setState({
        color: initialColor
      });
    }
  }

  render() {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h1", {
      style: {
        color: this.state.color,
        padding: "20px"
      }
    }, "Hello World!"), /*#__PURE__*/React__default.createElement("button", {
      onClick: this.handleClick
    }, "Change color"));
  }

}

_defineProperty(HelloWorld, "defaultProps", {
  initialColor: "#000"
});

_defineProperty(HelloWorld, "propTypes", {
  initialColor: PropTypes.string
});

function _templateObject6$h() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 5px;\n  display: inline;\n"]);

  _templateObject6$h = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$r() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: ", ";\n  "]);

  _templateObject5$r = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$E() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: ", ";\n  ", ";\n  &:hover {\n    text-decoration: ", ";\n  }\n"]);

  _templateObject4$E = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$K() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: ", ";\n  "]);

  _templateObject3$K = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$W() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  cursor: ", ";\n  ", ";\n  &:hover {\n    text-decoration: ", ";\n  }\n"]);

  _templateObject2$W = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$14() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  color: ", ";\n  font-weight: 700;\n  font-size: 14px;\n  margin: 2px;\n  margin-bottom: 3px;\n"]);

  _templateObject$14 = function _templateObject() {
    return data;
  };

  return data;
}
var InventoryTitleContainer = styled__default.div(_templateObject$14(), wbBlack);
var BlockOne = styled__default.div(_templateObject2$W(), props => props.onClick ? "pointer" : "", media.down.sml(_templateObject3$K(), props => props.onClick ? "underline" : ""), props => props.onClick ? "underline" : "");
var BlockTwo = styled__default.div(_templateObject4$E(), props => props.onClick ? "pointer" : "", media.down.sml(_templateObject5$r(), props => props.onClick ? "underline" : ""), props => props.onClick ? "underline" : "");
var DashContainer = styled__default.div(_templateObject6$h());

class InventoryTitle extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return /*#__PURE__*/React__default.createElement(InventoryTitleContainer, {
      className: "wbkv9-InventoryLine-Title"
    }, /*#__PURE__*/React__default.createElement(BlockOne, {
      className: "wbkv9-InventoryLine-Title-BlockOne",
      onClick: this.props.onClickBlockOne
    }, this.props.blockOne, this.props.badgeBlockOne), this.props.isDashRendered && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(DashContainer, null, "-")), /*#__PURE__*/React__default.createElement(BlockTwo, {
      className: "wbkv9-InventoryLine-Title-BlockTwo",
      onClick: this.props.onClickBlockTwo
    }, this.props.blockTwo, this.props.badgeBlockTwo));
  }

}

InventoryTitle.defaultProps = {
  badgeBlockOne: null,
  badgeBlockTwo: null
};
InventoryTitle.propTypes = {
  /** first text to be rendered  */
  blockOne: PropTypes__default.string.isRequired,

  /** second text to be rendered  */
  blockTwo: PropTypes__default.string.isRequired,

  /** checks if the dash has to be rendered */
  isDashRendered: PropTypes__default.bool.isRequired,

  /** first badge component if it has to be rendered  */
  badgeBlockOne: PropTypes__default.object,

  /** second badge component if it has to be rendered  */
  badgeBlockTwo: PropTypes__default.object,

  /** Function called when the block one is clicked, normally opens the modal of conditions */
  onClickBlockOne: PropTypes__default.func,

  /** Function called when the block two is clicked, normally opens the modal of conditions */
  onClickBlockTwo: PropTypes__default.func
};
var InventoryTitle$1 = React__default.memo(InventoryTitle);

function _templateObject6$i() {
  var data = _taggedTemplateLiteral(["\n    text-decoration: ", ";\n  "]);

  _templateObject6$i = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$s() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  ", ";\n  &:hover {\n    text-decoration: ", ";\n  }\n"]);

  _templateObject5$s = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$F() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n"]);

  _templateObject4$F = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$L() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 5px;\n"]);

  _templateObject3$L = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$X() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline;\n  & > * {\n    display: inline-flex;\n  }\n"]);

  _templateObject2$X = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$15() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  font-size: 14px;\n  max-width: none;\n  margin: 2px;\n  margin-bottom: 3px;\n  justify-content: space-between;\n  padding: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  &:hover {\n    color: ", ";\n    cursor: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject$15 = function _templateObject() {
    return data;
  };

  return data;
}
var InventoryDescriptionContainer = styled__default.div(_templateObject$15(), greyLight, props => props.isDropDown && props.inventoryGroupVisible ? "5px 5px" : "", props => props.isDropDown && props.inventoryGroupVisible ? backgroundButtonGrey : "", props => props.isDropDown && props.inventoryGroupVisible ? "".concat(greyLighter, " 1px solid") : "", props => props.isDropDown && props.inventoryGroupVisible ? "3px" : "", props => props.isDropDown && props.inventoryGroupVisible ? wbBlack : "", props => props.isDropDown && props.inventoryGroupVisible ? "pointer" : "", props => props.isDropDown && props.inventoryGroupVisible ? greyLight : "");
var TextContainer = styled__default.div(_templateObject2$X());
var Dash = styled__default.span(_templateObject3$L());
var SvgContainer$2 = styled__default.div(_templateObject4$F());
var Block = styled__default.div(_templateObject5$s(), props => props.onClick ? "pointer" : "", media.down.sml(_templateObject6$i(), props => props.onClick ? "underline" : ""), props => props.onClick ? "underline" : "");

class InventoryDescription extends React__default.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleOnClick", () => {
      if (this.props.isDropDown && this.props.inventoryGroupVisible) {
        this.props.handleInventoryDescriptionClick();
      }

      return null;
    });

    this.state = {};
  }

  render() {
    var isInventoryGroup = this.props.isDropDown && this.props.inventoryGroupVisible;
    return /*#__PURE__*/React__default.createElement(InventoryDescriptionContainer, {
      className: "wbkv9-InventoryLine-Description",
      isDropDown: this.props.isDropDown,
      onClick: this.handleOnClick,
      inventoryGroupVisible: this.props.inventoryGroupVisible
    }, /*#__PURE__*/React__default.createElement(TextContainer, null, /*#__PURE__*/React__default.createElement(Block, {
      className: "wbkv9-InventoryLine-Description-BlockOne",
      onClick: !isInventoryGroup ? this.props.onClickBlockOne : undefined
    }, this.props.blockOne), this.props.isDashRendered && /*#__PURE__*/React__default.createElement(Dash, null, "-"), /*#__PURE__*/React__default.createElement(Block, {
      className: "wbkv9-InventoryLine-Description-BlockTwo",
      onClick: this.props.onClickBlockTwo && !isInventoryGroup ? this.props.onClickBlockTwo : undefined
    }, this.props.blockTwo)), this.props.isDropDown && this.props.inventoryGroupVisible && /*#__PURE__*/React__default.createElement(SvgContainer$2, null, /*#__PURE__*/React__default.createElement(ArrowDropDown, null)));
  }

}

InventoryDescription.propTypes = {
  /** first text to be rendered  */
  blockOne: PropTypes__default.string.isRequired,

  /** second text to be rendered  */
  blockTwo: PropTypes__default.string.isRequired,

  /** checks if the dash has to be rendered */
  isDashRendered: PropTypes__default.bool.isRequired,

  /** checks if the dropdown is active */
  isDropDown: PropTypes__default.bool.isRequired,

  /** checks if are other inventory groups */
  inventoryGroupVisible: PropTypes__default.bool.isRequired,

  /** function called when this componen is clicked */
  handleInventoryDescriptionClick: PropTypes__default.func.isRequired,

  /** Function called when the block one is clicked, normally opens the modal of conditions */
  onClickBlockOne: PropTypes__default.func,

  /** Function called when the block two is clicked, normally opens the modal of conditions */
  onClickBlockTwo: PropTypes__default.func
};
var InventoryDescription$1 = React__default.memo(InventoryDescription);

var CreditCard = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
})), "Close");

function _templateObject5$t() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 3px;\n"]);

  _templateObject5$t = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$G() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4$G = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$M() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: 3px;\n"]);

  _templateObject3$M = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$Y() {
  var data = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n  align-self: flex-start;\n  margin-right: 1px;\n"]);

  _templateObject2$Y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$16() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n  font-size: 13px;\n  margin: 2px;\n  font-weight: 700;\n  align-items: center;\n"]);

  _templateObject$16 = function _templateObject() {
    return data;
  };

  return data;
}
var InventoryDetailsContainer = styled__default.div(_templateObject$16(), wbGreen);
var SvgContainer$3 = styled__default.div(_templateObject2$Y());
var BlockOneContainer = styled__default.div(_templateObject3$M());
var BlockOne$1 = styled__default.div(_templateObject4$G());
var BlockTwo$1 = styled__default.div(_templateObject5$t());

class InventoryDetails extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(InventoryDetailsContainer, {
      className: "wbkv9-InventoryLine-Details"
    }, this.props.blockOne && /*#__PURE__*/React__default.createElement(BlockOneContainer, null, /*#__PURE__*/React__default.createElement(SvgContainer$3, null, /*#__PURE__*/React__default.createElement(CreditCard, null)), /*#__PURE__*/React__default.createElement(BlockOne$1, {
      className: "wbkv9-InventoryLine-Details-BlockOne"
    }, this.props.blockOne)), window.showCancelMsg && this.props.availability && /*#__PURE__*/React__default.createElement(BlockTwo$1, {
      className: "wbkv9-InventoryLine-Details-BlockTwo"
    }, this.props.blockTwo)));
  }

}

InventoryDetails.defaultProps = {
  blockOne: null,
  blockTwo: null
}; //TODO: Correct proptypes
// InventoryDetails.propTypes = {
//   /** first text to be rendered  */
//   blockOne: PropTypes.string,
//   /** second text to be rendered  */
//   blockTwo: PropTypes.string,
//   /** checks if this Cancel Messages has to be rendered */
//   showCancelMsg: PropTypes.bool.isRequired
// };

var InventoryDetails$1 = pure(InventoryDetails);

function _templateObject8$c() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  "]);

  _templateObject8$c = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$f() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", ";\n"]);

  _templateObject7$f = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$j() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin-right: 5px;\n"]);

  _templateObject6$j = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$u() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 5px;\n  text-decoration: underline;\n  cursor: pointer;\n  display: block;\n  "]);

  _templateObject5$u = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$H() {
  var data = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n  display: none;\n  &:hover {\n    color: ", ";\n  }\n  ", ";\n"]);

  _templateObject4$H = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$N() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 0;\n"]);

  _templateObject3$N = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$Z() {
  var data = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n  margin-right: 5px;\n  text-decoration: underline;\n  cursor: pointer;\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject2$Z = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$17() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  font-size: 13px;\n  margin: 2px;\n  margin-bottom: 3px;\n"]);

  _templateObject$17 = function _templateObject() {
    return data;
  };

  return data;
}
var InventoryActionsContainer = styled__default.div(_templateObject$17(), greyLight);
var BlockOne$2 = styled__default.div(_templateObject2$Z(), wbBlack);
var BlockZero = styled__default(BlockOne$2)(_templateObject3$N());
var BlockTwo$2 = styled__default.div(_templateObject4$H(), wbBlack, media.up.md(_templateObject5$u()));
var MobileSeparator = styled__default.div(_templateObject6$j());
var Separator$1 = styled__default.div(_templateObject7$f(), media.up.md(_templateObject8$c()));

class InventoryActions extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return /*#__PURE__*/React__default.createElement(InventoryActionsContainer, {
      className: "wbkv9-InventoryLine-Actions"
    }, this.props.showMealPlans && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BlockZero, {
      className: "wbkv9-InventoryLine-Actions-BlockZero",
      onClick: this.props.handleInventoryActionsMealPlansClick
    }, this.props.blockZero), /*#__PURE__*/React__default.createElement(MobileSeparator, null, "|")), /*#__PURE__*/React__default.createElement(BlockOne$2, {
      className: "wbkv9-InventoryLine-Actions-BlockOne",
      onClick: this.props.handleInventoryActionsConditionsClick
    }, this.props.blockOne), /*#__PURE__*/React__default.createElement(Separator$1, null, "|"), /*#__PURE__*/React__default.createElement(BlockTwo$2, {
      className: "wbkv9-InventoryLine-Actions-BlockTwo",
      onClick: this.props.handleInventoryActionsCompareClick
    }, this.props.blockTwo));
  }

}

InventoryActions.defaultProps = {}; //TODO: Correct proptypes
// InventoryActions.propTypes = {
//   /** first text to be rendered */
//   blockOne: PropTypes.string.isRequired,
//   /** second text to be rendered */
//   blockTwo: PropTypes.string.isRequired,
//   /** function called when BlockOne is clicked */
//   handleInventoryActionsConditionsClick: PropTypes.func.isRequired,
//   /** function called when BlockTwo is clicked */
//   handleInventoryActionsCompareClick: PropTypes.func.isRequired
// };

var InventoryActions$1 = pure(InventoryActions);

function _templateObject$18() {
  var data = _taggedTemplateLiteral(["\n  font-family: \"Open Sans\";\n  display: flex;\n  flex-flow: column;\n"]);

  _templateObject$18 = function _templateObject() {
    return data;
  };

  return data;
}
var InventoryLineContainer = styled__default.div(_templateObject$18());

class InventoryLine extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    var inventoryData = {
      title: {
        blockOne: "",
        blockTwo: "",
        badgeBlockOne: null,
        badgeBlockTwo: null,
        isDashRendered: false,
        hasBadgeBlockOne: false,
        hasBadgeBlockTwo: false
      },
      description: {
        blockOne: "",
        blockTwo: "",
        isDashRendered: false,
        hasBadgeBlockOne: false,
        hasBadgeBlockTwo: false,
        isDropDown: false,
        inventoryGroupVisible: this.props.inventoryGroupVisible
      },
      details: {
        blockOne: this.props.depositAndInformation,
        blockTwo: this.props.cancellationMessage,
        hasDeposit: this.props.hasDeposit,
        availability: this.props.availability
      },
      actions: {
        blockZero: this.props.mealPlans,
        blockOne: this.props.links,
        blockTwo: this.props.compare
      }
    };

    switch (this.props.type) {
      case "configuration":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.ocupation
          }),
          description: _objectSpread2({}, inventoryData.description, {
            blockOne: this.props.pension,
            onClickBlockOne: this.props.handleMealPlanClicked,
            blockTwo: this.props.condition,
            isDashRendered: true,
            isDropDown: true
          })
        });
        break;

      case "condition":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.condition,
            onClickBlockOne: this.props.handleConditionClicked,
            badgeBlockOne: this.props.badge
          }),
          description: _objectSpread2({}, inventoryData.description, {
            blockOne: this.props.ocupation,
            onClickBlockTwo: this.props.handleMealPlanClicked,
            blockTwo: this.props.pension,
            isDropDown: true,
            isDashRendered: true
          })
        });
        break;

      case "mealplan":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.pension,
            onClickBlockOne: this.props.handleMealPlanClicked
          }),
          description: _objectSpread2({}, inventoryData.description, {
            blockOne: this.props.ocupation,
            blockTwo: this.props.condition,
            onClickBlockTwo: this.props.handleConditionClicked,
            isDropDown: true,
            isDashRendered: true
          })
        });
        break;

      case "configuration,condition":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.ocupation,
            blockTwo: this.props.condition,
            onClickBlockTwo: this.props.handleConditionClicked,
            badgeBlockTwo: this.props.badge,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            isDropDown: true,
            blockOne: this.props.pension,
            onClickBlockOne: this.props.handleMealPlanClicked
          })
        });
        break;

      case "configuration,mealplan":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.ocupation,
            blockTwo: this.props.pension,
            onClickBlockTwo: this.props.handleMealPlanClicked,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            isDropDown: true,
            blockOne: this.props.condition
          })
        });
        break;

      case "condition,configuration":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.condition,
            blockTwo: this.props.ocupation,
            onClickBlockOne: this.props.handleConditionClicked,
            badgeBlockOne: this.props.badge,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            isDropDown: true,
            blockOne: this.props.pension,
            onClickBlockOne: this.props.handleMealPlanClicked
          })
        });
        break;

      case "condition,mealplan":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.condition,
            blockTwo: this.props.pension,
            onClickBlockOne: this.props.handleConditionClicked,
            onClickBlockTwo: this.props.handleMealPlanClicked,
            badgeBlockOne: this.props.badge,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            isDropDown: true,
            blockOne: this.props.ocupation
          })
        });
        break;

      case "mealplan,configuration":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.pension,
            onClickBlockOne: this.props.handleMealPlanClicked,
            blockTwo: this.props.ocupation,
            badge: this.props.badge,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            isDropDown: true,
            blockOne: this.props.condition
          })
        });
        break;

      case "mealplan,condition":
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.pension,
            blockTwo: this.props.condition,
            onClickBlockOne: this.props.handleMealPlanClicked,
            onClickBlockTwo: this.props.handleConditionClicked,
            badgeBlockTwo: this.props.badge,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            isDropDown: true,
            blockOne: this.props.ocupation
          })
        });
        break;

      default:
        inventoryData = _objectSpread2({}, inventoryData, {
          title: _objectSpread2({}, inventoryData.title, {
            blockOne: this.props.pension,
            blockTwo: this.props.condition,
            onClickBlockOne: this.props.handleMealPlanClicked,
            onClickBlockTwo: this.props.handleConditionClicked,
            badgeBlockOne: "",
            badgeBlockTwo: this.props.badge,
            isDashRendered: true
          }),
          description: _objectSpread2({}, inventoryData.description, {
            blockOne: this.props.ocupation
          })
        });
        break;
    }

    return /*#__PURE__*/React__default.createElement(InventoryLineContainer, {
      className: "wbkv9-InventoryLine ".concat(this.props.className)
    }, /*#__PURE__*/React__default.createElement(InventoryTitle$1, inventoryData.title), /*#__PURE__*/React__default.createElement(InventoryDescription$1, _extends({}, inventoryData.description, {
      handleInventoryDescriptionClick: this.props.handleInventoryDescriptionClick
    })), (inventoryData.details.blockOne || inventoryData.details.blockTwo && window.showCancelMsg) && /*#__PURE__*/React__default.createElement(InventoryDetails$1, inventoryData.details), !this.props.inModification && /*#__PURE__*/React__default.createElement(InventoryActions$1, _extends({}, inventoryData.actions, {
      handleInventoryActionsConditionsClick: this.props.handleInventoryActionsConditionsClick,
      handleInventoryActionsCompareClick: this.props.handleInventoryActionsCompareClick,
      handleInventoryActionsMealPlansClick: this.props.handleInventoryActionsMealPlansClick,
      showMealPlans: this.props.handleMealPlanClicked
    })));
  }

}

InventoryLine.defaultProps = {
  className: "",
  pension: "Pension",
  condition: "Condición",
  ocupation: "Ocupación",
  depositAndInformation: "Depósito e Información",
  links: "Links",
  compare: "Comparar",
  type: "",
  inventoryGroupVisible: false,
  hasDeposit: false,
  handleConditionClicked: () => {},
  handleInventoryDescriptionClick: () => {},
  handleInventoryActionsConditionsClick: () => {},
  handleInventoryActionsCompareClick: () => {},
  cancellationMessage: null,
  badge: null
}; //TODO: Correct proptypes
// InventoryLine.propTypes = {
//   /** className passed to the first container */
//   className: PropTypes.string,
//   /** Text to be rendered by pensions */
//   pension: PropTypes.string,
//   /** Text to be rendered by condition */
//   condition: PropTypes.string,
//   /** Text to be rendered by ocupation */
//   ocupation: PropTypes.string,
//   /** Text to be rendered by deposits and extra information */
//   depositAndInformation: PropTypes.string,
//   /** Text to be rendered by links, normally conditions information */
//   links: PropTypes.string,
//   /** Text to be rendered by compare */
//   compare: PropTypes.string,
//   /** type defines the positions of the diferents text */
//   type: PropTypes.string,
//   /** method called when there is a click at inventory description */
//   handleInventoryDescriptionClick: PropTypes.func,
//   /** method called when there is a click at conditions in actions */
//   handleInventoryActionsConditionsClick: PropTypes.func,
//   /** method called when there is a click at compare in actions */
//   handleInventoryActionsCompareClick: PropTypes.func,
//   /** it contains the badge component */
//   handleConditionClicked: PropTypes.func,
//   /** checks if are other inventory groups */
//   inventoryGroupVisible: PropTypes.bool,
//   /** checks if this option has deposit */
//   hasDeposit: PropTypes.bool,
//   /** checks if this Cancel Messages has to be rendered */
//   showCancelMsg: PropTypes.bool,
//   /** it contains the cancellationMessage component */
//   cancellationMessage: PropTypes.object,
//   /** it contains the cancellationMessage component */
//   cancellationMessage: PropTypes.object,
//   /** it contains the badge component */
//   badge: PropTypes.object
// };

var index$9 = pure(InventoryLine);

function isModificationValid(_ref) {
  var {
    currentAmount = 0,
    newAmount,
    accommodationModificationRestrictionType
  } = _ref;

  if (!newAmount || newAmount <= 0) {
    return false;
  }

  switch (accommodationModificationRestrictionType) {
    case constants.restrictions.AMOUNT_GTE:
      return newAmount >= currentAmount;

    case constants.restrictions.NO_RESTRICTION:
      return true;

    default:
      return true;
  }
}

function _templateObject3$O() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #908f96;\n"]);

  _templateObject3$O = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$_() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: bold;\n  color: #222222;\n"]);

  _templateObject2$_ = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$19() {
  var data = _taggedTemplateLiteral(["\n  padding: 25px;\n"]);

  _templateObject$19 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$9 = styled__default("div")(_templateObject$19());
var Title$3 = styled__default("b")(_templateObject2$_());
var Content = styled__default("div")(_templateObject3$O());

function MealPlanDetails(_ref) {
  var {
    closeWindow,
    data
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "Conditions"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, {
      id: "checkout.reservation_summary.mealPlan"
    }),
    srcLogo: /*#__PURE__*/React__default.createElement(Info, null),
    closeWindow: closeWindow
  }, data && /*#__PURE__*/React__default.createElement(Container$9, null, /*#__PURE__*/React__default.createElement(Title$3, null, data.name), /*#__PURE__*/React__default.createElement(Content, {
    dangerouslySetInnerHTML: {
      __html: data.description || data.name
    }
  }))));
}

var index$a = React__default.memo(MealPlanDetails);

function _templateObject8$d() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 10px;\n"]);

  _templateObject8$d = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$g() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  color: inherit;\n  border: 0;\n  outline: none;\n  padding: 0;\n  text-decoration: underline;\n  cursor: pointer;\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject7$g = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$k() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 5px;\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  display: flex;\n  text-transform: capitalize;\n"]);

  _templateObject6$k = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$v() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 5px;\n  color: ", ";\n  font-size: 17px;\n  font-weight: 700;\n  text-align: end;\n"]);

  _templateObject5$v = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$I() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  color: ", ";\n  font-size: 13px;\n  font-weight: 400;\n"]);

  _templateObject4$I = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$P() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: none;\n"]);

  _templateObject3$P = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$$() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: capitalize;\n"]);

  _templateObject2$$ = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1a() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 20px;\n  padding: 20px 0;\n  border-top: ", ";\n  text-align: left;\n  width: 100%;\n  max-width: 208px;\n"]);

  _templateObject$1a = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$F = reactIntl.defineMessages({
  view: {
    id: "room_selection.summaryCart.view",
    description: "View",
    defaultMessage: "View"
  },
  delete: {
    id: "room_selection.summaryCart.delete",
    description: "delete",
    defaultMessage: "delete"
  },
  nights: {
    id: "bookingModification.nights",
    description: "nights",
    defaultMessage: "nights"
  },
  night: {
    id: "inventory.night",
    description: "night",
    defaultMessage: "night"
  }
});
var MiniCartRoomDetailsContainer = styled__default.div(_templateObject$1a(), props => props.roomID > 0 ? "1px solid ".concat(greyLighter) : "");
var MiniCartRoomDetailsTitle = styled__default.div(_templateObject2$$(), wbBlack);
var QuantityRoomsContaner = styled__default.div(_templateObject3$P(), wbBlack);
var MiniCartRoomDetailsDescriptionContainer = styled__default.div(_templateObject4$I(), greyLight);
var MiniCartRoomDetailsPriceContainer = styled__default.div(_templateObject5$v(), wbBlack);
var MiniCartRoomDetailsActionsContainer = styled__default.div(_templateObject6$k(), greyLight);
var ActionButtons = styled__default.button(_templateObject7$g(), wbBlack);
var LittleBar = styled__default.div(_templateObject8$d());

function MiniCartRoomDetails(props) {
  return /*#__PURE__*/React__default.createElement(MiniCartRoomDetailsContainer, {
    className: "".concat(props.className, " wbkv9-MiniCart-RoomDetails"),
    roomID: props.roomID
  }, /*#__PURE__*/React__default.createElement(MiniCartRoomDetailsTitle, null, props.room.accommodationName, props.room.quantity >= 2 && /*#__PURE__*/React__default.createElement(QuantityRoomsContaner, null, "(x", props.room.quantity, ")")), /*#__PURE__*/React__default.createElement(MiniCartRoomDetailsDescriptionContainer, null, /*#__PURE__*/React__default.createElement("div", null, props.startDate, " - ", props.endDate, " (", props.numberOfNights >= 1 ? props.numberOfNights : 1, " ", props.numberOfNights > 1 ? /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$F.nights) : /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$F.night), ")"), /*#__PURE__*/React__default.createElement("div", null, props.room.configuration), /*#__PURE__*/React__default.createElement("div", null, props.room.condition), /*#__PURE__*/React__default.createElement("div", null, props.room.mealPlan)), /*#__PURE__*/React__default.createElement(MiniCartRoomDetailsPriceContainer, null, props.currency, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: Math.ceil(props.room.totalRate * 100) / 100
  })), /*#__PURE__*/React__default.createElement(MiniCartRoomDetailsActionsContainer, null, /*#__PURE__*/React__default.createElement(ActionButtons, {
    onClick: props.handleFirstAction
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$F.view)), /*#__PURE__*/React__default.createElement(LittleBar, null, "|"), /*#__PURE__*/React__default.createElement(ActionButtons, {
    onClick: () => props.handleSecondAction(props.room)
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$F.delete))));
}

MiniCartRoomDetails.defaultProps = {
  className: "",
  handleFirstAction: () => {},
  handleSecondAction: () => {}
}; //TODO: Correct proptypes
// MiniCartRoomDetails.propTypes = {
//   /** className passed to the first container */
//   className: PropTypes.string,
//   /** className passed to the first container */
//   roomID: PropTypes.number.isRequired,
//   /** Room details */
//   room: PropTypes.object.isRequired,
//   /** Language selected */
//   locale: PropTypes.string.isRequired,
//   /** Currency selected */
//   currency: PropTypes.string.isRequired,
//   /** Date of check-in formatted with moment */
//   startDate: PropTypes.object.isRequired,
//   /** Date of check-out formatted with moment */
//   endDate: PropTypes.object.isRequired,
//   /** number of nights the room is being used */
//   numberOfNights: PropTypes.number.isRequired,
//   /** function called when the first action text in roomDetails is clicked */
//   handleFirstAction: PropTypes.func,
//   /** function called when the second action text in roomDetails is clicked */
//   handleSecondAction: PropTypes.func
// };

var RoomDetails = pure(MiniCartRoomDetails);

function _templateObject2$10() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 5px;\n"]);

  _templateObject2$10 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1b() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  color: ", ";\n  padding: 10px 0;\n  font-size: 17px;\n  font-weight: 700;\n  text-transform: capitalize;\n  border: 0;\n  outline: none;\n  cursor: pointer;\n  position: sticky;\n  bottom: 0;\n  min-height: auto;\n  max-width: 250px;\n"]);

  _templateObject$1b = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$G = reactIntl.defineMessages({
  total: {
    id: "checkout.total",
    description: "total",
    defaultMessage: "Total"
  }
});
var MiniCartPaymentButtonContainer = styled__default.button(_templateObject$1b(), wbGreen, white);
var SpaceContainer = styled__default.span(_templateObject2$10());

function MiniCartPaymentButton(props) {
  return /*#__PURE__*/React__default.createElement(MiniCartPaymentButtonContainer, {
    className: "".concat(props.className, " wbkv9-MiniCart-paymentButton"),
    onClick: props.handlePay
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$G.total), ": ", /*#__PURE__*/React__default.createElement(SpaceContainer, null, props.currency), /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: props.totalRate
  }));
}

MiniCartPaymentButton.defaultProps = {
  className: ""
};
MiniCartPaymentButton.propTypes = {
  /** className passed to the first container */
  className: PropTypes__default.string,

  /** total price from all the rooms */
  totalRate: PropTypes__default.number.isRequired,

  /** currency selected for the rooms */
  currency: PropTypes__default.string.isRequired,

  /** function called when the green button at the bottom is clicked */
  handlePay: PropTypes__default.func.isRequired
};
var PaymentButton = pure(MiniCartPaymentButton);

function _templateObject3$Q() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n  background-color: ", ";\n"]);

  _templateObject3$Q = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$11() {
  var data = _taggedTemplateLiteral(["\n  overflow-y: scroll;\n  display: flex;\n  flex-flow: column;\n  margin-right: -5015px;\n"]);

  _templateObject2$11 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1c() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  border: ", " solid 1px;\n  max-height: 550px;\n  overflow: hidden;\n  position: relative;\n"]);

  _templateObject$1c = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$H = reactIntl.defineMessages({
  emptyCart: {
    id: "cart.emptyCart",
    description: "text in the rigth side cart when is empty ",
    defaultMessage: "Your cart is empty"
  }
});
var MiniCartContainer = styled__default.div(_templateObject$1c(), greyLighter);
var ScrollBarContainer = styled__default.div(_templateObject2$11());
var EmptyContainer = styled__default.div(_templateObject3$Q(), greyBasic);

class MiniCart extends React__default.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "momentFormat", date => moment(date).locale(this.props.locale).format("D MMMM"));

    this.state = {
      isEmpty: this.props.rooms.length <= 0
    };
  }
  /** Used to transform dates into the corresponding language plus the format required */


  render() {
    var totalRate = 0;
    return /*#__PURE__*/React__default.createElement(MiniCartContainer, {
      className: "".concat(this.props.className, " wbkv9-MiniCart")
    }, /*#__PURE__*/React__default.createElement(ScrollBarContainer, null, !this.state.isEmpty && this.props.rooms.map((room, index) => {
      totalRate += room.totalRate;
      return /*#__PURE__*/React__default.createElement(RoomDetails, {
        key: room.id,
        roomID: index,
        room: room,
        startDate: this.momentFormat(room.startDate),
        endDate: this.momentFormat(room.endDate),
        handleFirstAction: this.props.handleFirstAction,
        handleSecondAction: this.props.handleSecondAction,
        locale: this.props.locale,
        currency: this.props.currency,
        numberOfNights: moment(Date.parse(room.endDate) - Date.parse(room.startDate)).format("D") - 1
      });
    }), this.state.isEmpty && /*#__PURE__*/React__default.createElement(EmptyContainer, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$H.emptyCart)), /*#__PURE__*/React__default.createElement(PaymentButton, {
      totalRate: Math.ceil(totalRate * 100) / 100,
      currency: this.props.currency || "",
      handlePay: !this.state.isEmpty && this.props.handlePay
    })));
  }

}

MiniCart.defaultProps = {
  className: "",
  handleFirstAction: () => {},
  handleSecondAction: () => {}
};
MiniCart.propTypes = {
  /** className passed to the first container */
  className: PropTypes__default.string,

  /** Number of rooms to be rendered */
  rooms: PropTypes__default.array.isRequired,

  /** Language selected */
  locale: PropTypes__default.string.isRequired,

  /** Currency selected */
  currency: PropTypes__default.string.isRequired,

  /** function called when the green button at the bottom is clicked */
  handlePay: PropTypes__default.func.isRequired,

  /** function called when the first action text in roomDetails is clicked */
  handleFirstAction: PropTypes__default.func,

  /** function called when the second action text in roomDetails is clicked */
  handleSecondAction: PropTypes__default.func
};
var index$b = pure(MiniCart);

var SvgEditPencil = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
})), "Adults");

var SaveIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, " ", /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), " ", /*#__PURE__*/React__default.createElement("path", {
  d: "M7 19v-6h10v6h2V7.828L16.172 5H5v14h2zM4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm5 12v4h6v-4H9z"
}), " "), "saveIcon");

function _templateObject15$7() {
  var data = _taggedTemplateLiteral(["\n  padding: 12px 8px;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 2px;\n  margin-left: 30px;\n  text-transform: uppercase;\n  background: ", ";\n  color: #ffffff;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject15$7 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$7() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n"]);

  _templateObject14$7 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$8() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 200px 400px;\n"]);

  _templateObject13$8 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$8() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 60px;\n"]);

  _templateObject12$8 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$9() {
  var data = _taggedTemplateLiteral(["\n  width: 200px;\n  margin-bottom: ", ";\n  color: ", ";\n  text-align: left;\n  margin-bottom: 15px;\n  color: #a3a3a8;\n"]);

  _templateObject11$9 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$9() {
  var data = _taggedTemplateLiteral(["\n  width: 200px;\n  margin-bottom: ", ";\n  color: ", ";\n  text-align: left;\n  margin-bottom: 15px;\n"]);

  _templateObject10$9 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$b() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  margin-bottom: 10px;\n  input {\n    width: 300px;\n  }\n  select {\n    width: 300px;\n  }\n  input,\n  select {\n    border-radius: 5px;\n    border: 1px solid #e1e1e1;\n    padding: 5px;\n  }\n"]);

  _templateObject9$b = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$e() {
  var data = _taggedTemplateLiteral(["\n  color: #a3a3a8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 230px;\n"]);

  _templateObject8$e = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$h() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject7$h = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$l() {
  var data = _taggedTemplateLiteral(["\n  font-size: 25px;\n  font-weight: bold;\n  color: #222222;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject6$l = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$w() {
  var data = _taggedTemplateLiteral(["\n  color: #908f96;\n  border: 1px solid #e4e4e4;\n  padding: 0px;\n  border-radius: 3px;\n  background-color: #e5e5e5;\n  height: 28px;\n  width: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg {\n    fill: #908f96;\n    width: 20px;\n  }\n"]);

  _templateObject5$w = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$J() {
  var data = _taggedTemplateLiteral(["\n  color: #908f96;\n  border: 1px solid #e4e4e4;\n  padding: 0px;\n  border-radius: 3px;\n  background-color: #e5e5e5;\n  height: 28px;\n  width: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg {\n    fill: #908f96;\n    width: 20px;\n  }\n"]);

  _templateObject4$J = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$R() {
  var data = _taggedTemplateLiteral(["\n  color: black;\n  font-size: 12px;\n  margin-left: 8px;\n"]);

  _templateObject3$R = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$12() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 20px;\n"]);

  _templateObject2$12 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1d() {
  var data = _taggedTemplateLiteral(["\n  width: 1300px;\n  padding: 20px;\n"]);

  _templateObject$1d = function _templateObject() {
    return data;
  };

  return data;
}
var messages$4 = reactIntl.defineMessages({
  category: {
    id: "loyalty.userForm.category",
    description: "User form field: tier",
    defaultMessage: "Categoría"
  },
  benefits: {
    id: "loyalty.accountBanner.benefits",
    description: "Pop up title",
    defaultMessage: "Ventajas"
  },
  address: {
    id: "loyalty.userForm.address",
    description: "User form field: address",
    defaultMessage: "Dirección"
  },
  birthDate: {
    id: "loyalty.userForm.birthdate",
    description: "User form field: birthDate",
    defaultMessage: "Fecha de nacimiento"
  },
  city: {
    id: "loyalty.userForm.city",
    description: "User form field: city",
    defaultMessage: "Ciudad"
  },
  country: {
    id: "loyalty.userForm.country",
    description: "User form field: country",
    defaultMessage: "País"
  },
  email: {
    id: "loyalty.userForm.email",
    description: "User form field: email",
    defaultMessage: "Email"
  },
  phone: {
    id: "loyalty.userForm.phone",
    description: "User form field: phone",
    defaultMessage: "Teléfono"
  },
  save: {
    id: "loyalty.userForm.save",
    description: "User form button: save",
    defaultMessage: "Guardar"
  },
  edit: {
    id: "loyalty.userForm.edit",
    description: "User form button: edit",
    defaultMessage: "Editar"
  },
  zipCode: {
    id: "loyalty.userForm.zipCode",
    description: "User form field: zipCode",
    defaultMessage: "Código postal"
  }
});
var Container$a = styled__default.div(_templateObject$1d());
var Header$2 = styled__default.div(_templateObject2$12());
var StyledAnchor = styled__default.a(_templateObject3$R());
var EditButton = styled__default.button(_templateObject4$J());
var SaveButton = styled__default.button(_templateObject5$w());
var NameStyled$1 = styled__default.div(_templateObject6$l());
var NameTierStyled = styled__default.div(_templateObject7$h());
var EmailStyled = styled__default.div(_templateObject8$e());
var ElementContainer$1 = styled__default.div(_templateObject9$b(), (_ref) => {
  var {
    justifyContent
  } = _ref;
  return justifyContent;
});
var LabelStyled$1 = styled__default.label(_templateObject10$9(), (_ref2) => {
  var {
    marginBottom
  } = _ref2;
  return marginBottom;
}, (_ref3) => {
  var {
    color
  } = _ref3;
  return color || "unset";
});
var LabelStyledGrey = styled__default.label(_templateObject11$9(), (_ref4) => {
  var {
    marginBottom
  } = _ref4;
  return marginBottom;
}, (_ref5) => {
  var {
    color
  } = _ref5;
  return color || "unset";
});
var ListContainer = styled__default.div(_templateObject12$8());
var LabelsContainer = styled__default.div(_templateObject13$8());
var PopupContainer$3 = styled__default.div(_templateObject14$7());

var InputLabel = (_ref6) => {
  var {
    message,
    name,
    type = "text",
    value,
    onChange,
    disabled = false
  } = _ref6;
  return /*#__PURE__*/React__default.createElement(ElementContainer$1, null, /*#__PURE__*/React__default.createElement(LabelStyled$1, {
    color: "#a3a3a8"
  }, message), /*#__PURE__*/React__default.createElement("input", {
    type: type,
    name: name,
    value: value,
    onChange: onChange,
    disabled: disabled
  }));
};

var ColoredLine = (_ref7) => {
  var {
    color
  } = _ref7;
  return /*#__PURE__*/React__default.createElement("hr", {
    style: {
      color: color,
      backgroundColor: color,
      height: 1,
      marginBottom: 36
    }
  });
};

var ButtonStyled$1 = styled__default.button(_templateObject15$7(), (_ref8) => {
  var {
    background
  } = _ref8;
  return background;
});

var DateLabel = (_ref9) => {
  var {
    message,
    name,
    value,
    onChange,
    locale
  } = _ref9;
  return /*#__PURE__*/React__default.createElement(ElementContainer$1, null, /*#__PURE__*/React__default.createElement(LabelStyled$1, {
    color: "#a3a3a8"
  }, message), /*#__PURE__*/React__default.createElement(DatePicker$1__default, {
    locale: locale,
    name: name,
    selected: value,
    onSelect: onChange,
    dateFormat: "dd/MM/yyyy"
  }));
};

function UserForm(_ref10) {
  var {
    address,
    birthDate,
    city,
    zipCode,
    countries = [],
    country,
    email,
    showForm,
    surname,
    name,
    phone,
    handleSubmit,
    tier,
    loyalty,
    handleModalContent,
    handleCloseModal,
    impersonate,
    loyaltyExternalSystemLink,
    loyaltyExternalSystemLinkLabel
  } = _ref10;

  var TiersModal = () => /*#__PURE__*/React__default.createElement(Popup, {
    headerText: intl.formatMessage(messages$4.benefits),
    closeWindow: handleCloseModal
  }, /*#__PURE__*/React__default.createElement(PopupContainer$3, null, /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.description) || ""
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (loyalty === null || loyalty === void 0 ? void 0 : loyalty.benefitDescription) || ""
    }
  })));

  var handleModal = React.useCallback(() => {
    handleModalContent( /*#__PURE__*/React__default.createElement(TiersModal, null), {
      modalWidth: "900px",
      hideCloseButton: true
    });
  }, [handleModalContent]);
  var intl = reactIntl.useIntl();
  var [isEditing, setIsEditing] = React.useState(showForm);
  var {
    locale
  } = intl; // add locale to datePicker

  var formatLocale = getLocale(locale);
  DatePicker$1.registerLocale(locale, formatLocale);
  var [form, setForm] = React.useState({
    address,
    birthDate,
    city,
    zipCode,
    country,
    email,
    surname,
    name,
    phone,
    tier
  });
  var countryObject = React.useMemo(() => countries.find(c => c.value === country) || {}, [countries, country]);
  var handleChangeForm = React.useCallback(e => {
    var {
      name,
      value
    } = e.target;
    setForm(prevState => Object.assign(Object.assign({}, prevState), {
      [name]: value || ""
    }));
  }, []);
  var handleChangeDate = React.useCallback(date => {
    setForm(prevState => Object.assign(Object.assign({}, prevState), {
      birthDate: date
    }));
  }, []);
  var handleEdit = React.useCallback(() => {
    setIsEditing(prevState => !prevState);
  }, []);
  var handleSubmitUser = React.useCallback(() => {
    handleSubmit({
      tier: form.tier,
      address: form.address,
      birthDate: form.birthDate,
      city: form.city,
      country: form.country,
      email: form.email,
      surname: form.surname,
      name: form.name,
      phone: form.phone,
      zipCode: form.zipCode
    });
  }, [form]);
  return /*#__PURE__*/React__default.createElement(Container$a, null, /*#__PURE__*/React__default.createElement(Header$2, null, /*#__PURE__*/React__default.createElement(NameTierStyled, null, /*#__PURE__*/React__default.createElement(NameStyled$1, null, name, " ", surname, " ", loyaltyExternalSystemLink ? /*#__PURE__*/React__default.createElement(StyledAnchor, {
    href: loyaltyExternalSystemLink
  }, " ", loyaltyExternalSystemLinkLabel) : null)), !impersonate && (isEditing ? /*#__PURE__*/React__default.createElement(SaveButton, {
    onClick: handleSubmitUser
  }, /*#__PURE__*/React__default.createElement(SaveIcon, null)) : /*#__PURE__*/React__default.createElement(EditButton, {
    onClick: handleEdit
  }, /*#__PURE__*/React__default.createElement(SvgEditPencil, null)))), /*#__PURE__*/React__default.createElement(ColoredLine, {
    color: "#a3a3a8"
  }), isEditing ? /*#__PURE__*/React__default.createElement(ListContainer, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(InputLabel, {
    name: "tier",
    value: form.tier.category,
    onChange: handleChangeForm,
    message: intl.formatMessage(messages$4.category),
    disabled: true
  }), /*#__PURE__*/React__default.createElement(InputLabel, {
    name: "phone",
    type: "tel",
    value: form.phone,
    onChange: handleChangeForm,
    message: intl.formatMessage(messages$4.phone)
  }), /*#__PURE__*/React__default.createElement(DateLabel, {
    name: "birthDate",
    value: form.birthDate,
    onChange: handleChangeDate,
    locale: locale,
    message: intl.formatMessage(messages$4.birthDate)
  }), /*#__PURE__*/React__default.createElement(InputLabel, {
    name: "email",
    value: form.email,
    onChange: handleChangeForm,
    message: intl.formatMessage(messages$4.email)
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ElementContainer$1, null, /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.country)), /*#__PURE__*/React__default.createElement("select", {
    name: "country",
    value: form.country,
    onChange: handleChangeForm
  }, countries.map((_ref11) => {
    var {
      label,
      value
    } = _ref11;
    return /*#__PURE__*/React__default.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), /*#__PURE__*/React__default.createElement(InputLabel, {
    name: "city",
    value: form.city,
    onChange: handleChangeForm,
    message: intl.formatMessage(messages$4.city)
  }), /*#__PURE__*/React__default.createElement(InputLabel, {
    name: "address",
    value: form.address,
    onChange: handleChangeForm,
    message: intl.formatMessage(messages$4.address)
  }), /*#__PURE__*/React__default.createElement(InputLabel, {
    name: "zipCode",
    value: form.zipCode,
    onChange: handleChangeForm,
    message: intl.formatMessage(messages$4.zipCode)
  }))) : /*#__PURE__*/React__default.createElement(ListContainer, null, /*#__PURE__*/React__default.createElement(LabelsContainer, {
    marginRight: "50px"
  }, /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.category)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, tier.category), /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.phone)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, phone), /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.birthDate)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, birthDate && dateFns.format(birthDate, "dd/MM/yyyy")), /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.email)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, email)), /*#__PURE__*/React__default.createElement(LabelsContainer, null, /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.country)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, countryObject === null || countryObject === void 0 ? void 0 : countryObject.label), /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.city)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, city), /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.address)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, address), /*#__PURE__*/React__default.createElement(LabelStyledGrey, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$4.zipCode)), /*#__PURE__*/React__default.createElement(LabelStyled$1, null, zipCode))));
}

function _templateObject$1e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject$1e = function _templateObject() {
    return data;
  };

  return data;
}
var ContainerFirstContent = styled__default.div(_templateObject$1e());
function LoyaltyMyAccount(_ref) {
  var {
    countries = [],
    user,
    tier,
    loyalty,
    handleSubmit,
    handleModalContent,
    handleCloseModal,
    impersonate,
    loyaltyExternalSystemLink,
    loyaltyExternalSystemLinkLabel
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ContainerFirstContent, null, /*#__PURE__*/React__default.createElement(UserForm, _extends({}, user, {
    impersonate: impersonate,
    tier: tier,
    loyalty: loyalty,
    countries: countries,
    handleModalContent: handleModalContent,
    handleCloseModal: handleCloseModal,
    handleSubmit: handleSubmit,
    loyaltyExternalSystemLink: loyaltyExternalSystemLink,
    loyaltyExternalSystemLinkLabel: loyaltyExternalSystemLinkLabel
  }))));
}

function _templateObject4$K() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px;\n  text-align: left;\n  font-size: 14px;\n  border-bottom: 1px solid #e4e4e4;\n  color: ", ";\n"]);

  _templateObject4$K = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$S() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 3px;\n  color: #bebdc1;\n  font-size: 12px;\n  th {\n    background-color: #f6f6f6;\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #e1e1e1;\n  }\n"]);

  _templateObject3$S = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$13() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #e1e1e1;\n  border-bottom: 0;\n  width: 100%;\n"]);

  _templateObject2$13 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1f() {
  var data = _taggedTemplateLiteral(["\n  h2 {\n    text-align: left;\n    margin-bottom: 22px;\n    font-size: 26px;\n  }\n"]);

  _templateObject$1f = function _templateObject() {
    return data;
  };

  return data;
}
var messages$5 = reactIntl.defineMessages({
  title: {
    id: "loyalty.transactionsList.title",
    description: "Transactions list title",
    defaultMessage: "Mis reservas"
  },
  establishment: {
    id: "loyalty.transactionsList.establishment",
    description: "Transactions list field: establishment",
    defaultMessage: "Establecimiento"
  },
  reservation: {
    id: "loyalty.transactionsList.reservation",
    description: "Transactions list field: reservation",
    defaultMessage: "Reserva"
  },
  bookingDate: {
    id: "loyalty.transactionsList.bookingDate",
    description: "Transactions list field: bookingDate",
    defaultMessage: "Fecha reserva"
  },
  checkin: {
    id: "loyalty.transactionsList.checkin",
    description: "Transactions list field: checkin",
    defaultMessage: "Entrada"
  },
  checkout: {
    id: "loyalty.transactionsList.checkout",
    description: "Transactions list field: checkout",
    defaultMessage: "Salida"
  },
  nights: {
    id: "loyalty.transactionsList.nights",
    description: "Transactions list field: nights",
    defaultMessage: "Noches"
  },
  guests: {
    id: "loyalty.transactionsList.guests",
    description: "Transactions list field: guests",
    defaultMessage: "Huéspedes"
  },
  room: {
    id: "loyalty.transactionsList.room",
    description: "Transactions list field: room",
    defaultMessage: "Habitación"
  },
  price: {
    id: "loyalty.transactionsList.price",
    description: "Transactions list field: price",
    defaultMessage: "Precio"
  },
  people: {
    id: "loyalty.transactionsList.people",
    description: "Transactions list field: people",
    defaultMessage: "personas"
  },
  manage: {
    id: "loyalty.transactionsList.manage",
    description: "Transactions list field: manage",
    defaultMessage: "Gestionar"
  }
});
var Container$b = styled__default.div(_templateObject$1f());
var TableStyled = styled__default.table(_templateObject2$13());
var Header$3 = styled__default.tr(_templateObject3$S());
var DataCell = styled__default.td(_templateObject4$K(), props => props.status === "CANCELLED" ? "#ababb0" : "#656565");

function formatDate(date) {
  var dt = new Date(date);
  var dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  return dateFns.format(dtDateOnly, "dd/MM/yyyy");
}

function getNights(checkin, checkout) {
  return dateFns.differenceInDays(new Date(checkout), new Date(checkin));
}

function TransactionsList(_ref) {
  var {
    transactions
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$b, null, /*#__PURE__*/React__default.createElement("h2", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.title)), /*#__PURE__*/React__default.createElement(TableStyled, {
    cellSpacing: "0",
    cellPadding: "0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement(Header$3, null, /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.establishment)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.reservation)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.bookingDate)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.checkin)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.checkout)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.nights)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.guests)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.room)), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.price)), /*#__PURE__*/React__default.createElement("th", null))), /*#__PURE__*/React__default.createElement("tbody", null, transactions.map((transaction, index) => {
    var {
      amount,
      propertyName,
      reservationId,
      createdAt,
      checkin,
      checkout,
      numGuests,
      descriptionRoom,
      link,
      status
    } = transaction;
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "row-".concat(index)
    }, /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, propertyName), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, reservationId), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, formatDate(createdAt)), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, formatDate(checkin)), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, formatDate(checkout)), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, getNights(checkin, checkout)), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, numGuests, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$5.people)), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, descriptionRoom), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, amount.currency, " ", amount.amount), /*#__PURE__*/React__default.createElement(DataCell, {
      status: status
    }, link));
  }))));
}

function _templateObject3$T() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 10px;\n"]);

  _templateObject3$T = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$14() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"]);

  _templateObject2$14 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1g() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject$1g = function _templateObject() {
    return data;
  };

  return data;
}
var ContainerFirstContent$1 = styled__default.div(_templateObject$1g());
var ContainerSecondContent = styled__default.div(_templateObject2$14());
var ContainerAssociatedTier = styled__default.div(_templateObject3$T());
function LoyaltyMyReservations(_ref) {
  var {
    transactions
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ContainerSecondContent, null, /*#__PURE__*/React__default.createElement(TransactionsList, {
    transactions: transactions
  })));
}

function _templateObject14$8() {
  var data = _taggedTemplateLiteral(["\n display: block;\n  "]);

  _templateObject14$8 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$9() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  display: none;\n  ", ";\n"]);

  _templateObject13$9 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$9() {
  var data = _taggedTemplateLiteral(["\n display: block;\n  "]);

  _templateObject12$9 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$a() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 400;\n  display: none;\n  ", ";\n"]);

  _templateObject11$a = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$a() {
  var data = _taggedTemplateLiteral(["\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n  "]);

  _templateObject10$a = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$c() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject9$c = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$f() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n"]);

  _templateObject8$f = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$i() {
  var data = _taggedTemplateLiteral(["\n    border: 1.3px solid ", ";\n    border-radius: 7px;\n    background-color: #ffffff;\n    padding: 10px 0;\n    margin: 5px;\n    outline: 0;\n    cursor: pointer;\n    font-weight: 700;\n    text-decoration: none;\n  "]);

  _templateObject7$i = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$m() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  background-color: white;\n  color: ", ";\n  font-size: 13px;\n  text-decoration: underline;\n  outline: 0;\n  ", ";\n  :hover {\n    border-color: #555;\n    color: #555;\n  }\n"]);

  _templateObject6$m = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$x() {
  var data = _taggedTemplateLiteral(["\n  border: 1.3px solid ", ";\n  color: ", ";\n  border-radius: 7px;\n  background-color: #ffffff;\n  padding: 10px 20px;\n  margin: 5px;\n  outline: 0;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n    color: white;\n    .wbkv9-subtitleText {\n      color: white;\n    }\n  }\n"]);

  _templateObject5$x = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$L() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 0;\n  "]);

  _templateObject4$L = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$U() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 20px;\n  ", ";\n"]);

  _templateObject3$U = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$15() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n"]);

  _templateObject2$15 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1h() {
  var data = _taggedTemplateLiteral(["\n  font-family: \"Open Sans\";\n  width: 100%;\n"]);

  _templateObject$1h = function _templateObject() {
    return data;
  };

  return data;
}
var colors = {
  green: "#329911",
  grey: "#908f96"
};
var ModificationButtonBarComponent = styled__default.div(_templateObject$1h());
var DivFlex = styled__default.div(_templateObject2$15());
var DivFlexCancel = styled__default.div(_templateObject3$U(), media.up.md(_templateObject4$L()));
var Button$3 = styled__default.button(_templateObject5$x(), colors.green, colors.green, colors.green);
var GreyButton$1 = styled__default.button(_templateObject6$m(), colors.grey, media.up.md(_templateObject7$i(), props => props.colorBorder));
var Text$2 = styled__default.div(_templateObject8$f());
var CancelText = styled__default.div(_templateObject9$c(), media.up.md(_templateObject10$a()));
var Subtitle = styled__default.div(_templateObject11$a(), props => props.subtitleText, media.up.md(_templateObject12$9()));
var CancelSubtitle = styled__default.div(_templateObject13$9(), media.up.md(_templateObject14$8()));
var msgs$I = reactIntl.defineMessages({
  changeDates: {
    id: "bookingModification.changeDates.button",
    description: "Change Dates text",
    defaultMessage: "Change Dates"
  },
  modifyAcomodation: {
    id: "bookingModification.modAccommodation.button",
    description: "Modify Acomodation Text",
    defaultMessage: "Modify Acomodation"
  },
  editExtras: {
    id: "bookingModification.editExtras.button",
    description: "Edit Extras Text",
    defaultMessage: "Edit Extras"
  },
  cancelBooking: {
    id: "bookingModification.cancel.button",
    description: "Cancel Booking Text",
    defaultMessage: "Cancel Booking"
  },
  until: {
    id: "bookingModification.until.button",
    description: "until date",
    defaultMessage: "Until"
  }
});

function ModificationButtonBar(props) {
  /** This data is used to create the buttons, because it uses props needs to be inside the function */
  var buttonsContent = [{
    text: msgs$I.changeDates,
    functionOnClick: props.datesFunction,
    buttonClass: "wbkv9-ChangeDates",
    untilText: msgs$I.until,
    untilDate: props.untilDateDates,
    colorBorder: colors.green,
    colorText: colors.green,
    subtitleText: colors.grey,
    isModifiable: props.areReservationDatesModifiable
  }, {
    text: msgs$I.modifyAcomodation,
    functionOnClick: props.modifyFunction,
    buttonClass: "wbkv9-ModifyAcomodation",
    untilText: msgs$I.until,
    untilDate: props.untilDateModify,
    colorBorder: colors.green,
    colorText: colors.green,
    subtitleText: colors.grey,
    isModifiable: props.isReservationAccommodationModifiable
  }, {
    text: msgs$I.editExtras,
    functionOnClick: props.extrasFunction,
    buttonClass: "wbkv9-EditExtras",
    untilText: msgs$I.until,
    untilDate: props.untilDateExtras,
    colorBorder: colors.green,
    colorText: colors.green,
    subtitleText: colors.grey,
    isModifiable: props.areReservationExtrasModifiable
  }];
  var cancelButton = {
    text: msgs$I.cancelBooking,
    functionOnClick: props.cancelFunction,
    buttonClass: "wbkv9-CancelBooking",
    untilText: msgs$I.until,
    untilDate: props.untilDateCancel,
    colorBorder: colors.grey,
    colorText: colors.grey,
    subtitleText: colors.grey,
    isModifiable: props.isCancelActive
  };
  return /*#__PURE__*/React__default.createElement(ModificationButtonBarComponent, {
    className: classnames("wbkv9-ModificationButtonBar", props.className)
  }, /*#__PURE__*/React__default.createElement(DivFlex, null, buttonsContent.map((value, idx) => value.isModifiable && /*#__PURE__*/React__default.createElement(Button$3, {
    key: idx,
    className: value.buttonClass,
    onClick: () => {
      value.functionOnClick();
    },
    colorBorder: value.colorBorder
  }, /*#__PURE__*/React__default.createElement(Text$2, {
    colorText: value.colorText
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, value.text)), /*#__PURE__*/React__default.createElement(Subtitle, {
    className: "wbkv9-subtitleText",
    subtitleText: value.subtitleText
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, value.untilText)), " ", /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    value: value.untilDate
  }))))), /*#__PURE__*/React__default.createElement(DivFlexCancel, null, cancelButton.isModifiable && /*#__PURE__*/React__default.createElement(GreyButton$1, {
    className: cancelButton.buttonClass,
    onClick: () => {
      cancelButton.functionOnClick();
    },
    colorBorder: cancelButton.colorBorder
  }, /*#__PURE__*/React__default.createElement(CancelText, {
    colorText: cancelButton.colorText
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, cancelButton.text)), /*#__PURE__*/React__default.createElement(CancelSubtitle, {
    subtitleText: cancelButton.subtitleText
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, cancelButton.untilText)), " ", /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    value: cancelButton.untilDate
  })))))));
}

ModificationButtonBar.defaultProps = {
  datesFunction: () => null,
  modifyFunction: () => null,
  extrasFunction: () => null,
  cancelFunction: () => null,
  previousFunction: () => null,
  untilDateDates: null,
  untilDateModify: null,
  untilDateExtras: null,
  untilDateCancel: null,
  areReservationDatesModifiable: false,
  isReservationAccommodationModifiable: false,
  areReservationExtrasModifiable: false,
  isCancelActive: false,
  className: ""
};
ModificationButtonBar.propTypes = {
  /** functions that will active clicking the corresponding button */
  datesFunction: PropTypes__default.func,
  modifyFunction: PropTypes__default.func,
  extrasFunction: PropTypes__default.func,
  cancelFunction: PropTypes__default.func,
  previousFunction: PropTypes__default.func,

  /** Dates until the button will appear */
  untilDateDates: PropTypes__default.number,
  untilDateModify: PropTypes__default.number,
  untilDateExtras: PropTypes__default.number,
  untilDateCancel: PropTypes__default.number,

  /** the buttons renders in case they are modifiable and cancel active */
  areReservationDatesModifiable: PropTypes__default.bool,
  isReservationAccommodationModifiable: PropTypes__default.bool,
  areReservationExtrasModifiable: PropTypes__default.bool,
  isCancelActive: PropTypes__default.bool,
  className: PropTypes__default.string
};
var index$c = pure(ModificationButtonBar);

var CheckCircle = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), "CheckCircle");

function _templateObject11$b() {
  var data = _taggedTemplateLiteral(["\n  display:block;\n  "]);

  _templateObject11$b = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$b() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", ";\n"]);

  _templateObject10$b = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$d() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  "]);

  _templateObject9$d = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$g() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 700;\n  text-align: left;\n  margin-bottom: 10px;\n  ", ";\n"]);

  _templateObject8$g = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$j() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n"]);

  _templateObject7$j = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$n() {
  var data = _taggedTemplateLiteral(["\n  height: 15px;\n  width: 15px;\n  fill: #329911;\n"]);

  _templateObject6$n = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$y() {
  var data = _taggedTemplateLiteral(["\n  color: #908f96;\n  text-decoration: underline;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject5$y = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$M() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n"]);

  _templateObject4$M = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$V() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: left;\n"]);

  _templateObject3$V = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$16() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n"]);

  _templateObject2$16 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1i() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n"]);

  _templateObject$1i = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$J = reactIntl.defineMessages({
  ref: {
    id: "reservation_confirmed.reservation_detail.reference",
    description: "Ref.",
    defaultMessage: "Ref."
  },
  reservation: {
    id: "reservation_confirmed.reservation_detail.reservationNumber",
    description: "Reservation",
    defaultMessage: "Reservation"
  },
  checkIn: {
    id: "reservation_confirmed.reservation_information.arriveAt",
    description: "Arrival",
    defaultMessage: "Arrival"
  },
  checkOut: {
    id: "reservation_confirmed.reservation_information.leaveAt",
    description: "Departure",
    defaultMessage: "Departure"
  },
  guests: {
    id: "reservation_confirmed.reservation_information.numGuests",
    description: "Guests",
    defaultMessage: "Guests"
  },
  roomType: {
    id: "bookingModification.roomType",
    description: "Room Type",
    defaultMessage: "Room Type"
  },
  conditions: {
    id: "reservation_confirmed.reservation_information.seeConditions",
    description: "Conditions",
    defaultMessage: "Conditions"
  }
});
var StyledModifyReservationChangesSummary = styled__default.div(_templateObject$1i());
var ModifyReservationChangesSummaryDetails = styled__default.div(_templateObject2$16());
var ReservationField = styled__default.div(_templateObject3$V(), props => props.changed ? "#329911" : "#222222");
var Bold$1 = styled__default.span(_templateObject4$M());
var Conditions$2 = styled__default.span(_templateObject5$y());
var StyledCheckCircle = styled__default(CheckCircle)(_templateObject6$n());
var CancellationMessageConditions = styled__default.div(_templateObject7$j());
var MobileHeader$1 = styled__default.div(_templateObject8$g(), media.up.sml(_templateObject9$d()));
var ReservationFieldRoomType = styled__default(ReservationField)(_templateObject10$b(), media.up.sml(_templateObject11$b()));

function ModifyReservationChangesSummary(_ref) {
  var {
    reservation,
    reservationRef,
    checkIn,
    checkInChanged,
    checkOut,
    checkOutChanged,
    guests,
    guestsChanged,
    roomType,
    roomTypeChanged,
    mealPlan,
    conditionName,
    handleConditions,
    cancelRelease,
    accommodationQuantity,
    restrictions,
    cutOffDate
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledModifyReservationChangesSummary, null, /*#__PURE__*/React__default.createElement(MobileHeader$1, null, " ", accommodationQuantity, " ", roomType), /*#__PURE__*/React__default.createElement(ModifyReservationChangesSummaryDetails, null, /*#__PURE__*/React__default.createElement(ReservationField, null, /*#__PURE__*/React__default.createElement(Bold$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.reservation)), ": ", reservation), /*#__PURE__*/React__default.createElement(ReservationField, null, /*#__PURE__*/React__default.createElement(Bold$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.ref)), ": ", reservationRef), /*#__PURE__*/React__default.createElement(ReservationField, {
    changed: checkInChanged
  }, checkInChanged && /*#__PURE__*/React__default.createElement(StyledCheckCircle, null), /*#__PURE__*/React__default.createElement(Bold$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.checkIn)), ": ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
    value: checkIn
  })), /*#__PURE__*/React__default.createElement(ReservationField, {
    changed: checkOutChanged
  }, checkOutChanged && /*#__PURE__*/React__default.createElement(StyledCheckCircle, null), /*#__PURE__*/React__default.createElement(Bold$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.checkOut)), ": ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
    value: checkOut
  })), /*#__PURE__*/React__default.createElement(ReservationField, {
    changed: guestsChanged
  }, guestsChanged && /*#__PURE__*/React__default.createElement(StyledCheckCircle, null), /*#__PURE__*/React__default.createElement(Bold$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.guests)), ": ", guests), /*#__PURE__*/React__default.createElement(ReservationFieldRoomType, {
    changed: roomTypeChanged
  }, roomTypeChanged && /*#__PURE__*/React__default.createElement(StyledCheckCircle, null), /*#__PURE__*/React__default.createElement(Bold$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.roomType)), ": ", roomType), /*#__PURE__*/React__default.createElement(ReservationFieldRoomType, null, mealPlan, ", ", conditionName), /*#__PURE__*/React__default.createElement(CancellationMessageConditions, null, /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement(CancellationMessage$1, {
    cancellationRelease: cancelRelease,
    restrictions: restrictions,
    includeIcon: false,
    cutOffDate: cutOffDate
  }), " - "), /*#__PURE__*/React__default.createElement(Conditions$2, {
    onClick: handleConditions
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$J.conditions)))));
}

ModifyReservationChangesSummary.propTypes = {
  cancelRelease: PropTypes__default.number.isRequired,
  restrictions: PropTypes__default.array.isRequired,
  reservation: PropTypes__default.string.isRequired,
  reservationRef: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.PropTypes.instanceOf(Date).isRequired,
  checkInChanged: PropTypes__default.bool.isRequired,
  checkOut: PropTypes__default.PropTypes.instanceOf(Date).isRequired,
  checkOutChanged: PropTypes__default.bool.isRequired,
  guests: PropTypes__default.number.isRequired,
  guestsChanged: PropTypes__default.bool.isRequired,
  roomType: PropTypes__default.string.isRequired,
  roomTypeChanged: PropTypes__default.bool.isRequired,
  mealPlan: PropTypes__default.string.isRequired,
  conditionName: PropTypes__default.string.isRequired,
  handleConditions: PropTypes__default.func.isRequired,
  accommodationQuantity: PropTypes__default.number.isRequired,
  cutOffDate: PropTypes__default.instanceOf(Date).isRequired
};
var index$d = pure(ModifyReservationChangesSummary);

function _templateObject3$W() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  border: 1px solid #908f96;\n  background-color: #ffffff;\n  color: #908f96;\n  text-transform: uppercase;\n  padding: 10px 25px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject3$W = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$17() {
  var data = _taggedTemplateLiteral(["\n  color: #329911;\n  background-color: #ecf4e8;\n  margin-bottom: 25px;\n  padding: 15px;\n"]);

  _templateObject2$17 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1j() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 14px;\n\n  & > * {\n    border-radius: 5px;\n    font-weight: 700;\n  }\n"]);

  _templateObject$1j = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$K = reactIntl.defineMessages({
  greatSuccess: {
    id: "bookingModification.modal.confirm_success",
    description: "Booking modified correctly!",
    defaultMessage: "Booking modified correctly!"
  },
  close: {
    id: "bookingModification.modal.close",
    description: "Close",
    defaultMessage: "Close"
  }
});
var StyledModifyReservationSuccess = styled__default.div(_templateObject$1j());
var Message = styled__default.div(_templateObject2$17());
var Button$4 = styled__default.div(_templateObject3$W());

function ModifyReservationSuccess(_ref) {
  var {
    className,
    closeWindow
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledModifyReservationSuccess, {
    className: className
  }, /*#__PURE__*/React__default.createElement(Message, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$K.greatSuccess)), /*#__PURE__*/React__default.createElement(Button$4, {
    onClick: closeWindow
  }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$K.close)));
}

ModifyReservationSuccess.propTypes = {
  className: PropTypes__default.string,
  closeWindow: PropTypes__default.func.isRequired
};
ModifyReservationSuccess.defaultProps = {
  className: ""
};
var ModifyReservationSuccess$1 = pure(ModifyReservationSuccess);

function _templateObject7$k() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  margin-left: 10px;\n  text-transform: uppercase;\n"]);

  _templateObject7$k = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$o() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: bold;\n  cursor: pointer;\n  padding: 10px 20px;\n  border-radius: 5px;\n"]);

  _templateObject6$o = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$z() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 14px;\n"]);

  _templateObject5$z = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$N() {
  var data = _taggedTemplateLiteral(["\n  .wbkv9-AgeSelector-textAgesContainer {\n    text-align: left;\n    margin-left: 5px;\n  }\n  .wbkv9-AgeSelector-ageSelectorsContainer {\n    display: flex;\n    justify-content: left;\n  }\n"]);

  _templateObject4$N = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$X() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n"]);

  _templateObject3$X = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$18() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n"]);

  _templateObject2$18 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1k() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n"]);

  _templateObject$1k = function _templateObject() {
    return data;
  };

  return data;
}
var Container$c = styled__default.div(_templateObject$1k());
var FirstRowContainer = styled__default.div(_templateObject2$18());
var OccupantForm$1 = styled__default.div(_templateObject3$X());
var OccupantSelectorContainer = styled__default.div(_templateObject4$N());
var Title$4 = styled__default.div(_templateObject5$z());
var msgs$L = reactIntl.defineMessages({
  chooseRate: {
    id: "bookingModification.modalAccommodation.chooseAnother",
    description: "Room Selection Title",
    defaultMessage: "Choose another accommodation available"
  },
  updateRooms: {
    id: "bookingModification.modalAccommodation.apply",
    description: "updateRooms",
    defaultMessage: "APPLY"
  }
});
var StyledButton$3 = styled__default.div(_templateObject6$o());
var ApplyButton = styled__default(StyledButton$3)(_templateObject7$k(), wbGreen, white);

function RoomSelection(_ref) {
  var {
    className,
    occupantSelector,
    onSubmit,
    rooms
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$c, {
    className: "wbkv9-Modification-RoomSelection ".concat(className)
  }, /*#__PURE__*/React__default.createElement(FirstRowContainer, null, /*#__PURE__*/React__default.createElement(Title$4, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$L.chooseRate)), /*#__PURE__*/React__default.createElement(OccupantForm$1, null, /*#__PURE__*/React__default.createElement(OccupantSelectorContainer, null, occupantSelector)), /*#__PURE__*/React__default.createElement(ApplyButton, {
    onClick: onSubmit
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$L.updateRooms))), rooms);
}

RoomSelection.propTypes = {
  className: PropTypes__default.string,
  occupantSelector: PropTypes__default.node.isRequired,
  onSubmit: PropTypes__default.func.isRequired,
  rooms: PropTypes__default.node.isRequired
};
RoomSelection.defaultProps = {
  className: ""
};

function _templateObject5$A() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5$A = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$O() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  color: #908f96;\n  cursor: pointer;\n"]);

  _templateObject4$O = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$Y() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  flex: 1 1 100%;\n  text-align: center;\n"]);

  _templateObject3$Y = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$19() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n"]);

  _templateObject2$19 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1l() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n"]);

  _templateObject$1l = function _templateObject() {
    return data;
  };

  return data;
}
var Container$d = styled__default.div(_templateObject$1l());
var FirstRowContainer$1 = styled__default.div(_templateObject2$19());
var Title$5 = styled__default.div(_templateObject3$Y());
var ArrowBack$1 = styled__default(ArrowBackIcon)(_templateObject4$O());
var BackButton = styled__default.div(_templateObject5$A());
var msgs$M = reactIntl.defineMessages({
  chooseRate: {
    id: "bookingModification.modalAccommodation.chooseRate",
    description: "Rate Selection Title",
    defaultMessage: "Choose Rate"
  }
});

function RateSelection(_ref) {
  var {
    className,
    onBack,
    inventories
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$d, {
    className: "wbkv9-Modification-RateSelection ".concat(className)
  }, /*#__PURE__*/React__default.createElement(FirstRowContainer$1, null, /*#__PURE__*/React__default.createElement(BackButton, {
    onClick: onBack
  }, /*#__PURE__*/React__default.createElement(ArrowBack$1, null)), /*#__PURE__*/React__default.createElement(Title$5, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$M.chooseRate))), inventories);
}

RateSelection.propTypes = {
  className: PropTypes__default.string,
  onBack: PropTypes__default.func.isRequired,
  inventories: PropTypes__default.node.isRequired
};
RateSelection.defaultProps = {
  className: ""
};

function Step(_ref) {
  var {
    render,
    matchStep,
    step
  } = _ref;

  if (step !== matchStep) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", null, render());
}

Step.propTypes = {
  step: PropTypes__default.string,
  matchStep: PropTypes__default.string.isRequired,
  render: PropTypes__default.func.isRequired
};
Step.defaultProps = {
  step: undefined
};
var Step$1 = recompose.pure(Step);

function _templateObject$1m() {
  var data = _taggedTemplateLiteral(["\n  min-height: 500px;\n"]);

  _templateObject$1m = function _templateObject() {
    return data;
  };

  return data;
}
var LoaderWrapper = styled__default.div(_templateObject$1m());
var msgs$N = reactIntl.defineMessages({
  confirmNewBooking: {
    id: "bookingModification.modal.confirm_newBooking",
    description: "Dates available",
    defaultMessage: "You're about to change your booking"
  }
});

function dateToString(date) {
  return moment$1(date).format("YYYY-MM-DD");
}

var OCCUPANTS_TYPE = {
  SENIOR: "SENIOR",
  ADULT: "ADULT",
  TEENAGER: "TEENAGER",
  CHILDREN: "CHILD",
  BABY: "BABY",
  CHILDREN_COUNT: "childrenCount"
};
var STEPS = {
  ROOM_SELECTION: "room-selection",
  RATE_SELECTION: "rate-selection",
  CONFIRM: "confirm",
  SUCCESS: "success"
};

function getOccupantValue(_ref) {
  var {
    occupantType,
    occupantValues
  } = _ref;

  switch (occupantType) {
    case OCCUPANTS_TYPE.SENIOR:
      return occupantValues.seniors;

    case OCCUPANTS_TYPE.ADULT:
      return occupantValues.adults;

    case OCCUPANTS_TYPE.TEENAGER:
      return occupantValues.teenagers;

    case OCCUPANTS_TYPE.CHILDREN:
      return occupantValues.children;

    case OCCUPANTS_TYPE.BABY:
      return occupantValues.babies;

    case OCCUPANTS_TYPE.CHILDREN_COUNT:
      return occupantValues.childrenCount;

    default:
      return 0;
  }
}

class Wizard extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleChangeOccupants", (_ref2) => {
      var {
        value,
        occupantType
      } = _ref2;

      switch (occupantType) {
        case OCCUPANTS_TYPE.SENIOR:
          return this.setState({
            seniors: value
          });

        case OCCUPANTS_TYPE.ADULT:
          return this.setState({
            adults: value
          });

        case OCCUPANTS_TYPE.TEENAGER:
          return this.setState({
            teenagers: value
          });

        case OCCUPANTS_TYPE.CHILDREN:
          return this.setState({
            children: value
          });

        case OCCUPANTS_TYPE.BABY:
          return this.setState({
            babies: value
          });

        default:
          return 0;
      }
    });

    _defineProperty(this, "handleChildrenCount", (_ref3) => {
      var {
        childrenCount,
        guestAges
      } = _ref3;
      this.setState({
        childrenCount,
        guestAges
      });
    });

    _defineProperty(this, "handleUpdateRooms", () => {
      this.props.updateRooms({
        seniors: this.state.seniors,
        adults: this.state.adults,
        teenagers: this.state.teenagers,
        children: this.state.children,
        babies: this.state.babies,
        childrenCount: this.state.childrenCount,
        guestAges: this.state.guestAges
      });
    });

    _defineProperty(this, "handleConfirmModification", () => {
      this.props.onConfirmModification();
    });

    this.state = {
      seniors: props.seniors,
      adults: props.adults,
      teenagers: props.teenagers,
      children: props.kids,
      babies: props.babies,
      childrenCount: props.childrenCount,
      guestAges: props.guestAges
    };
  }

  render() {
    var {
      className,
      loading,
      onCancel,
      isModificationSuccess
    } = this.props; // if ever should we need more precision from the component in order to handle room selection or inventory selection
    // we could use the cloneElement strategy

    var occupantFields = this.props.occupantFields.reduce((accumulator, it) => _objectSpread2({}, accumulator, {
      [it.name]: _objectSpread2({}, it, {
        value: getOccupantValue({
          occupantType: it.name,
          occupantValues: {
            seniors: this.state.seniors,
            adults: this.state.adults,
            teenagers: this.state.teenagers,
            children: this.state.children,
            babies: this.state.babies,
            childrenCount: this.state.childrenCount
          }
        }),
        onChange: event => this.handleChangeOccupants({
          value: event.target.value,
          occupantType: it.name
        })
      })
    }), {});
    var childrenCountFields = occupantFields.childrenCount && {
      initialChildrenCount: this.state.childrenCount,
      initialGuestAges: this.state.guestAges,
      onChange: this.handleChildrenCount
    } || {};
    var occupantSelector = React__default.cloneElement(this.props.occupantSelector, _objectSpread2({
      fields: occupantFields
    }, childrenCountFields));
    var hasError = !isModificationValid({
      currentAmount: this.props.currentAmount,
      newAmount: this.props.newAmount,
      accommodationModificationRestrictionType: this.props.accommodationModificationRestrictionType
    });
    return /*#__PURE__*/React__default.createElement("div", {
      className: "wbkv9-ModifyReservationWizardAccommodation ".concat(className)
    }, loading && /*#__PURE__*/React__default.createElement(LoaderWrapper, null, /*#__PURE__*/React__default.createElement(Loader, null)), !loading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS.ROOM_SELECTION,
      render: () => /*#__PURE__*/React__default.createElement(RoomSelection, {
        occupantSelector: occupantSelector,
        onSubmit: this.handleUpdateRooms,
        rooms: this.props.rooms
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS.RATE_SELECTION,
      render: () => /*#__PURE__*/React__default.createElement(RateSelection, {
        inventories: this.props.inventories,
        onBack: this.props.goBack
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS.CONFIRM,
      render: () => /*#__PURE__*/React__default.createElement(ConfirmModification, {
        title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$N.confirmNewBooking),
        oldRoom: this.props.currentInventoryName,
        newRoom: this.props.newInventoryName,
        oldCheckIn: dateToString(this.props.checkIn),
        newCheckIn: dateToString(this.props.checkIn),
        oldCheckOut: dateToString(this.props.checkOut),
        newCheckOut: dateToString(this.props.checkOut),
        oldAmount: this.props.currentAmount,
        newAmount: this.props.newAmount,
        currency: this.props.currency,
        minimumAmount: this.props.currentAmount,
        error: hasError,
        handleCancel: this.props.onCancel,
        handleConfirm: this.handleConfirmModification,
        reset: this.props.goBack,
        isModificationSuccess: isModificationSuccess,
        oldExtras: this.props.oldExtras,
        newExtras: this.props.newExtras
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS.SUCCESS,
      render: () => /*#__PURE__*/React__default.createElement(ModifyReservationSuccess$1, {
        closeWindow: onCancel
      })
    })));
  }

}

Wizard.propTypes = {
  className: PropTypes__default.string,
  onCancel: PropTypes__default.func.isRequired,
  onConfirmModification: PropTypes__default.func.isRequired,
  updateRooms: PropTypes__default.func.isRequired,
  loading: PropTypes__default.bool.isRequired,
  rooms: PropTypes__default.node,
  inventories: PropTypes__default.node,
  seniors: PropTypes__default.number.isRequired,
  adults: PropTypes__default.number.isRequired,
  teenagers: PropTypes__default.number.isRequired,
  kids: PropTypes__default.number.isRequired,
  babies: PropTypes__default.number.isRequired,
  occupantFields: PropTypes__default.arrayOf(PropTypes__default.shape({
    name: PropTypes__default.string,
    value: PropTypes__default.number,
    onChange: PropTypes__default.func
  })).isRequired,
  occupantSelector: PropTypes__default.node.isRequired,
  checkIn: PropTypes__default.instanceOf(Date).isRequired,
  checkOut: PropTypes__default.instanceOf(Date).isRequired,
  currentAmount: PropTypes__default.number.isRequired,
  newAmount: PropTypes__default.number,
  currentInventoryName: PropTypes__default.string.isRequired,
  newInventoryName: PropTypes__default.string,
  accommodationModificationRestrictionType: PropTypes__default.oneOf([constants.restrictions.AMOUNT_GTE, constants.restrictions.NO_RESTRICTION]).isRequired,
  step: PropTypes__default.oneOf([STEPS.ROOM_SELECTION, STEPS.RATE_SELECTION, STEPS.CONFIRM, STEPS.SUCCESS]).isRequired,
  currency: PropTypes__default.string.isRequired,
  goBack: PropTypes__default.func.isRequired,
  isModificationSuccess: PropTypes__default.bool,
  oldExtras: PropTypes__default.string,
  newExtras: PropTypes__default.string
};
Wizard.defaultProps = {
  className: "",
  newAmount: undefined,
  newInventoryName: undefined,
  rooms: /*#__PURE__*/React__default.createElement("div", null, "Rooms"),
  inventories: /*#__PURE__*/React__default.createElement("div", null, "Inventories"),
  isModificationSuccess: undefined,
  oldExtras: undefined,
  newExtras: undefined
};

function _templateObject3$Z() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject3$Z = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1a() {
  var data = _taggedTemplateLiteral(["\n    max-height: 600px;\n  "]);

  _templateObject2$1a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1n() {
  var data = _taggedTemplateLiteral(["\n  padding: 25px;\n  height: calc(100vh - 56px);\n  overflow: auto;\n  ", ";\n"]);

  _templateObject$1n = function _templateObject() {
    return data;
  };

  return data;
}
var StyledWizard = styled__default(Wizard)(_templateObject$1n(), media.up.mdl(_templateObject2$1a()));
var StyledPopup = styled__default(Popup)(_templateObject3$Z());
var msgs$O = reactIntl.defineMessages({
  changeAccommodation: {
    id: "bookingModification.modAccommodation.button",
    description: "Modify accommodation",
    defaultMessage: "Modify accommodation"
  }
});

function ModifyReservationWizardAccommodationPopup(props) {
  var {
    className,
    onClose,
    onCancel,
    onConfirmModification,
    updateRooms,
    loading,
    rooms,
    inventories,
    seniors,
    adults,
    teenagers,
    kids,
    babies,
    childrenCount,
    guestAges,
    occupantSelector,
    checkIn,
    checkOut,
    currentAmount,
    newAmount,
    currentInventoryName,
    newInventoryName,
    accommodationModificationRestrictionType,
    currency,
    step,
    goBack,
    occupantFields,
    isModificationSuccess,
    oldExtras,
    newExtras
  } = props;
  return /*#__PURE__*/React__default.createElement(StyledPopup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$O.changeAccommodation),
    closeWindow: onClose
  }, /*#__PURE__*/React__default.createElement(StyledWizard, {
    occupantFields: occupantFields,
    step: step,
    goBack: goBack,
    className: className,
    onClose: onClose,
    onCancel: onCancel,
    onConfirmModification: onConfirmModification,
    updateRooms: updateRooms,
    loading: loading,
    rooms: rooms,
    inventories: inventories,
    seniors: seniors,
    adults: adults,
    teenagers: teenagers,
    kids: kids,
    babies: babies,
    childrenCount: childrenCount,
    guestAges: guestAges,
    occupantSelector: occupantSelector,
    checkIn: checkIn,
    checkOut: checkOut,
    currentAmount: currentAmount,
    newAmount: newAmount,
    currentInventoryName: currentInventoryName,
    newInventoryName: newInventoryName,
    accommodationModificationRestrictionType: accommodationModificationRestrictionType,
    currency: currency,
    isModificationSuccess: isModificationSuccess,
    oldExtras: oldExtras,
    newExtras: newExtras
  }));
}

ModifyReservationWizardAccommodationPopup.propTypes = {
  className: PropTypes__default.string,
  onClose: PropTypes__default.func.isRequired,
  onCancel: PropTypes__default.func.isRequired,
  onConfirmModification: PropTypes__default.func.isRequired,
  updateRooms: PropTypes__default.func.isRequired,
  loading: PropTypes__default.bool.isRequired,
  rooms: PropTypes__default.node,
  inventories: PropTypes__default.node,
  seniors: PropTypes__default.number.isRequired,
  adults: PropTypes__default.number.isRequired,
  teenagers: PropTypes__default.number.isRequired,
  kids: PropTypes__default.number.isRequired,
  babies: PropTypes__default.number.isRequired,
  occupantFields: PropTypes__default.arrayOf(PropTypes__default.shape({
    name: PropTypes__default.string,
    value: PropTypes__default.number,
    onChange: PropTypes__default.func
  })).isRequired,
  occupantSelector: PropTypes__default.node.isRequired,
  checkIn: PropTypes__default.instanceOf(Date).isRequired,
  checkOut: PropTypes__default.instanceOf(Date).isRequired,
  currentAmount: PropTypes__default.number.isRequired,
  newAmount: PropTypes__default.number,
  currentInventoryName: PropTypes__default.string.isRequired,
  newInventoryName: PropTypes__default.string,
  accommodationModificationRestrictionType: PropTypes__default.oneOf([constants.restrictions.AMOUNT_GTE, constants.restrictions.NO_RESTRICTION]).isRequired,
  currency: PropTypes__default.string.isRequired,
  step: PropTypes__default.string.isRequired,
  goBack: PropTypes__default.func.isRequired,
  isModificationSuccess: PropTypes__default.bool,
  oldExtras: PropTypes__default.string,
  newExtras: PropTypes__default.string
};
ModifyReservationWizardAccommodationPopup.defaultProps = {
  className: "",
  rooms: /*#__PURE__*/React__default.createElement("div", null, "Rooms"),
  inventories: /*#__PURE__*/React__default.createElement("div", null, "Inventories"),
  newAmount: undefined,
  newInventoryName: undefined,
  isModificationSuccess: undefined,
  oldExtras: undefined,
  newExtras: undefined
};

function _templateObject11$c() {
  var data = _taggedTemplateLiteral(["\n  display: block !important;\n  text-align: center;\n  color: #b20e0e;\n  background-color: #f7e6e6;\n  padding: 15px;\n"]);

  _templateObject11$c = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$c() {
  var data = _taggedTemplateLiteral(["\n  color: #b20e0e;\n  background-color: #f7e6e6;\n  border-radius: 5px;\n  padding: 15px;\n  margin-bottom: 15px;\n"]);

  _templateObject10$c = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$e() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  @media (min-width: 640px) {\n    display: block;\n  }\n"]);

  _templateObject9$e = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$h() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  @media (min-width: 640px) {\n    display: none;\n  }\n"]);

  _templateObject8$h = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$l() {
  var data = _taggedTemplateLiteral(["\n  border: ", "\n  background-color: ", "\n  color: ", "\n  opacity: ", "\n  padding: 15px;\n  &:hover {\n    cursor: ", "\n  }\n"]);

  _templateObject7$l = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$p() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid #908f96;\n  background-color: #ffffff;\n  color: #908f96;\n  padding: 15px;\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject6$p = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$B() {
  var data = _taggedTemplateLiteral(["\n  z-index: 9999;\n  display: flex;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  width: 100%;\n  flex-direction: column;\n\n  position: absolute;\n  bottom: 0;\n  margin: 0 25px;\n\n  & div {\n    display: flex;\n    justify-content: center;\n    border-radius: 0;\n    flex: 1 1 auto;\n  }\n\n  & > :nth-child(2) {\n    margin-right: 0;\n  }\n\n  @media (min-width: 640px) {\n    font-size: 13px;\n    width: auto;\n    justify-content: center;\n    position: static;\n\n    & > :first-child {\n      margin-bottom: 10px;\n    }\n\n    & > div > div:first-child {\n      margin-right: 10px;\n    }\n\n    & div {\n      border-radius: 5px;\n      display: flex;\n    }\n  }\n"]);

  _templateObject5$B = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$P() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  @media (min-width: 640px) {\n    margin-right: 5%;\n  }\n"]);

  _templateObject4$P = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$_() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: #908f96;\n  margin-bottom: 25px;\n"]);

  _templateObject3$_ = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1b() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 700;\n  color: #222222;\n  margin-bottom: 15px;\n"]);

  _templateObject2$1b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1o() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 400px;\n  & > * {\n  }\n"]);

  _templateObject$1o = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$P = reactIntl.defineMessages({
  header: {
    id: "bookingModification.modalDates.chooseDates",
    description: "Choose check-in and check-out",
    defaultMessage: "Choose check-in and check-out"
  },
  hasToBeGreater: {
    id: "bookingModification.modalDates.stayGreater_than",
    description: "The stay must be equal to or greater than",
    defaultMessage: "The stay must be equal to or greater than"
  },
  nights: {
    id: "bookingModification.nights",
    description: "nights",
    defaultMessage: "nights"
  },
  checkAvailability: {
    id: "bookingModification.modal.checkAvailability",
    description: "Check Availability",
    defaultMessage: "Check Availability"
  },
  cancel: {
    id: "bookingModification.modal.cancel",
    description: "Cancel",
    defaultMessage: "Cancel"
  },
  noAvailability: {
    id: "bookingModification.modalDates.noAvailability",
    description: "There is no availability on the chosen dates",
    defaultMessage: "There is no availability on the chosen dates"
  },
  minStay: {
    id: "bookingModification.minStay",
    description: "Minimum stay",
    defaultMessage: "Minimum stay"
  }
});
var StyledCalendar = styled__default.div(_templateObject$1o());
var Header$4 = styled__default.div(_templateObject2$1b());
var Message$1 = styled__default.div(_templateObject3$_());
var ButtonContainerWrapper = styled__default.div(_templateObject4$P());
var ButtonContainer$1 = styled__default.div(_templateObject5$B());
var CancelButton$1 = styled__default.div(_templateObject6$p());
var ConfirmButton$2 = styled__default.div(_templateObject7$l(), props => props.enabled ? 0 : "1px solid #908f96", props => props.enabled ? "#329911" : "#ffffff", props => props.enabled ? "#ffffff" : "#908f96", props => props.enabled ? 1 : 0.5, props => props.enabled ? "pointer" : "not-allowed");
var DayRangePickerMobile$1 = styled__default.div(_templateObject8$h());
var DayRangePickerDesktop$1 = styled__default.div(_templateObject9$e());
var ErrorMessage$3 = styled__default.div(_templateObject10$c());
var BottomErrorMessage = styled__default.div(_templateObject11$c());

class Calendar extends React.PureComponent {
  constructor(props) {
    var _this;

    super(props);
    _this = this;

    _defineProperty(this, "getStayLength", () => moment(this.props.endDate).diff(moment(this.props.startDate), "days"));

    _defineProperty(this, "handleDateChange", (startDate, endDate) => {
      if (endDate && !moment(endDate).isSame(this.state.endDate, "days") && !this.newStayLengthMeetsReq({
        startDate,
        endDate
      })) {
        this.setState({
          startDate,
          endDate
        });
      } else {
        this.setState({
          startDate,
          endDate
        });
      }
    });

    _defineProperty(this, "startEndSet", () => this.state.startDate && this.state.endDate);

    _defineProperty(this, "newStayLengthMeetsReq", function () {
      var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.startDate;
      var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.endDate;

      if (_this.props.restrictions !== constants.restrictions.AMOUNT_AND_STAY_GTE && _this.props.restrictions !== constants.restrictions.STAY_GTE) {
        return true;
      }

      return moment(endDate).diff(moment(startDate), "days") >= _this.getStayLength();
    });

    _defineProperty(this, "handleSubmit", () => {
      if (this.startEndSet()) {
        if (this.newStayLengthMeetsReq()) {
          this.props.onConfirmDates({
            startDate: this.state.startDate,
            endDate: this.state.endDate
          });
        }
      }
    });

    this.state = {
      startDate: props.startDate,
      endDate: props.endDate
    };
  }

  render() {
    var stayLength = this.getStayLength();
    var confirmMeetsRequirements = this.startEndSet() && this.newStayLengthMeetsReq();
    var {
      isAvailable,
      closeWindow
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(StyledCalendar, null, isAvailable === false && /*#__PURE__*/React__default.createElement(ErrorMessage$3, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.noAvailability)), /*#__PURE__*/React__default.createElement(Header$4, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.header)), (this.props.restrictions === constants.restrictions.AMOUNT_AND_STAY_GTE || this.props.restrictions === constants.restrictions.STAY_GTE) && /*#__PURE__*/React__default.createElement(Message$1, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.hasToBeGreater), " ", stayLength, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.nights)), /*#__PURE__*/React__default.createElement(DayRangePickerMobile$1, null, /*#__PURE__*/React__default.createElement(DayRangePicker$1, {
      sendToParent: this.handleDateChange,
      monthsShown: 1,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startsOpen: true,
      alwaysOpened: true
    })), /*#__PURE__*/React__default.createElement(DayRangePickerDesktop$1, null, /*#__PURE__*/React__default.createElement(DayRangePicker$1, {
      sendToParent: this.handleDateChange,
      monthsShown: 2,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      startsOpen: true,
      alwaysOpened: true
    }))), /*#__PURE__*/React__default.createElement(ButtonContainerWrapper, null, /*#__PURE__*/React__default.createElement(ButtonContainer$1, null, this.startEndSet() && !confirmMeetsRequirements && /*#__PURE__*/React__default.createElement(BottomErrorMessage, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.minStay), " ", /*#__PURE__*/React__default.createElement("span", null, " ", stayLength, " "), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.nights)), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CancelButton$1, {
      onClick: closeWindow
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.cancel)), /*#__PURE__*/React__default.createElement(ConfirmButton$2, {
      onClick: confirmMeetsRequirements ? this.handleSubmit : undefined,
      enabled: confirmMeetsRequirements
    }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$P.checkAvailability))))));
  }

}

Calendar.propTypes = {
  startDate: PropTypes__default.object.isRequired,
  endDate: PropTypes__default.object.isRequired,
  restrictions: PropTypes__default.string,
  stayLength: PropTypes__default.number,
  onConfirmDates: PropTypes__default.func.isRequired,
  isAvailable: PropTypes__default.bool.isRequired,
  closeWindow: PropTypes__default.func.isRequired
};
Calendar.defaultProps = {
  restrictions: constants.restrictions.AMOUNT_AND_STAY_GTE,
  stayLength: 0
};

function _templateObject3$$() {
  var data = _taggedTemplateLiteral(["\n  min-height: 500px;\n"]);

  _templateObject3$$ = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1c() {
  var data = _taggedTemplateLiteral(["\n    max-height: ", ";\n  "]);

  _templateObject2$1c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1p() {
  var data = _taggedTemplateLiteral(["\n  padding: 25px;\n  height: calc(100vh - 56px);\n  overflow: auto;\n  ", ";\n"]);

  _templateObject$1p = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$Q = reactIntl.defineMessages({
  datesAvailable: {
    id: "bookingModification.modalDates.datesAvailable",
    description: "Dates available",
    defaultMessage: "Good news! The dates you chose are available."
  }
});
var STEPS$1 = {
  CALENDAR: "calendar",
  CONFIRM: "confirm",
  SUCCESS: "success"
};
var StyledWizard$1 = styled__default.div(_templateObject$1p(), media.up.mdl(_templateObject2$1c(), props => props.isAvailable !== false ? "600px" : "675px"));
var LoaderWrapper$1 = styled__default.div(_templateObject3$$());

function dateToString$1(date) {
  return moment$1(date).format("YYYY-MM-DD");
}

class ModifyReservationWizardDates extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "handleConfirmModification", () => {
      this.props.onConfirmModification();
    });
  }

  render() {
    var {
      closeWindow,
      restrictions,
      className,
      isAvailable,
      loading,
      reset,
      onConfirmDates,
      checkIn,
      checkOut,
      originalCheckIn,
      originalCheckOut,
      isModificationSuccess
    } = this.props;
    var hasError = !isModificationValid({
      currentAmount: this.props.currentAmount,
      newAmount: this.props.newAmount,
      accommodationModificationRestrictionType: this.props.restrictions
    });
    return /*#__PURE__*/React__default.createElement(StyledWizard$1, {
      isAvailable: isAvailable
    }, loading && /*#__PURE__*/React__default.createElement(LoaderWrapper$1, null, /*#__PURE__*/React__default.createElement(Loader, null)), !loading && /*#__PURE__*/React__default.createElement("div", {
      className: "wbkv9-ModifyReservationWizardDates ".concat(className)
    }, /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS$1.CALENDAR,
      render: () => /*#__PURE__*/React__default.createElement(Calendar, {
        isAvailable: isAvailable,
        closeWindow: closeWindow,
        restrictions: restrictions,
        onConfirmDates: onConfirmDates,
        startDate: originalCheckIn,
        endDate: originalCheckOut
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS$1.CONFIRM,
      render: () => /*#__PURE__*/React__default.createElement(ConfirmModification, {
        title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Q.datesAvailable),
        reset: reset,
        error: hasError,
        oldRoom: this.props.currentInventoryName,
        newRoom: this.props.newInventoryName,
        oldCheckIn: dateToString$1(originalCheckIn),
        newCheckIn: dateToString$1(checkIn),
        oldCheckOut: dateToString$1(originalCheckOut),
        newCheckOut: dateToString$1(checkOut),
        oldAmount: this.props.currentAmount,
        newAmount: this.props.newAmount,
        currency: this.props.currency,
        minimumAmount: this.props.currentAmount,
        handleCancel: this.props.closeWindow,
        handleConfirm: this.handleConfirmModification,
        isModificationSuccess: isModificationSuccess,
        oldExtras: this.props.oldExtras,
        newExtras: this.props.newExtras
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS$1.SUCCESS,
      render: () => /*#__PURE__*/React__default.createElement(ModifyReservationSuccess$1, {
        closeWindow: closeWindow
      })
    })));
  }

}

ModifyReservationWizardDates.propTypes = {
  onConfirmModification: PropTypes__default.func.isRequired,
  closeWindow: PropTypes__default.func.isRequired,
  restrictions: PropTypes__default.bool.isRequired,
  className: PropTypes__default.string,
  isAvailable: PropTypes__default.bool.isRequired,
  loading: PropTypes__default.bool.isRequired,
  reset: PropTypes__default.func.isRequired,
  onConfirmDates: PropTypes__default.func.isRequired,
  checkOut: PropTypes__default.string.isRequired,
  checkIn: PropTypes__default.string.isRequired,
  originalCheckOut: PropTypes__default.string.isRequired,
  originalCheckIn: PropTypes__default.string.isRequired,
  currentAmount: PropTypes__default.number.isRequired,
  newAmount: PropTypes__default.number,
  currentInventoryName: PropTypes__default.string.isRequired,
  newInventoryName: PropTypes__default.string,
  currency: PropTypes__default.string.isRequired,
  step: PropTypes__default.oneOf([STEPS$1.CALENDAR, STEPS$1.CONFIRM, STEPS$1.SUCCESS]).isRequired,
  isModificationSuccess: PropTypes__default.bool,
  oldExtras: PropTypes__default.string,
  newExtras: PropTypes__default.string
};
ModifyReservationWizardDates.defaultProps = {
  className: "",
  newAmount: undefined,
  newInventoryName: undefined,
  isModificationSuccess: undefined,
  oldExtras: undefined,
  newExtras: undefined
};

function _templateObject$1q() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject$1q = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$R = reactIntl.defineMessages({
  changeDates: {
    id: "bookingModification.changeDates.button",
    description: "Change dates",
    defaultMessage: "Change dates"
  }
});
var StyledPopup$1 = styled__default(Popup)(_templateObject$1q());

function ModifyReservationWizardDatesPopup(props) {
  var {
    currentAmount,
    newAmount,
    isAvailable,
    loading,
    isSuccessful,
    reset,
    onConfirmDates,
    closeWindow,
    datesModificationRestrictionType,
    checkIn,
    checkOut,
    className,
    currency,
    currentInventoryName,
    newInventoryName,
    onConfirmModification,
    originalCheckIn,
    originalCheckOut,
    step,
    goBack,
    isModificationSuccess,
    oldExtras,
    newExtras
  } = props;
  return /*#__PURE__*/React__default.createElement(StyledPopup$1, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$R.changeDates),
    closeWindow: closeWindow
  }, /*#__PURE__*/React__default.createElement(ModifyReservationWizardDates, {
    step: step,
    goBack: goBack,
    className: className,
    isAvailable: isAvailable,
    loading: loading,
    currentAmount: currentAmount,
    newAmount: newAmount,
    isSuccessful: isSuccessful,
    reset: reset,
    onConfirmDates: onConfirmDates,
    closeWindow: closeWindow,
    restrictions: datesModificationRestrictionType,
    checkIn: checkIn,
    checkOut: checkOut,
    currency: currency,
    currentInventoryName: currentInventoryName,
    newInventoryName: newInventoryName,
    onConfirmModification: onConfirmModification,
    originalCheckIn: originalCheckIn,
    originalCheckOut: originalCheckOut,
    isModificationSuccess: isModificationSuccess,
    oldExtras: oldExtras,
    newExtras: newExtras
  }));
}

ModifyReservationWizardDatesPopup.propTypes = {
  className: PropTypes__default.string,
  closeWindow: PropTypes__default.func.isRequired,
  currentAmount: PropTypes__default.number.isRequired,
  newAmount: PropTypes__default.number.isRequired,
  isAvailable: PropTypes__default.bool.isRequired,
  loading: PropTypes__default.bool.isRequired,
  isSuccessful: PropTypes__default.bool.isRequired,
  reset: PropTypes__default.func.isRequired,
  onConfirmDates: PropTypes__default.func.isRequired,
  datesModificationRestrictionType: PropTypes__default.oneOf([constants.restrictions.AMOUNT_AND_STAY_GTE, constants.restrictions.STAY_GTE, constants.restrictions.AMOUNT_GTE, constants.restrictions.NO_RESTRICTION]).isRequired,
  checkIn: PropTypes__default.instanceOf(Date),
  checkOut: PropTypes__default.instanceOf(Date),
  originalCheckIn: PropTypes__default.instanceOf(Date),
  originalCheckOut: PropTypes__default.instanceOf(Date),
  currency: PropTypes__default.string.isRequired,
  currentInventoryName: PropTypes__default.string.isRequired,
  newInventoryName: PropTypes__default.string,
  onConfirmModification: PropTypes__default.func.isRequired,
  step: PropTypes__default.string.isRequired,
  goBack: PropTypes__default.func.isRequired,
  isModificationSuccess: PropTypes__default.bool,
  oldExtras: PropTypes__default.string,
  newExtras: PropTypes__default.string
};
ModifyReservationWizardDatesPopup.defaultProps = {
  className: "",
  checkIn: new Date(),
  checkOut: new Date(),
  originalCheckIn: new Date(),
  originalCheckOut: new Date(),
  newInventoryName: undefined,
  isModificationSuccess: undefined,
  oldExtras: undefined,
  newExtras: undefined
};
var index$e = pure(ModifyReservationWizardDatesPopup);

function _templateObject2$1d() {
  var data = _taggedTemplateLiteral(["\n  > div {\n    overflow: hidden;\n    max-height: none;\n  }\n"]);

  _templateObject2$1d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1r() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n"]);

  _templateObject$1r = function _templateObject() {
    return data;
  };

  return data;
}
var Container$e = styled__default.div(_templateObject$1r());
var StyledExtraList = styled__default(ExtraList)(_templateObject2$1d());

function ExtrasSelection(_ref) {
  var {
    className,
    extras,
    onSubmit,
    handleGallery,
    closeWindow,
    serviceHasImage,
    addObligatoryExtrasRateToRoomSelection,
    selectedServices,
    serviceRatesInfo,
    guestsList,
    questionnaires
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$e, {
    className: "wbkv9-Modification-ExtrasSelection ".concat(className)
  }, /*#__PURE__*/React__default.createElement(StyledExtraList, {
    extras: extras,
    selectedServices: selectedServices,
    serviceRatesInfo: serviceRatesInfo,
    onSubmit: onSubmit,
    handleGallery: handleGallery,
    handleModalContent: null,
    closeWindow: () => ({}),
    onCancel: closeWindow,
    serviceHasImage: serviceHasImage,
    addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection,
    type: "service",
    guestsList: guestsList,
    questionnaires: questionnaires
  }));
}

ExtrasSelection.propTypes = {
  className: PropTypes__default.string,

  /** method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,
  extras: PropTypes__default.array.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes__default.bool.isRequired,
  selectedServices: PropTypes__default.object.isRequired,
  serviceRatesInfo: PropTypes__default.object.isRequired,
  onSubmit: PropTypes__default.func.isRequired,
  serviceHasImage: PropTypes__default.bool.isRequired,
  handleGallery: PropTypes__default.func.isRequired,
  guestsList: PropTypes__default.object.isRequired
};
ExtrasSelection.defaultProps = {
  className: ""
};

function _templateObject4$Q() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    color: ", ";\n  "]);

  _templateObject4$Q = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$10() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-weight: 700;\n\n  ", ";\n"]);

  _templateObject3$10 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1e() {
  var data = _taggedTemplateLiteral(["\n    flex: 1 1 auto;\n    border-radius: 0;\n    \n    &:first-child {\n      border-radius: 5px 0 0 0;\n    }\n    \n    &:last-child {\n      border-radius: 0 5px 0 0;\n    }\n    \n    &:not(:last-child) {\n      border-right: none;\n    }\n  "]);

  _templateObject2$1e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1s() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n  font-size: 14px;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 5px;\n\n  ", ";\n"]);

  _templateObject$1s = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$S = reactIntl.defineMessages({
  price: {
    id: "bookingModification.modal.price",
    description: "Price",
    defaultMessage: "Price"
  }
});
var Table$2 = styled__default.div(_templateObject$1s(), props => props.bold ? wbBlack : greyLight, greyLighter, media.up.md(_templateObject2$1e()));
var TableHeader$1 = styled__default(TableRow)(_templateObject3$10(), greyBasic, media.up.md(_templateObject4$Q(), wbBlack));

var ExtrasTable = (_ref) => {
  var {
    className,
    headerTitle,
    amount,
    bold,
    rows,
    currency
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Table$2, {
    className: className,
    bold: bold
  }, /*#__PURE__*/React__default.createElement(TableHeader$1, null, headerTitle), rows && rows.map((row, idx) => /*#__PURE__*/React__default.createElement(TableRow, {
    key: idx
  }, /*#__PURE__*/React__default.createElement(RowValue, {
    bold: bold
  }, row.text))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(FormattedMessageWrapper, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$S.price)), ":", /*#__PURE__*/React__default.createElement(RowValue, {
    bold: bold
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: amount,
    maximumFractionDigits: 0
  }), " ", currency)));
};

ExtrasTable.defaultProps = {
  className: "wbkv9-ExtrasTable",
  headerTitle: {},
  room: "Infinity",
  checkIn: "2019-08-16",
  checkOut: "2019-08-18",
  amount: undefined,
  error: false,
  bold: false
};
ExtrasTable.propTypes = {
  className: PropTypes__default.string,
  headerTitle: PropTypes__default.object,
  room: PropTypes__default.string,
  checkIn: PropTypes__default.string,
  checkOut: PropTypes__default.string,
  amount: PropTypes__default.number,
  error: PropTypes__default.bool,
  bold: PropTypes__default.bool,
  rows: PropTypes__default.arrayOf(PropTypes__default.object).isRequired,
  currency: PropTypes__default.string.isRequired
};

function _templateObject3$11() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n  "]);

  _templateObject3$11 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1f() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2$1f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1t() {
  var data = _taggedTemplateLiteral(["\n  min-height: 500px;\n"]);

  _templateObject$1t = function _templateObject() {
    return data;
  };

  return data;
}
var LoaderWrapper$2 = styled__default.div(_templateObject$1t());
var TablesContainer$1 = styled__default.div(_templateObject2$1f(), media.up.md(_templateObject3$11()));
var msgs$T = reactIntl.defineMessages({
  confirmExtras: {
    id: "bookingModification.editExtras.modal.confirm.title",
    description: "Confirm extras",
    defaultMessage: "Confirm extras"
  },
  oldTitle: {
    id: "bookingModification.editExtras.modal.confirm.oldExtras",
    description: "Old extras",
    defaultMessage: "Old extras"
  },
  newTitle: {
    id: "bookingModification.editExtras.modal.confirm.newExtras",
    description: "New extras",
    defaultMessage: "New extras"
  }
});

function dateToString$2(date) {
  return moment$1(date).format("YYYY-MM-DD");
}

var STEPS$2 = {
  EXTRAS_SELECTION: "extras-selection",
  CONFIRM: "confirm",
  SUCCESS: "success"
};

class Wizard$1 extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleUpdateExtras", (quantity, forms) => {
      this.props.updateExtras(quantity, forms);
    });

    _defineProperty(this, "handleConfirmModification", () => {
      this.props.onConfirmModification();
    });

    this.state = {};
  }

  render() {
    var {
      className,
      loading,
      onCancel,
      isModificationSuccess,
      extras,
      selectedServices,
      handleGallery,
      serviceHasImage,
      addObligatoryExtrasRateToRoomSelection,
      serviceRatesInfo,
      guestsList,
      questionnaires
    } = this.props; // There's no restriction when modifying extras

    var hasError = false;
    return /*#__PURE__*/React__default.createElement("div", {
      className: "wbkv9-ModifyReservationWizardExtras ".concat(className)
    }, loading && /*#__PURE__*/React__default.createElement(LoaderWrapper$2, null, /*#__PURE__*/React__default.createElement(Loader, null)), !loading && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS$2.EXTRAS_SELECTION,
      render: () => /*#__PURE__*/React__default.createElement(ExtrasSelection, {
        closeWindow: onCancel,
        onSubmit: this.handleUpdateExtras,
        extras: extras,
        selectedServices: selectedServices,
        serviceRatesInfo: serviceRatesInfo,
        handleGallery: handleGallery,
        handleModalContent: null,
        serviceHasImage: serviceHasImage,
        addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection,
        guestsList: guestsList,
        questionnaires: questionnaires
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS$2.CONFIRM,
      render: () => /*#__PURE__*/React__default.createElement(ConfirmModification, {
        title: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$T.confirmExtras),
        oldRoom: this.props.currentInventoryName,
        newRoom: this.props.newInventoryName,
        oldCheckIn: dateToString$2(this.props.checkIn),
        newCheckIn: dateToString$2(this.props.checkIn),
        oldCheckOut: dateToString$2(this.props.checkOut),
        newCheckOut: dateToString$2(this.props.checkOut),
        oldAmount: this.props.currentAmount,
        newAmount: this.props.newAmount,
        currency: this.props.currency,
        minimumAmount: this.props.currentAmount,
        error: hasError,
        handleCancel: this.props.onCancel,
        handleConfirm: this.handleConfirmModification,
        reset: this.props.goBack,
        isModificationSuccess: isModificationSuccess,
        content: /*#__PURE__*/React__default.createElement(TablesContainer$1, null, /*#__PURE__*/React__default.createElement(ExtrasTable, {
          headerTitle: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$T.oldTitle),
          rows: this.props.currentExtras.map(it => ({
            text: it.name
          })),
          amount: this.props.currentAmount,
          currency: this.props.currency,
          bold: true
        }), /*#__PURE__*/React__default.createElement(ExtrasTable, {
          headerTitle: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$T.newTitle),
          rows: this.props.newExtras.map(it => ({
            text: it.name
          })),
          amount: this.props.newAmount,
          currency: this.props.currency,
          bold: true
        }))
      })
    }), /*#__PURE__*/React__default.createElement(Step$1, {
      step: this.props.step,
      matchStep: STEPS$2.SUCCESS,
      render: () => /*#__PURE__*/React__default.createElement(ModifyReservationSuccess$1, {
        closeWindow: onCancel
      })
    })));
  }

}

Wizard$1.propTypes = {
  className: PropTypes__default.string,
  onCancel: PropTypes__default.func.isRequired,
  onConfirmModification: PropTypes__default.func.isRequired,
  updateExtras: PropTypes__default.func.isRequired,
  loading: PropTypes__default.bool.isRequired,
  checkIn: PropTypes__default.instanceOf(Date).isRequired,
  checkOut: PropTypes__default.instanceOf(Date).isRequired,
  currentAmount: PropTypes__default.number.isRequired,
  newAmount: PropTypes__default.number,
  currentInventoryName: PropTypes__default.string.isRequired,
  newInventoryName: PropTypes__default.string,
  step: PropTypes__default.oneOf([STEPS$2.EXTRAS_SELECTION, STEPS$2.CONFIRM, STEPS$2.SUCCESS]).isRequired,
  currency: PropTypes__default.string.isRequired,
  goBack: PropTypes__default.func.isRequired,
  isModificationSuccess: PropTypes__default.bool,
  extras: PropTypes__default.array.isRequired,
  selectedServices: PropTypes__default.object.isRequired,
  serviceRatesInfo: PropTypes__default.object.isRequired,
  handleGallery: PropTypes__default.func.isRequired,
  serviceHasImage: PropTypes__default.bool.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes__default.bool.isRequired,
  guestsList: PropTypes__default.object.isRequired,
  currentExtras: PropTypes__default.arrayOf(PropTypes__default.shape({
    name: PropTypes__default.string
  })).isRequired,
  newExtras: PropTypes__default.arrayOf(PropTypes__default.shape({
    name: PropTypes__default.string
  })).isRequired
};
Wizard$1.defaultProps = {
  className: "",
  newAmount: undefined,
  newInventoryName: undefined,
  isModificationSuccess: undefined
};

function _templateObject3$12() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject3$12 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1g() {
  var data = _taggedTemplateLiteral(["\n    max-height: 600px;\n  "]);

  _templateObject2$1g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1u() {
  var data = _taggedTemplateLiteral(["\n  padding: 25px;\n  height: calc(100vh - 56px);\n  overflow: auto;\n  ", ";\n"]);

  _templateObject$1u = function _templateObject() {
    return data;
  };

  return data;
}
var StyledWizard$2 = styled__default(Wizard$1)(_templateObject$1u(), media.up.mdl(_templateObject2$1g()));
var StyledPopup$2 = styled__default(Popup)(_templateObject3$12());
var msgs$U = reactIntl.defineMessages({
  changeExtras: {
    id: "bookingModification.editExtras.button",
    description: "Edit Extras",
    defaultMessage: "Modify accommodation"
  }
});

function ModifyReservationWizardExtrasPopup(props) {
  var {
    className,
    onClose,
    onCancel,
    onConfirmModification,
    updateExtras,
    loading,
    checkIn,
    checkOut,
    currentAmount,
    newAmount,
    currentInventoryName,
    newInventoryName,
    currency,
    step,
    goBack,
    isModificationSuccess,
    extras,
    selectedServices,
    handleGallery,
    serviceHasImage,
    addObligatoryExtrasRateToRoomSelection,
    currentExtras,
    newExtras,
    serviceRatesInfo,
    guestsList,
    questionnaires
  } = props;
  return /*#__PURE__*/React__default.createElement(StyledPopup$2, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$U.changeExtras),
    closeWindow: onClose
  }, /*#__PURE__*/React__default.createElement(StyledWizard$2, {
    step: step,
    goBack: goBack,
    className: className,
    onClose: onClose,
    onCancel: onCancel,
    onConfirmModification: onConfirmModification,
    updateExtras: updateExtras,
    loading: loading,
    checkIn: checkIn,
    checkOut: checkOut,
    currentAmount: currentAmount,
    newAmount: newAmount,
    currentInventoryName: currentInventoryName,
    newInventoryName: newInventoryName,
    currency: currency,
    isModificationSuccess: isModificationSuccess,
    extras: extras,
    selectedServices: selectedServices,
    handleGallery: handleGallery,
    serviceHasImage: serviceHasImage,
    addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection,
    currentExtras: currentExtras,
    newExtras: newExtras,
    serviceRatesInfo: serviceRatesInfo,
    guestsList: guestsList,
    questionnaires: questionnaires
  }));
}

ModifyReservationWizardExtrasPopup.propTypes = {
  className: PropTypes__default.string,
  onClose: PropTypes__default.func.isRequired,
  onCancel: PropTypes__default.func.isRequired,
  onConfirmModification: PropTypes__default.func.isRequired,
  updateExtras: PropTypes__default.func.isRequired,
  loading: PropTypes__default.bool.isRequired,
  checkIn: PropTypes__default.instanceOf(Date).isRequired,
  checkOut: PropTypes__default.instanceOf(Date).isRequired,
  currentAmount: PropTypes__default.number.isRequired,
  newAmount: PropTypes__default.number,
  currentInventoryName: PropTypes__default.string.isRequired,
  newInventoryName: PropTypes__default.string,
  currency: PropTypes__default.string.isRequired,
  step: PropTypes__default.string.isRequired,
  goBack: PropTypes__default.func.isRequired,
  isModificationSuccess: PropTypes__default.bool,
  extras: PropTypes__default.array.isRequired,
  selectedServices: PropTypes__default.object.isRequired,
  serviceRatesInfo: PropTypes__default.object.isRequired,
  handleGallery: PropTypes__default.func.isRequired,
  serviceHasImage: PropTypes__default.bool.isRequired,
  addObligatoryExtrasRateToRoomSelection: PropTypes__default.bool.isRequired,
  guestsList: PropTypes__default.object.isRequired,
  currentExtras: PropTypes__default.arrayOf(PropTypes__default.shape({
    name: PropTypes__default.string
  })).isRequired,
  newExtras: PropTypes__default.arrayOf(PropTypes__default.shape({
    name: PropTypes__default.string
  })).isRequired
};
ModifyReservationWizardExtrasPopup.defaultProps = {
  className: "",
  newAmount: undefined,
  newInventoryName: undefined,
  isModificationSuccess: undefined
};

var InsertPhoto = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
})), "TrashCan");

function _templateObject3$13() {
  var data = _taggedTemplateLiteral(["\n  width: 18px;\n  margin: 5px;\n  position: absolute;\n  opacity: 0.9;\n  top: 30px;\n  left: 37px;\n  fill: #938e90;\n  background-color: white;\n"]);

  _templateObject3$13 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1h() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 100%;\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  margin: 0 15px 0 7.5px;\n"]);

  _templateObject2$1h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1v() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n"]);

  _templateObject$1v = function _templateObject() {
    return data;
  };

  return data;
}
var Container$f = styled__default.div(_templateObject$1v());
var ImageStyled = styled__default.img(_templateObject2$1h());
var InsertPhotoIcon = styled__default(InsertPhoto)(_templateObject3$13());

function ImageCircle(_ref) {
  var {
    src,
    onClick,
    showImageCircle
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$f, null, showImageCircle && /*#__PURE__*/React__default.createElement(InsertPhotoIcon, null), /*#__PURE__*/React__default.createElement(ImageStyled, {
    className: "image-circle",
    src: src,
    onClick: onClick
  }));
}

function _templateObject5$C() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-align: left;\n  text-transform: ", ";\n"]);

  _templateObject5$C = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$R() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  text-align: left;\n"]);

  _templateObject4$R = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$14() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3$14 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1i() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2$1i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1w() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 17.5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #f6f6f6;\n  position: relative;\n  .image-circle {\n    margin: 0 15px 0 0;\n  }\n"]);

  _templateObject$1w = function _templateObject() {
    return data;
  };

  return data;
}
var Container$g = styled__default.div(_templateObject$1w());
var ContainerData = styled__default.div(_templateObject2$1i());
var TextContainer$1 = styled__default.div(_templateObject3$14());
var Title$6 = styled__default.div(_templateObject4$R(), props => props.titleColor, props => props.titleSize, props => props.titleWeight, props => props.Uppercase ? "uppercase" : "");
var Subtitle$1 = styled__default.div(_templateObject5$C(), props => props.subtitleColor, props => props.subtitleSize, props => props.subtitleWeight || 400, props => props.Uppercase ? "uppercase" : "");

function HeaderPackage(_ref) {
  var {
    children,
    deviceType,
    image,
    title,
    subtitle,
    onImageClick,
    subtitleColor,
    subtitleSize,
    subtitleUppercase,
    subtitleWeight,
    titleColor,
    titleUppercase,
    titleWeight
  } = _ref;
  var {
    selectUnits
  } = children || {};

  if (deviceType === constants.DEVICE_TYPE.DESKTOP) {
    return /*#__PURE__*/React__default.createElement(Container$g, null, /*#__PURE__*/React__default.createElement(ContainerData, null, /*#__PURE__*/React__default.createElement(ImageCircle, {
      src: image,
      onClick: onImageClick
    }), /*#__PURE__*/React__default.createElement(TextContainer$1, null, /*#__PURE__*/React__default.createElement(Title$6, {
      titleColor: titleColor,
      titleWeight: titleWeight,
      titleSize: "14px",
      Uppercase: titleUppercase
    }, title), /*#__PURE__*/React__default.createElement(Subtitle$1, {
      subtitleColor: subtitleColor,
      subtitleSize: subtitleSize,
      Uppercase: subtitleUppercase,
      subtitleWeight: subtitleWeight
    }, subtitle))), selectUnits && selectUnits);
  }

  if (deviceType === constants.DEVICE_TYPE.MOBILE) {
    return /*#__PURE__*/React__default.createElement(Container$g, null, /*#__PURE__*/React__default.createElement(ContainerData, null, /*#__PURE__*/React__default.createElement(TextContainer$1, null, /*#__PURE__*/React__default.createElement(Title$6, {
      titleColor: titleColor,
      titleWeight: titleWeight,
      titleSize: "12px",
      Uppercase: titleUppercase
    }, "".concat(title, ":")), !selectUnits && /*#__PURE__*/React__default.createElement(Subtitle$1, {
      subtitleColor: subtitleColor,
      subtitleSize: "14px",
      Uppercase: subtitleUppercase,
      subtitleWeight: subtitleWeight
    }, subtitle), selectUnits && selectUnits)), /*#__PURE__*/React__default.createElement(ImageCircle, {
      src: image,
      showImageCircle: true,
      onClick: onImageClick
    }));
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
}

var HeaderPackage$1 = pure(HeaderPackage);

function _templateObject17$5() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject17$5 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$6() {
  var data = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  background-color: ", ";\n  border-right: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  transform: rotate(45deg);\n  position: absolute;\n  right: 51px;\n  top: -5px;\n  z-index: 1;\n  display: block;\n  ", ";\n"]);

  _templateObject16$6 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 15px;\n"]);

  _templateObject15$8 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$9() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"]);

  _templateObject14$9 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$a() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n"]);

  _templateObject13$a = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$a() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 200;\n  margin-right: 5px;\n"]);

  _templateObject12$a = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$d() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject11$d = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$d() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 15px 20px;\n  justify-content: space-between;\n  border-bottom: 1px solid #eaeaea;\n  align-items: center;\n"]);

  _templateObject10$d = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$f() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject9$f = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$i() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n  cursor: pointer;\n  &:hover&:not(.unavailable),\n  &.selected {\n    background-color: #f1f1f1;\n  }\n  &:first-child {\n    padding-top: 0;\n  }\n  &:last-child {\n    border: none;\n    padding-bottom: 0;\n  }\n"]);

  _templateObject8$i = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$m() {
  var data = _taggedTemplateLiteral(["\n  height: auto;\n  width: auto;\n  min-width: 500px;\n  top: 52px;\n  z-index: 2000;\n  position: absolute;\n  background-color: #fff;\n  border: 1px solid #e1e1e1;\n  right: 17px;\n"]);

  _templateObject7$m = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$q() {
  var data = _taggedTemplateLiteral(["\n  text-align: initial;\n"]);

  _templateObject6$q = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$D() {
  var data = _taggedTemplateLiteral(["\n        width: 23px;\n        height: 23px;\n      "]);

  _templateObject5$D = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$S() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n  background: white;\n  padding: 4px 6px 4px 5px;\n  border: 1px solid #e1e1e1;\n  height: 26px;\n  color: #908f96;\n  box-sizing: content-box;\n  border-radius: 3px;\n  .arrowDownContainer {\n    width: 20px;\n    justify-content: end;\n    svg {\n      width: 20px;\n      height: 20px;\n      ", ";\n      fill: #908f96;\n    }\n  }\n"]);

  _templateObject4$S = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$15() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  min-width: 120px;\n"]);

  _templateObject3$15 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1j() {
  var data = _taggedTemplateLiteral(["\n    border-top: none;\n  "]);

  _templateObject2$1j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1x() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-top: ", ";\n\n  ", ";\n"]);

  _templateObject$1x = function _templateObject() {
    return data;
  };

  return data;
}
var titleUppercase = false;
var titleColor = "#908f96";
var titleWeight = 400;
var subtitleColor = "#222222";
var subtitleSize = "16px";
var subtitleUppercase = true;
var subtitleWeight = 600;
var messages$6 = reactIntl.defineMessages({
  UNITS: {
    id: "inventory.roomDenomination.units",
    description: "Room denomination for inventory",
    defaultMessage: "Units"
  },
  ROOMS: {
    id: "inventory.roomDenomination.rooms",
    description: "Room denomination for inventory",
    defaultMessage: "Rooms"
  },
  APARTMENTS: {
    id: "inventory.roomDenomination.apartments",
    description: "Room denomination for inventory",
    defaultMessage: "Apartments"
  },
  BUNGALOWS: {
    id: "inventory.roomDenomination.bungalows",
    description: "Room denomination for inventory",
    defaultMessage: "Bungalows"
  },
  CABINS: {
    id: "inventory.roomDenomination.cabins",
    description: "Room denomination for inventory",
    defaultMessage: "Cabins"
  },
  HOUSES: {
    id: "inventory.roomDenomination.houses",
    description: "Room denomination for inventory",
    defaultMessage: "Houses"
  },
  SHIP_CABIN: {
    id: "inventory.roomDenomination.ship_cabins",
    description: "Room denomination for inventory",
    defaultMessage: "Cabins"
  },
  VILLAS: {
    id: "inventory.roomDenomination.villas",
    description: "Room denomination for inventory",
    defaultMessage: "Villas"
  },
  BEDS: {
    id: "inventory.roomDenomination.beds",
    description: "Room denomination for inventory",
    defaultMessage: "Beds"
  },
  UNITS_SINGULAR: {
    id: "inventory.roomDenomination.units.singular",
    description: "Room denomination for units selector",
    defaultMessage: "unit"
  },
  ROOMS_SINGULAR: {
    id: "inventory.roomDenomination.rooms.singular",
    description: "Room denomination for units selector",
    defaultMessage: "room"
  },
  APARTMENTS_SINGULAR: {
    id: "inventory.roomDenomination.apartments.singular",
    description: "Room denomination for units selector",
    defaultMessage: "apartment"
  },
  BUNGALOWS_SINGULAR: {
    id: "inventory.roomDenomination.bungalows.singular",
    description: "Room denomination for units selector",
    defaultMessage: "bungalow"
  },
  CABINS_SINGULAR: {
    id: "inventory.roomDenomination.cabins.singular",
    description: "Room denomination for units selector",
    defaultMessage: "cabin"
  },
  HOUSES_SINGULAR: {
    id: "inventory.roomDenomination.houses.singular",
    description: "Room denomination for units selector",
    defaultMessage: "house"
  },
  SHIP_CABIN_SINGULAR: {
    id: "inventory.roomDenomination.ship_cabins.singular",
    description: "Room denomination for units selector",
    defaultMessage: "cabin"
  },
  VILLAS_SINGULAR: {
    id: "inventory.roomDenomination.villas.singular",
    description: "Room denomination for units selector",
    defaultMessage: "villa"
  },
  BEDS_SINGULAR: {
    id: "inventory.roomDenomination.beds.singular",
    description: "Room denomination for units selector",
    defaultMessage: "bed"
  },
  changeRoom: {
    id: "package.changeRoom",
    description: "First option for units selector",
    defaultMessage: "Cambiar"
  },
  unavailable: {
    id: "room_selection.entity.agotada",
    description: "agotada",
    defaultMessage: "Sold Out"
  },
  roomsList: {
    id: "packages.modal.roomsList",
    description: "roomsList for modal",
    defaultMessage: "Listado de"
  }
});
var Container$h = styled__default.div(_templateObject$1x(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "" : "1px solid ".concat(greyLighter), media.up.md(_templateObject2$1j()));
var SelectContainer = styled__default.div(_templateObject3$15());
var SelectInputWrapperStyled = styled__default(SelectInputWrapper$1)(_templateObject4$S(), media.up.lg(_templateObject5$D()));
var SelectText = styled__default.div(_templateObject6$q());
var FloatingMenuContainer$1 = styled__default.div(_templateObject7$m());
var OptionSelect = styled__default.div(_templateObject8$i(), props => props.statusCode !== constants.BOOKABLE_STATUS.AVAILABLE && "#8F8F96");
var ContainerText = styled__default.div(_templateObject9$f());
var Text$3 = styled__default.span(_templateObject10$d());
var PriceStyled = styled__default.span(_templateObject11$d());
var CurrencyStyle = styled__default.span(_templateObject12$a());
var List = styled__default.div(_templateObject13$a(), props => props.deviceType === constants.DEVICE_TYPE.DESKTOP ? "14px" : "12px");
var UpperText = styled__default.span(_templateObject14$9());
var ContainerHeader = styled__default.div(_templateObject15$8());
var MobileTriangle = styled__default.div(_templateObject16$6(), greyBasic, greyLighter, greyLighter, media.up.md(_templateObject17$5()));

function getCapitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function Header$5(_ref) {
  var {
    room,
    handleImageClick,
    index,
    intl,
    children,
    deviceType,
    roomDenominationSingular
  } = _ref;

  if (room) {
    return /*#__PURE__*/React__default.createElement(ContainerHeader, {
      key: index
    }, /*#__PURE__*/React__default.createElement(HeaderPackage$1, {
      deviceType: deviceType,
      title: getCapitalize(intl.formatMessage(messages$6[roomDenominationSingular])),
      titleColor: titleColor,
      titleUppercase: titleUppercase,
      titleWeight: titleWeight,
      subtitle: room.name,
      subtitleColor: subtitleColor,
      subtitleSize: subtitleSize,
      subtitleUppercase: subtitleUppercase,
      subtitleWeight: subtitleWeight,
      image: room.image,
      onImageClick: event => handleImageClick(event, room)
    }, {
      selectUnits: children && children
    }), room.inventories);
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
}

var RoomList = (_ref2) => {
  var {
    selectedRoom,
    rooms,
    handleSelectRoom,
    currency,
    deviceType
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(List, {
    deviceType: deviceType
  }, rooms.map(room => /*#__PURE__*/React__default.createElement(OptionSelect, {
    className: "".concat(selectedRoom && room.name === selectedRoom.name && "selected", " ").concat(room.statusCode !== constants.BOOKABLE_STATUS.AVAILABLE && "unavailable"),
    onClick: event => handleSelectRoom(event, room),
    statusCode: room.statusCode
  }, /*#__PURE__*/React__default.createElement(ContainerText, null, /*#__PURE__*/React__default.createElement(Text$3, null, /*#__PURE__*/React__default.createElement("span", null, room.name), room.statusCode !== constants.BOOKABLE_STATUS.AVAILABLE ? /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, messages$6.unavailable)) : /*#__PURE__*/React__default.createElement(PriceStyled, null, /*#__PURE__*/React__default.createElement(CurrencyStyle, null, currency), " ", room.price))))));
};

var Package = React__default.memo(props => {
  var {
    currency,
    deviceType,
    element,
    onImageClick,
    onSelectRoomChange,
    roomDenominationSingular,
    roomDenominationPlural,
    rooms,
    selectedRoom,
    showCollapsedRooms
  } = props;
  var intl = reactIntl.useIntl();
  var [openSelectUnits, setOpenSelectUnits] = React.useState(false);
  var [showPopup, setShowPopup] = React.useState(false);
  var [selectedRoomName, setSelectedRoomName] = React.useState("");
  var menuRef = React.useRef();
  React.useEffect(() => {
    if (selectedRoom) {
      setSelectedRoomName(selectedRoom.name);
    }
  }, [selectedRoom]);
  var handleChangeUnit = React.useCallback(e => {
    if (menuRef && menuRef.current && menuRef.current.contains(e.target)) {
      return;
    }

    setOpenSelectUnits(!openSelectUnits);
  }, [openSelectUnits, menuRef]);
  React.useEffect(() => {
    if (openSelectUnits) {
      document.addEventListener("mousedown", handleChangeUnit);
    }

    return () => {
      document.removeEventListener("mousedown", handleChangeUnit);
    };
  }, [openSelectUnits, handleChangeUnit]);
  var handleModal = React.useCallback(() => {
    setShowPopup(!showPopup);
  }, [showPopup]);
  var handleShowSelectUnit = React.useCallback(() => {
    if (deviceType === constants.DEVICE_TYPE.MOBILE) {
      handleModal();
    }

    setOpenSelectUnits(!openSelectUnits);
  }, [openSelectUnits, handleModal, deviceType]);
  var handleSelectRoom = React.useCallback((event, room) => {
    event.preventDefault();

    if (room.statusCode === constants.BOOKABLE_STATUS.AVAILABLE) {
      onSelectRoomChange(room);
      setOpenSelectUnits(false);
      setShowPopup(false);
    }
  }, [onSelectRoomChange]);
  var handleImageClick = React.useCallback((event, room) => {
    event.preventDefault();
    var media = room.image;
    var name = room.name;
    var description = room.description;
    onImageClick(media, name, description);
  }, [onImageClick]);

  if (showPopup) {
    return /*#__PURE__*/React__default.createElement(Modal //@ts-ignore
    , {
      closeModal: handleModal,
      element: element,
      headerText: "".concat(intl.formatMessage(Object.assign({}, messages$6.roomsList)), " ").concat(intl.formatMessage(Object.assign({}, messages$6[roomDenominationPlural])).toLowerCase())
    }, /*#__PURE__*/React__default.createElement(RoomList, {
      selectedRoom: selectedRoom || undefined,
      deviceType: deviceType,
      rooms: rooms,
      handleSelectRoom: handleSelectRoom,
      currency: currency
    }));
  }

  if (!showCollapsedRooms) {
    return /*#__PURE__*/React__default.createElement(Container$h, {
      deviceType: deviceType
    }, deviceType === constants.DEVICE_TYPE.MOBILE && /*#__PURE__*/React__default.createElement(MobileTriangle, null), rooms.map((room, index) => /*#__PURE__*/React__default.createElement(Header$5, {
      key: index,
      room: room,
      index: index,
      intl: intl,
      deviceType: deviceType,
      roomDenominationSingular: roomDenominationSingular,
      handleImageClick: handleImageClick
    })));
  }

  if (showCollapsedRooms && selectedRoom) {
    return /*#__PURE__*/React__default.createElement(Container$h, {
      deviceType: deviceType
    }, deviceType === constants.DEVICE_TYPE.MOBILE && /*#__PURE__*/React__default.createElement(MobileTriangle, null), /*#__PURE__*/React__default.createElement(Header$5, {
      room: selectedRoom,
      index: 1,
      intl: intl,
      deviceType: deviceType,
      roomDenominationSingular: roomDenominationSingular,
      handleImageClick: handleImageClick
    }, /*#__PURE__*/React__default.createElement(React.Fragment, null, /*#__PURE__*/React__default.createElement(SelectContainer, null, /*#__PURE__*/React__default.createElement(SelectInputWrapperStyled //@ts-ignore
    , {
      onClick: handleShowSelectUnit,
      icon: true,
      hideFirstIcon: true,
      hideBorder: true,
      customPadding: true
    }, /*#__PURE__*/React__default.createElement(SelectText, null, deviceType === constants.DEVICE_TYPE.DESKTOP ? "".concat(intl.formatMessage(messages$6.changeRoom), " ").concat(intl.formatMessage(messages$6[roomDenominationSingular]).toLowerCase()) : /*#__PURE__*/React__default.createElement(UpperText, null, selectedRoomName)))), openSelectUnits && /*#__PURE__*/React__default.createElement(FloatingMenuContainer$1, {
      ref: menuRef
    }, /*#__PURE__*/React__default.createElement(RoomList, {
      selectedRoom: selectedRoom,
      deviceType: deviceType,
      rooms: rooms,
      handleSelectRoom: handleSelectRoom,
      currency: currency
    })))));
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
});

function _templateObject7$n() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 400;\n  color: ", ";\n"]);

  _templateObject7$n = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$r() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 400;\n  color: ", ";\n"]);

  _templateObject6$r = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$E() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 1px;\n  color: ", ";\n"]);

  _templateObject5$E = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$T() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  font-weight: 400;\n  color: ", ";\n"]);

  _templateObject4$T = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$16() {
  var data = _taggedTemplateLiteral(["\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 1px;\n  color: ", ";\n"]);

  _templateObject3$16 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1k() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n"]);

  _templateObject2$1k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1y() {
  var data = _taggedTemplateLiteral(["\npadding: 20px;\nDisplay: flex;\nbackground-color:  ", "\njustify-content: space-between;\nborder-bottom: 1px solid #e1e1e1;\n        &:last-child{\n        border-bottom: 0px solid #e1e1e1;\n        }\n&:hover {cursor: pointer;\n         background-color: ", ";\n         \n@media (max-width: 420px) {\noverflow-y: hidden;\n        &:last-child{\n        border-bottom: 1px solid #e1e1e1;\n        }\n        }\n"]);

  _templateObject$1y = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$V = reactIntl.defineMessages({
  listofTariff: {
    id: "listofTariff.listofTariffDetails",
    description: "money per night",
    defaultMessage: "/night"
  }
});
var DivInfo = styled__default.div(_templateObject$1y(), props => props.selected ? props.bColor : "#ffffff", props => props.selected ? "" : "#f6f6f6");
var DivInfoWrapperPrice = styled__default.div(_templateObject2$1k());
var DivInfoTitle = styled__default.div(_templateObject3$16(), props => props.selected ? "#f6f6f6" : "#222222");
var DivInfoSubtitle = styled__default.div(_templateObject4$T(), props => props.selected ? "#f6f6f6" : "#908f96");
var DivInfoPrice = styled__default.div(_templateObject5$E(), props => props.selected ? "#f6f6f6" : "#222222");
var DivInfoSubprice = styled__default.div(_templateObject6$r(), props => props.selected ? "#f6f6f6" : "#908f96");
var DivInfoDifferencePrice = styled__default.span(_templateObject7$n(), props => props.selected ? "#f6f6f6" : "#908f96");

function ListOfTariffDetails(props) {
  return /*#__PURE__*/React__default.createElement(DivInfo, {
    className: "DivInfo",
    selected: props.selected === props.id,
    onClick: () => {
      props.chooseSelectedRoom(props.id, props.tariffValue);
    },
    bColor: props.bColor
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DivInfoTitle, {
    className: "DivInfoTitle",
    selected: props.selected === props.id
  }, props.tariffValue.mealplan.name), /*#__PURE__*/React__default.createElement(DivInfoSubtitle, {
    className: "DivInfoSubtitle",
    selected: props.selected === props.id
  }, props.tariffValue.condition.name)), /*#__PURE__*/React__default.createElement(DivInfoWrapperPrice, {
    className: "DivInfoWrapperPrice"
  }, /*#__PURE__*/React__default.createElement(DivInfoPrice, {
    className: "DivInfoPrice",
    selected: props.selected === props.id
  }, props.currency, " ", props.tariffValue.totalRate, /*#__PURE__*/React__default.createElement(DivInfoDifferencePrice, null, " ", props.tariffValue.totalRate !== props.priceSelected && !!props.priceSelected && /*#__PURE__*/React__default.createElement("span", null, "( ", props.currency, " ", props.tariffValue.totalRate - props.priceSelected, /*#__PURE__*/React__default.createElement("svg", {
    height: "20",
    width: "20",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.selected === props.id ? "#f6f6f6" : "#908f96"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: props.tariffValue.totalRate - props.priceSelected < 0 ? "M7 16l5 5 5-5z" : "M7 20l5-5 5 5z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), ")"))), /*#__PURE__*/React__default.createElement(DivInfoSubprice, {
    className: "DivInfoSubprice",
    selected: props.selected === props.id
  }, props.currency, " ", props.tariffValue.averageRate, /*#__PURE__*/React__default.createElement("span", null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$V.listofTariff)))));
}

ListOfTariffDetails.defaultProps = {
  id: "",
  currency: "EUR",
  bColor: "",
  selected: {},
  chooseSelectedRoom: () => undefined,
  priceSelected: 0
};
ListOfTariffDetails.propTypes = {
  /** every room with the different prices to be rendered */
  id: PropTypes__default.string,
  tariffValue: PropTypes__default.object.isRequired,
  currency: PropTypes__default.string,
  bColor: PropTypes__default.string,
  selected: PropTypes__default.string,
  chooseSelectedRoom: PropTypes__default.func,
  priceSelected: PropTypes__default.number
};
var ListOfTariffDetails$1 = pure(ListOfTariffDetails);

function _templateObject$1z() {
  var data = _taggedTemplateLiteral(["\n  border: 0px 1px 1px 1px solid #e1e1e1;\n  font-family: Open Sans;\n  font-size: 14px;\n  @media (max-width: 420px) {\n  }\n"]);

  _templateObject$1z = function _templateObject() {
    return data;
  };

  return data;
}
var DivFather$2 = styled__default.div(_templateObject$1z());
class ListOfTariff extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      roomSelected: {},
      priceSelected: 0,
      selected: ""
    };
    this.chooseSelectedRoom = this.chooseSelectedRoom.bind(this);
    this.prepareTariffs = this.prepareTariffs.bind(this);
  }

  prepareTariffs(roomsKey, rooms) {
    var room = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    roomsKey.map(currentValue => {
      rooms[currentValue].inventories.filter(filterValue => filterValue.ticker === rooms[currentValue].selected).map(roomValue => {
        room.push(roomValue);
        return this;
      });
      return this;
    });
    room.sort((a, b) => {
      if (a.totalRate < b.totalRate) {
        return -1;
      }

      if (a.totalRate > b.totalRate) {
        return 1;
      }

      return 0;
    });
    return room;
  }

  chooseSelectedRoom(id, room) {
    this.setState({
      selected: id,
      roomSelected: room,
      priceSelected: room.totalRate
    });
    this.props.roomFunction(this.state.roomSelected);
  }

  render() {
    var {
      inventoryGroups: baseTariffs,
      currency
    } = this.props.tariffs;
    var roomsKey = Object.keys(baseTariffs);
    var finalTariff = this.prepareTariffs(roomsKey, baseTariffs);
    return /*#__PURE__*/React__default.createElement(DivFather$2, {
      className: "ListOfTariff"
    }, finalTariff.map((actualTariff, index) => /*#__PURE__*/React__default.createElement(ListOfTariffDetails$1, {
      className: "ListofTariffDetails",
      tariffValue: actualTariff,
      currency: currency,
      key: actualTariff.ticker,
      id: "ListOfTariffDetails".concat(index),
      bColor: this.props.bColor,
      selected: this.state.selected,
      chooseSelectedRoom: this.chooseSelectedRoom,
      priceSelected: this.state.priceSelected
    })));
  }

}
ListOfTariff.defaultProps = {
  bColor: ""
};
ListOfTariff.propTypes = {
  /** every room with the different prices to be rendered */
  tariffs: PropTypes__default.object.isRequired,
  bColor: PropTypes__default.string,
  roomFunction: PropTypes__default.func.isRequired
};

var Info$1 = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
})), "Info");

/**  Popup of the List of Tariffs */
var msgs$W = reactIntl.defineMessages({
  listofTariff: {
    id: "ListofTariff.ListofTariffIndex",
    description: "Header title",
    defaultMessage: "List of Tariff"
  }
});

function PopupListOfTariff(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "PopupListOfTariff"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$W.listofTariff),
    srcLogo: /*#__PURE__*/React__default.createElement(Info$1, null),
    closeWindow: props.closeWindow
  }, props.data && /*#__PURE__*/React__default.createElement(ListOfTariff, {
    tariffs: props.data,
    bColor: props.bColor,
    roomFunction: roomSelected => roomSelected
  })));
}

PopupListOfTariff.defaultProps = {
  bColor: "#d4ba7e"
};
PopupListOfTariff.propTypes = {
  /** method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,

  /** The data of tariff which will be rendered as a child in the Popup */
  data: PropTypes__default.object.isRequired,
  bColor: PropTypes__default.string
};
var index$f = pure(PopupListOfTariff);

function _templateObject3$17() {
  var data = _taggedTemplateLiteral(["\n  color: #908f96;\n"]);

  _templateObject3$17 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1l() {
  var data = _taggedTemplateLiteral(["\n  padding: 25px;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  color: #222222;\n"]);

  _templateObject2$1l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1A() {
  var data = _taggedTemplateLiteral(["\n  font-family: \"Open Sans\";\n  font-size: 14px;\n"]);

  _templateObject$1A = function _templateObject() {
    return data;
  };

  return data;
}
var DivFather$3 = styled__default.div(_templateObject$1A());
var DivInfo$1 = styled__default.div(_templateObject2$1l());
var DivDate = styled__default.div(_templateObject3$17());

function LostReservedDetails(props) {
  var ticket = 0;

  function updateId() {
    ticket += 1;
    return ticket;
  }

  return /*#__PURE__*/React__default.createElement(DivFather$3, {
    className: "LostReservedDetails"
  }, props.hotels.map(currentValue => /*#__PURE__*/React__default.createElement(DivInfo$1, {
    key: updateId()
  }, currentValue.numberOfUnits, "x ", currentValue.inventory.name, currentValue.startDate && currentValue.endDate ? /*#__PURE__*/React__default.createElement(DivDate, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
    value: currentValue.startDate
  }), "-", " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
    value: currentValue.endDate
  })) : "")));
}

LostReservedDetails.propTypes = {
  /** the lost reserved data, array of objects */
  hotels: PropTypes__default.array.isRequired
};
var LostReservedDetails$1 = pure(LostReservedDetails);

var Info$2 = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
})), "Info");

/** Popup of the lost reserved */
var msgs$X = reactIntl.defineMessages({
  lostReserved: {
    id: "app.label.deletedReservations",
    description: "Header title",
    defaultMessage: "Lost Reserved"
  }
});

function PopupLostReserved(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "PopupLostReserved"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$X.lostReserved),
    srcLogo: /*#__PURE__*/React__default.createElement(Info$2, null),
    closeWindow: props.closeWindow
  }, props.data && /*#__PURE__*/React__default.createElement(LostReservedDetails$1, {
    hotels: props.data
  })));
}

PopupLostReserved.defaultProps = {};
PopupLostReserved.propTypes = {
  /** Method to close the component */
  closeWindow: PropTypes__default.func.isRequired,

  /**  array of object to render the lost reserved data as child */
  data: PropTypes__default.array.isRequired
};
var index$g = pure(PopupLostReserved);

function _templateObject$1B() {
  var data = _taggedTemplateLiteral(["\n  font-weight: bold;\n"]);

  _templateObject$1B = function _templateObject() {
    return data;
  };

  return data;
}
var DivTitle$1 = styled__default.div(_templateObject$1B());

function WbkPrivacyPolicy(props) {
  var className = "WbkPrivacyPolicy";
  var PolicyText = /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement(DivTitle$1, null, "Informed consent clause"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, "Protection of personal data: In compliance with the provisions of Regulation (EU) 2016/679 of the European Parliament and of the Council, of April 27, 2016 (RGPD) you are informed that the data provided will be processed by INTEDOCS DIGITAL SOLUTIONS SL, with CIF B64554629 located in c/ Dr. August Pi i Sunyer 9-11, Bajos, 08034, Barcelona with telephone number 930013880 and email address info@witbooking.com. Your data will be processed in order to manage your hotel reservation. The personal data provided will be kept for the time necessary to comply with legal and contractual obligations according to current regulations at all times. The legal basis for the processing of your data is your consent. The data will be communicated to ", props.propertyName, ". You are informed that you can exercise your rights of access, rectification, deletion, limitation, portability and opposition, as well as withdraw your consent for the processing of your data. You can obtain more information about your rights by going to the website of the Spanish Agency for Data Protection, as well as submit a claim to this agency to consider it appropriate. For more detailed information, see our", " ", /*#__PURE__*/React__default.createElement("a", {
    href: "https://s3.eu-central-1.amazonaws.com/witbooking.static/doc/GDPR_EN.pdf",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy policy"), "."));

  if (props.locale === "es") {
    PolicyText = /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, /*#__PURE__*/React__default.createElement(DivTitle$1, null, "Clausula de consentimiento informado"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", null, "Protecci\xF3n de datos de car\xE1cter personal: En cumplimiento de lo dispuesto en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016 (RGPD) se le informa que los datos facilitados ser\xE1n tratados por INTEDOCS SOLUCIONES DIGITALES S.L, con CIF B64554629 situada en c/ Dr. August Pi i Sunyer 9-11, Bajos, 08034, Barcelona con tel\xE9fono 930013880 y direcci\xF3n de correo electr\xF3nico info@witbooking.com. Sus datos ser\xE1n tratados con la finalidad de gestionar la su reserva hotelera. Los datos personales proporcionados se conservar\xE1n durante el tiempo necesario para dar cumplimiento a las obligaciones legales y contractuales seg\xFAn la normativa vigente en cada momento. La base legal para el tratamiento de sus datos es su consentimiento. Los datos ser\xE1n comunicados a", " ", props.propertyName, ".Se le informa de que puede ejercer sus derechos de acceso, rectificaci\xF3n, supresi\xF3n, limitaci\xF3n, portabilidad y oposici\xF3n, as\xED como retirar su consentimiento para el tratamiento de sus datos. Puede obtener m\xE1s informaci\xF3n sobre sus derechos acudiendo a la p\xE1gina web de la Agencia Espa\xF1ola de Protecci\xF3n de Datos, as\xED como presentar una reclamaci\xF3n ante este organismo de considerarlo oportuno. Para ver una informaci\xF3n m\xE1s detallada, consulte nuestra", " ", /*#__PURE__*/React__default.createElement("a", {
      href: "https://s3.eu-central-1.amazonaws.com/witbooking.static/doc/GDPR_ES.pdf",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Pol\xEDtica de privacidad"), "."));
  }

  return PolicyText;
}

WbkPrivacyPolicy.propTypes = {
  /** This property has the name of the hotel */
  propertyName: PropTypes__default.string.isRequired
};
var WbkPrivacyPolicy$1 = pure(WbkPrivacyPolicy);

function HotelPrivacyPolicy(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "HotelPrivacyPolicy",
    dangerouslySetInnerHTML: {
      __html: props.privacyPolicy
    }
  });
}

HotelPrivacyPolicy.propTypes = {
  /** every room with the different prices to be rendered */
  privacyPolicy: PropTypes__default.string.isRequired
};
var HotelPrivacyPolicy$1 = pure(HotelPrivacyPolicy);

function _templateObject2$1m() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2$1m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1C() {
  var data = _taggedTemplateLiteral(["\n  border: 0px 1px 1px 1px solid #e1e1e1;\n  font-family: Open Sans;\n  font-size: 14px;\n  padding: 25px;\n  @media (max-width: 420px) {\n  }\n"]);

  _templateObject$1C = function _templateObject() {
    return data;
  };

  return data;
}
var DivFather$4 = styled__default.div(_templateObject$1C());
var HotelPrivacyContainerBottom = styled__default.div(_templateObject2$1m(), props => props.marginBottom ? "margin-top:20px" : "margin-bottom:20px");

function PrivacyDetails(props) {
  return /*#__PURE__*/React__default.createElement(DivFather$4, {
    className: "PrivacyDetails"
  }, props.data.reverse ? /*#__PURE__*/React__default.createElement("div", null, !props.hideDefaultPrivacyPolicy && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(WbkPrivacyPolicy$1, {
    propertyName: props.data.propertyName,
    locale: props.locale
  })), props.data.privacyPolicy && /*#__PURE__*/React__default.createElement(HotelPrivacyContainerBottom, {
    marginBottom: props.data.reverse
  }, /*#__PURE__*/React__default.createElement(HotelPrivacyPolicy$1, {
    privacyPolicy: props.data.privacyPolicy
  }))) : /*#__PURE__*/React__default.createElement("div", null, props.data.privacyPolicy && /*#__PURE__*/React__default.createElement(HotelPrivacyContainerBottom, null, /*#__PURE__*/React__default.createElement(HotelPrivacyPolicy$1, {
    privacyPolicy: props.data.privacyPolicy
  })), !props.hideDefaultPrivacyPolicy && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(WbkPrivacyPolicy$1, {
    propertyName: props.data.propertyName,
    locale: props.locale
  }))));
}

PrivacyDetails.defaultProps = {
  hideDefaultPrivacyPolicy: false
};
PrivacyDetails.propTypes = {
  /** This contains diverse properties which will be render as text or determine the order */
  data: PropTypes__default.object.isRequired,
  locale: PropTypes__default.string.isRequired,
  hideDefaultPrivacyPolicy: PropTypes__default.bool
};
var PrivacyDetails$1 = pure(PrivacyDetails);

/**  Popup of Privacy Policy */
var msgs$Y = reactIntl.defineMessages({
  privacy: {
    id: "titles.PrivacyTitle",
    description: "Header title",
    defaultMessage: "Priv Policy"
  }
});

function PopupPrivacy(props) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "PopupPrivacy"
  }, /*#__PURE__*/React__default.createElement(Popup, {
    headerText: /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Y.privacy),
    srcLogo: /*#__PURE__*/React__default.createElement(Info, null),
    closeWindow: props.closeWindow
  }, props.data && /*#__PURE__*/React__default.createElement(PrivacyDetails$1, {
    data: props.data,
    locale: props.locale,
    hideDefaultPrivacyPolicy: props.hideDefaultPrivacyPolicy
  })));
}

PopupPrivacy.defaultProps = {
  hideDefaultPrivacyPolicy: false
};
PopupPrivacy.propTypes = {
  locale: PropTypes__default.string.isRequired,

  /** method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,

  /** The data of privacy policies which will be rendered as a child in the Popup */
  data: PropTypes__default.object.isRequired,
  hideDefaultPrivacyPolicy: PropTypes__default.bool
};
var index$h = pure(PopupPrivacy);

function _templateObject15$9() {
  var data = _taggedTemplateLiteral(["\n  color: #329911;\n  text-decoration: underline;\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject15$9 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$a() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n"]);

  _templateObject14$a = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$b() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 20px;\n  text-align: left;\n"]);

  _templateObject13$b = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$b() {
  var data = _taggedTemplateLiteral(["\n  color: #b20e0e;\n  font-weight: 700;\n"]);

  _templateObject12$b = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$e() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f5e6e6;\n  padding: 10px 10px 20px 10px;\n  @media (min-width: 768px) {\n    padding: 20px 20px 20px 20px;\n  }\n"]);

  _templateObject11$e = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$e() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  color: #329911;\n  @media (min-width: 768px) {\n    display: inline;\n  }\n"]);

  _templateObject10$e = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$g() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject9$g = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$j() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: ", ";\n  &:hover {\n    cursor: ", ";\n  }\n"]);

  _templateObject8$j = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$o() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n"]);

  _templateObject7$o = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$s() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"]);

  _templateObject6$s = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$F() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f6f6f6;\n  border-bottom: solid 1px #e1e1e1;\n  font-weight: 400;\n  color: #1578bc;\n  font-size:", ";\n  padding:", ";\n  @media (min-width: 768px) {\n    font-size: 14px;\n      padding:", ";\n"]);

  _templateObject5$F = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$U() {
  var data = _taggedTemplateLiteral(["\n  background-color: #f6f6f6;\n  border-bottom: solid 1px #e1e1e1;\n  color: #010101;\n  font-weight: 700;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 10px 10px 10px;\n  @media (min-width: 768px) {\n    padding: 15px 20px 15px 20px;\n  }\n"]);

  _templateObject4$U = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$18() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"]);

  _templateObject3$18 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1n() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n"]);

  _templateObject2$1n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1D() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n"]);

  _templateObject$1D = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$Z = reactIntl.defineMessages({
  bestPrice: {
    id: "checkout.price_breakdown.bestPrice",
    description: "bestPrice",
    defaultMessage: "Best Price Guaranteed!"
  },
  bookingTotal: {
    id: "checkout.booking_total.bookingTotal",
    description: "Booking total",
    defaultMessage: "Booking total"
  },
  stayPrice: {
    id: "checkout.reservation_summary.stayPrice",
    description: "Stay",
    defaultMessage: "Stay"
  },
  free: {
    id: "booking_confirmation.reservation_summary.free",
    description: "free",
    defaultMessage: "Free"
  },
  included: {
    id: "service_selection.service.included",
    description: "included",
    defaultMessage: "Included"
  },
  extrasCancelled: {
    id: "bookingModification.extrasCancelled",
    description: "Services / extras canceled.",
    defaultMessage: "Services / extras canceled."
  },
  bookExtrasAgain: {
    id: "bookingModification.bookExtras_again",
    description: "Book again",
    defaultMessage: "Book again"
  }
});
var NonBold = styled__default.span(_templateObject$1D());
var Bold$2 = styled__default.span(_templateObject2$1n());
var PriceBreakdownWrapper = styled__default.div(_templateObject3$18());
var PriceContainer = styled__default.div(_templateObject4$U());
var PriceContainerExtras = styled__default.div(_templateObject5$F(), props => props.inModifyReservation ? "14px" : "11px", props => props.cancelled ? 0 : "10px", props => props.cancelled ? 0 : "20px");
var Currency$1 = styled__default.span(_templateObject6$s());
var LineThrough = styled__default.span(_templateObject7$o());
var Underline = styled__default.span(_templateObject8$j(), props => props.inModifyReservation ? undefined : "underline", props => props.inModifyReservation ? "default" : "pointer");
var ExtraItem$1 = styled__default.div(_templateObject9$g());
var BestPriceWrapper = styled__default.span(_templateObject10$e());
var ExtrasCancelledContainer = styled__default.div(_templateObject11$e());
var ExtrasCancelledMessage = styled__default.div(_templateObject12$b());
var QuantityName = styled__default.div(_templateObject13$b());
var Price = styled__default.div(_templateObject14$a());
var ExtrasBookAgain = styled__default.div(_templateObject15$9());

function renderServicePercentage(service, serviceRate, baseRate) {
  if (service.type !== constants.SERVICE_TYPE.PERCENTAGE) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("span", null, " (", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: serviceRate / baseRate // eslint-disable-next-line react/style-prop-object
    ,
    style: "percent",
    maximumFractionDigits: 2
  }), ")");
}

function PriceBreakdown(props) {
  var {
    addObligatoryExtrasRateToRoomSelection,
    discountAmount,
    baseRate,
    currency,
    discountDiff,
    hasDiscounts,
    hasSelectedServices,
    selectedServices,
    serviceRatesInfo,
    handleGallery,
    totalRate,
    cancelled,
    bookAgain,
    className,
    inModifyReservation,
    showBestPriceGuaranteed
  } = props;

  var isIncluded = (_ref) => {
    var {
      service
    } = _ref;
    return selectedServices[service].totalRate !== 0 && addObligatoryExtrasRateToRoomSelection && selectedServices[service].type !== constants.SERVICE_TYPE.PERCENTAGE && selectedServices[service].obligatory;
  };

  var showTotalRate = !hasDiscounts && !cancelled || hasDiscounts && hasSelectedServices && !cancelled;
  return /*#__PURE__*/React__default.createElement(PriceBreakdownWrapper, {
    className: "wbkv9-PriceBreakdown ".concat(className)
  }, (hasSelectedServices || cancelled) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PriceContainer, null, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.stayPrice), hasDiscounts && /*#__PURE__*/React__default.createElement("span", {
    className: "wbkv9-ReservationSummary-discountPercentage"
  }, " (-", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: discountAmount / baseRate
    /* eslint-disable-next-line */
    ,
    style: "percent",
    maximumFractionDigits: 2
  }), ")")), /*#__PURE__*/React__default.createElement("span", null, hasDiscounts && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(NonBold, null, /*#__PURE__*/React__default.createElement(Currency$1, null, "".concat(currency, " ")), /*#__PURE__*/React__default.createElement(LineThrough, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: baseRate,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }), "   ")), /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: discountDiff,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })) ||
  /*#__PURE__*/
  //   else just the currency and the original price
  React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Currency$1, null, "".concat(currency, " ")), /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: baseRate,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })))), /*#__PURE__*/React__default.createElement(PriceContainerExtras, {
    cancelled: cancelled,
    inModifyReservation: inModifyReservation,
    className: "wbkv9-ReservationSummary-servicesMainContainer"
  }, !cancelled && Object.keys(selectedServices).map(service => /*#__PURE__*/React__default.createElement(ExtraItem$1, {
    key: service
  }, /*#__PURE__*/React__default.createElement(QuantityName, null, /*#__PURE__*/React__default.createElement(Underline, {
    inModifyReservation: inModifyReservation,
    onClick: () => handleGallery(selectedServices[service])
  }, /*#__PURE__*/React__default.createElement("span", null, "(".concat(selectedServices[service].showedQuantity || selectedServices[service].quantity, ") "), selectedServices[service].name, renderServicePercentage(selectedServices[service], serviceRatesInfo[service], baseRate)))), /*#__PURE__*/React__default.createElement(Price, null, isIncluded({
    service
  }) && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.included) || selectedServices[service].totalRate !== 0 && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(Currency$1, null, " ", "".concat(currency, " ")), /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: serviceRatesInfo[service],
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })) || /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.free)))) || /*#__PURE__*/React__default.createElement(ExtrasCancelledContainer, null, /*#__PURE__*/React__default.createElement(ExtrasCancelledMessage, null, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.extrasCancelled), " "), /*#__PURE__*/React__default.createElement(ExtrasBookAgain, {
    onClick: bookAgain
  }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.bookExtrasAgain), " ")))), /*#__PURE__*/React__default.createElement(PriceContainer, {
    className: "wbkv9-ReservationSummary-total"
  }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.bookingTotal), hasDiscounts && !hasSelectedServices && !cancelled && /*#__PURE__*/React__default.createElement("span", {
    className: "wbkv9-ReservationSummary-discountPercentage"
  }, " (-", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: discountAmount / baseRate
    /* eslint-disable-next-line */
    ,
    style: "percent",
    maximumFractionDigits: 2
  }), ")")), !inModifyReservation && /*#__PURE__*/React__default.createElement(BestPriceWrapper, {
    className: "wbkv9-PriceBreakdown-BestPrice"
  }, showBestPriceGuaranteed && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$Z.bestPrice)), /*#__PURE__*/React__default.createElement("span", null, showTotalRate && /*#__PURE__*/React__default.createElement("span", null, currency, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: totalRate,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })) || // If has the cancelled prop show the baseRate instead
  !hasDiscounts && cancelled && /*#__PURE__*/React__default.createElement("span", null, currency, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: baseRate,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })), hasDiscounts && (!hasSelectedServices || cancelled) && /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(NonBold, null, !cancelled && /*#__PURE__*/React__default.createElement(Currency$1, null, " ", "".concat(currency, " ")) || /*#__PURE__*/React__default.createElement(Bold$2, null, " ", /*#__PURE__*/React__default.createElement(Currency$1, null, " ", "".concat(currency, " ")), " "), !cancelled && /*#__PURE__*/React__default.createElement(LineThrough, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: baseRate,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }), "   ")), /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: discountDiff,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })))));
} //TODO: Correct proptypes

/* PriceBreakdown.propTypes = {
  addObligatoryExtrasRateToRoomSelection: PropTypes.bool.isRequired,
  discountAmount: PropTypes.bool.isRequired,
  baseRate: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  discountDiff: PropTypes.number.isRequired,
  hasDiscounts: PropTypes.bool.isRequired,
  hasSelectedServices: PropTypes.bool.isRequired,
  selectedServices: PropTypes.object.isRequired,
  serviceRatesInfo: PropTypes.object.isRequired,
  handleGallery: PropTypes.func,
  totalRate: PropTypes.number.isRequired,
  cancelled: PropTypes.bool,
  bookAgain: PropTypes.func,
  className: PropTypes.string,
  inModifyReservation: PropTypes.bool,
  showBestPriceGuaranteed: PropTypes.bool
};
*/


PriceBreakdown.defaultProps = {
  cancelled: false,
  bookAgain: () => {},
  className: "",
  inModifyReservation: false,
  showBestPriceGuaranteed: false,
  handleGallery: () => {}
};
var PriceBreakdown$1 = pure(PriceBreakdown);

function _templateObject$1E() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n"]);

  _templateObject$1E = function _templateObject() {
    return data;
  };

  return data;
}
var Container$i = styled__default.div(_templateObject$1E());
/*
Icon names have an identifier which is used to differentiate to which set of icons they belong to
e.g. material/local_pharmacy, the material part serves to identify the icon set "material" (google icons)
There can be multiple sets, e.g. font-awesome/local_pharmacy, so this is used to remove the unique icon name
inside the set, in this case 'local_pharmacy'
* */

function removeIconSetIdentifier(iconName) {
  return iconName && iconName.split("/")[1];
}

var Icon = (_ref) => {
  var {
    iconName,
    className
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$i, {
    className: classnames("wbkv9-PromotionItem-icon ".concat(className))
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "material-icons"
  }, removeIconSetIdentifier(iconName)));
};

Icon.defaultProps = {
  className: ""
};
Icon.propTypes = {
  iconName: PropTypes__default.string.isRequired,
  className: PropTypes__default.string
};

function _templateObject11$f() {
  var data = _taggedTemplateLiteral(["\n .wbkv9-BookableErrorMessage-label-bold {\n   font-weight: bold;\n }\n"]);

  _templateObject11$f = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$f() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 40px;\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject10$f = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$h() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n"]);

  _templateObject9$h = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$k() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 21px;\n"]);

  _templateObject8$k = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$p() {
  var data = _taggedTemplateLiteral(["\n  word-wrap: break-word;\n  max-width: none;\n  flex: 1 1 auto;\n"]);

  _templateObject7$p = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$t() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 20px 20px 20px;\n  font-size: 13px;\n  font-weight: 400;\n  border-bottom: solid 1px #e1e1e1;\n  & ul {\n    padding: 0 0 0 20px;\n  }\n"]);

  _templateObject6$t = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$G() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 0 0 40px;\n  margin: 0 10px 0 0;\n  justify-content: center;\n"]);

  _templateObject5$G = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$V() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n"]);

  _templateObject4$V = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$19() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  font-style: italic;\n"]);

  _templateObject3$19 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1o() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 14px;\n  padding: 20px 20px 20px 20px;\n"]);

  _templateObject2$1o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1F() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  border-bottom: solid 1px #e1e1e1;\n  background-color: ", ";\n  font-size: 13px;\n  font-weight: 700;\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject$1F = function _templateObject() {
    return data;
  };

  return data;
}
var PromotionStyle = styled__default.div(_templateObject$1F(), props => props.expanded ? props.inverseTextColor : props.textColor, props => props.expanded ? props.textColor : "fff");
var PromotionStyleTop = styled__default.div(_templateObject2$1o());
PromotionStyleTop.displayName = "PromotionStyleTop";
var Reduction = styled__default.div(_templateObject3$19());
Reduction.displayName = "Reduction";
var PercentageSign = styled__default.div(_templateObject4$V());
PercentageSign.displayName = "PercentageSign";
var ReductionAndArrow = styled__default.div(_templateObject5$G());
var PromotionsBody = styled__default.div(_templateObject6$t());
var PromotionName = styled__default.div(_templateObject7$p());
var ArrowContainer = styled__default.div(_templateObject8$k());
var Currency$2 = styled__default.span(_templateObject9$h());
var StyledIcon$1 = styled__default(Icon)(_templateObject10$f());
var GlobalStyle$4 = styled.createGlobalStyle(_templateObject11$f());
var ariValueType = ["MIN_STAY", "MAX_STAY", "MIN_NOTICE", "MAX_NOTICE", "CONTRACT_PERIOD"];

function getStatusDetails(statusMap, type) {
  if (!statusMap[type]) {
    return null;
  }

  return {
    status: statusMap[type].code,
    valueType: statusMap[type].filterType,
    value: statusMap[type].value,
    labelClassName: "wbkv9-BookableErrorMessage-label-bold"
  };
}

function hasRestrictions(status, expires, reduction) {
  var hasErrorMessages = ariValueType.map(valueType => {
    if (status[valueType] && status[valueType].value !== null) {
      return true;
    }

    return null;
  }).filter(it => it !== null).length > 0;
  return hasErrorMessages || expires || reduction > 0;
}
/** Component that renders each individual promotion */


class PromotionItem extends React.PureComponent {
  constructor() {
    super();

    _defineProperty(this, "showDiscountReduction", promotion => Boolean(!promotion.icon && promotion.reduction && promotion.reduction !== 0 && promotion.discountedNights <= 0 && promotion.minStayForDiscountedNights <= 0));

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.click(this.props.expandId);
  }

  render() {
    var {
      expanded,
      currency,
      inverseTextColor,
      textColor,
      BookableErrorMessage,
      data: {
        name,
        reduction,
        percentage,
        description,
        expires,
        status,
        icon
      },
      data
    } = this.props;
    var showReduction = this.showDiscountReduction(data);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(GlobalStyle$4, null), /*#__PURE__*/React__default.createElement(PromotionStyle, {
      className: expanded && "Promotions-PromotionItem",
      expanded: expanded,
      inverseTextColor: inverseTextColor,
      textColor: textColor
    }, /*#__PURE__*/React__default.createElement(PromotionStyleTop, {
      onClick: this.handleClick
    }, /*#__PURE__*/React__default.createElement(ReductionAndArrow, null, showReduction && /*#__PURE__*/React__default.createElement(Reduction, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
      value: reduction,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }), percentage ? /*#__PURE__*/React__default.createElement(PercentageSign, null, "%") : /*#__PURE__*/React__default.createElement(Currency$2, null, currency)), !showReduction && /*#__PURE__*/React__default.createElement(StyledIcon$1, {
      iconName: icon
    })), /*#__PURE__*/React__default.createElement(PromotionName, null, name), /*#__PURE__*/React__default.createElement(ArrowContainer, null, !expanded && /*#__PURE__*/React__default.createElement(ArrowDropDown, null), expanded && /*#__PURE__*/React__default.createElement(ArrowDropUp, null))), expanded && /*#__PURE__*/React__default.createElement(PromotionsBody, null, /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), hasRestrictions(status, expires, reduction) && /*#__PURE__*/React__default.createElement("div", null, ariValueType.map(valueType => /*#__PURE__*/React__default.createElement("div", {
      key: valueType
    }, /*#__PURE__*/React__default.createElement(BookableErrorMessage, _extends({
      colon: true
    }, getStatusDetails(status, valueType))))), expires && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BookableErrorMessage, _extends({
      colon: true
    }, getStatusDetails(status, "VALIDITY"))))))));
  }

}

PromotionItem.defaultProps = {
  data: {},
  expandId: null,
  expanded: false,
  currency: "",
  inverseTextColor: "",
  textColor: "",
  click: () => null
};
PromotionItem.propTypes = {
  /** Individual promotion object */
  data: PropTypes__default.object,

  /** ID necessary for the callback function */
  expandId: PropTypes__default.number,

  /** Whether this promotion is expanded or not */
  expanded: PropTypes__default.bool,

  /** Currency */
  currency: PropTypes__default.string,

  /** Background color for expanded promotion */
  inverseTextColor: PropTypes__default.string,

  /** Text color for expanded promotion */
  textColor: PropTypes__default.string,

  /** Callback function that passes the expandedID of the current component
   *  to the parent component */
  click: PropTypes__default.func,
  BookableErrorMessage: PropTypes__default.func.isRequired
};

/** Main component that renders the header and iterates through promotions prop to render each
 * promotion in body. Saves in its state which one of the promotions is expanded.
 * Provides a callback function to Promotion components that allows to change
 * which one of promotions is expanded. */

class PromotionsList extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      expanded: null
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(id) {
    if (this.state.expanded === id) {
      this.setState({
        expanded: null
      });
    } else {
      this.setState({
        expanded: id
      });
    }
  }

  render() {
    var {
      promotions,
      currency,
      inverseTextColor,
      textColor,
      BookableErrorMessage
    } = this.props;
    return /*#__PURE__*/React__default.createElement("div", null, Object.values(promotions).map((promotion, index) => /*#__PURE__*/React__default.createElement(PromotionItem, {
      className: "promotion",
      key: promotion.ticker,
      data: promotion,
      expandId: index,
      expanded: index === this.state.expanded,
      currency: currency,
      inverseTextColor: inverseTextColor,
      textColor: textColor,
      click: this.handleClick,
      BookableErrorMessage: BookableErrorMessage
    })));
  }

}

PromotionsList.defaultProps = {
  inverseTextColor: "",
  textColor: ""
};
PromotionsList.propTypes = {
  /** A JSON that contains all the promotions */
  promotions: PropTypes__default.object.isRequired,

  /** Currency */
  currency: PropTypes__default.string.isRequired,

  /** Background color for expanded promotion */
  inverseTextColor: PropTypes__default.string,

  /** Text color for expanded promotion */
  textColor: PropTypes__default.string,
  BookableErrorMessage: PropTypes__default.func.isRequired
};

var msgs$_ = reactIntl.defineMessages({
  advantages: {
    id: "mobile_promotion_list.title",
    description: "Direct booking advantages",
    defaultMessage: "Direct booking advantages"
  }
});

function PopupPromotions(props) {
  var {
    promotions,
    currency,
    inverseTextColor,
    textColor,
    BookableErrorMessage,
    closeWindow,
    headerText,
    headerIcon,
    footer
  } = props;
  return /*#__PURE__*/React__default.createElement(Popup, {
    headerText: headerText !== null && headerText !== void 0 ? headerText : /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$_.advantages),
    closeWindow: closeWindow,
    srcLogo: headerIcon,
    footer: footer
  }, promotions && /*#__PURE__*/React__default.createElement(PromotionsList, {
    promotions: promotions,
    currency: currency,
    inverseTextColor: inverseTextColor,
    textColor: textColor,
    BookableErrorMessage: BookableErrorMessage
  }));
}

PopupPromotions.defaultProps = {
  currency: "",
  inverseTextColor: "",
  textColor: "",
  BookableErrorMessage: () => null
};
PopupPromotions.propTypes = {
  /** Method to close the Popup */
  closeWindow: PropTypes__default.func.isRequired,

  /** JSON promotions */
  promotions: PropTypes__default.object.isRequired,

  /** Currency */
  currency: PropTypes__default.string,

  /** Background color for expanded promotion */
  inverseTextColor: PropTypes__default.string,

  /** Text color for expanded promotion */
  textColor: PropTypes__default.string,
  BookableErrorMessage: PropTypes__default.func
};
var index$i = pure(PopupPromotions);

var BaselineBarChart = createSvgIcon( /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
}), /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), "BaselineBarChart");

/* TODO: SANITIZE */
function renderHTML(src) {
  return {
    __html: src
  };
}

function _templateObject39$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n\n  @media (min-width: ", ") {\n    display: block;\n\n    ", ", ", " {\n      width: 100%;\n    }\n  }\n"]);

  _templateObject39$1 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  svg {\n    fill: ", ";\n  }\n"]);

  _templateObject38$1 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .wbkv9-PropertyCard-thumbnailContainer img {\n    width: auto;\n    height: 100%;\n    max-width: none;\n  }\n\n  .slick-slider,\n  .slick-list,\n  .slick-track,\n  .wbkv9-Thumbnail,\n  .wbkv9-Thumbnail-aside {\n    height: 100%;\n  }\n\n  .wbkv9-Thumbnail {\n    width: 100%;\n  }\n\n  @media (min-width: ", ") {\n    display: block;\n    position: relative;\n    width: 302px;\n    max-width: 302px;\n    height: 100%;\n    flex: 0 0 302px;\n    background-color: ", ";\n  }\n\n  @media (min-width: ", "), (min-width: ", ") {\n    width: 302px;\n    max-width: 302px;\n    flex: 0 0 302px;\n  }\n\n  @media (min-width: ", ") {\n    .wbkv9-RoomSelection-hotelCardContainer {\n      &:not(.hasMap) {\n        .wbkv9-PropertyCard-imageSlider {\n          display: block;\n        }\n      }\n    }\n  }\n\n  @media (min-width: 965px) {\n    .wbkv9-RoomSelection-hotelCardContainer {\n      &:not(.hasMap) {\n        .wbkv9-PropertyCard-imageSlider {\n          display: block;\n        }\n      }\n    }\n  }\n\n  @media (min-width: ", ") {\n    .wbkv9-RoomSelection-hotelCardContainer {\n      &:not(.hasMap) {\n        .wbkv9-PropertyCard-imageSlider {\n          display: block;\n        }\n      }\n    }\n  }\n\n  @media (min-width: ", ") and (max-width: 1365px) {\n    width: 166px;\n    max-width: 166px;\n    flex: 0 0 166px;\n  }\n\n  @media (min-width: 1366px) and (max-width: ", ") {\n    width: 210px;\n    max-width: 210px;\n    flex: 0 0 210px;\n  }\n\n  @media (min-width: 1440px) {\n    .wbkv9-RoomSelection-hotelCardContainer {\n      &:not(.hasMap) {\n        .wbkv9-PropertyCard-imageSlider {\n          display: block;\n        }\n      }\n    }\n  }\n"]);

  _templateObject37$1 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36$1() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject36$1 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: 400;\n\n  @media (min-width: ", ") {\n    margin-left: 4px;\n    font-size: inherit;\n  }\n"]);

  _templateObject35$1 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject34$1 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  font-weight: 700;\n  text-align: center;\n\n  > span {\n    display: block;\n  }\n  @media (min-width: ", ") and (max-width: ", ") {\n    font-size: 13px;\n  }\n\n  @media (min-width: ", ") {\n    font-weight: 400;\n    text-align: left;\n\n    > span {\n      display: inline-block;\n    }\n  }\n"]);

  _templateObject33$1 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32$1() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-size: 10px;\n  font-weight: 400;\n  text-align: center;\n\n  button {\n    text-transform: uppercase;\n  }\n\n  @media (min-width: ", ") {\n    font-size: inherit;\n    font-weight: 700;\n    text-align: left;\n  }\n"]);

  _templateObject32$1 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 4px 0;\n\n  ", ";\n\n  @media (min-width: ", ") {\n    background-color: ", ";\n    border: 1px solid ", ";\n    padding: 0 10px 2px;\n\n    ", ", ", ", ", " {\n      color: ", ";\n    }\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    background-color: transparent;\n    border: none;\n\n    ", " {\n      button {\n        background-color: transparent;\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject31$1 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 4px 10px 2px;\n\n  ", ";\n\n  @media (min-width: ", ") {\n    padding: 0 10px 2px;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    background-color: transparent;\n\n    ", " {\n      button {\n        background-color: transparent;\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject30$1 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29$1() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  ", ";\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 0 10px;\n\n    ", " {\n      font-size: 13px;\n    }\n  }\n"]);

  _templateObject29$1 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28$1() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: ", ") and (max-width: ", ") {\n    flex-direction: column;\n  }\n"]);

  _templateObject28$1 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27$2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n\n  ", " {\n    height: 100%;\n  }\n\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    .wbkv9-PropertyCard-collapsibleArrow-active {\n      svg {\n        width: 10px;\n        height: 6px;\n        fill: ", ";\n      }\n    }\n  }\n\n  @media (min-width: ", ") {\n    ", " {\n      display: block;\n    }\n\n    ", " {\n      .wbkv9-PropertyCard-collapsibleArrow-active {\n        background-color: ", ";\n\n        svg {\n          width: 13px;\n          height: 8px;\n          fill: ", ";\n        }\n      }\n    }\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject27$2 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26$2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  border-radius: 100%;\n\n  svg {\n    width: 13px;\n    height: 8px;\n    fill: ", ";\n  }\n\n  &.hasOccupancyNotPossible {\n    display: none;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    width: 22px;\n    height: 22px;\n    background-color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n\n    &.hasOccupancyNotPossible {\n      display: flex;\n    }\n  }\n\n  @media (min-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject26$2 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 0 10px 2px;\n\n  @media (min-width: ", ") {\n    flex-wrap: nowrap;\n    width: auto;\n    height: 53px;\n    border-radius: 5px;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    height: 100%;\n    flex-wrap: wrap;\n  }\n"]);

  _templateObject25$2 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n\n  @media (min-width: ", ") {\n    width: auto;\n    height: auto;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    height: 100%;\n  }\n"]);

  _templateObject24$3 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 0 0 91px;\n  width: 91px;\n\n  @media (min-width: ", ") {\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    flex: none;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: auto;\n    flex: 0 1 auto;\n  }\n"]);

  _templateObject23$3 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22$3() {
  var data = _taggedTemplateLiteral(["\n  border-right: 1.4px solid ", ";\n  margin: 5px 15px 0;\n  height: 12px;\n\n  @media (min-width: ", ") {\n    display: none;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: block;\n  }\n"]);

  _templateObject22$3 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21$3() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 400;\n\n  button {\n    text-decoration: underline;\n  }\n\n  @media (min-width: ", ") {\n    font-weight: 700;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    font-weight: 400;\n  }\n"]);

  _templateObject21$3 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    font-size: 13px;\n  }\n"]);

  _templateObject20$3 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19$3() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  @media (min-width: ", ") {\n    display: flex;\n    max-height: 41px;\n    overflow: hidden;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject19$3 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$4() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  width: 100%;\n  padding: 8px 10px 11px 0;\n\n  @media (min-width: ", ") {\n    padding: 0;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    width: auto;\n  }\n"]);

  _templateObject18$4 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$6() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n  "]);

  _templateObject17$6 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$7() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  padding: 0 0 0 20px;\n  display: flex;\n  flex-wrap: nowrap;\n  background-color: ", ";\n  transition: background-color 0.4s;\n\n  &:hover {\n    ", "\n  }\n\n  ", ";\n\n  ", ";\n\n  @media (min-width: ", ") {\n    flex-wrap: wrap;\n    padding: 6px 20px 11px;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    flex-wrap: nowrap;\n    padding: 6px 10px 11px 13px;\n    align-items: center;\n\n    &:hover {\n      ", ", ", " {\n        color: ", ";\n      }\n\n      ", " {\n        .Amount {\n          color: ", ";\n        }\n      }\n\n      ", " {\n        .wbkv9-BookableErrorMessage-label,\n        .wbkv9-BookableErrorMessage-value {\n          color: ", ";\n        }\n      }\n\n      ", " {\n        button {\n          color: ", ";\n        }\n      }\n    }\n  }\n"]);

  _templateObject16$7 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$a() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n\n    ", ", ", ", ", ", ", " {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n"]);

  _templateObject15$a = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$b() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  @media (min-width: ", ") {\n    display: block;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    text-decoration: underline;\n  }\n"]);

  _templateObject14$b = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$c() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 22px;\n  text-decoration: underline;\n\n  @media (min-width: ", ") {\n    margin-left: 38px;\n    text-decoration: none;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n    margin-left: 0;\n    text-align: center;\n    color: ", ";\n    margin-top: 15px;\n  }\n"]);

  _templateObject13$c = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$c() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n  button {\n    min-height: 0;\n    text-transform: uppercase;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n    text-align: center;\n    font-size: 13px;\n\n    button {\n      color: ", ";\n      border-radius: 5px;\n      background-color: ", ";\n      padding: 8px 22px;\n    }\n  }\n"]);

  _templateObject12$c = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$g() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 7px 0;\n  color: ", ";\n  font-size: 13px;\n  line-height: 16px;\n  text-transform: uppercase;\n\n  .wbkv9-BookableErrorMessage {\n    text-align: center;\n  }\n\n  .wbkv9-BookableErrorMessage-label,\n  .wbkv9-BookableErrorMessage-value {\n    color: ", ";\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 13px;\n    text-transform: uppercase;\n    display: block;\n  }\n\n  @media (min-width: ", ") {\n    flex-wrap: nowrap;\n\n    &.wbkv9-PropertyCard-occupancyNotPossible {\n      flex-wrap: wrap;\n    }\n\n    .wbkv9-BookableErrorMessage {\n      text-align: left;\n    }\n\n    .wbkv9-BookableErrorMessage-label,\n    .wbkv9-BookableErrorMessage-value {\n      font-size: 13px;\n      line-height: 16px;\n    }\n\n    .wbkv9-BookableErrorMessage-value {\n      font-weight: 400;\n    }\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n\n    .wbkv9-BookableErrorMessage {\n      text-align: center;\n    }\n\n    .wbkv9-BookableErrorMessage-label,\n    .wbkv9-BookableErrorMessage-value {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject11$g = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$g() {
  var data = _taggedTemplateLiteral(["\n  .Amount {\n    align-items: center;\n\n    .decimalPart {\n      margin-top: -4px;\n    }\n  }\n\n  @media (min-width: ", ") {\n    margin-right: 3px;\n    margin-left: 15px;\n\n    .Amount {\n      .decimalPart {\n        margin-top: -5px;\n      }\n    }\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n    margin-right: 0;\n    margin-left: 0;\n    margin-bottom: 6px;\n\n    .Amount {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject10$g = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$i() {
  var data = _taggedTemplateLiteral(["\n  font-size: 10px;\n  font-weight: 400;\n\n  button {\n    min-height: 0;\n  }\n\n  @media (min-width: ", ") {\n    font-size: inherit;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n    text-align: center;\n  }\n"]);

  _templateObject9$i = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$l() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  text-decoration: underline;\n"]);

  _templateObject8$l = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$q() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  font-weight: 400;\n\n  button {\n    text-decoration: underline;\n  }\n\n  &.active {\n    display: flex;\n    align-items: center;\n    height: 16px;\n    padding: 0 16px;\n    margin-top: 3px;\n    margin-left: -16px;\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n\n    > span {\n      margin-bottom: 2px;\n    }\n\n    ", " {\n      position: absolute;\n      left: 50%;\n      bottom: -6px;\n      transform: translateX(-50%);\n      width: 0;\n      height: 0;\n      border-color: ", " transparent transparent;\n      border-style: solid;\n      border-width: 6px 6px 0;\n      z-index: 2;\n      transition: border-color 0.4s;\n    }\n  }\n\n  @media (min-width: ", ") {\n    display: none;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: block;\n  }\n"]);

  _templateObject7$q = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$u() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  text-transform: capitalize;\n  @media (min-width: ", ") {\n    display: flex;\n    justify-content: flex-start;\n    position: relative;\n    margin: 0 10px 8px -5px;\n    cursor: pointer;\n\n    button {\n      position: relative;\n      height: 36px;\n      border-radius: 5px;\n      border: 1px solid ", ";\n      background-color: ", ";\n      color: ", ";\n      font-size: 13px;\n      line-height: 14px;\n      font-weight: 400;\n      text-transform: uppercase;\n      padding: 0 10px;\n      z-index: 1;\n      transition: background-color 0.4s;\n    }\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n\n    &.active {\n      button {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      ", " {\n        position: absolute;\n        left: 50%;\n        bottom: -8px;\n        transform: translateX(-50%);\n        width: 0;\n        height: 0;\n        border-color: ", " transparent transparent;\n        border-style: solid;\n        border-width: 9px 9px 0;\n        z-index: 2;\n        transition: border-color 0.4s;\n      }\n    }\n\n    &:hover {\n      button {\n        background-color: ", ";\n        color: ", ";\n      }\n\n      ", " {\n        border-color: ", " transparent transparent;\n      }\n    }\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    display: none;\n  }\n"]);

  _templateObject6$u = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$H() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  position: absolute;\n  left: 50%;\n  bottom: -6px;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-color: ", " transparent transparent;\n  border-style: solid;\n  border-width: 6px 6px 0;\n  z-index: 2;\n  transition: border-color 0.4s;\n"]);

  _templateObject5$H = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$W() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 20px;\n  transition: color 0.4s;\n\n  @media (min-width: ", ") {\n    font-size: 14px;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n  }\n"]);

  _templateObject4$W = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1a() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  margin-bottom: -2px;\n  transition: color 0.4s;\n\n  @media (min-width: ", ") {\n    font-size: 20px;\n    margin-bottom: 1px;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    width: 100%;\n    margin-bottom: 11px;\n    font-size: 18px;\n    line-height: 22px;\n  }\n"]);

  _templateObject3$1a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1p() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: auto;\n  border: 1px solid ", ";\n  text-align: left;\n\n  @media (min-width: ", "), (min-width: ", ") {\n    height: 192px;\n  }\n\n  @media (min-width: ", ") and (max-width: ", ") {\n    height: 125px;\n  }\n"]);

  _templateObject2$1p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1G() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1G = function _templateObject() {
    return data;
  };

  return data;
}
var PropertyCardContainer = styled__default.div(_templateObject$1G());
var PropertyCardWrapper = styled__default.div(_templateObject2$1p(), greyLighter, minWidthTabletHorizontal, minWidthLargeDesktop, minWidthDesktop, maxWidthDesktop);
var PropertyName = styled__default.div(_templateObject3$1a(), wbBlack, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var PropertyDescriptionContainer = styled__default.div(_templateObject4$W(), greyLight, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var CompareRatesArrow = styled__default.div(_templateObject5$H(), greyLight);
var CompareRatesButton = styled__default.div(_templateObject6$u(), minWidthTabletHorizontal, greyLight, white, greyLight, greyLight, white, CompareRatesArrow, greyLight, wbGreyLightest, greyLight, CompareRatesArrow, wbGreyLightest, minWidthDesktop, maxWidthDesktop);
var CompareRatesLabel = styled__default.div(_templateObject7$q(), greyLight, white, CompareRatesArrow, greyLight, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var CheckAvailabilityButtonText = styled__default.div(_templateObject8$l(), greyLight);
var SecondaryText = styled__default.div(_templateObject9$i(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var Amount$4 = styled__default.div(_templateObject10$g(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop, wbBlack);
var ButtonTextContainer = styled__default.div(_templateObject11$g(), white, white, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop, wbOrange);
var MainText = styled__default.div(_templateObject12$c(), minWidthDesktop, maxWidthDesktop, white, wbGreen);
var ShowAvailability = styled__default.div(_templateObject13$c(), white, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop, greyLight);
var ShowAvailabilityText = styled__default(ShowAvailability)(_templateObject14$b(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var PropertyInfoContainerSelected = styled.css(_templateObject15$a(), wbBlack, PropertyName, PropertyDescriptionContainer, CompareRatesButton, CheckAvailabilityButtonText, white, white);
var PropertyInfoContainer = styled__default.div(_templateObject16$7(), greyBasic, PropertyInfoContainerSelected, props => props.markerSelected && PropertyInfoContainerSelected, media.down.md(_templateObject17$6()), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop, SecondaryText, ShowAvailabilityText, white, Amount$4, white, ButtonTextContainer, white, MainText, white);
var PropertyInfoWrapper = styled__default.div(_templateObject18$4(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var PropertyDescription = styled__default.div(_templateObject19$3(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var LabelsContainer$1 = styled__default.div(_templateObject20$3(), minWidthDesktop, maxWidthDesktop);
var ReadMore$3 = styled__default.div(_templateObject21$3(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var LabelsSeparator = styled__default.div(_templateObject22$3(), greyLight, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var ButtonsContainer$1 = styled__default.div(_templateObject23$3(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var AvailabilityButtonContainer = styled__default.div(_templateObject24$3(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var AvailabilityButton = styled__default.div(_templateObject25$2(), minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop);
var CollapsibleArrow = styled__default.div(_templateObject26$2(), greyLight, minWidthTabletHorizontal, greyLight, greyBasic, minWidthTabletHorizontal);
var AvailableButton = styled__default(AvailabilityButton)(_templateObject27$2(), wbGreen, ButtonTextContainer, MainText, CollapsibleArrow, white, minWidthTabletHorizontal, MainText, CollapsibleArrow, white, wbGreen, minWidthDesktop, maxWidthDesktop);
var AvailabilityButtonWrapper = styled.css(_templateObject28$1(), minWidthDesktop, maxWidthDesktop);
var SecondaryAvailableButton = styled__default.div(_templateObject29$1(), AvailabilityButtonWrapper, minWidthDesktop, maxWidthDesktop, SecondaryText);
var RestrictedButton = styled__default(AvailabilityButton)(_templateObject30$1(), wbOrange, AvailabilityButtonWrapper, minWidthTabletHorizontal, minWidthDesktop, maxWidthDesktop, MainText, wbOrange);
var UnavailableButton = styled__default(AvailabilityButton)(_templateObject31$1(), greyLight, AvailabilityButtonWrapper, minWidthTabletHorizontal, white, greyLight, ButtonTextContainer, ShowAvailability, ShowAvailabilityText, greyLight, minWidthDesktop, maxWidthDesktop, MainText, greyLight);
var OccupancyNotPossibleSecondaryText = styled__default.div(_templateObject32$1(), minWidthTabletHorizontal);
var OccupancyNotPossibleMainText = styled__default.div(_templateObject33$1(), minWidthDesktop, maxWidthDesktop, minWidthTabletHorizontal);
var OccupancyNotPossibleUnity = styled__default.span(_templateObject34$1());
var OccupancyNotPossibleRooms = styled__default.div(_templateObject35$1(), minWidthTabletHorizontal);
var AvailabilityText = styled__default(ShowAvailability)(_templateObject36$1(), minWidthTabletHorizontal);
var ImageSlider = styled__default.div(_templateObject37$1(), greyBasic, minWidthTabletHorizontal, greyBasic, minWidthTabletHorizontal, minWidthLargeDesktop, minWidthDesktopAlternative, minWidthDesktop, minWidthDesktop, maxWidthDesktop);
var CheckAvailabilityButton = styled__default.div(_templateObject38$1(), greyLight);
var BookableContainer = styled__default.div(_templateObject39$1(), minWidthTabletHorizontal, MainText, SecondaryText);

var msgs$$ = reactIntl.defineMessages({
  from: {
    id: "room_selection.hotel_card.from",
    description: "from",
    defaultMessage: "FROM"
  },
  readMore: {
    id: "room_selection.hotel_card.readMore",
    description: "Read more",
    defaultMessage: "Read more"
  },
  compareRates: {
    id: "room_selection.hotel_card.compareRates",
    description: "Compare rates",
    defaultMessage: "Compare rates"
  },
  bookNow: {
    id: "room_selection.hotel_card.bookNow",
    description: "bookNow",
    defaultMessage: "BOOK NOW"
  },
  requires: {
    id: "room_selection.hotel_card.requires",
    description: "Requires",
    defaultMessage: "Requires"
  },
  twoPlus: {
    id: "room_selection.hotel_card.twoPlus",
    description: "2+",
    defaultMessage: "2+"
  },
  rooms: {
    id: "room_selection.hotel_card.rooms",
    description: "Rooms",
    defaultMessage: "Rooms"
  },
  availability: {
    id: "room_selection.hotel_card.availability",
    description: "availability",
    defaultMessage: "availability"
  },
  unavailable: {
    id: "room_selection.hotel_card.unavailable",
    description: "unavailable",
    defaultMessage: "Sold Out"
  },
  viewAvailability: {
    id: "room_selection.hotel_card.viewAvailability",
    description: "view availability",
    defaultMessage: "view availability"
  },
  showAvailability: {
    id: "room_selection.hotel_card.showAvailability",
    description: "Show availability",
    defaultMessage: "Show availability"
  }
});

function PropertyCard(_ref) {
  var {
    propertyTicker,
    propertyName,
    description,
    currency,
    available,
    restricted,
    unavailable,
    occupancyNotPossible,
    calendarExpanded,
    markerSelected,
    AmountComponent,
    BookableErrorMessage,
    Slider,
    ArrowDownIcon,
    children,
    onHover,
    onMouseLeave,
    handleClick,
    handleCalendar
  } = _ref;
  return /*#__PURE__*/React__default.createElement(PropertyCardContainer, {
    className: "wbkv9-PropertyCard-container",
    onMouseEnter: () => onHover(propertyTicker),
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React__default.createElement(PropertyCardWrapper, {
    className: "wbkv9-PropertyCard-wrapper"
  }, /*#__PURE__*/React__default.createElement(ImageSlider, {
    className: "wbkv9-PropertyCard-imageSlider"
  }, Slider), /*#__PURE__*/React__default.createElement(PropertyInfoContainer, {
    className: "wbkv9-PropertyCard-propertyInfoContainer",
    markerSelected: markerSelected
  }, /*#__PURE__*/React__default.createElement(PropertyInfoWrapper, {
    className: "wbkv9-PropertyCard-propertyInfoWrapper"
  }, /*#__PURE__*/React__default.createElement(PropertyName, {
    className: "wbkv9-PropertyCard-propertyName"
  }, propertyName), /*#__PURE__*/React__default.createElement(PropertyDescriptionContainer, {
    className: "wbkv9-PropertyCard-propertyDescriptionContainer"
  }, /*#__PURE__*/React__default.createElement(PropertyDescription, {
    className: "wbkv9-PropertyCard-propertyDescription"
  }, /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: renderHTML(description)
  })), /*#__PURE__*/React__default.createElement(LabelsContainer$1, {
    className: "wbkv9-PropertyCard-labelsContainer"
  }, /*#__PURE__*/React__default.createElement(ReadMore$3, {
    className: "wbkv9-PropertyCard-readMore"
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.readMore))), /*#__PURE__*/React__default.createElement(LabelsSeparator, {
    className: "wbkv9-PropertyCard-labelsSeparator"
  }), /*#__PURE__*/React__default.createElement(CompareRatesLabel, {
    className: classnames("wbkv9-PropertyCard-compareRatesLabel", calendarExpanded && "wbkv9-PropertyCard-compareRatesLabelActive", calendarExpanded && "active")
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: handleCalendar
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.compareRates)), /*#__PURE__*/React__default.createElement(CompareRatesArrow, {
    className: "wbkv9-PropertyCard-compareRatesLabelArrow"
  }))))), /*#__PURE__*/React__default.createElement(ButtonsContainer$1, {
    className: "wbkv9-PropertyCard-buttonsContainer"
  }, /*#__PURE__*/React__default.createElement(CompareRatesButton, {
    className: classnames("wbkv9-PropertyCard-compareRatesButton", calendarExpanded && "wbkv9-PropertyCard-compareRatesButtonActive", calendarExpanded && "active"),
    onClick: handleCalendar
  }, /*#__PURE__*/React__default.createElement(CheckAvailabilityButton, null, /*#__PURE__*/React__default.createElement(BaselineBarChart, null), /*#__PURE__*/React__default.createElement(CheckAvailabilityButtonText, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.availability))), /*#__PURE__*/React__default.createElement(CompareRatesArrow, {
    className: "wbkv9-PropertyCard-compareRatesArrow"
  })), /*#__PURE__*/React__default.createElement(AvailabilityButtonContainer, {
    className: "wbkv9-PropertyCard-availabilityButtonContainer",
    onClick: handleClick
  }, available && /*#__PURE__*/React__default.createElement(AvailableButton, {
    className: classnames("wbkv9-PropertyCard-availableButton", "wbkv9-PropertyCard-availabilityButton")
  }, /*#__PURE__*/React__default.createElement(ButtonTextContainer, {
    className: classnames("wbkv9-PropertyCard-buttonTextContainer", occupancyNotPossible && "wbkv9-PropertyCard-occupancyNotPossible")
  }, !occupancyNotPossible && /*#__PURE__*/React__default.createElement(BookableContainer, {
    className: "wbkv9--PropertyCard-bookableContainer"
  }, /*#__PURE__*/React__default.createElement(MainText, {
    className: "wbkv9-PropertyCard-mainText"
  }, /*#__PURE__*/React__default.createElement("button", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.bookNow))), /*#__PURE__*/React__default.createElement(SecondaryText, {
    className: "wbkv9-PropertyCard-secondaryText"
  }, /*#__PURE__*/React__default.createElement("button", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.from), " ", currency))), occupancyNotPossible && /*#__PURE__*/React__default.createElement(OccupancyNotPossibleSecondaryText, {
    className: "wbkv9-PropertyCard-occupancyNotPossibleSecondaryText"
  }, /*#__PURE__*/React__default.createElement("button", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.requires))), occupancyNotPossible && /*#__PURE__*/React__default.createElement(OccupancyNotPossibleMainText, {
    className: "wbkv9-PropertyCard-occupancyNotPossibleMainText"
  }, /*#__PURE__*/React__default.createElement(OccupancyNotPossibleUnity, {
    className: "wbkv9-PropertyCard-occupancyNotPossibleUnity"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.twoPlus)), /*#__PURE__*/React__default.createElement(OccupancyNotPossibleRooms, {
    className: "wbkv9-PropertyCard-occupancyNotPossibleRooms"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.rooms))), !occupancyNotPossible && /*#__PURE__*/React__default.createElement(Amount$4, {
    className: "wbkv9-PropertyCard-amount"
  }, AmountComponent), /*#__PURE__*/React__default.createElement(CollapsibleArrow, {
    className: classnames("wbkv9-PropertyCard-collapsibleArrow", "wbkv9-PropertyCard-collapsibleArrow-active", occupancyNotPossible && "wbkv9-PropertyCard-arrowDown-hasOccupancyNotPossible")
  }, ArrowDownIcon))), available && /*#__PURE__*/React__default.createElement(SecondaryAvailableButton, {
    className: "wbkv9-PropertyCard-secondaryAvailableButton"
  }, /*#__PURE__*/React__default.createElement(SecondaryText, {
    className: "wbkv9-PropertyCard-secondaryText"
  }, /*#__PURE__*/React__default.createElement("button", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.from), " ", currency)), /*#__PURE__*/React__default.createElement(Amount$4, {
    className: "wbkv9-PropertyCard-amount"
  }, AmountComponent), /*#__PURE__*/React__default.createElement(MainText, {
    className: "wbkv9-PropertyCard-mainText"
  }, /*#__PURE__*/React__default.createElement("button", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.bookNow)))), restricted && /*#__PURE__*/React__default.createElement(RestrictedButton, {
    className: classnames("wbkv9-PropertyCard-restrictedButton", "wbkv9-PropertyCard-availabilityButton"),
    onClick: handleCalendar
  }, /*#__PURE__*/React__default.createElement(ButtonTextContainer, {
    className: "wbkv9-PropertyCard-buttonTextContainer"
  }, /*#__PURE__*/React__default.createElement(MainText, {
    className: "wbkv9-PropertyCard-mainText"
  }, BookableErrorMessage)), /*#__PURE__*/React__default.createElement(ShowAvailabilityText, {
    className: classnames("wbkv9-PropertyCard-showAvailability", "wbkv9-PropertyCard-showAvailabilityText")
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.viewAvailability)), /*#__PURE__*/React__default.createElement(AvailabilityText, {
    className: classnames("wbkv9-PropertyCard-showAvailability", "wbkv9-PropertyCard-availabilityText")
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.availability))), unavailable && /*#__PURE__*/React__default.createElement(UnavailableButton, {
    className: classnames("wbkv9-PropertyCard-unavailableButton", "wbkv9-PropertyCard-availabilityButton"),
    onClick: handleCalendar
  }, /*#__PURE__*/React__default.createElement(ButtonTextContainer, {
    className: "wbkv9-PropertyCard-buttonTextContainer"
  }, /*#__PURE__*/React__default.createElement(MainText, {
    className: "wbkv9-PropertyCard-mainText"
  }, /*#__PURE__*/React__default.createElement("button", null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.unavailable)))), /*#__PURE__*/React__default.createElement(ShowAvailabilityText, {
    className: classnames("wbkv9-PropertyCard-showAvailability", "wbkv9-PropertyCard-showAvailabilityText")
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.viewAvailability)), /*#__PURE__*/React__default.createElement(AvailabilityText, {
    className: classnames("wbkv9-PropertyCard-showAvailability", "wbkv9-PropertyCard-availabilityText")
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$$.availability))))))), children);
}

PropertyCard.defaultProps = {
  propertyTicker: "demo_devs",
  propertyName: "Hotel Demo",
  description: "Holi qué tal",
  currency: "EUR",
  available: false,
  restricted: false,
  unavailable: false,
  occupancyNotPossible: false,
  calendarExpanded: false,
  markerSelected: "",
  AmountComponent: null,
  BookableErrorMessage: null,
  Slider: null,
  ArrowDownIcon: null,
  children: null,
  onHover: () => null,
  onMouseLeave: () => null,
  handleClick: () => null,
  handleGallery: () => null,
  handleCalendar: () => null
}; //TODO: Correct proptypes

var SubdirectoryArrowIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React__default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
})), "SubdirectoryArrow");

function _templateObject32$2() {
  var data = _taggedTemplateLiteral(["\n  border-top: 1px solid ", ";\n\n  ", ";\n"]);

  _templateObject32$2 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31$2() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n"]);

  _templateObject31$2 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30$2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject30$2 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29$2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject29$2 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28$2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject28$2 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject27$3 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject26$3 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject25$3 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24$4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject24$4 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23$4() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    font-size: 11px;\n  }\n\n  @media (min-width: ", ") {\n    ", " {\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject23$4 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22$4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"]);

  _templateObject22$4 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21$4() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"]);

  _templateObject21$4 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n\n  ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 6px;\n  }\n\n  @media (min-width: ", ") {\n    &:not(:last-child) {\n      margin-bottom: 17px;\n    }\n  }\n"]);

  _templateObject20$4 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19$4() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  @media (min-width: ", ") {\n    display: ", ";\n    width: 18px;\n    height: 18px;\n    margin-right: 4px;\n    fill: ", ";\n    opacity: 0.5;\n  }\n"]);

  _templateObject19$4 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$5() {
  var data = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n"]);

  _templateObject18$5 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$7() {
  var data = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n\n  ", " {\n    font-size: 12px;\n  }\n\n  ", " {\n    font-size: 15px;\n  }\n\n  @media (min-width: ", ") {\n    ", " {\n      font-size: ", ";\n    }\n\n    ", " {\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject17$7 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$8() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    ", " {\n      font-size: ", ";\n    }\n  }\n"]);

  _templateObject16$8 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$b() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 700;\n"]);

  _templateObject15$b = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$c() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: baseline;\n  font-size: 10px;\n  text-align: right;\n\n  ", " {\n    margin-left: 3px;\n    margin-right: 0;\n  }\n\n  @media (min-width: ", ") {\n    line-height: ", ";\n  }\n"]);

  _templateObject14$c = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$d() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject13$d = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$d() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  font-weight: 400;\n"]);

  _templateObject12$d = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$h() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-wrap: wrap;\n  margin-top: 11px;\n"]);

  _templateObject11$h = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$h() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject10$h = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$j() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: baseline;\n"]);

  _templateObject9$j = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$m() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 5px;\n  font-size: 10px;\n  line-height: 15px;\n  font-weight: 400;\n  text-align: left;\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n  }\n"]);

  _templateObject8$m = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$r() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-size: 15px;\n  line-height: 15px;\n  text-align: left;\n\n  @media (min-width: ", ") {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"]);

  _templateObject7$r = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$v() {
  var data = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n"]);

  _templateObject6$v = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$I() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  color: ", ";\n  font-weight: 700;\n"]);

  _templateObject5$I = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$X() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n\n  ", ";\n"]);

  _templateObject4$X = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1b() {
  var data = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  align-items: baseline;\n"]);

  _templateObject3$1b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1q() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 11px 19px 13px;\n\n  @media (min-width: ", ") {\n    padding: 13px 19px 16px;\n  }\n"]);

  _templateObject2$1q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1H() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  ", ";\n  @media (min-width: ", ") {\n    ", ";\n  }\n"]);

  _templateObject$1H = function _templateObject() {
    return data;
  };

  return data;
}
var Container$j = styled__default.div(_templateObject$1H(), greyBasic, greyLighter, props => props.inPaymentForm ? "border-left: 0; border-right: 0;" : null, minWidthDesktop, props => props.inPaymentForm ? "display:none" : null);
var MainContainer = styled__default.div(_templateObject2$1q(), minWidthTabletHorizontal);
var LineContainer = styled.css(_templateObject3$1b());
var TotalAmountContainer = styled__default(MainContainer)(_templateObject4$X(), greyLighter, LineContainer);
var MainLabel = styled__default.div(_templateObject5$I(), wbBlack);
var TotalAmountLabel = styled__default(MainLabel)(_templateObject6$v());
var MainText$1 = styled__default.div(_templateObject7$r(), minWidthTabletHorizontal, props => props.inPaymentForm ? "15px" : "20px", props => props.inPaymentForm ? "15px" : "20px");
var SubText = styled__default.div(_templateObject8$m(), minWidthTabletHorizontal, props => props.inPaymentForm ? "10px" : "14px");
var AmountContainer = styled__default.div(_templateObject9$j());
var DefaultTotalAmount = styled__default(AmountContainer)(_templateObject10$h());
var SelectedTotalAmount = styled__default(AmountContainer)(_templateObject11$h());
var MainCurrency = styled__default.div(_templateObject12$d());
var Currency$3 = styled__default(MainCurrency)(_templateObject13$d());
var InformativeMessage = styled__default.div(_templateObject14$c(), Currency$3, minWidthTabletHorizontal, props => props.inPaymentForm ? "10px" : "23px");
var MainTotalAmount = styled__default.div(_templateObject15$b());
var TotalAmount = styled__default(MainTotalAmount)(_templateObject16$8(), minWidthTabletHorizontal, Currency$3, props => props.inPaymentForm ? "12px" : "20px");
var TotalAmountValueContainer = styled__default(AmountContainer)(_templateObject17$7(), Currency$3, TotalAmount, minWidthTabletHorizontal, Currency$3, props => props.inPaymentForm ? "12px" : "14px", TotalAmount, props => props.inPaymentForm ? "12px" : "20px");
var AmountToPayContainer = styled__default(MainContainer)(_templateObject18$5());
var SubdirectoryArrow = styled__default(SubdirectoryArrowIcon)(_templateObject19$4(), minWidthTabletHorizontal, props => props.inPaymentForm ? "none" : "block", wbBlack);
var SecondaryContainer = styled__default.div(_templateObject20$4(), LineContainer, minWidthTabletHorizontal);
var SecondaryLabel = styled__default(MainLabel)(_templateObject21$4(), minWidthTabletHorizontal, props => props.inPaymentForm ? "12px" : "18px");
var SecondaryAmount = styled__default(MainTotalAmount)(_templateObject22$4(), minWidthTabletHorizontal, props => props.inPaymentForm ? "12px" : "18px");
var SecondaryAmountContainer = styled__default(AmountContainer)(_templateObject23$4(), Currency$3, minWidthTabletHorizontal, Currency$3, props => props.inPaymentForm ? "12px" : "14px");
var DepositContainer = styled__default(SecondaryContainer)(_templateObject24$4());
var DepositLabel = styled__default(SecondaryLabel)(_templateObject25$3());
var DepositAmount = styled__default(SecondaryAmount)(_templateObject26$3());
var DepositAmountContainer = styled__default(SecondaryAmountContainer)(_templateObject27$3());
var PendingContainer = styled__default(SecondaryContainer)(_templateObject28$2());
var PendingLabel = styled__default(SecondaryLabel)(_templateObject29$2());
var PendingAmount = styled__default(SecondaryAmount)(_templateObject30$2());
var PendingAmountContainer = styled__default(SecondaryAmountContainer)(_templateObject31$2());
var CancellationMessageContainer = styled__default(MainContainer)(_templateObject32$2(), greyLighter, LineContainer);

var msgs$10 = reactIntl.defineMessages({
  totalBooking: {
    id: "checkout.booking_total.bookingTotal",
    description: "Total Booking",
    defaultMessage: "Total Booking"
  },
  deposit: {
    id: "checkout.deposit",
    description: "Deposit",
    defaultMessage: "Deposit"
  },
  payAtProperty: {
    id: "checkout.payAtProperty",
    description: "Pay at the property",
    defaultMessage: "Pay at the property"
  },
  cityTaxIncluded: {
    id: "checkout.booking_total.cityTaxIncluded",
    description: "cityTaxIncluded",
    defaultMessage: "(city tax included)"
  },
  PAY_AT_ESTABLISHMENT: {
    id: "checkout.payAtProperty",
    description: "Pay at the property",
    defaultMessage: "Pay at the property"
  },
  PAY_AT_HOTEL: {
    id: "checkout.payAtHotel",
    description: "Pay at the hotel",
    defaultMessage: "Pay at the hotel"
  },
  PENDING_PAYMENT: {
    id: "checkout.pendingPayment",
    description: "Pending payment",
    defaultMessage: "Pending payment"
  },
  PAY_ACCORDING_TO_CONDITIONS: {
    id: "checkout.remainingConditions",
    description: "Remainder, to be paid according to the conditions.",
    defaultMessage: "Remainder, to be paid according to the conditions."
  },
  AMOUNT_REMAINING: {
    id: "checkout.remaining",
    description: "Remainder",
    defaultMessage: "Remainder"
  },
  informativeMsg: {
    id: "checkout.additional_info.informativeMsg",
    description: "Merely informative. Payments in",
    defaultMessage: "Merely informative. Payments in"
  },
  TAXES_INCLUDED: {
    id: "checkout.booking_total.taxesIncluded",
    description: "Taxes included",
    defaultMessage: "Taxes included"
  },
  TAXES_EXCLUDED: {
    id: "checkout.booking_total.taxesExcluded",
    description: "Taxes excluded",
    defaultMessage: "Taxes excluded"
  },
  TAXES_AND_FEES_INCLUDED: {
    id: "checkout.booking_total.VatAndTaxesIncluded",
    description: "Taxes and fees included",
    defaultMessage: "Taxes and fees included"
  },
  TAXES_AND_FEES_EXCLUDED: {
    id: "checkout.booking_total.VatAndTaxesExcluded",
    description: "Taxes and fees excluded",
    defaultMessage: "Taxes and fees excluded"
  },
  TAXES_INCLUDED_FEES_EXCLUDED: {
    id: "checkout.booking_total.VatIncludedTaxesExcluded",
    description: "Taxes included / fees excluded",
    defaultMessage: "Taxes included / fees excluded"
  }
});
var NO_TEXT = "NO_TEXT";

function ReservationTotalAmount(_ref) {
  var {
    currency,
    defaultCurrency,
    defaultTotalAmount,
    totalAmount,
    deposit,
    pending,
    inPaymentForm,
    cancelRelease,
    reservationStartDate,
    pendingAmountText,
    cutOffDate,
    taxesText,
    className,
    originalTotalTax = 0,
    originalTotalCityTax = 0,
    showCityTaxAddedText
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Container$j, {
    inPaymentForm: inPaymentForm,
    className: "".concat(className, " wbkv9-ReservationTotalAmount-container")
  }, /*#__PURE__*/React__default.createElement(TotalAmountContainer, {
    className: "wbkv9-ReservationTotalAmount-totalAmountContainer"
  }, /*#__PURE__*/React__default.createElement(TotalAmountLabel, {
    className: "wbkv9-ReservationTotalAmount-totalAmountLabel"
  }, /*#__PURE__*/React__default.createElement(MainText$1, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-mainText"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$10.totalBooking), ":"), /*#__PURE__*/React__default.createElement(SubText, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-subText"
  }, taxesText && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, _extends({}, msgs$10[taxesText], {
    values: {
      taxes: originalTotalCityTax > 0 ? " (".concat(originalTotalTax, " ").concat(defaultCurrency, ")") : "",
      fees: originalTotalCityTax > 0 ? " (".concat(originalTotalCityTax, " ").concat(defaultCurrency, ")") : ""
    }
  })))), /*#__PURE__*/React__default.createElement(TotalAmountValueContainer, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-totalAmountValueContainer"
  }, /*#__PURE__*/React__default.createElement(DefaultTotalAmount, {
    className: "wbkv9-ReservationTotalAmount-defaultTotalAmount"
  }, /*#__PURE__*/React__default.createElement(Currency$3, {
    className: "wbkv9-ReservationTotalAmount-defaultCurrency"
  }, defaultCurrency), /*#__PURE__*/React__default.createElement(TotalAmount, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-defaultTotalAmount"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: defaultTotalAmount,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))), defaultCurrency !== currency && /*#__PURE__*/React__default.createElement(SelectedTotalAmount, {
    className: "wbkv9-ReservationTotalAmount-selectedTotalAmount"
  }, /*#__PURE__*/React__default.createElement(Currency$3, {
    className: "wbkv9-ReservationTotalAmount-currency"
  }, currency), /*#__PURE__*/React__default.createElement(TotalAmount, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-totalAmount"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: totalAmount,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })), /*#__PURE__*/React__default.createElement(InformativeMessage, {
    inPaymentForm: inPaymentForm
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$10.informativeMsg), /*#__PURE__*/React__default.createElement(Currency$3, {
    className: "wbkv9-ReservationTotalAmount-defaultCurrency"
  }, defaultCurrency))))), /*#__PURE__*/React__default.createElement(AmountToPayContainer, {
    className: "wbkv9-ReservationTotalAmount-amountToPayContainer"
  }, /*#__PURE__*/React__default.createElement(DepositContainer, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-depositContainer"
  }, /*#__PURE__*/React__default.createElement(DepositLabel, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-depositLabel"
  }, /*#__PURE__*/React__default.createElement(SubdirectoryArrow, {
    inPaymentForm: inPaymentForm
  }), /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$10.deposit), ":"), /*#__PURE__*/React__default.createElement(DepositAmountContainer, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-depositAmountContainer"
  }, /*#__PURE__*/React__default.createElement(Currency$3, {
    className: "wbkv9-ReservationTotalAmount-currency"
  }, defaultCurrency), /*#__PURE__*/React__default.createElement(DepositAmount, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-depositAmount"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: deposit,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })))), /*#__PURE__*/React__default.createElement(PendingContainer, {
    className: "wbkv9-ReservationTotalAmount-pendingContainer"
  }, pendingAmountText !== NO_TEXT && /*#__PURE__*/React__default.createElement(PendingLabel, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-pendingLabel"
  }, /*#__PURE__*/React__default.createElement(SubdirectoryArrow, {
    inPaymentForm: inPaymentForm
  }), pendingAmountText && /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$10[pendingAmountText]) || /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$10.payAtProperty), showCityTaxAddedText ? /*#__PURE__*/React__default.createElement("span", null, "\xA0(", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$10.cityTaxIncluded), ")") : "", ":"), /*#__PURE__*/React__default.createElement(PendingAmountContainer, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-pendingAmountContainer"
  }, /*#__PURE__*/React__default.createElement(Currency$3, {
    className: "wbkv9-ReservationTotalAmount-currency"
  }, defaultCurrency), /*#__PURE__*/React__default.createElement(PendingAmount, {
    inPaymentForm: inPaymentForm,
    className: "wbkv9-ReservationTotalAmount-pendingAmount"
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedNumber, {
    value: pending,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))))), reservationStartDate && reservationStartDate.length > 0 && false && /*#__PURE__*/React__default.createElement(CancellationMessageContainer, null, /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-cancellationMessageContainer"
  }, /*#__PURE__*/React__default.createElement(CancellationMessage$1, {
    cancellationRelease: cancelRelease,
    restrictions: reservationStartDate,
    staticFont: true,
    cutOffDate: cutOffDate
  }))));
}

ReservationTotalAmount.defaultProps = {
  currency: "USD",
  defaultCurrency: "EUR",
  defaultTotalAmount: 0,
  totalAmount: 0,
  deposit: 0,
  pending: 0,
  pendingAmountText: "payAtProperty"
}; //TODO: Correct proptypes
// ReservationTotalAmount.propTypes = {
//   currency: PropTypes.string,
//   defaultCurrency: PropTypes.string,
//   defaultTotalAmount: PropTypes.number,
//   totalAmount: PropTypes.number,
//   deposit: PropTypes.number,
//   pending: PropTypes.number,
//   pendingAmountText: PropTypes.string,
//   restrictions: PropTypes.array.required,
//   cutOffDate: PropTypes.instanceOf(Date).isRequired
// };

var index$j = reactIntl.injectIntl(pure(ReservationTotalAmount));

function _templateObject7$s() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: 400;\n  text-align: left;\n"]);

  _templateObject7$s = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$w() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  text-align: left;\n"]);

  _templateObject6$w = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$J() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5$J = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$Y() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 100%;\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  margin: 0 15px 0 7.5px;\n"]);

  _templateObject4$Y = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1c() {
  var data = _taggedTemplateLiteral(["\n  margin: ", ";\n"]);

  _templateObject3$1c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1r() {
  var data = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  color: #908f96;\n  cursor: pointer;\n"]);

  _templateObject2$1r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1I() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  border: ", ";\n  background: ", ";\n"]);

  _templateObject$1I = function _templateObject() {
    return data;
  };

  return data;
}
var SMALL = "small";
var MEDIUM = "medium";
var LARGE = "large"; // based on https://github.com/styled-components/styled-components/issues/129

var theme$1 = {
  library: {
    ResultHeader: {
      [SMALL]: {
        background: "#f6f6f6",
        border: "1px solid #e1e1e1",
        titleFontSize: "14px",
        subtitleFontSize: "11px",
        arrowMargin: "0 0 0 10px"
      },
      [MEDIUM]: {
        border: "none",
        titleFontSize: "20px",
        subtitleFontSize: "13px",
        arrowMargin: "0 0 0 10px"
      },
      [LARGE]: {
        border: "none",
        titleFontSize: "20px",
        subtitleFontSize: "13px",
        arrowMargin: "0 0 0 10px"
      }
    }
  }
};
var Container$k = styled__default.div(_templateObject$1I(), props => props.theme.library.ResultHeader[props.nature].border, props => props.theme.library.ResultHeader[props.nature].background);
var ArrowBack$2 = styled__default(ArrowBackIcon)(_templateObject2$1r());
var BackButton$1 = styled__default.div(_templateObject3$1c(), props => props.theme.library.ResultHeader[props.nature].arrowMargin);
var Image$1 = styled__default.img(_templateObject4$Y());
var TextContainer$2 = styled__default.div(_templateObject5$J());
var Title$7 = styled__default.div(_templateObject6$w(), props => props.titleColor, props => props.theme.library.ResultHeader[props.nature].titleFontSize, props => props.titleWeight, props => props.Uppercase ? "uppercase" : "");
var Subtitle$2 = styled__default.div(_templateObject7$s(), props => props.subtitleColor, props => props.theme.library.ResultHeader[props.nature].subtitleFontSize); // Used to display Property and Room information
// It's always on top of a list of selling options

function ResultHeader(_ref) {
  var {
    className,
    image,
    hasBackButton,
    title,
    subtitle,
    onBack,
    onClick,
    onImageClick,
    nature,
    titleColor,
    subtitleColor,
    titleWeight,
    titleUppercase
  } = _ref;
  return /*#__PURE__*/React__default.createElement(styled.ThemeProvider, {
    theme: theme$1
  }, /*#__PURE__*/React__default.createElement(Container$k, {
    className: classnames(className, "wbkv9-ResultHeader"),
    onClick: onClick,
    nature: nature
  }, hasBackButton && /*#__PURE__*/React__default.createElement(BackButton$1, {
    nature: nature,
    onClick: onBack
  }, /*#__PURE__*/React__default.createElement(ArrowBack$2, null)), image && nature !== LARGE && /*#__PURE__*/React__default.createElement(Image$1, {
    src: image,
    onClick: onImageClick
  }), /*#__PURE__*/React__default.createElement(TextContainer$2, null, /*#__PURE__*/React__default.createElement(Title$7, {
    nature: nature,
    titleColor: titleColor,
    titleWeight: titleWeight,
    className: "wbkv9-ResultHeader-Title",
    Uppercase: titleUppercase
  }, title), /*#__PURE__*/React__default.createElement(Subtitle$2, {
    nature: nature,
    subtitleColor: subtitleColor,
    className: "wbkv9-ResultHeader-Subtitle"
  }, subtitle))));
}

ResultHeader.propTypes = {
  className: PropTypes__default.string,

  /** The component can have different appearances depending on this prop  */
  nature: PropTypes__default.oneOf([SMALL, MEDIUM, LARGE]),

  /** Source of the image which illustrates the entity of the component */
  image: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.instanceOf(null)]),

  /** Main info to be displayed in big bold letters */
  title: PropTypes__default.string.isRequired,

  /** Secondary info to be displayed */
  subtitle: PropTypes__default.string,

  /** Determines if the component has go back button or not */
  hasBackButton: PropTypes__default.bool,

  /** Function to be executed when clicking the back button */
  onBack: PropTypes__default.func,

  /** Function to be executed when clicking anywhere in the component, except the back button */
  onClick: PropTypes__default.func,

  /** Function to be executed when clicking in the component image */
  onImageClick: PropTypes__default.func,

  /** Color for the letters at title  */
  titleColor: PropTypes__default.string,

  /** Weight for the letters at title  */
  titleWeight: PropTypes__default.number,

  /** Color for the letters at subtitle  */
  subtitleColor: PropTypes__default.string,

  /** Should the title be uppercase?  */
  titleUppercase: PropTypes__default.bool
};
ResultHeader.defaultProps = {
  className: "",
  nature: SMALL,
  subtitle: undefined,
  hasBackButton: false,
  onBack: () => null,
  onClick: () => null,
  onImageClick: () => null,
  titleColor: "#222222",
  titleWeight: 700,
  subtitleColor: "#908f96",
  image: null,
  titleUppercase: true
};
var index$k = pure(ResultHeader);

var DeleteIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
})), "Delete");

function _templateObject19$5() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 2px;\n"]);

  _templateObject19$5 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18$6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-left: -5px;\n"]);

  _templateObject18$6 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17$8() {
  var data = _taggedTemplateLiteral(["\n  & > *:not:last-child {\n    margin-bottom: 3px;\n  }\n"]);

  _templateObject17$8 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16$9() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n  height: 18px;\n  min-height: 18px;\n"]);

  _templateObject16$9 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$c() {
  var data = _taggedTemplateLiteral(["    \n   width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  "]);

  _templateObject15$c = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$d() {
  var data = _taggedTemplateLiteral(["\n  transform: rotate(180deg);\n  fill: ", ";\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  min-height: 24px;\n  margin: 0 20px;\n  ", ";\n"]);

  _templateObject14$d = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$e() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"]);

  _templateObject13$e = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 5px;\n"]);

  _templateObject12$e = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$i() {
  var data = _taggedTemplateLiteral(["    \n    margin: 20px 0;\n  "]);

  _templateObject11$i = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$i() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px 0;\n  ", ";\n"]);

  _templateObject10$i = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$k() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  &:hover {\n    cursor: pointer;\n    color: #000;\n  }\n"]);

  _templateObject9$k = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$n() {
  var data = _taggedTemplateLiteral(["    \n  font-size: 17px;\n  "]);

  _templateObject8$n = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$t() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 15px;\n  ", ";\n"]);

  _templateObject7$t = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$x() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject6$x = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$K() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  @media (min-width: 768px) {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  @media (min-width: 1366px) {\n    margin-left: auto;\n  }\n"]);

  _templateObject5$K = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$Z() {
  var data = _taggedTemplateLiteral(["    \n    display: flex;\n  "]);

  _templateObject4$Z = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1d() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  text-align: left;\n  color: #908f96;\n  display: none;\n  ", ";\n\n  & > * {\n    flex: 1 1 auto;\n  }\n\n  & > *:first-child {\n    flex: 0 1 auto;\n    min-width: 250px;\n  }\n\n  & > *:nth-child(2) {\n    margin-right: 60px;\n  }\n"]);

  _templateObject3$1d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1s() {
  var data = _taggedTemplateLiteral(["    \n    display: none;\n  "]);

  _templateObject2$1s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1J() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  text-align: left;\n  color: #908f96;\n  display: flex;\n  flex-direction: column;\n  ", ";\n"]);

  _templateObject$1J = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$11 = reactIntl.defineMessages({
  delete: {
    id: "checkout.booking_total.delete",
    description: "delete booking",
    defaultMessage: "delete booking"
  },
  nights: {
    id: "booking_confirmation.reservation_summary.nights",
    description: "Nights",
    defaultMessage: "Nights"
  },
  guests: {
    id: "checkout.reservation_summary.guests",
    description: "Guests",
    defaultMessage: "Guests"
  },
  checkIn: {
    id: "checkout.reservation_summary.checkIn",
    description: "Check-in",
    defaultMessage: "Check-in"
  },
  checkOut: {
    id: "checkout.reservation_summary.checkOut",
    description: "Check-out",
    defaultMessage: "Check-out"
  },
  readConditions: {
    id: "checkout.reservation_summary.readConditions",
    description: "Read conditions",
    defaultMessage: "read conditions and cancellation policy"
  }
});
var MobileRoomStayInfo = styled__default.div(_templateObject$1J(), media.up.md(_templateObject2$1s()));
var DesktopRoomStayInfo = styled__default.div(_templateObject3$1d(), media.up.md(_templateObject4$Z()));
var AdditionalInfo$1 = styled__default.div(_templateObject5$K());
var DatesMessage = styled__default.div(_templateObject6$x(), wbBlack);
var Dates = styled__default.div(_templateObject7$t(), wbBlack, media.up.md(_templateObject8$n()));
var Underline$1 = styled__default.div(_templateObject9$k());
var DatesWrapper = styled__default.div(_templateObject10$i(), media.up.md(_templateObject11$i()));
var CheckIn = styled__default.div(_templateObject12$e());
var CheckOut = styled__default.div(_templateObject13$e());
var StyledArrowIcon = styled__default(ArrowIcon)(_templateObject14$d(), greyLighter, media.up.md(_templateObject15$c()));
var StyledDeleteIcon = styled__default(DeleteIcon)(_templateObject16$9(), greyLight);
var MobileInfoList = styled__default.div(_templateObject17$8());
var IconAndText = styled__default.div(_templateObject18$6());
var SeeConditions = styled__default(Underline$1)(_templateObject19$5());

function RoomStayInfo(props) {
  var {
    accommodationName,
    numberOfNights,
    startDate,
    endDate,
    mealPlan,
    occupantsList,
    conditionName,
    handleModal,
    onRemoveReservation,
    restrictions,
    cutOffDate,
    selectedPackage
  } = props;

  var dates = (msg, date) => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DatesMessage, null, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11[msg])), /*#__PURE__*/React__default.createElement(Dates, {
    className: "wbkv9-ReservationSummary-Value"
  }, " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedDate, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
    value: date
  })));

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(MobileRoomStayInfo, null, /*#__PURE__*/React__default.createElement(DatesWrapper, null, dates("checkIn", startDate), /*#__PURE__*/React__default.createElement(StyledArrowIcon, null), dates("checkOut", endDate)), /*#__PURE__*/React__default.createElement(MobileInfoList, null, selectedPackage && /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-package"
  }, accommodationName), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-nights"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "wbkv9-ReservationSummary-Value"
  }, numberOfNights), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11.nights)), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-guests"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "wbkv9-ReservationSummary-Value"
  }, occupantsList)), /*#__PURE__*/React__default.createElement(AdditionalInfo$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-condition"
  }, mealPlan, ", ", conditionName), window.showCancelMsg && /*#__PURE__*/React__default.createElement(CancellationMessage$1, {
    includeIcon: true,
    restrictions: restrictions,
    cutOffDate: cutOffDate,
    staticFont: true
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-actionsContainer"
  }, /*#__PURE__*/React__default.createElement(SeeConditions, {
    className: "wbkv9-ReservationSummary-readConditionsAction wbkv9-ReservationSummary-action",
    onClick: handleModal
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11.readConditions)), /*#__PURE__*/React__default.createElement(IconAndText, null, /*#__PURE__*/React__default.createElement(StyledDeleteIcon, null), /*#__PURE__*/React__default.createElement(Underline$1, {
    className: "wbkv9-ReservationSummary-deleteBookingAction wbkv9-ReservationSummary-action",
    onClick: onRemoveReservation
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11.delete))))))), /*#__PURE__*/React__default.createElement(DesktopRoomStayInfo, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CheckIn, null, dates("checkIn", startDate)), selectedPackage && /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-package"
  }, accommodationName), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-nights"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "wbkv9-ReservationSummary-Value"
  }, numberOfNights), " ", /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11.nights)), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-guests"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "wbkv9-ReservationSummary-Value"
  }, occupantsList)), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-condition"
  }, mealPlan, ", ", conditionName)), /*#__PURE__*/React__default.createElement(StyledArrowIcon, null), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(CheckOut, null, dates("checkOut", endDate)), /*#__PURE__*/React__default.createElement(AdditionalInfo$1, null, /*#__PURE__*/React__default.createElement("div", null, window.showCancelMsg && /*#__PURE__*/React__default.createElement(CancellationMessage$1, {
    includeIcon: true,
    restrictions: restrictions,
    cutOffDate: cutOffDate
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "wbkv9-ReservationSummary-actionsContainer"
  }, /*#__PURE__*/React__default.createElement(SeeConditions, {
    className: "wbkv9-ReservationSummary-readConditionsAction wbkv9-ReservationSummary-action",
    onClick: handleModal
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11.readConditions)), /*#__PURE__*/React__default.createElement(IconAndText, null, /*#__PURE__*/React__default.createElement(StyledDeleteIcon, null), /*#__PURE__*/React__default.createElement(Underline$1, {
    className: "wbkv9-ReservationSummary-deleteBookingAction wbkv9-ReservationSummary-action",
    onClick: onRemoveReservation
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$11.delete)))))))));
}

RoomStayInfo.propTypes = {
  numberOfNights: PropTypes__default.number.isRequired,
  startDate: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.instanceOf(Date)]).isRequired,
  endDate: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.instanceOf(Date)]).isRequired,
  mealPlan: PropTypes__default.string.isRequired,
  occupantsList: PropTypes__default.string.isRequired,
  conditionName: PropTypes__default.string.isRequired,
  handleModal: PropTypes__default.func.isRequired,
  onRemoveReservation: PropTypes__default.func.isRequired,
  showCancelMsg: PropTypes__default.bool,
  cancelRelease: PropTypes__default.number.isRequired,
  reservationStartDate: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.instanceOf(Date)]).isRequired,
  restrictions: PropTypes__default.array.isRequired,
  cutOffDate: PropTypes__default.oneOfType([PropTypes__default.instanceOf(Date), PropTypes__default.number]).isRequired
};
var RoomStayInfo$1 = pure(RoomStayInfo);

function _templateObject8$o() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 20px 20px 20px;\n  @media (min-width: 768px) {\n    padding: 20px 20px 20px 20px;\n  }\n"]);

  _templateObject8$o = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$u() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  @media (min-width: 768px) {\n    display: none;\n  }\n  &:hover {\n    pointer-events: ", ";\n  }\n  cursor: ", ";\n  padding-right: ", ";\n"]);

  _templateObject7$u = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$y() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  @media (min-width: 768px) {\n    display: block;\n  }\n  &:hover {\n    pointer-events: ", ";\n  }\n  cursor: ", ";\n"]);

  _templateObject6$y = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$L() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject5$L = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$_() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #1578bc;\n  height: 35px;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 400;\n  text-transform: uppercase;\n  border-radius: 5px;\n  @media (min-width: 768px) {\n    font-size: 13px;\n  }\n"]);

  _templateObject4$_ = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1e() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  :hover {\n    text-decoration: underline;\n  }\n  @media (min-width: 768px) {\n    padding-right: 30px;\n  }\n  text-align: left;\n"]);

  _templateObject3$1e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1t() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #010101;\n  padding: 20px 20px 0 20px;\n  @media (min-width: 768px) {\n    font-size: 16px;\n    justify-content: flex-start;\n    align-items: baseline;\n  }\n  @media (min-width: 1280px) {\n    justify-content: space-between;\n    align-items: baseline;\n    background-color: ", ";\n    color: ", ";\n    padding: 10px 20px 10px 20px;\n    border: 0;\n  }\n"]);

  _templateObject2$1t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1K() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  @media (min-width: 768px) {\n    font-size: 14px;\n  }\n"]);

  _templateObject$1K = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$12 = reactIntl.defineMessages({
  UNITS: {
    id: "checkout.reservation_summary.roomDenomination.units.plural",
    description: "Room denomination for units selector",
    defaultMessage: "units"
  },
  ROOMS: {
    id: "checkout.reservation_summary.roomDenomination.rooms.plural",
    description: "Room denomination for units selector",
    defaultMessage: "rooms"
  },
  APARTMENTS: {
    id: "checkout.reservation_summary.roomDenomination.apartments.plural",
    description: "Room denomination for units selector",
    defaultMessage: "apartments"
  },
  BUNGALOWS: {
    id: "checkout.reservation_summary.roomDenomination.bungalows.plural",
    description: "Room denomination for units selector",
    defaultMessage: "bungalows"
  },
  CABINS: {
    id: "checkout.reservation_summary.roomDenomination.cabins.plural",
    description: "Room denomination for units selector",
    defaultMessage: "cabins"
  },
  HOUSES: {
    id: "checkout.reservation_summary.roomDenomination.houses.plural",
    description: "Room denomination for units selector",
    defaultMessage: "houses"
  },
  SHIP_CABIN: {
    id: "checkout.reservation_summary.roomDenomination.ship_cabins.plural",
    description: "Room denomination for units selector",
    defaultMessage: "cabins"
  },
  VILLAS: {
    id: "checkout.reservation_summary.roomDenomination.villas.plural",
    description: "Room denomination for units selector",
    defaultMessage: "villas"
  },
  BEDS: {
    id: "checkout.reservation_summary.roomDenomination.beds.plural",
    description: "Room denomination for units selector",
    defaultMessage: "beds"
  },
  UNITS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.units.singular",
    description: "Room denomination for units selector",
    defaultMessage: "unit"
  },
  ROOMS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.rooms.singular",
    description: "Room denomination for units selector",
    defaultMessage: "room"
  },
  APARTMENTS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.apartments.singular",
    description: "Room denomination for units selector",
    defaultMessage: "apartment"
  },
  BUNGALOWS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.bungalows.singular",
    description: "Room denomination for units selector",
    defaultMessage: "bungalow"
  },
  CABINS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.cabins.singular",
    description: "Room denomination for units selector",
    defaultMessage: "cabin"
  },
  HOUSES_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.houses.singular",
    description: "Room denomination for units selector",
    defaultMessage: "house"
  },
  SHIP_CABIN_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.ship_cabins.singular",
    description: "Room denomination for units selector",
    defaultMessage: "cabin"
  },
  VILLAS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.villas.singular",
    description: "Room denomination for units selector",
    defaultMessage: "villa"
  },
  BEDS_SINGULAR: {
    id: "checkout.reservation_summary.roomDenomination.beds.singular",
    description: "Room denomination for units selector",
    defaultMessage: "bed"
  },
  improveYourStay: {
    id: "checkout.reservation_summary.improveStay",
    description: "Improve your stay",
    defaultMessage: "Improve your stay"
  }
});
var RoomInfoPriceWrapper = styled__default.div(_templateObject$1K());
var Header$6 = styled__default.div(_templateObject2$1t(), props => props.backgroundColor ? "#".concat(props.backgroundColor) : null, props => props.textColor ? "#".concat(props.textColor) : null);
var HeaderTitle = styled__default.span(_templateObject3$1e());
var Button$5 = styled__default.button(_templateObject4$_());
var ButtonContainer$2 = styled__default.div(_templateObject5$L());
var WitSelectLarge = styled__default(WitSelect$1)(_templateObject6$y(), props => !props.disableUnit ? "inherit" : "none", props => !props.disableUnit ? "pointer" : "default");
var WitSelectSmall = styled__default(WitSelect$1)(_templateObject7$u(), props => !props.disableUnit ? "inherit" : "none", props => !props.disableUnit ? "pointer" : "default", props => props.disableUnit && "0px");
var Body$1 = styled__default.div(_templateObject8$o());

function RoomReservationCard(props) {
  var {
    selectValue,
    totalOccupancy,
    selectOnChange,
    selectOnClick,
    buttonOnClick,
    accommodationName,
    numberOfNights,
    startDate,
    endDate,
    mealPlan,
    occupantsList,
    conditionName,
    maxAvailableBookableRooms,
    intl,
    handleModal,
    onRemoveReservation,
    cancelRelease,
    reservationStartDate,
    discountAmount,
    baseRate,
    currency,
    discountDiff,
    hasDiscounts,
    hasSelectedServices,
    selectedServices,
    addObligatoryExtrasRateToRoomSelection,
    serviceRatesInfo,
    handleGallery,
    totalRate,
    roomDenomination,
    backgroundColor,
    textColor,
    hasServices,
    restrictions,
    cutOffDate,
    extrasToShow,
    showBestPriceGuaranteed,
    disableUnit,
    handleRoomGallery,
    selectedPackage
  } = props;
  return /*#__PURE__*/React__default.createElement(RoomInfoPriceWrapper, null, /*#__PURE__*/React__default.createElement(Header$6, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    className: "wbkv9-RoomInfoPriceWrapper-header"
  }, /*#__PURE__*/React__default.createElement(HeaderTitle, {
    onClick: handleRoomGallery
  }, selectedPackage ? selectedPackage.name : accommodationName), /*#__PURE__*/React__default.createElement(WitSelectSmall, {
    value: selectValue,
    onChange: selectOnChange,
    onClick: selectOnClick,
    image: disableUnit ? false : true,
    disabled: disableUnit,
    disableUnit: disableUnit
  }, new Array(maxAvailableBookableRooms + 1).fill(false).map((ign, idx) => /*#__PURE__*/React__default.createElement("option", {
    key: idx,
    value: idx
  }, idx))), /*#__PURE__*/React__default.createElement(WitSelectLarge, {
    value: selectValue,
    onChange: selectOnChange,
    onClick: selectOnClick,
    image: disableUnit ? false : true,
    disabled: disableUnit,
    disableUnit: disableUnit
  }, /*#__PURE__*/React__default.createElement("option", {
    value: "0"
  }, "".concat(0, " ", intl.formatMessage(msgs$12[roomDenomination]))), new Array(maxAvailableBookableRooms).fill(false).map((ign, idx) =>
  /*#__PURE__*/

  /* eslint-disable-next-line */
  React__default.createElement("option", {
    key: idx + 1,
    value: idx + 1
    /*selected={idx + 1 === 1}*/

  }, "".concat(idx + 1, " "), idx + 1 > 1 && intl.formatMessage(msgs$12[roomDenomination]), idx + 1 <= 1 && intl.formatMessage(msgs$12["".concat(roomDenomination, "_SINGULAR")]))))), /*#__PURE__*/React__default.createElement(Body$1, null, /*#__PURE__*/React__default.createElement(RoomStayInfo$1, {
    accommodationName: accommodationName,
    numberOfNights: numberOfNights,
    startDate: startDate,
    endDate: endDate,
    mealPlan: mealPlan,
    occupantsList: occupantsList,
    conditionName: conditionName,
    handleModal: handleModal,
    onRemoveReservation: onRemoveReservation,
    cancelRelease: cancelRelease,
    reservationStartDate: reservationStartDate,
    restrictions: restrictions,
    cutOffDate: cutOffDate,
    selectedPackage: selectedPackage
  }), /*#__PURE__*/React__default.createElement(PriceBreakdown$1, {
    discountAmount: discountAmount,
    baseRate: baseRate,
    currency: currency,
    discountDiff: discountDiff,
    hasDiscounts: hasDiscounts,
    hasSelectedServices: hasSelectedServices,
    selectedServices: selectedServices,
    numberOfUnits: selectValue,
    addObligatoryExtrasRateToRoomSelection: addObligatoryExtrasRateToRoomSelection,
    serviceRatesInfo: serviceRatesInfo,
    handleGallery: handleGallery,
    totalRate: totalRate,
    showBestPriceGuaranteed: showBestPriceGuaranteed,
    totalOccupancy: totalOccupancy
  }), extrasToShow && hasServices && /*#__PURE__*/React__default.createElement(ButtonContainer$2, null, /*#__PURE__*/React__default.createElement(Button$5, {
    onClick: buttonOnClick
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$12.improveYourStay)))));
} // RoomReservationCard.propTypes = {
//   accommodationName: PropTypes.string.isRequired,
//   addObligatoryExtrasRateToRoomSelection: PropTypes.bool.isRequired,
//   backgroundColor: PropTypes.string.isRequired,
//   baseRate: PropTypes.number.isRequired,
//   buttonOnClick: PropTypes.func.isRequired,
//   cancelRelease: PropTypes.number.isRequired,
//   conditionName: PropTypes.string.isRequired,
//   currency: PropTypes.string.isRequired,
//   discountAmount: PropTypes.bool.isRequired,
//   discountDiff: PropTypes.number.isRequired,
//   endDate: PropTypes.string.isRequired,
//   handleGallery: PropTypes.func.isRequired,
//   handleModal: PropTypes.func.isRequired,
//   hasDiscounts: PropTypes.bool.isRequired,
//   hasSelectedServices: PropTypes.bool.isRequired,
//   intl: PropTypes.object.isRequired,
//   maxAvailableBookableRooms: PropTypes.number.isRequired,
//   mealPlan: PropTypes.string.isRequired,
//   numberOfNights: PropTypes.number.isRequired,
//   occupantsList: PropTypes.string.isRequired,
//   onRemoveReservation: PropTypes.func.isRequired,
//   reservationStartDate: PropTypes.string.isRequired,
//   roomDenomination: PropTypes.string.isRequired,
//   selectOnChange: PropTypes.func.isRequired,
//   selectOnClick: PropTypes.any.isRequired,
//   selectValue: PropTypes.number.isRequired,
//   totalOccupancy: PropTypes.number.isRequired,
//   selectedServices: PropTypes.object.isRequired,
//   serviceRatesInfo: PropTypes.object.isRequired,
//   startDate: PropTypes.string.isRequired,
//   textColor: PropTypes.string.isRequired,
//   totalRate: PropTypes.number.isRequired,
//   hasServices: PropTypes.bool.isRequired,
//   restrictions: PropTypes.array.isRequired,
//   cutOffDate: PropTypes.instanceOf(Date).isRequired,
//   extrasToShow: PropTypes.bool.isRequired,
//   showBestPriceGuaranteed: PropTypes.bool.isRequired,
// };


PriceBreakdown$1.defaultProps = {
  showBestPriceGuaranteed: false
};
var index$l = pure(RoomReservationCard);

var LocationIcon = createSvgIcon( /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), "LocationGPS");

function _templateObject3$1f() {
  var data = _taggedTemplateLiteral(["\n  color: #000;\n  background-color: #fff;\n"]);

  _templateObject3$1f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1u() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n  border: none;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  background-color: transparent;\n\n  width: 100%;\n  z-index: 1;\n  color: #ffffff;\n\n  height: 100%;\n  padding: 0 39px 0 30px;\n"]);

  _templateObject2$1u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1L() {
  var data = _taggedTemplateLiteral(["\n  color: #999999;\n"]);

  _templateObject$1L = function _templateObject() {
    return data;
  };

  return data;
}
var Location = styled__default(LocationIcon)(_templateObject$1L());
var CustomSelect$2 = styled__default.select(_templateObject2$1u());
var CustomOption = styled__default.option(_templateObject3$1f()); // Used to display Property and Room information
// It's always on top of a list of selling options

function SelectInput(_ref) {
  var {
    className,
    options,
    value,
    onChange,
    disabled
  } = _ref;
  return /*#__PURE__*/React__default.createElement(SelectInputWrapper$1, {
    disabled: disabled,
    className: className,
    icon: /*#__PURE__*/React__default.createElement(Location, null),
    customPadding: true
  }, /*#__PURE__*/React__default.createElement(CustomSelect$2, {
    value: value,
    onChange: onChange
  }, options.map(optionElem => /*#__PURE__*/React__default.createElement(CustomOption, {
    key: optionElem.value,
    value: optionElem.value
  }, optionElem.label))));
}

SelectInput.propTypes = {
  className: PropTypes__default.string,

  /** The component can have different appearances depending on this prop  */
  value: PropTypes__default.any.isRequired,

  /** The component can have different appearances depending on this prop  */
  onChange: PropTypes__default.func.isRequired,

  /** The component can have different appearances depending on this prop  */
  disabled: PropTypes__default.bool,

  /** Source of the image which illustrates the entity of the component */
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.string,
    value: PropTypes__default.any
  })).isRequired
};
SelectInput.defaultProps = {
  className: "",
  disabled: false
};
var index$m = pure(SelectInput);

function _templateObject5$M() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject5$M = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$$() {
  var data = _taggedTemplateLiteral(["\n  background-color: #1578bc;\n  border: none;\n  width: ", ";\n  background-color: ", ";\n  font-size: 13px;\n  color: white;\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  outline: 0;\n  justify-content: center;\n"]);

  _templateObject4$$ = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1g() {
  var data = _taggedTemplateLiteral(["\n  background-color: white;\n  border: 1px solid grey;\n  width: 50%;\n  height: 42px;\n  color: #929198;\n  font-size: 13px;\n  text-transform: uppercase;\n  cursor: pointer;\n"]);

  _templateObject3$1g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1v() {
  var data = _taggedTemplateLiteral(["\n  width: 15px;\n  height: 15px;\n  margin-right: 10px;\n  svg {\n    vertical-align: baseline;\n  }\n"]);

  _templateObject2$1v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1M() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  height: 42px;\n"]);

  _templateObject$1M = function _templateObject() {
    return data;
  };

  return data;
}
var DivFather$5 = styled__default.div(_templateObject$1M());
var SvgContainer$4 = styled__default.span(_templateObject2$1v());
var ButtonAddBooking = styled__default.button(_templateObject3$1g());
var ButtonPrice = styled__default.button(_templateObject4$$(), props => props.disableUnit ? "100%" : "50%", props => props.color);
var DivFlexContainer = styled__default.div(_templateObject5$M());
var msgs$13 = reactIntl.defineMessages({
  addAnother: {
    id: "checkout.addAnother",
    description: "addAnother",
    defaultMessage: "Add another reservation"
  }
});

function StickyCheckout(props) {
  return /*#__PURE__*/React__default.createElement(DivFather$5, {
    className: "wbkv9-Lib-StyckyCheckout"
  }, !props.disableUnit && /*#__PURE__*/React__default.createElement(ButtonAddBooking, {
    className: "wbkv9-Lib-ButtonAddBooking",
    onClick: props.functionAddBooking
  }, /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$13.addAnother)), /*#__PURE__*/React__default.createElement(ButtonPrice, {
    className: "wbkv9-Lib-ButtonPrice",
    disableUnit: props.disableUnit,
    color: props.color,
    onClick: props.functionButtonPrice
  }, /*#__PURE__*/React__default.createElement(DivFlexContainer, null, /*#__PURE__*/React__default.createElement(SvgContainer$4, null, /*#__PURE__*/React__default.createElement(ShoppingCart, null)), props.currency, " ", props.totalInBasket)));
}

StickyCheckout.defaultProps = {
  functionAddBooking: () => null,
  functionButtonPrice: () => null,
  color: "black",
  currency: "EUR",
  totalInBasket: "0"
}; //TODO: Correct proptypes
// StickyCheckout.propTypes = {
//   /** Corporative color for the basket */
//   color: PropTypes.string,
//   /** function to return to step one and add new bookings */
//   functionAddBooking: PropTypes.func,
//   /** function that activates when pressing the basket button */
//   functionButtonPrice: PropTypes.func,
//   /** currency selected by the user */
//   currency: PropTypes.string,
//   /** total price in the basket */
//   totalInBasket: PropTypes.number,
// };

var index$n = pure(StickyCheckout);

function _templateObject$1N() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n  "]);

  _templateObject$1N = function _templateObject() {
    return data;
  };

  return data;
}
var SIZE = {
  XXLARGE: "25px",
  XLARGE: "20px",
  LARGE: "16px",
  STANDARD: "14px",
  SMALL: "12px",
  XSMALL: "10px"
};
var COLOR = {
  BLACK: "#222222",
  GREY: "#908F96",
  GREEN: "#329911",
  RED: "#B20E0E",
  ORANGE: "#FF9125",
  WHITE: "#FFFFFF",
  BLUE: "#1578BC"
};
var templateMapping = {
  [constants.TYPOGRAPHY.DEFAULT]: {
    color: COLOR.BLACK,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.XXLARGE]: {
    color: COLOR.BLACK,
    size: SIZE.XXLARGE,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.XLARGE]: {
    color: COLOR.BLACK,
    size: SIZE.XLARGE,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.LARGE]: {
    color: COLOR.BLACK,
    size: SIZE.LARGE,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD]: {
    color: COLOR.BLACK,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD_BOLD]: {
    color: COLOR.BLACK,
    size: SIZE.STANDARD,
    fontWeight: "700"
  },
  [constants.TYPOGRAPHY.STANDARD_GREY]: {
    color: COLOR.GREY,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD_GREEN]: {
    color: COLOR.GREEN,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD_RED]: {
    color: COLOR.RED,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD_ORANGE]: {
    color: COLOR.ORANGE,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD_WHITE]: {
    color: COLOR.WHITE,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.STANDARD_BLUE]: {
    color: COLOR.BLUE,
    size: SIZE.STANDARD,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.SMALL]: {
    color: COLOR.BLACK,
    size: SIZE.SMALL,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.SMALL_BOLD]: {
    color: COLOR.BLACK,
    size: SIZE.SMALL,
    fontWeight: "700"
  },
  [constants.TYPOGRAPHY.SMALL_GREY]: {
    color: COLOR.GREY,
    size: SIZE.SMALL,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.SMALL_WHITE]: {
    color: COLOR.WHITE,
    size: SIZE.SMALL,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.SMALL_BLUE]: {
    color: COLOR.BLUE,
    size: SIZE.SMALL,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.XSMALL]: {
    color: COLOR.BLACK,
    size: SIZE.XSMALL,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.XSMALL_GREY]: {
    color: COLOR.GREY,
    size: SIZE.XSMALL,
    fontWeight: "normal"
  },
  [constants.TYPOGRAPHY.XSMALL_WHITE]: {
    color: COLOR.WHITE,
    size: SIZE.XSMALL,
    fontWeight: "normal"
  }
};

function WbkTypography(_ref) {
  var {
    component,
    template = constants.TYPOGRAPHY.DEFAULT,
    children
  } = _ref;
  var Component = component || "div";
  var StyledComponent = styled__default(Component)(_templateObject$1N(), templateMapping[template].color, templateMapping[template].size, templateMapping[template].fontWeight);
  return /*#__PURE__*/React__default.createElement(StyledComponent, null, children);
}

WbkTypography.propTypes = {
  component: PropTypes__default.string,
  template: PropTypes__default.string,
  children: PropTypes__default.string.isRequired
};

var MenuThreePoints = createSvgIcon( /*#__PURE__*/React__default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), "MenuThreePoints");

function _templateObject5$N() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  border-radius: 4px;\n  border: 1px solid #e1e1e1;\n  background-color: #fff;\n  padding: 7px 10px;\n  cursor: pointer;\n\n  svg {\n    fill: gray;\n    width: 16px;\n    height: 16px;\n  }\n"]);

  _templateObject5$N = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$10() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 20px;\n  border-bottom: 1px solid #ccc;\n\n  &.selected {\n    font-weight: bold;\n    background-color: #f0f0f0;\n  }\n\n  &.selected:hover {\n    font-weight: bold;\n    background-color: #f4f2f3;\n  }\n\n  &:hover {\n    cursor: pointer;\n    font-weight: bold;\n    background-color: #f0f0f0;\n  }\n\n  &:last-child {\n    border-bottom: 0px solid #ccc;\n  }\n"]);

  _templateObject4$10 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1h() {
  var data = _taggedTemplateLiteral(["\n  float: ", ";\n  flex: 1 1 auto;\n\n  border-top: 1px solid #e5e8ec;\n  display: none;\n\n  box-shadow: 2px 0px 4px -4px rgb(0 0 0 / 75%), 3px 0px 4px -4px rgb(0 0 0 / 75%),\n    0px 3px 4px -4px rgb(0 0 0 / 75%) !important;\n  margin: 0px;\n  min-width: 200px;\n  max-width: 300px;\n  border: 1px solid #e1e1e1 !important;\n  color: #908f96;\n  background-color: #fff;\n\n  &.open {\n    display: block;\n  }\n"]);

  _templateObject3$1h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1w() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject2$1w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1O() {
  var data = _taggedTemplateLiteral(["\n  * {\n    font-family: \"Open Sans\", sans-serif;\n  }\n\n  float: ", ";\n  position: relative;\n  z-index: 1000;\n  cursor: default;\n  user-select: none;\n  font-weight: lighter;\n  font-size: 0.8rem;\n  align-items: center;\n  height: 30px;\n  width: 40px;\n  background-color: #fff;\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE/Edge */\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n"]);

  _templateObject$1O = function _templateObject() {
    return data;
  };

  return data;
}
var StyledDropdown = styled__default.div(_templateObject$1O(), (_ref) => {
  var {
    alignLeft
  } = _ref;
  return alignLeft ? "left;" : "right;";
});
var StyledDropdownHeader = styled__default.div(_templateObject2$1w());
var StyledDropdownBody = styled__default.div(_templateObject3$1h(), (_ref2) => {
  var {
    alignLeft
  } = _ref2;
  return alignLeft ? "left;" : "right;";
});
var StyledDropdownItem = styled__default.div(_templateObject4$10());
var StyledContainerIcon = styled__default.div(_templateObject5$N());

var Dropdown$1 = (_ref4) => {
  var {
    onChange,
    items,
    alignLeft = true,
    defSelected = {
      label: "",
      ticker: ""
    }
  } = _ref4;
  var ref = React.useRef();
  var [show, setShow] = React.useState(false);
  var [selectedItem, setSelectedItem] = React.useState(defSelected.ticker);
  var checkIfClickedOutside = React.useCallback(e => {
    if (ref.current && !ref.current.contains(e.target)) {
      window.removeEventListener("mousedown", checkIfClickedOutside);
      setShow(false);
    }
  }, [ref]);
  var handleOnToggle = React.useCallback(() => {
    setShow(prevShow => {
      if (!prevShow) {
        window.addEventListener("mousedown", checkIfClickedOutside);
      }

      return !prevShow;
    });
  }, [checkIfClickedOutside]);
  var handleOnChange = React.useCallback(idValue => {
    var index = items.findIndex(item => item.ticker === idValue);
    onChange(Object.assign({}, items[index]));
    setSelectedItem(idValue);
    setShow(false);
  }, [onChange, items]);
  return /*#__PURE__*/React__default.createElement(StyledDropdown, {
    alignLeft: alignLeft,
    ref: ref
  }, /*#__PURE__*/React__default.createElement(StyledDropdownHeader, {
    onClick: handleOnToggle
  }, /*#__PURE__*/React__default.createElement(StyledContainerIcon, null, /*#__PURE__*/React__default.createElement(MenuThreePoints, null))), /*#__PURE__*/React__default.createElement(StyledDropdownBody, {
    alignLeft: alignLeft,
    className: "".concat(show && "open")
  }, items.map(item => /*#__PURE__*/React__default.createElement(StyledDropdownItem, {
    key: item.ticker,
    id: item.ticker,
    className: "".concat(item.ticker == selectedItem && "selected"),
    onClick: () => handleOnChange(item.ticker)
  }, item.label))));
};

var constants$1 = {
  DISPLAY_ELEMENT_TYPE: {
    INFO: "INFO",
    MAP: "MAP",
    AVAILABILITY: "AVAILABILITY",
    CUSTOM: "CUSTOM"
  },
  BOOKABLE_STATUS: {
    AVAILABLE: "AVAILABLE",
    UNAVAILABLE: "UNAVAILABLE",
    RESTRICTED: "RESTRICTED",
    IGNORED_FILTER: "IGNORED_FILTER"
  }
};

function _templateObject7$v() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  padding-right: 17px;\n  box-sizing: content-box;\n"]);

  _templateObject7$v = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$z() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n"]);

  _templateObject6$z = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$O() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  overflow: hidden;\n"]);

  _templateObject5$O = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: #908f96;\n  height: 25px;\n  align-items: flex-end;\n  padding: ", ";\n  white-space: nowrap;\n\n  cursor: pointer;\n  font-size: 16px;\n  border-right: 2px solid #e1e1e1;\n  font-weight: 400;\n  opacity: 0.8;\n  transition: all 0.6s;\n\n  &:hover {\n    opacity: 1;\n    color: #222222 !important;\n    cursor: pointer;\n  }\n\n  &.selected {\n    color: #222222 !important;\n    opacity: 1;\n    font-weight: 700;\n  }\n\n  &.firstShow {\n    padding: ", ";\n  }\n\n  &.lastShow {\n    border-right: none;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &.lastShow > * {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n"]);

  _templateObject4$11 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1i() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  justify-content: start;\n  width: calc(\n    100% - ", "\n  );\n  text-overflow: ellipsis;\n"]);

  _templateObject3$1i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1x() {
  var data = _taggedTemplateLiteral(["\n  justify-content: space-between;\n  display: flex;\n  flex: 0 0 auto;\n  text-transform: capitalize;\n  margin-bottom: 10px;\n\n  .MenuItem:nth-child(1) {\n    padding-left: 0;\n  }\n\n  @media (min-width: $min-width-desktop) {\n    align-items: flex-end;\n  }\n"]);

  _templateObject2$1x = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1P() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n\n  .slick-slide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: 100%;\n    z-index: 1;\n  }\n\n  .slick-active {\n    z-index: 2;\n  }\n"]);

  _templateObject$1P = function _templateObject() {
    return data;
  };

  return data;
}
var msgs$14 = reactIntl.defineMessages({
  info: {
    id: "contextualdisplay.info",
    description: "Info tab",
    defaultMessage: "Info"
  },
  map: {
    id: "contextualdisplay.map",
    description: "Map tab",
    defaultMessage: "Map"
  },
  availability: {
    id: "contextualdisplay.availability",
    description: "Availability tab",
    defaultMessage: "Not available for"
  }
});
var StyledContainer$1 = styled__default.div(_templateObject$1P());
var StyledContainerMenu = styled__default.div(_templateObject2$1x());
var StyledContainerDisplayElements = styled__default.div(_templateObject3$1i(), (_ref) => {
  var {
    showDropDown
  } = _ref;
  return "".concat(showDropDown ? "50px" : "0px");
});
var StyledElement = styled__default.div(_templateObject4$11(), (_ref2) => {
  var {
    paddingBetweenElements = 15
  } = _ref2;
  return "0 ".concat(paddingBetweenElements, "px");
}, (_ref3) => {
  var {
    paddingBetweenElements = 15
  } = _ref3;
  return "0px ".concat(paddingBetweenElements, "px 0px 0px");
});
var StyledSpan = styled__default.div(_templateObject5$O(), (_ref4) => {
  var {
    width
  } = _ref4;
  return "".concat(width);
});
var StyledNoScrollbarParent = styled__default.div(_templateObject6$z());
var StyledNoScrollbarChild = styled__default.div(_templateObject7$v());

var renderTranslatedDisplayLabel = label => {
  switch (label) {
    case constants$1.DISPLAY_ELEMENT_TYPE.INFO:
      return /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$14.info);

    case constants$1.DISPLAY_ELEMENT_TYPE.MAP:
      return /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$14.map);

    case constants$1.DISPLAY_ELEMENT_TYPE.AVAILABILITY:
      return /*#__PURE__*/React__default.createElement(reactIntl.FormattedMessage, msgs$14.availability);

    default:
      return label;
  }
};

var Tabs = (_ref5) => {
  var {
    activeEntityChain,
    displayElements,
    onSelectElement,
    children,
    paddingBetweenElements = 15,
    defItemTickerSelected,
    BackArrow
  } = _ref5;

  var _a;

  var [myDisplayElements, setMyDisplayElements] = React.useState([...displayElements]);
  var [indexSlice, setIndexSlice] = React.useState(displayElements.length);
  var [itemTickerSelected, setItemTickerSelected] = React.useState("");
  var [showDropdown, setShowDropdown] = React.useState(false);
  var [refItemsTab, setRefItemsTab] = React.useState({});
  var [widthLastItem, setWidthLastItem] = React.useState(0);
  var [refBackArrow, setRefBackArrow] = React.useState({});
  var arrowWidth = ((_a = refBackArrow === null || refBackArrow === void 0 ? void 0 : refBackArrow.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
  var refContainerElement = React.useRef(null);
  var [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth
  });
  React.useEffect(() => {
    var handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    window.addEventListener("resize", handleResize);
  }, []);
  React.useEffect(() => {
    var handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    window.addEventListener("resize", handleResize);
  }, []);
  React.useEffect(() => {
    setMyDisplayElements([...displayElements]);
  }, [displayElements]);
  React.useEffect(() => {
    var temp = {};

    if (myDisplayElements) {
      myDisplayElements.forEach(displayElement => {
        temp["".concat(displayElement.ticker)] = React.createRef();
      });
      setRefItemsTab(Object.assign({}, temp));
    }
  }, [myDisplayElements]);
  React.useEffect(() => {
    var _a;

    if (refContainerElement) {
      var accWidth = 0;
      var refContainerElementWidth = ((_a = refContainerElement === null || refContainerElement === void 0 ? void 0 : refContainerElement.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) - arrowWidth;
      myDisplayElements.every((element, index) => {
        var _a, _b, _c, _d;

        (_b = (_a = refItemsTab === null || refItemsTab === void 0 ? void 0 : refItemsTab[element.ticker]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.removeAttribute("style");
        var currentOffsetWidth = (_d = (_c = refItemsTab === null || refItemsTab === void 0 ? void 0 : refItemsTab[element.ticker]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.offsetWidth;

        if (currentOffsetWidth) {
          if (accWidth + currentOffsetWidth < refContainerElementWidth) {
            accWidth += currentOffsetWidth;
            return true;
          } else {
            index < myDisplayElements.length - 1 && myDisplayElements.length > 1 ? setShowDropdown(true) : setShowDropdown(false);
            setIndexSlice(index + 1);
            setWidthLastItem(refContainerElementWidth - accWidth - 10);
            return false;
          }
        }
      });
    }
  }, [refItemsTab, dimensions]);
  React.useEffect(() => {
    setItemTickerSelected(defItemTickerSelected);
  }, [defItemTickerSelected]);
  var handleSelectItem = React.useCallback(id => {
    setItemTickerSelected(id);
    onSelectElement({
      element: id
    });
  }, []);
  var handleDropown = React.useCallback(v => {
    var newData = [...myDisplayElements];
    var indexElement = newData.findIndex(element => element.ticker === v.ticker);
    var removed = newData.splice(indexElement, 1)[0];
    handleSelectItem(removed.ticker);
    newData.unshift(removed);
    setMyDisplayElements([...newData]);
  }, []);
  return /*#__PURE__*/React__default.createElement(StyledContainer$1, null, activeEntityChain && /*#__PURE__*/React__default.createElement(StyledContainerMenu, null, /*#__PURE__*/React__default.createElement(StyledContainerDisplayElements, {
    showDropDown: showDropdown && myDisplayElements.length > 1,
    ref: refContainerElement
  }, /*#__PURE__*/React__default.createElement("span", {
    ref: refBackArrow
  }, BackArrow), myDisplayElements.map((item, index) => {
    return /*#__PURE__*/React__default.createElement(StyledElement, {
      paddingBetweenElements: paddingBetweenElements,
      ref: refItemsTab[item.ticker],
      key: item.ticker,
      className: "".concat(itemTickerSelected === item.ticker ? "selected" : "", " ").concat(index === indexSlice - 1 || myDisplayElements.length === 1 ? "lastShow" : "", " ").concat(index === 0 && myDisplayElements.length > 1 ? "firstShow" : ""),
      onClick: () => handleSelectItem(item.ticker)
    }, /*#__PURE__*/React__default.createElement(StyledSpan, {
      width: index === indexSlice - 1 && widthLastItem > 0 ? widthLastItem + "px" : "100%"
    }, renderTranslatedDisplayLabel(item.label)));
  })), showDropdown && indexSlice < myDisplayElements.length && /*#__PURE__*/React__default.createElement(Dropdown$1, {
    items: myDisplayElements.slice(indexSlice > 0 ? indexSlice : myDisplayElements.length),
    onChange: handleDropown,
    alignLeft: false,
    defSelected: myDisplayElements[0]
  })), /*#__PURE__*/React__default.createElement(StyledNoScrollbarParent, null, /*#__PURE__*/React__default.createElement(StyledNoScrollbarChild, {
    className: "".concat(activeEntityChain ? "noMargin" : "", " ").concat(itemTickerSelected.includes("map") ? "noMargin" : "")
  }, children)));
};

var ArrowBefore = createSvgIcon( /*#__PURE__*/React__default.createElement("svg", {
  fill: "#000000",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "ArrowBefore");

var ArrowNext$1 = createSvgIcon( /*#__PURE__*/React__default.createElement("svg", {
  fill: "#000000",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
})), "ArrowNext");

function _templateObject3$1j() {
  var data = _taggedTemplateLiteral(["\n  z-index: 3;\n  left: 0px;\n  height: 100%;\n  width: 44px;\n  &:before {\n    content: none;\n  }\n\n  .NavigateBeforeSVG {\n    position: absolute;\n    top: calc(50% - 22px);\n    opacity: 0.8;\n    width: 44px;\n    height: 44px;\n    fill: white;\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  .slick-prev {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 44px;\n    height: 100%;\n    top: 0 !important;\n    -webkit-transform: none !important;\n    -ms-transform: none !important;\n    transform: none !important;\n  }\n"]);

  _templateObject3$1j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1y() {
  var data = _taggedTemplateLiteral(["\n  z-index: 3;\n  right: 0px;\n  height: 100%;\n  width: 44px;\n  &:before {\n    content: none;\n  }\n\n  .NavigateNextSVG {\n    position: absolute;\n    top: calc(50% - 22px);\n    opacity: 0.8;\n    width: 44px;\n    height: 44px;\n    fill: red;\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  .slick-next {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 44px;\n    height: 100%;\n    top: 0 !important;\n    -webkit-transform: none !important;\n    -ms-transform: none !important;\n    transform: none !important;\n  }\n"]);

  _templateObject2$1y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1Q() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100% !important;\n\n  .slick-slide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    z-index: 1;\n  }\n\n  .slick-active {\n    z-index: 2;\n  }\n"]);

  _templateObject$1Q = function _templateObject() {
    return data;
  };

  return data;
}
var StyledContainer$2 = styled__default.div(_templateObject$1Q());
var StyledNextIcon = styled__default.div(_templateObject2$1y());
var StyledBeforeIcon = styled__default.div(_templateObject3$1j());
var settingsProps = {
  children: [],
  arrows: true,
  infinite: true,
  autoplay: false,
  swipe: false,
  centerMode: false,
  lazyLoad: "ondemand",
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  nextArrow: /*#__PURE__*/React__default.createElement(StyledNextIcon, null, /*#__PURE__*/React__default.createElement("div", {
    className: "NavigateNextSVG"
  }, /*#__PURE__*/React__default.createElement(ArrowNext$1, null))),
  prevArrow: /*#__PURE__*/React__default.createElement(StyledBeforeIcon, null, /*#__PURE__*/React__default.createElement("div", {
    className: "NavigateBeforeSVG"
  }, /*#__PURE__*/React__default.createElement(ArrowBefore, null)))
};

var Carousel = _a => {
  var {
    children
  } = _a,
      otherProps = tslib.__rest(_a, ["children"]);

  return /*#__PURE__*/React__default.createElement(StyledContainer$2, null, /*#__PURE__*/React__default.createElement(Slider, _extends({}, settingsProps, otherProps, {
    children: children
  })));
};

exports.AgentsLogin = index;
exports.AgentsReport = index$1;
exports.BookingForm = index$2;
exports.ButtonBar = ButtonBar;
exports.Cancellation = PopupCancellation$1;
exports.CancellationMessage = CancellationMessage$1;
exports.Carousel = Carousel;
exports.CommunicationPolicy = index$3;
exports.Conditions = index$4;
exports.ConfirmModification = ConfirmModification;
exports.ConfirmationPage = index$5;
exports.DatePicker = DatePicker;
exports.Dropdown = Dropdown$1;
exports.EntityGrid = EntityGrid;
exports.Extras = index$6;
exports.ExtrasAdditionalInfo = index$7;
exports.FixedCart = index$8;
exports.FormGenerator = FormGenerator;
exports.HelloWorld = HelloWorld;
exports.InventoryLine = index$9;
exports.IsModificationValid = isModificationValid;
exports.Loader = Loader;
exports.LoyaltyMyAccount = LoyaltyMyAccount;
exports.LoyaltyMyReservations = LoyaltyMyReservations;
exports.MealPlanDetails = index$a;
exports.MiniCart = index$b;
exports.ModificationButtonBar = index$c;
exports.ModifyReservationChangesSummary = index$d;
exports.ModifyReservationSuccess = ModifyReservationSuccess$1;
exports.ModifyReservationWizardAccommodation = ModifyReservationWizardAccommodationPopup;
exports.ModifyReservationWizardDates = index$e;
exports.ModifyReservationWizardExtras = ModifyReservationWizardExtrasPopup;
exports.Package = Package;
exports.Popup = Popup;
exports.PopupListOfTarif = index$f;
exports.PopupLostReserved = index$g;
exports.PopupPrivacy = index$h;
exports.PriceBreakdown = PriceBreakdown$1;
exports.Promotions = index$i;
exports.PropertyCard = PropertyCard;
exports.ReservationTotalAmount = index$j;
exports.ResultHeader = index$k;
exports.RoomReservationCard = index$l;
exports.RoomStayInfo = RoomStayInfo$1;
exports.SelectInput = index$m;
exports.SelectInputWrapper = SelectInputWrapper$1;
exports.SmartImage = SmartImageContainer;
exports.SmartThumbnail = SmartThumbnailWrapper;
exports.Step = Step$1;
exports.StyckyCheckout = index$n;
exports.Tabs = Tabs;
exports.Thumbnail = Thumbnail;
exports.Tier = Tier;
exports.WbkTypography = WbkTypography;
exports.WitButton = WitButton;
exports.WitModal = WitModal;
exports.WitSelect = WitSelect$1;
//# sourceMappingURL=index.js.map
